(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefac0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefac0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jFKHr", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $e52612429bc61abf$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $e52612429bc61abf$var$global; // eslint-disable-line no-undef

});

parcelRegister("jdXyk", function(module, exports) {
var $dfed6d25c4191dfa$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $dfed6d25c4191dfa$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("cAHsA", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("gtdMs"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("gtdMs", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("fO65L", function(module, exports) {

var $jFKHr = parcelRequire("jFKHr");

var $fMnFl = parcelRequire("fMnFl");

var $fMiEZ = parcelRequire("fMiEZ");

var $10sdZ = parcelRequire("10sdZ");

var $ATdaw = parcelRequire("ATdaw");
var $b8204043938f1594$var$PROTOTYPE = 'prototype';
var $b8204043938f1594$var$$export = function(type, name, source) {
    var IS_FORCED = type & $b8204043938f1594$var$$export.F;
    var IS_GLOBAL = type & $b8204043938f1594$var$$export.G;
    var IS_STATIC = type & $b8204043938f1594$var$$export.S;
    var IS_PROTO = type & $b8204043938f1594$var$$export.P;
    var IS_BIND = type & $b8204043938f1594$var$$export.B;
    var target = IS_GLOBAL ? $jFKHr : IS_STATIC ? $jFKHr[name] || ($jFKHr[name] = {}) : ($jFKHr[name] || {})[$b8204043938f1594$var$PROTOTYPE];
    var exports = IS_GLOBAL ? $fMnFl : $fMnFl[name] || ($fMnFl[name] = {});
    var expProto = exports[$b8204043938f1594$var$PROTOTYPE] || (exports[$b8204043938f1594$var$PROTOTYPE] = {});
    var key, own, out, exp;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        // export native or passed
        out = (own ? target : source)[key];
        // bind timers to global for call from export context
        exp = IS_BIND && own ? $ATdaw(out, $jFKHr) : IS_PROTO && typeof out == 'function' ? $ATdaw(Function.call, out) : out;
        // extend global
        if (target) $10sdZ(target, key, out, type & $b8204043938f1594$var$$export.U);
        // export
        if (exports[key] != out) $fMiEZ(exports, key, exp);
        if (IS_PROTO && expProto[key] != out) expProto[key] = out;
    }
};
$jFKHr.core = $fMnFl;
// type bitmap
$b8204043938f1594$var$$export.F = 1; // forced
$b8204043938f1594$var$$export.G = 2; // global
$b8204043938f1594$var$$export.S = 4; // static
$b8204043938f1594$var$$export.P = 8; // proto
$b8204043938f1594$var$$export.B = 16; // bind
$b8204043938f1594$var$$export.W = 32; // wrap
$b8204043938f1594$var$$export.U = 64; // safe
$b8204043938f1594$var$$export.R = 128; // real proto method for `library`
module.exports = $b8204043938f1594$var$$export;

});
parcelRegister("fMnFl", function(module, exports) {
var $b7cdb23f79fba2eb$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $b7cdb23f79fba2eb$var$core; // eslint-disable-line no-undef

});

parcelRegister("fMiEZ", function(module, exports) {

var $lhvOa = parcelRequire("lhvOa");

var $fTxIB = parcelRequire("fTxIB");

module.exports = (parcelRequire("cAHsA")) ? function(object, key, value) {
    return $lhvOa.f(object, key, $fTxIB(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("lhvOa", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $f7e3dbf44d622721$export$2d1720544b23b823; }, function (v) { return $f7e3dbf44d622721$export$2d1720544b23b823 = v; });
var $f7e3dbf44d622721$export$2d1720544b23b823;

var $978rB = parcelRequire("978rB");

var $fzOzX = parcelRequire("fzOzX");

var $ltjni = parcelRequire("ltjni");
var $f7e3dbf44d622721$var$dP = Object.defineProperty;

$f7e3dbf44d622721$export$2d1720544b23b823 = (parcelRequire("cAHsA")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $978rB(O);
    P = $ltjni(P, true);
    $978rB(Attributes);
    if ($fzOzX) try {
        return $f7e3dbf44d622721$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("978rB", function(module, exports) {

var $1WkAz = parcelRequire("1WkAz");
module.exports = function(it) {
    if (!$1WkAz(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("1WkAz", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("fzOzX", function(module, exports) {



module.exports = !(parcelRequire("cAHsA")) && !(parcelRequire("gtdMs"))(function() {
    return Object.defineProperty((parcelRequire("kv3M8"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("kv3M8", function(module, exports) {

var $1WkAz = parcelRequire("1WkAz");

var $jFKHr = parcelRequire("jFKHr");
var $03d9f6383aab4d28$require$document = $jFKHr.document;
// typeof document.createElement is 'object' in old IE
var $03d9f6383aab4d28$var$is = $1WkAz($03d9f6383aab4d28$require$document) && $1WkAz($03d9f6383aab4d28$require$document.createElement);
module.exports = function(it) {
    return $03d9f6383aab4d28$var$is ? $03d9f6383aab4d28$require$document.createElement(it) : {};
};

});


parcelRegister("ltjni", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $1WkAz = parcelRequire("1WkAz");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$1WkAz(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$1WkAz(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$1WkAz(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$1WkAz(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("fTxIB", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("10sdZ", function(module, exports) {

var $jFKHr = parcelRequire("jFKHr");

var $fMiEZ = parcelRequire("fMiEZ");

var $jdXyk = parcelRequire("jdXyk");

var $0bbbaf60dc5ac496$var$SRC = (parcelRequire("kZJHg"))('src');

var $4vDUM = parcelRequire("4vDUM");
var $0bbbaf60dc5ac496$var$TO_STRING = 'toString';
var $0bbbaf60dc5ac496$var$TPL = ('' + $4vDUM).split($0bbbaf60dc5ac496$var$TO_STRING);

(parcelRequire("fMnFl")).inspectSource = function(it) {
    return $4vDUM.call(it);
};
(module.exports = function(O, key, val, safe) {
    var isFunction = typeof val == 'function';
    if (isFunction) $jdXyk(val, 'name') || $fMiEZ(val, 'name', key);
    if (O[key] === val) return;
    if (isFunction) $jdXyk(val, $0bbbaf60dc5ac496$var$SRC) || $fMiEZ(val, $0bbbaf60dc5ac496$var$SRC, O[key] ? '' + O[key] : $0bbbaf60dc5ac496$var$TPL.join(String(key)));
    if (O === $jFKHr) O[key] = val;
    else if (!safe) {
        delete O[key];
        $fMiEZ(O, key, val);
    } else if (O[key]) O[key] = val;
    else $fMiEZ(O, key, val);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, $0bbbaf60dc5ac496$var$TO_STRING, function toString() {
    return typeof this == 'function' && this[$0bbbaf60dc5ac496$var$SRC] || $4vDUM.call(this);
});

});
parcelRegister("kZJHg", function(module, exports) {
var $f48cf39c7701acad$var$id = 0;
var $f48cf39c7701acad$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$f48cf39c7701acad$var$id + $f48cf39c7701acad$var$px).toString(36));
};

});

parcelRegister("4vDUM", function(module, exports) {

module.exports = (parcelRequire("bW5w6"))('native-function-to-string', Function.toString);

});
parcelRegister("bW5w6", function(module, exports) {

var $fMnFl = parcelRequire("fMnFl");

var $jFKHr = parcelRequire("jFKHr");
var $8b0964050bdaefcf$var$SHARED = '__core-js_shared__';
var $8b0964050bdaefcf$var$store = $jFKHr[$8b0964050bdaefcf$var$SHARED] || ($jFKHr[$8b0964050bdaefcf$var$SHARED] = {});

(module.exports = function(key, value) {
    return $8b0964050bdaefcf$var$store[key] || ($8b0964050bdaefcf$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $fMnFl.version,
    mode: (parcelRequire("cE8bo")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("cE8bo", function(module, exports) {
module.exports = false;

});




parcelRegister("ATdaw", function(module, exports) {
// optional / simple context binding

var $bCxjV = parcelRequire("bCxjV");
module.exports = function(fn, that, length) {
    $bCxjV(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("bCxjV", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});



parcelRegister("6DkCi", function(module, exports) {

var $lhvOa = parcelRequire("lhvOa");
var $4d4660a07183aec2$require$def = $lhvOa.f;

var $jdXyk = parcelRequire("jdXyk");

var $4d4660a07183aec2$var$TAG = (parcelRequire("kC7Sb"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$jdXyk(it = stat ? it : it.prototype, $4d4660a07183aec2$var$TAG)) $4d4660a07183aec2$require$def(it, $4d4660a07183aec2$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("kC7Sb", function(module, exports) {

var $f01d76aa85262900$var$store = (parcelRequire("bW5w6"))('wks');

var $kZJHg = parcelRequire("kZJHg");

var $jFKHr = parcelRequire("jFKHr");
var $f01d76aa85262900$require$Symbol = $jFKHr.Symbol;
var $f01d76aa85262900$var$USE_SYMBOL = typeof $f01d76aa85262900$require$Symbol == 'function';
var $f01d76aa85262900$var$$exports = module.exports = function(name) {
    return $f01d76aa85262900$var$store[name] || ($f01d76aa85262900$var$store[name] = $f01d76aa85262900$var$USE_SYMBOL && $f01d76aa85262900$require$Symbol[name] || ($f01d76aa85262900$var$USE_SYMBOL ? $f01d76aa85262900$require$Symbol : $kZJHg)('Symbol.' + name));
};
$f01d76aa85262900$var$$exports.store = $f01d76aa85262900$var$store;

});


parcelRegister("iUlRw", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $dc3e6a5ebf197777$export$2d1720544b23b823; }, function (v) { return $dc3e6a5ebf197777$export$2d1720544b23b823 = v; });
var $dc3e6a5ebf197777$export$2d1720544b23b823;

$dc3e6a5ebf197777$export$2d1720544b23b823 = (parcelRequire("kC7Sb"));

});

parcelRegister("4z7mj", function(module, exports) {

var $jFKHr = parcelRequire("jFKHr");

var $fMnFl = parcelRequire("fMnFl");

var $cE8bo = parcelRequire("cE8bo");

var $iUlRw = parcelRequire("iUlRw");

var $lhvOa = parcelRequire("lhvOa");
var $3530239d23eaf551$require$defineProperty = $lhvOa.f;
module.exports = function(name) {
    var $Symbol = $fMnFl.Symbol || ($fMnFl.Symbol = $cE8bo ? {} : $jFKHr.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $3530239d23eaf551$require$defineProperty($Symbol, name, {
        value: $iUlRw.f(name)
    });
};

});

parcelRegister("dz1a9", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $k4Th0 = parcelRequire("k4Th0");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $k4Th0(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("k4Th0", function(module, exports) {
var $e9df0e789bc38a19$var$toString = {}.toString;
module.exports = function(it) {
    return $e9df0e789bc38a19$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("fhIl3", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $3hDAb = parcelRequire("3hDAb");

var $igR5o = parcelRequire("igR5o");

var $iWPS0 = parcelRequire("iWPS0");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $3hDAb($this);
        var length = $igR5o(O.length);
        var index = $iWPS0(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("3hDAb", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $dz1a9 = parcelRequire("dz1a9");

var $7kSv5 = parcelRequire("7kSv5");
module.exports = function(it) {
    return $dz1a9($7kSv5(it));
};

});
parcelRegister("7kSv5", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("igR5o", function(module, exports) {
// 7.1.15 ToLength

var $U0K0I = parcelRequire("U0K0I");
var $d4d2e65fc51c0fa8$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $d4d2e65fc51c0fa8$var$min($U0K0I(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("U0K0I", function(module, exports) {
// 7.1.4 ToInteger
var $0a85ce3ec445c48d$var$ceil = Math.ceil;
var $0a85ce3ec445c48d$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $0a85ce3ec445c48d$var$floor : $0a85ce3ec445c48d$var$ceil)(it);
};

});


parcelRegister("iWPS0", function(module, exports) {

var $U0K0I = parcelRequire("U0K0I");
var $dcb5e113ad46b5e8$var$max = Math.max;
var $dcb5e113ad46b5e8$var$min = Math.min;
module.exports = function(index, length) {
    index = $U0K0I(index);
    return index < 0 ? $dcb5e113ad46b5e8$var$max(index + length, 0) : $dcb5e113ad46b5e8$var$min(index, length);
};

});


parcelRegister("dJ9Ze", function(module, exports) {

var $9fe7397b65657bc6$var$shared = (parcelRequire("bW5w6"))('keys');

var $kZJHg = parcelRequire("kZJHg");
module.exports = function(key) {
    return $9fe7397b65657bc6$var$shared[key] || ($9fe7397b65657bc6$var$shared[key] = $kZJHg(key));
};

});

parcelRegister("9siHt", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});

parcelRegister("1iccq", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $0f10ef6a69fe49bd$export$2d1720544b23b823; }, function (v) { return $0f10ef6a69fe49bd$export$2d1720544b23b823 = v; });
var $0f10ef6a69fe49bd$export$2d1720544b23b823;
$0f10ef6a69fe49bd$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("hRWRg", function(module, exports) {
// 7.2.2 IsArray(argument)

var $k4Th0 = parcelRequire("k4Th0");
module.exports = Array.isArray || function isArray(arg) {
    return $k4Th0(arg) == 'Array';
};

});

parcelRegister("eb8lU", function(module, exports) {
// 7.1.13 ToObject(argument)

var $7kSv5 = parcelRequire("7kSv5");
module.exports = function(it) {
    return Object($7kSv5(it));
};

});

parcelRegister("lUyCu", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $978rB = parcelRequire("978rB");

var $ag4eO = parcelRequire("ag4eO");

var $9siHt = parcelRequire("9siHt");

var $ff39aeb87b92e6f4$var$IE_PROTO = (parcelRequire("dJ9Ze"))('IE_PROTO');
var $ff39aeb87b92e6f4$var$Empty = function() {};
var $ff39aeb87b92e6f4$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $ff39aeb87b92e6f4$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("kv3M8"))('iframe');
    var i = $9siHt.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("e7ZIo")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $ff39aeb87b92e6f4$var$createDict = iframeDocument.F;
    while(i--)delete $ff39aeb87b92e6f4$var$createDict[$ff39aeb87b92e6f4$var$PROTOTYPE][$9siHt[i]];
    return $ff39aeb87b92e6f4$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $ff39aeb87b92e6f4$var$Empty[$ff39aeb87b92e6f4$var$PROTOTYPE] = $978rB(O);
        result = new $ff39aeb87b92e6f4$var$Empty();
        $ff39aeb87b92e6f4$var$Empty[$ff39aeb87b92e6f4$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$ff39aeb87b92e6f4$var$IE_PROTO] = O;
    } else result = $ff39aeb87b92e6f4$var$createDict();
    return Properties === undefined ? result : $ag4eO(result, Properties);
};

});
parcelRegister("ag4eO", function(module, exports) {

var $lhvOa = parcelRequire("lhvOa");

var $978rB = parcelRequire("978rB");

var $62EBp = parcelRequire("62EBp");

module.exports = (parcelRequire("cAHsA")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $978rB(O);
    var keys = $62EBp(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$lhvOa.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("62EBp", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $ozPiq = parcelRequire("ozPiq");

var $9siHt = parcelRequire("9siHt");
module.exports = Object.keys || function keys(O) {
    return $ozPiq(O, $9siHt);
};

});
parcelRegister("ozPiq", function(module, exports) {

var $jdXyk = parcelRequire("jdXyk");

var $3hDAb = parcelRequire("3hDAb");

var $049e085fbe100285$var$arrayIndexOf = (parcelRequire("fhIl3"))(false);

var $049e085fbe100285$var$IE_PROTO = (parcelRequire("dJ9Ze"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $3hDAb(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $049e085fbe100285$var$IE_PROTO) $jdXyk(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($jdXyk(O, key = names[i++])) ~$049e085fbe100285$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});



parcelRegister("e7ZIo", function(module, exports) {

var $jFKHr = parcelRequire("jFKHr");
var $a4919773409ff2d9$require$document = $jFKHr.document;
module.exports = $a4919773409ff2d9$require$document && $a4919773409ff2d9$require$document.documentElement;

});


parcelRegister("7cjSp", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $015a35f9bf6a5941$export$2d1720544b23b823; }, function (v) { return $015a35f9bf6a5941$export$2d1720544b23b823 = v; });
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $015a35f9bf6a5941$export$2d1720544b23b823;

var $3hDAb = parcelRequire("3hDAb");

var $9B1GU = parcelRequire("9B1GU");
var $015a35f9bf6a5941$require$gOPN = $9B1GU.f;
var $015a35f9bf6a5941$var$toString = {}.toString;
var $015a35f9bf6a5941$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $015a35f9bf6a5941$var$getWindowNames = function(it) {
    try {
        return $015a35f9bf6a5941$require$gOPN(it);
    } catch (e) {
        return $015a35f9bf6a5941$var$windowNames.slice();
    }
};
$015a35f9bf6a5941$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $015a35f9bf6a5941$var$windowNames && $015a35f9bf6a5941$var$toString.call(it) == '[object Window]' ? $015a35f9bf6a5941$var$getWindowNames(it) : $015a35f9bf6a5941$require$gOPN($3hDAb(it));
};

});
parcelRegister("9B1GU", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $6fc8e1906401997a$export$2d1720544b23b823; }, function (v) { return $6fc8e1906401997a$export$2d1720544b23b823 = v; });
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $6fc8e1906401997a$export$2d1720544b23b823;

var $ozPiq = parcelRequire("ozPiq");

var $6fc8e1906401997a$var$hiddenKeys = (parcelRequire("9siHt")).concat('length', 'prototype');
$6fc8e1906401997a$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $ozPiq(O, $6fc8e1906401997a$var$hiddenKeys);
};

});


parcelRegister("6VRFP", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $50c1b36515ee62b8$export$2d1720544b23b823; }, function (v) { return $50c1b36515ee62b8$export$2d1720544b23b823 = v; });
var $50c1b36515ee62b8$export$2d1720544b23b823;

var $1iccq = parcelRequire("1iccq");

var $fTxIB = parcelRequire("fTxIB");

var $3hDAb = parcelRequire("3hDAb");

var $ltjni = parcelRequire("ltjni");

var $jdXyk = parcelRequire("jdXyk");

var $fzOzX = parcelRequire("fzOzX");
var $50c1b36515ee62b8$var$gOPD = Object.getOwnPropertyDescriptor;

$50c1b36515ee62b8$export$2d1720544b23b823 = (parcelRequire("cAHsA")) ? $50c1b36515ee62b8$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $3hDAb(O);
    P = $ltjni(P, true);
    if ($fzOzX) try {
        return $50c1b36515ee62b8$var$gOPD(O, P);
    } catch (e) {}
    if ($jdXyk(O, P)) return $fTxIB(!$1iccq.f.call(O, P), O[P]);
};

});

parcelRegister("bwayZ", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $fO65L = parcelRequire("fO65L");

var $fMnFl = parcelRequire("fMnFl");

var $gtdMs = parcelRequire("gtdMs");
module.exports = function(KEY, exec) {
    var fn = ($fMnFl.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $fO65L($fO65L.S + $fO65L.F * $gtdMs(function() {
        fn(1);
    }), 'Object', exp);
};

});

parcelRegister("6yhFg", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $jdXyk = parcelRequire("jdXyk");

var $eb8lU = parcelRequire("eb8lU");

var $4c539edc09c7131d$var$IE_PROTO = (parcelRequire("dJ9Ze"))('IE_PROTO');
var $4c539edc09c7131d$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $eb8lU(O);
    if ($jdXyk(O, $4c539edc09c7131d$var$IE_PROTO)) return O[$4c539edc09c7131d$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $4c539edc09c7131d$var$ObjectProto : null;
};

});

parcelRegister("3YyFT", function(module, exports) {
'use strict';

var $cAHsA = parcelRequire("cAHsA");

var $62EBp = parcelRequire("62EBp");

var $1idHk = parcelRequire("1idHk");

var $1iccq = parcelRequire("1iccq");

var $eb8lU = parcelRequire("eb8lU");

var $dz1a9 = parcelRequire("dz1a9");
var $2e51df5c77625555$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$2e51df5c77625555$var$$assign || (parcelRequire("gtdMs"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $2e51df5c77625555$var$$assign({}, A)[S] != 7 || Object.keys($2e51df5c77625555$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $eb8lU(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $1idHk.f;
    var isEnum = $1iccq.f;
    while(aLen > index){
        var S = $dz1a9(arguments[index++]);
        var keys = getSymbols ? $62EBp(S).concat(getSymbols(S)) : $62EBp(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$cAHsA || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $2e51df5c77625555$var$$assign;

});
parcelRegister("1idHk", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $0f121901e8fd41f5$export$2d1720544b23b823; }, function (v) { return $0f121901e8fd41f5$export$2d1720544b23b823 = v; });
var $0f121901e8fd41f5$export$2d1720544b23b823;
$0f121901e8fd41f5$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});


parcelRegister("gsEkn", function(module, exports) {
// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare
    return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

});

parcelRegister("bDxU1", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $1WkAz = parcelRequire("1WkAz");

var $978rB = parcelRequire("978rB");
var $878da294afbeb76d$var$check = function(O, proto) {
    $978rB(O);
    if (!$1WkAz(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("ATdaw"))(Function.call, (parcelRequire("6VRFP")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $878da294afbeb76d$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $878da294afbeb76d$var$check
};

});

parcelRegister("8iPtU", function(module, exports) {
// getting tag from 19.1.3.6 Object.prototype.toString()

var $k4Th0 = parcelRequire("k4Th0");

var $60b7f04b9ef0e291$var$TAG = (parcelRequire("kC7Sb"))('toStringTag');
// ES3 wrong here
var $60b7f04b9ef0e291$var$ARG = $k4Th0(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $60b7f04b9ef0e291$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (e) {}
};
module.exports = function(it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = $60b7f04b9ef0e291$var$tryGet(O = Object(it), $60b7f04b9ef0e291$var$TAG)) == 'string' ? T : $60b7f04b9ef0e291$var$ARG ? $k4Th0(O) : (B = $k4Th0(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

});

parcelRegister("7xMFU", function(module, exports) {
'use strict';

var $bCxjV = parcelRequire("bCxjV");

var $1WkAz = parcelRequire("1WkAz");

var $j6Vk6 = parcelRequire("j6Vk6");
var $57e15f539c1e438c$var$arraySlice = [].slice;
var $57e15f539c1e438c$var$factories = {};
var $57e15f539c1e438c$var$construct = function(F, len, args) {
    if (!(len in $57e15f539c1e438c$var$factories)) {
        for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
        // eslint-disable-next-line no-new-func
        $57e15f539c1e438c$var$factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
    }
    return $57e15f539c1e438c$var$factories[len](F, args);
};
module.exports = Function.bind || function bind(that /* , ...args */ ) {
    var fn = $bCxjV(this);
    var partArgs = $57e15f539c1e438c$var$arraySlice.call(arguments, 1);
    var bound = function() {
        var args = partArgs.concat($57e15f539c1e438c$var$arraySlice.call(arguments));
        return this instanceof bound ? $57e15f539c1e438c$var$construct(fn, args.length, args) : $j6Vk6(fn, args, that);
    };
    if ($1WkAz(fn.prototype)) bound.prototype = fn.prototype;
    return bound;
};

});
parcelRegister("j6Vk6", function(module, exports) {
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that) {
    var un = that === undefined;
    switch(args.length){
        case 0:
            return un ? fn() : fn.call(that);
        case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
        case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
        case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
        case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }
    return fn.apply(that, args);
};

});


parcelRegister("218jD", function(module, exports) {

var $fO65L = parcelRequire("fO65L");

var $7kSv5 = parcelRequire("7kSv5");

var $gtdMs = parcelRequire("gtdMs");

var $aOJxG = parcelRequire("aOJxG");
var $1782201c43270e73$var$space = '[' + $aOJxG + ']';
var $1782201c43270e73$var$non = '\u200b\u0085';
var $1782201c43270e73$var$ltrim = RegExp('^' + $1782201c43270e73$var$space + $1782201c43270e73$var$space + '*');
var $1782201c43270e73$var$rtrim = RegExp($1782201c43270e73$var$space + $1782201c43270e73$var$space + '*$');
var $1782201c43270e73$var$exporter = function(KEY, exec, ALIAS) {
    var exp = {};
    var FORCE = $gtdMs(function() {
        return !!$aOJxG[KEY]() || $1782201c43270e73$var$non[KEY]() != $1782201c43270e73$var$non;
    });
    var fn = exp[KEY] = FORCE ? exec($1782201c43270e73$var$trim) : $aOJxG[KEY];
    if (ALIAS) exp[ALIAS] = fn;
    $fO65L($fO65L.P + $fO65L.F * FORCE, 'String', exp);
};
// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var $1782201c43270e73$var$trim = $1782201c43270e73$var$exporter.trim = function(string, TYPE) {
    string = String($7kSv5(string));
    if (TYPE & 1) string = string.replace($1782201c43270e73$var$ltrim, '');
    if (TYPE & 2) string = string.replace($1782201c43270e73$var$rtrim, '');
    return string;
};
module.exports = $1782201c43270e73$var$exporter;

});
parcelRegister("aOJxG", function(module, exports) {
module.exports = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

});


parcelRegister("2sMRG", function(module, exports) {
'use strict';

var $U0K0I = parcelRequire("U0K0I");

var $7kSv5 = parcelRequire("7kSv5");
module.exports = function repeat(count) {
    var str = String($7kSv5(this));
    var res = '';
    var n = $U0K0I(count);
    if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
    for(; n > 0; (n >>>= 1) && (str += str))if (n & 1) res += str;
    return res;
};

});

parcelRegister("01OvM", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $1WkAz = parcelRequire("1WkAz");
var $005746ab2c3e373e$var$floor = Math.floor;
module.exports = function isInteger(it) {
    return !$1WkAz(it) && isFinite(it) && $005746ab2c3e373e$var$floor(it) === it;
};

});

parcelRegister("dg6i7", function(module, exports) {
// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
    return (x = +x) > -0.00000001 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

});

parcelRegister("liGgn", function(module, exports) {
// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
    // eslint-disable-next-line no-self-compare
    return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

});

parcelRegister("e0ukR", function(module, exports) {
// 20.2.2.16 Math.fround(x)

var $liGgn = parcelRequire("liGgn");
var $a32898c646869a7b$var$pow = Math.pow;
var $a32898c646869a7b$var$EPSILON = $a32898c646869a7b$var$pow(2, -52);
var $a32898c646869a7b$var$EPSILON32 = $a32898c646869a7b$var$pow(2, -23);
var $a32898c646869a7b$var$MAX32 = $a32898c646869a7b$var$pow(2, 127) * (2 - $a32898c646869a7b$var$EPSILON32);
var $a32898c646869a7b$var$MIN32 = $a32898c646869a7b$var$pow(2, -126);
var $a32898c646869a7b$var$roundTiesToEven = function(n) {
    return n + 1 / $a32898c646869a7b$var$EPSILON - 1 / $a32898c646869a7b$var$EPSILON;
};
module.exports = Math.fround || function fround(x) {
    var $abs = Math.abs(x);
    var $sign = $liGgn(x);
    var a, result;
    if ($abs < $a32898c646869a7b$var$MIN32) return $sign * $a32898c646869a7b$var$roundTiesToEven($abs / $a32898c646869a7b$var$MIN32 / $a32898c646869a7b$var$EPSILON32) * $a32898c646869a7b$var$MIN32 * $a32898c646869a7b$var$EPSILON32;
    a = (1 + $a32898c646869a7b$var$EPSILON32 / $a32898c646869a7b$var$EPSILON) * $abs;
    result = a - (a - $abs);
    // eslint-disable-next-line no-self-compare
    if (result > $a32898c646869a7b$var$MAX32 || result != result) return $sign * Infinity;
    return $sign * result;
};

});

parcelRegister("gBqgj", function(module, exports) {

var $U0K0I = parcelRequire("U0K0I");

var $7kSv5 = parcelRequire("7kSv5");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($7kSv5(that));
        var i = $U0K0I(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("iHG7p", function(module, exports) {
'use strict';

var $cE8bo = parcelRequire("cE8bo");

var $fO65L = parcelRequire("fO65L");

var $10sdZ = parcelRequire("10sdZ");

var $fMiEZ = parcelRequire("fMiEZ");

var $3QMgK = parcelRequire("3QMgK");

var $bLWpp = parcelRequire("bLWpp");

var $6DkCi = parcelRequire("6DkCi");

var $6yhFg = parcelRequire("6yhFg");

var $d9dcea0304aa0772$var$ITERATOR = (parcelRequire("kC7Sb"))('iterator');
var $d9dcea0304aa0772$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $d9dcea0304aa0772$var$FF_ITERATOR = '@@iterator';
var $d9dcea0304aa0772$var$KEYS = 'keys';
var $d9dcea0304aa0772$var$VALUES = 'values';
var $d9dcea0304aa0772$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $bLWpp(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$d9dcea0304aa0772$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $d9dcea0304aa0772$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $d9dcea0304aa0772$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $d9dcea0304aa0772$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$d9dcea0304aa0772$var$ITERATOR] || proto[$d9dcea0304aa0772$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $6yhFg($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $6DkCi(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$cE8bo && typeof IteratorPrototype[$d9dcea0304aa0772$var$ITERATOR] != 'function') $fMiEZ(IteratorPrototype, $d9dcea0304aa0772$var$ITERATOR, $d9dcea0304aa0772$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $d9dcea0304aa0772$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$cE8bo || FORCED) && ($d9dcea0304aa0772$var$BUGGY || VALUES_BUG || !proto[$d9dcea0304aa0772$var$ITERATOR])) $fMiEZ(proto, $d9dcea0304aa0772$var$ITERATOR, $default);
    // Plug for library
    $3QMgK[NAME] = $default;
    $3QMgK[TAG] = $d9dcea0304aa0772$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($d9dcea0304aa0772$var$VALUES),
            keys: IS_SET ? $default : getMethod($d9dcea0304aa0772$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $10sdZ(proto, key, methods[key]);
        } else $fO65L($fO65L.P + $fO65L.F * ($d9dcea0304aa0772$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("3QMgK", function(module, exports) {
module.exports = {};

});

parcelRegister("bLWpp", function(module, exports) {
'use strict';

var $lUyCu = parcelRequire("lUyCu");

var $fTxIB = parcelRequire("fTxIB");

var $6DkCi = parcelRequire("6DkCi");
var $89216440de446d74$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("fMiEZ"))($89216440de446d74$var$IteratorPrototype, (parcelRequire("kC7Sb"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $lUyCu($89216440de446d74$var$IteratorPrototype, {
        next: $fTxIB(1, next)
    });
    $6DkCi(Constructor, NAME + ' Iterator');
};

});


parcelRegister("4epiS", function(module, exports) {

var $314c18ff1c4b55dc$var$MATCH = (parcelRequire("kC7Sb"))('match');
module.exports = function(KEY) {
    var re = /./;
    try {
        '/./'[KEY](re);
    } catch (e) {
        try {
            re[$314c18ff1c4b55dc$var$MATCH] = false;
            return !'/./'[KEY](re);
        } catch (f) {}
    }
    return true;
};

});

parcelRegister("21MH9", function(module, exports) {

var $fO65L = parcelRequire("fO65L");

var $gtdMs = parcelRequire("gtdMs");

var $7kSv5 = parcelRequire("7kSv5");
var $17a1729497c6fc11$var$quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var $17a1729497c6fc11$var$createHTML = function(string, tag, attribute, value) {
    var S = String($7kSv5(string));
    var p1 = '<' + tag;
    if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace($17a1729497c6fc11$var$quot, '&quot;') + '"';
    return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function(NAME, exec) {
    var O = {};
    O[NAME] = exec($17a1729497c6fc11$var$createHTML);
    $fO65L($fO65L.P + $fO65L.F * $gtdMs(function() {
        var test = ''[NAME]('"');
        return test !== test.toLowerCase() || test.split('"').length > 3;
    }), 'String', O);
};

});

parcelRegister("ipaqp", function(module, exports) {
'use strict';

var $978rB = parcelRequire("978rB");

var $ltjni = parcelRequire("ltjni");
var $d662a5fd8165617b$var$NUMBER = 'number';
module.exports = function(hint) {
    if (hint !== 'string' && hint !== $d662a5fd8165617b$var$NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
    return $ltjni($978rB(this), hint != $d662a5fd8165617b$var$NUMBER);
};

});

parcelRegister("bRXyE", function(module, exports) {
// check on default Array iterator

var $3QMgK = parcelRequire("3QMgK");

var $8a42d7e6615882d3$var$ITERATOR = (parcelRequire("kC7Sb"))('iterator');
var $8a42d7e6615882d3$var$ArrayProto = Array.prototype;
module.exports = function(it) {
    return it !== undefined && ($3QMgK.Array === it || $8a42d7e6615882d3$var$ArrayProto[$8a42d7e6615882d3$var$ITERATOR] === it);
};

});

parcelRegister("fm12X", function(module, exports) {

var $8iPtU = parcelRequire("8iPtU");

var $b2d9b8efc351a0bf$var$ITERATOR = (parcelRequire("kC7Sb"))('iterator');

var $3QMgK = parcelRequire("3QMgK");

module.exports = (parcelRequire("fMnFl")).getIteratorMethod = function(it) {
    if (it != undefined) return it[$b2d9b8efc351a0bf$var$ITERATOR] || it['@@iterator'] || $3QMgK[$8iPtU(it)];
};

});

parcelRegister("5HrAP", function(module, exports) {

var $42665f4e05aa5516$var$ITERATOR = (parcelRequire("kC7Sb"))('iterator');
var $42665f4e05aa5516$var$SAFE_CLOSING = false;
try {
    var $42665f4e05aa5516$var$riter = [
        7
    ][$42665f4e05aa5516$var$ITERATOR]();
    $42665f4e05aa5516$var$riter['return'] = function() {
        $42665f4e05aa5516$var$SAFE_CLOSING = true;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from($42665f4e05aa5516$var$riter, function() {
        throw 2;
    });
} catch (e) {}
module.exports = function(exec, skipClosing) {
    if (!skipClosing && !$42665f4e05aa5516$var$SAFE_CLOSING) return false;
    var safe = false;
    try {
        var arr = [
            7
        ];
        var iter = arr[$42665f4e05aa5516$var$ITERATOR]();
        iter.next = function() {
            return {
                done: safe = true
            };
        };
        arr[$42665f4e05aa5516$var$ITERATOR] = function() {
            return iter;
        };
        exec(arr);
    } catch (e) {}
    return safe;
};

});

parcelRegister("iWRb1", function(module, exports) {
'use strict';

var $gtdMs = parcelRequire("gtdMs");
module.exports = function(method, arg) {
    return !!method && $gtdMs(function() {
        // eslint-disable-next-line no-useless-call
        arg ? method.call(null, function() {}, 1) : method.call(null);
    });
};

});

parcelRegister("d90U1", function(module, exports) {
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex

var $ATdaw = parcelRequire("ATdaw");

var $dz1a9 = parcelRequire("dz1a9");

var $eb8lU = parcelRequire("eb8lU");

var $igR5o = parcelRequire("igR5o");

var $3ybrc = parcelRequire("3ybrc");
module.exports = function(TYPE, $create) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    var create = $create || $3ybrc;
    return function($this, callbackfn, that) {
        var O = $eb8lU($this);
        var self = $dz1a9(O);
        var f = $ATdaw(callbackfn, that, 3);
        var length = $igR5o(self.length);
        var index = 0;
        var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
        var val, res;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            val = self[index];
            res = f(val, index, O);
            if (TYPE) {
                if (IS_MAP) result[index] = res; // map
                else if (res) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return val; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        result.push(val); // filter
                }
                else if (IS_EVERY) return false; // every
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
    };
};

});
parcelRegister("3ybrc", function(module, exports) {
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)

var $d61QJ = parcelRequire("d61QJ");
module.exports = function(original, length) {
    return new ($d61QJ(original))(length);
};

});
parcelRegister("d61QJ", function(module, exports) {

var $1WkAz = parcelRequire("1WkAz");

var $hRWRg = parcelRequire("hRWRg");

var $988d452734706e5a$var$SPECIES = (parcelRequire("kC7Sb"))('species');
module.exports = function(original) {
    var C;
    if ($hRWRg(original)) {
        C = original.constructor;
        // cross-realm fallback
        if (typeof C == 'function' && (C === Array || $hRWRg(C.prototype))) C = undefined;
        if ($1WkAz(C)) {
            C = C[$988d452734706e5a$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? Array : C;
};

});



parcelRegister("blz7k", function(module, exports) {
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';

var $eb8lU = parcelRequire("eb8lU");

var $iWPS0 = parcelRequire("iWPS0");

var $igR5o = parcelRequire("igR5o");
module.exports = [].copyWithin || function copyWithin(target /* = 0 */ , start /* = 0, end = @length */ ) {
    var O = $eb8lU(this);
    var len = $igR5o(O.length);
    var to = $iWPS0(target, len);
    var from = $iWPS0(start, len);
    var end = arguments.length > 2 ? arguments[2] : undefined;
    var count = Math.min((end === undefined ? len : $iWPS0(end, len)) - from, len - to);
    var inc = 1;
    if (from < to && to < from + count) {
        inc = -1;
        from += count - 1;
        to += count - 1;
    }
    while(count-- > 0){
        if (from in O) O[to] = O[from];
        else delete O[to];
        to += inc;
        from += inc;
    }
    return O;
};

});

parcelRegister("elzBR", function(module, exports) {
// 22.1.3.31 Array.prototype[@@unscopables]

var $a71ea63226520915$var$UNSCOPABLES = (parcelRequire("kC7Sb"))('unscopables');
var $a71ea63226520915$var$ArrayProto = Array.prototype;

if ($a71ea63226520915$var$ArrayProto[$a71ea63226520915$var$UNSCOPABLES] == undefined) (parcelRequire("fMiEZ"))($a71ea63226520915$var$ArrayProto, $a71ea63226520915$var$UNSCOPABLES, {});
module.exports = function(key) {
    $a71ea63226520915$var$ArrayProto[$a71ea63226520915$var$UNSCOPABLES][key] = true;
};

});

parcelRegister("fC6rw", function(module, exports) {
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';

var $eb8lU = parcelRequire("eb8lU");

var $iWPS0 = parcelRequire("iWPS0");

var $igR5o = parcelRequire("igR5o");
module.exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = $eb8lU(this);
    var length = $igR5o(O.length);
    var aLen = arguments.length;
    var index = $iWPS0(aLen > 1 ? arguments[1] : undefined, length);
    var end = aLen > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : $iWPS0(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};

});

parcelRegister("68OYb", function(module, exports) {
'use strict';

var $jFKHr = parcelRequire("jFKHr");

var $lhvOa = parcelRequire("lhvOa");

var $cAHsA = parcelRequire("cAHsA");

var $478b06f6e0e4384d$var$SPECIES = (parcelRequire("kC7Sb"))('species');
module.exports = function(KEY) {
    var C = $jFKHr[KEY];
    if ($cAHsA && C && !C[$478b06f6e0e4384d$var$SPECIES]) $lhvOa.f(C, $478b06f6e0e4384d$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});

parcelRegister("lA4ZU", function(module, exports) {
'use strict';

var $elzBR = parcelRequire("elzBR");

var $h8jrd = parcelRequire("h8jrd");

var $3QMgK = parcelRequire("3QMgK");

var $3hDAb = parcelRequire("3hDAb");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("iHG7p"))(Array, 'Array', function(iterated, kind) {
    this._t = $3hDAb(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $h8jrd(1);
    }
    if (kind == 'keys') return $h8jrd(0, index);
    if (kind == 'values') return $h8jrd(0, O[index]);
    return $h8jrd(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$3QMgK.Arguments = $3QMgK.Array;
$elzBR('keys');
$elzBR('values');
$elzBR('entries');

});
parcelRegister("h8jrd", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});


parcelRegister("kuOKi", function(module, exports) {
'use strict';

var $978rB = parcelRequire("978rB");
module.exports = function() {
    var that = $978rB(this);
    var result = '';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.unicode) result += 'u';
    if (that.sticky) result += 'y';
    return result;
};

});

parcelRegister("7TKGE", function(module, exports) {
'use strict';
parcelRequire("irY8l");

var $10sdZ = parcelRequire("10sdZ");

var $fMiEZ = parcelRequire("fMiEZ");

var $gtdMs = parcelRequire("gtdMs");

var $7kSv5 = parcelRequire("7kSv5");

var $kC7Sb = parcelRequire("kC7Sb");

var $3KKCO = parcelRequire("3KKCO");
var $5c01e282456ee0d7$var$SPECIES = $kC7Sb('species');
var $5c01e282456ee0d7$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$gtdMs(function() {
    // #replace needs built-in support for named groups.
    // #match works fine because it just return the exec results, even if it has
    // a "grops" property.
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: '7'
        };
        return result;
    };
    return ''.replace(re, '$<a>') !== '7';
});
var $5c01e282456ee0d7$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function() {
    // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = 'ab'.split(re);
    return result.length === 2 && result[0] === 'a' && result[1] === 'b';
}();
module.exports = function(KEY, length, exec) {
    var SYMBOL = $kC7Sb(KEY);
    var DELEGATES_TO_SYMBOL = !$gtdMs(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ''[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !$gtdMs(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        re.exec = function() {
            execCalled = true;
            return null;
        };
        if (KEY === 'split') {
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$5c01e282456ee0d7$var$SPECIES] = function() {
                return re;
            };
        }
        re[SYMBOL]('');
        return !execCalled;
    }) : undefined;
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !$5c01e282456ee0d7$var$REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !$5c01e282456ee0d7$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
        var nativeRegExpMethod = /./[SYMBOL];
        var fns = exec($7kSv5, SYMBOL, ''[KEY], function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
            if (regexp.exec === $3KKCO) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: nativeRegExpMethod.call(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: nativeMethod.call(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        var strfn = fns[0];
        var rxfn = fns[1];
        $10sdZ(String.prototype, KEY, strfn);
        $fMiEZ(RegExp.prototype, SYMBOL, length == 2 ? function(string, arg) {
            return rxfn.call(string, this, arg);
        } : function(string) {
            return rxfn.call(string, this);
        });
    }
};

});
parcelRegister("irY8l", function(module, exports) {
'use strict';

var $3KKCO = parcelRequire("3KKCO");

(parcelRequire("fO65L"))({
    target: 'RegExp',
    proto: true,
    forced: $3KKCO !== /./.exec
}, {
    exec: $3KKCO
});

});
parcelRegister("3KKCO", function(module, exports) {
'use strict';

var $kuOKi = parcelRequire("kuOKi");
var $2bb9d5b7bcdb948c$var$nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var $2bb9d5b7bcdb948c$var$nativeReplace = String.prototype.replace;
var $2bb9d5b7bcdb948c$var$patchedExec = $2bb9d5b7bcdb948c$var$nativeExec;
var $2bb9d5b7bcdb948c$var$LAST_INDEX = 'lastIndex';
var $2bb9d5b7bcdb948c$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/, re2 = /b*/g;
    $2bb9d5b7bcdb948c$var$nativeExec.call(re1, 'a');
    $2bb9d5b7bcdb948c$var$nativeExec.call(re2, 'a');
    return re1[$2bb9d5b7bcdb948c$var$LAST_INDEX] !== 0 || re2[$2bb9d5b7bcdb948c$var$LAST_INDEX] !== 0;
}();
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $2bb9d5b7bcdb948c$var$NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var $2bb9d5b7bcdb948c$var$PATCH = $2bb9d5b7bcdb948c$var$UPDATES_LAST_INDEX_WRONG || $2bb9d5b7bcdb948c$var$NPCG_INCLUDED;
if ($2bb9d5b7bcdb948c$var$PATCH) $2bb9d5b7bcdb948c$var$patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    if ($2bb9d5b7bcdb948c$var$NPCG_INCLUDED) reCopy = new RegExp('^' + re.source + '$(?!\\s)', $kuOKi.call(re));
    if ($2bb9d5b7bcdb948c$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re[$2bb9d5b7bcdb948c$var$LAST_INDEX];
    match = $2bb9d5b7bcdb948c$var$nativeExec.call(re, str);
    if ($2bb9d5b7bcdb948c$var$UPDATES_LAST_INDEX_WRONG && match) re[$2bb9d5b7bcdb948c$var$LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    if ($2bb9d5b7bcdb948c$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
    // eslint-disable-next-line no-loop-func
    $2bb9d5b7bcdb948c$var$nativeReplace.call(match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    return match;
};
module.exports = $2bb9d5b7bcdb948c$var$patchedExec;

});



parcelRegister("cn7DE", function(module, exports) {
// 7.3.20 SpeciesConstructor(O, defaultConstructor)

var $978rB = parcelRequire("978rB");

var $bCxjV = parcelRequire("bCxjV");

var $901d8edb96d92cf2$var$SPECIES = (parcelRequire("kC7Sb"))('species');
module.exports = function(O, D) {
    var C = $978rB(O).constructor;
    var S;
    return C === undefined || (S = $978rB(C)[$901d8edb96d92cf2$var$SPECIES]) == undefined ? D : $bCxjV(S);
};

});

parcelRegister("bws30", function(module, exports) {
module.exports = function(it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) throw TypeError(name + ': incorrect invocation!');
    return it;
};

});

parcelRegister("epQAv", function(module, exports) {

var $jFKHr = parcelRequire("jFKHr");

var $7gc9z = parcelRequire("7gc9z");
var $a7ec3159a94a3ee7$require$macrotask = $7gc9z.set;
var $a7ec3159a94a3ee7$var$Observer = $jFKHr.MutationObserver || $jFKHr.WebKitMutationObserver;
var $a7ec3159a94a3ee7$var$process = $jFKHr.process;
var $a7ec3159a94a3ee7$var$Promise = $jFKHr.Promise;

var $a7ec3159a94a3ee7$var$isNode = (parcelRequire("k4Th0"))($a7ec3159a94a3ee7$var$process) == 'process';
module.exports = function() {
    var head, last, notify;
    var flush = function() {
        var parent, fn;
        if ($a7ec3159a94a3ee7$var$isNode && (parent = $a7ec3159a94a3ee7$var$process.domain)) parent.exit();
        while(head){
            fn = head.fn;
            head = head.next;
            try {
                fn();
            } catch (e) {
                if (head) notify();
                else last = undefined;
                throw e;
            }
        }
        last = undefined;
        if (parent) parent.enter();
    };
    // Node.js
    if ($a7ec3159a94a3ee7$var$isNode) notify = function() {
        $a7ec3159a94a3ee7$var$process.nextTick(flush);
    };
    else if ($a7ec3159a94a3ee7$var$Observer && !($jFKHr.navigator && $jFKHr.navigator.standalone)) {
        var toggle = true;
        var node = document.createTextNode('');
        new $a7ec3159a94a3ee7$var$Observer(flush).observe(node, {
            characterData: true
        }); // eslint-disable-line no-new
        notify = function() {
            node.data = toggle = !toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if ($a7ec3159a94a3ee7$var$Promise && $a7ec3159a94a3ee7$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        var promise = $a7ec3159a94a3ee7$var$Promise.resolve(undefined);
        notify = function() {
            promise.then(flush);
        };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
    } else notify = function() {
        // strange IE + webpack dev server bug - use .call(global)
        $a7ec3159a94a3ee7$require$macrotask.call($jFKHr, flush);
    };
    return function(fn) {
        var task = {
            fn: fn,
            next: undefined
        };
        if (last) last.next = task;
        if (!head) {
            head = task;
            notify();
        }
        last = task;
    };
};

});
parcelRegister("7gc9z", function(module, exports) {

var $ATdaw = parcelRequire("ATdaw");

var $j6Vk6 = parcelRequire("j6Vk6");

var $e7ZIo = parcelRequire("e7ZIo");

var $kv3M8 = parcelRequire("kv3M8");

var $jFKHr = parcelRequire("jFKHr");
var $54937473bf4acb40$var$process = $jFKHr.process;
var $54937473bf4acb40$var$setTask = $jFKHr.setImmediate;
var $54937473bf4acb40$var$clearTask = $jFKHr.clearImmediate;
var $54937473bf4acb40$var$MessageChannel = $jFKHr.MessageChannel;
var $54937473bf4acb40$var$Dispatch = $jFKHr.Dispatch;
var $54937473bf4acb40$var$counter = 0;
var $54937473bf4acb40$var$queue = {};
var $54937473bf4acb40$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $54937473bf4acb40$var$defer, $54937473bf4acb40$var$channel, $54937473bf4acb40$var$port;
var $54937473bf4acb40$var$run = function() {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if ($54937473bf4acb40$var$queue.hasOwnProperty(id)) {
        var fn = $54937473bf4acb40$var$queue[id];
        delete $54937473bf4acb40$var$queue[id];
        fn();
    }
};
var $54937473bf4acb40$var$listener = function(event) {
    $54937473bf4acb40$var$run.call(event.data);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$54937473bf4acb40$var$setTask || !$54937473bf4acb40$var$clearTask) {
    $54937473bf4acb40$var$setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $54937473bf4acb40$var$queue[++$54937473bf4acb40$var$counter] = function() {
            // eslint-disable-next-line no-new-func
            $j6Vk6(typeof fn == 'function' ? fn : Function(fn), args);
        };
        $54937473bf4acb40$var$defer($54937473bf4acb40$var$counter);
        return $54937473bf4acb40$var$counter;
    };
    $54937473bf4acb40$var$clearTask = function clearImmediate(id) {
        delete $54937473bf4acb40$var$queue[id];
    };
    // Node.js 0.8-
    if ((parcelRequire("k4Th0"))($54937473bf4acb40$var$process) == 'process') $54937473bf4acb40$var$defer = function(id) {
        $54937473bf4acb40$var$process.nextTick($ATdaw($54937473bf4acb40$var$run, id, 1));
    };
    else if ($54937473bf4acb40$var$Dispatch && $54937473bf4acb40$var$Dispatch.now) $54937473bf4acb40$var$defer = function(id) {
        $54937473bf4acb40$var$Dispatch.now($ATdaw($54937473bf4acb40$var$run, id, 1));
    };
    else if ($54937473bf4acb40$var$MessageChannel) {
        $54937473bf4acb40$var$channel = new $54937473bf4acb40$var$MessageChannel();
        $54937473bf4acb40$var$port = $54937473bf4acb40$var$channel.port2;
        $54937473bf4acb40$var$channel.port1.onmessage = $54937473bf4acb40$var$listener;
        $54937473bf4acb40$var$defer = $ATdaw($54937473bf4acb40$var$port.postMessage, $54937473bf4acb40$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($jFKHr.addEventListener && typeof postMessage == 'function' && !$jFKHr.importScripts) {
        $54937473bf4acb40$var$defer = function(id) {
            $jFKHr.postMessage(id + '', '*');
        };
        $jFKHr.addEventListener('message', $54937473bf4acb40$var$listener, false);
    // IE8-
    } else if ($54937473bf4acb40$var$ONREADYSTATECHANGE in $kv3M8('script')) $54937473bf4acb40$var$defer = function(id) {
        $e7ZIo.appendChild($kv3M8('script'))[$54937473bf4acb40$var$ONREADYSTATECHANGE] = function() {
            $e7ZIo.removeChild(this);
            $54937473bf4acb40$var$run.call(id);
        };
    };
    else $54937473bf4acb40$var$defer = function(id) {
        setTimeout($ATdaw($54937473bf4acb40$var$run, id, 1), 0);
    };
}
module.exports = {
    set: $54937473bf4acb40$var$setTask,
    clear: $54937473bf4acb40$var$clearTask
};

});


parcelRegister("2aUHX", function(module, exports) {

var $10sdZ = parcelRequire("10sdZ");
module.exports = function(target, src, safe) {
    for(var key in src)$10sdZ(target, key, src[key], safe);
    return target;
};

});

parcelRegister("i4WpZ", function(module, exports) {
'use strict';

var $jFKHr = parcelRequire("jFKHr");

var $fO65L = parcelRequire("fO65L");

var $10sdZ = parcelRequire("10sdZ");

var $2aUHX = parcelRequire("2aUHX");

var $khJao = parcelRequire("khJao");

var $d1wID = parcelRequire("d1wID");

var $bws30 = parcelRequire("bws30");

var $1WkAz = parcelRequire("1WkAz");

var $gtdMs = parcelRequire("gtdMs");

var $5HrAP = parcelRequire("5HrAP");

var $6DkCi = parcelRequire("6DkCi");

var $6yI0d = parcelRequire("6yI0d");
module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
    var Base = $jFKHr[NAME];
    var C = Base;
    var ADDER = IS_MAP ? 'set' : 'add';
    var proto = C && C.prototype;
    var O = {};
    var fixMethod = function(KEY) {
        var fn = proto[KEY];
        $10sdZ(proto, KEY, KEY == 'delete' ? function(a) {
            return IS_WEAK && !$1WkAz(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'has' ? function has(a) {
            return IS_WEAK && !$1WkAz(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'get' ? function get(a) {
            return IS_WEAK && !$1WkAz(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'add' ? function add(a) {
            fn.call(this, a === 0 ? 0 : a);
            return this;
        } : function set(a, b) {
            fn.call(this, a === 0 ? 0 : a, b);
            return this;
        });
    };
    if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !$gtdMs(function() {
        new C().entries().next();
    }))) {
        // create collection constructor
        C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
        $2aUHX(C.prototype, methods);
        $khJao.NEED = true;
    } else {
        var instance = new C();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
        // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $gtdMs(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        var ACCEPT_ITERABLES = $5HrAP(function(iter) {
            new C(iter);
        }); // eslint-disable-line no-new
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $gtdMs(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new C();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            C = wrapper(function(target, iterable) {
                $bws30(target, C, NAME);
                var that = $6yI0d(new Base(), target, C);
                if (iterable != undefined) $d1wID(iterable, IS_MAP, that[ADDER], that);
                return that;
            });
            C.prototype = proto;
            proto.constructor = C;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && proto.clear) delete proto.clear;
    }
    $6DkCi(C, NAME);
    O[NAME] = C;
    $fO65L($fO65L.G + $fO65L.W + $fO65L.F * (C != Base), O);
    if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
    return C;
};

});
parcelRegister("khJao", function(module, exports) {

var $ec486e553db00471$var$META = (parcelRequire("kZJHg"))('meta');

var $1WkAz = parcelRequire("1WkAz");

var $jdXyk = parcelRequire("jdXyk");

var $lhvOa = parcelRequire("lhvOa");
var $ec486e553db00471$require$setDesc = $lhvOa.f;
var $ec486e553db00471$var$id = 0;
var $ec486e553db00471$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $ec486e553db00471$var$FREEZE = !(parcelRequire("gtdMs"))(function() {
    return $ec486e553db00471$var$isExtensible(Object.preventExtensions({}));
});
var $ec486e553db00471$var$setMeta = function(it) {
    $ec486e553db00471$require$setDesc(it, $ec486e553db00471$var$META, {
        value: {
            i: 'O' + ++$ec486e553db00471$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $ec486e553db00471$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$1WkAz(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$jdXyk(it, $ec486e553db00471$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$ec486e553db00471$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $ec486e553db00471$var$setMeta(it);
    // return object ID
    }
    return it[$ec486e553db00471$var$META].i;
};
var $ec486e553db00471$var$getWeak = function(it, create) {
    if (!$jdXyk(it, $ec486e553db00471$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$ec486e553db00471$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $ec486e553db00471$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$ec486e553db00471$var$META].w;
};
// add metadata on freeze-family methods calling
var $ec486e553db00471$var$onFreeze = function(it) {
    if ($ec486e553db00471$var$FREEZE && $ec486e553db00471$var$meta.NEED && $ec486e553db00471$var$isExtensible(it) && !$jdXyk(it, $ec486e553db00471$var$META)) $ec486e553db00471$var$setMeta(it);
    return it;
};
var $ec486e553db00471$var$meta = module.exports = {
    KEY: $ec486e553db00471$var$META,
    NEED: false,
    fastKey: $ec486e553db00471$var$fastKey,
    getWeak: $ec486e553db00471$var$getWeak,
    onFreeze: $ec486e553db00471$var$onFreeze
};

});

parcelRegister("d1wID", function(module, exports) {

var $ATdaw = parcelRequire("ATdaw");

var $cVo8z = parcelRequire("cVo8z");

var $bRXyE = parcelRequire("bRXyE");

var $978rB = parcelRequire("978rB");

var $igR5o = parcelRequire("igR5o");

var $fm12X = parcelRequire("fm12X");
var $97b4bfa61e97e1ef$var$BREAK = {};
var $97b4bfa61e97e1ef$var$RETURN = {};
var $97b4bfa61e97e1ef$var$exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function() {
        return iterable;
    } : $fm12X(iterable);
    var f = $ATdaw(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if ($bRXyE(iterFn)) for(length = $igR5o(iterable.length); length > index; index++){
        result = entries ? f($978rB(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === $97b4bfa61e97e1ef$var$BREAK || result === $97b4bfa61e97e1ef$var$RETURN) return result;
    }
    else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done;){
        result = $cVo8z(iterator, f, step.value, entries);
        if (result === $97b4bfa61e97e1ef$var$BREAK || result === $97b4bfa61e97e1ef$var$RETURN) return result;
    }
};
$97b4bfa61e97e1ef$var$exports.BREAK = $97b4bfa61e97e1ef$var$BREAK;
$97b4bfa61e97e1ef$var$exports.RETURN = $97b4bfa61e97e1ef$var$RETURN;

});
parcelRegister("cVo8z", function(module, exports) {
// call something on iterator step with safe closing on error

var $978rB = parcelRequire("978rB");
module.exports = function(iterator, fn, value, entries) {
    try {
        return entries ? fn($978rB(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) $978rB(ret.call(iterator));
        throw e;
    }
};

});


parcelRegister("6yI0d", function(module, exports) {

var $1WkAz = parcelRequire("1WkAz");

var $bDxU1 = parcelRequire("bDxU1");
var $4c680d0c4f38902f$require$setPrototypeOf = $bDxU1.set;
module.exports = function(that, target, C) {
    var S = target.constructor;
    var P;
    if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && $1WkAz(P) && $4c680d0c4f38902f$require$setPrototypeOf) $4c680d0c4f38902f$require$setPrototypeOf(that, P);
    return that;
};

});


parcelRegister("erNx4", function(module, exports) {

var $jFKHr = parcelRequire("jFKHr");

var $fMiEZ = parcelRequire("fMiEZ");

var $kZJHg = parcelRequire("kZJHg");
var $a84a0265baf20fe8$var$TYPED = $kZJHg('typed_array');
var $a84a0265baf20fe8$var$VIEW = $kZJHg('view');
var $a84a0265baf20fe8$var$ABV = !!($jFKHr.ArrayBuffer && $jFKHr.DataView);
var $a84a0265baf20fe8$var$CONSTR = $a84a0265baf20fe8$var$ABV;
var $a84a0265baf20fe8$var$i = 0;
var $a84a0265baf20fe8$var$l = 9;
var $a84a0265baf20fe8$var$Typed;
var $a84a0265baf20fe8$var$TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');
while($a84a0265baf20fe8$var$i < $a84a0265baf20fe8$var$l)if ($a84a0265baf20fe8$var$Typed = $jFKHr[$a84a0265baf20fe8$var$TypedArrayConstructors[$a84a0265baf20fe8$var$i++]]) {
    $fMiEZ($a84a0265baf20fe8$var$Typed.prototype, $a84a0265baf20fe8$var$TYPED, true);
    $fMiEZ($a84a0265baf20fe8$var$Typed.prototype, $a84a0265baf20fe8$var$VIEW, true);
} else $a84a0265baf20fe8$var$CONSTR = false;
module.exports = {
    ABV: $a84a0265baf20fe8$var$ABV,
    CONSTR: $a84a0265baf20fe8$var$CONSTR,
    TYPED: $a84a0265baf20fe8$var$TYPED,
    VIEW: $a84a0265baf20fe8$var$VIEW
};

});

parcelRegister("iuSWU", function(module, exports) {
'use strict';

var $jFKHr = parcelRequire("jFKHr");

var $cAHsA = parcelRequire("cAHsA");

var $cE8bo = parcelRequire("cE8bo");

var $erNx4 = parcelRequire("erNx4");

var $fMiEZ = parcelRequire("fMiEZ");

var $2aUHX = parcelRequire("2aUHX");

var $gtdMs = parcelRequire("gtdMs");

var $bws30 = parcelRequire("bws30");

var $U0K0I = parcelRequire("U0K0I");

var $igR5o = parcelRequire("igR5o");

var $4YEeq = parcelRequire("4YEeq");

var $9B1GU = parcelRequire("9B1GU");
var $d775a7189e817c48$require$gOPN = $9B1GU.f;

var $lhvOa = parcelRequire("lhvOa");
var $d775a7189e817c48$require$dP = $lhvOa.f;

var $fC6rw = parcelRequire("fC6rw");

var $6DkCi = parcelRequire("6DkCi");
var $d775a7189e817c48$var$ARRAY_BUFFER = 'ArrayBuffer';
var $d775a7189e817c48$var$DATA_VIEW = 'DataView';
var $d775a7189e817c48$var$PROTOTYPE = 'prototype';
var $d775a7189e817c48$var$WRONG_LENGTH = 'Wrong length!';
var $d775a7189e817c48$var$WRONG_INDEX = 'Wrong index!';
var $d775a7189e817c48$var$$ArrayBuffer = $jFKHr[$d775a7189e817c48$var$ARRAY_BUFFER];
var $d775a7189e817c48$var$$DataView = $jFKHr[$d775a7189e817c48$var$DATA_VIEW];
var $d775a7189e817c48$var$Math = $jFKHr.Math;
var $d775a7189e817c48$var$RangeError = $jFKHr.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var $d775a7189e817c48$var$Infinity1 = $jFKHr.Infinity;
var $d775a7189e817c48$var$BaseBuffer = $d775a7189e817c48$var$$ArrayBuffer;
var $d775a7189e817c48$var$abs = $d775a7189e817c48$var$Math.abs;
var $d775a7189e817c48$var$pow = $d775a7189e817c48$var$Math.pow;
var $d775a7189e817c48$var$floor = $d775a7189e817c48$var$Math.floor;
var $d775a7189e817c48$var$log = $d775a7189e817c48$var$Math.log;
var $d775a7189e817c48$var$LN2 = $d775a7189e817c48$var$Math.LN2;
var $d775a7189e817c48$var$BUFFER = 'buffer';
var $d775a7189e817c48$var$BYTE_LENGTH = 'byteLength';
var $d775a7189e817c48$var$BYTE_OFFSET = 'byteOffset';
var $d775a7189e817c48$var$$BUFFER = $cAHsA ? '_b' : $d775a7189e817c48$var$BUFFER;
var $d775a7189e817c48$var$$LENGTH = $cAHsA ? '_l' : $d775a7189e817c48$var$BYTE_LENGTH;
var $d775a7189e817c48$var$$OFFSET = $cAHsA ? '_o' : $d775a7189e817c48$var$BYTE_OFFSET;
// IEEE754 conversions based on https://github.com/feross/ieee754
function $d775a7189e817c48$var$packIEEE754(value, mLen, nBytes) {
    var buffer = new Array(nBytes);
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? $d775a7189e817c48$var$pow(2, -24) - $d775a7189e817c48$var$pow(2, -77) : 0;
    var i = 0;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    var e, m, c;
    value = $d775a7189e817c48$var$abs(value);
    // eslint-disable-next-line no-self-compare
    if (value != value || value === Infinity) {
        // eslint-disable-next-line no-self-compare
        m = value != value ? 1 : 0;
        e = eMax;
    } else {
        e = $d775a7189e817c48$var$floor($d775a7189e817c48$var$log(value) / $d775a7189e817c48$var$LN2);
        if (value * (c = $d775a7189e817c48$var$pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * $d775a7189e817c48$var$pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * $d775a7189e817c48$var$pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * $d775a7189e817c48$var$pow(2, eBias - 1) * $d775a7189e817c48$var$pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
    buffer[--i] |= s * 128;
    return buffer;
}
function $d775a7189e817c48$var$unpackIEEE754(buffer, mLen, nBytes) {
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = eLen - 7;
    var i = nBytes - 1;
    var s = buffer[i--];
    var e = s & 127;
    var m;
    s >>= 7;
    for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : s ? -Infinity : Infinity;
    else {
        m = m + $d775a7189e817c48$var$pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * $d775a7189e817c48$var$pow(2, e - mLen);
}
function $d775a7189e817c48$var$unpackI32(bytes) {
    return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function $d775a7189e817c48$var$packI8(it) {
    return [
        it & 0xff
    ];
}
function $d775a7189e817c48$var$packI16(it) {
    return [
        it & 0xff,
        it >> 8 & 0xff
    ];
}
function $d775a7189e817c48$var$packI32(it) {
    return [
        it & 0xff,
        it >> 8 & 0xff,
        it >> 16 & 0xff,
        it >> 24 & 0xff
    ];
}
function $d775a7189e817c48$var$packF64(it) {
    return $d775a7189e817c48$var$packIEEE754(it, 52, 8);
}
function $d775a7189e817c48$var$packF32(it) {
    return $d775a7189e817c48$var$packIEEE754(it, 23, 4);
}
function $d775a7189e817c48$var$addGetter(C, key, internal) {
    $d775a7189e817c48$require$dP(C[$d775a7189e817c48$var$PROTOTYPE], key, {
        get: function() {
            return this[internal];
        }
    });
}
function $d775a7189e817c48$var$get(view, bytes, index, isLittleEndian) {
    var numIndex = +index;
    var intIndex = $4YEeq(numIndex);
    if (intIndex + bytes > view[$d775a7189e817c48$var$$LENGTH]) throw $d775a7189e817c48$var$RangeError($d775a7189e817c48$var$WRONG_INDEX);
    var store = view[$d775a7189e817c48$var$$BUFFER]._b;
    var start = intIndex + view[$d775a7189e817c48$var$$OFFSET];
    var pack = store.slice(start, start + bytes);
    return isLittleEndian ? pack : pack.reverse();
}
function $d775a7189e817c48$var$set(view, bytes, index, conversion, value, isLittleEndian) {
    var numIndex = +index;
    var intIndex = $4YEeq(numIndex);
    if (intIndex + bytes > view[$d775a7189e817c48$var$$LENGTH]) throw $d775a7189e817c48$var$RangeError($d775a7189e817c48$var$WRONG_INDEX);
    var store = view[$d775a7189e817c48$var$$BUFFER]._b;
    var start = intIndex + view[$d775a7189e817c48$var$$OFFSET];
    var pack = conversion(+value);
    for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}
if (!$erNx4.ABV) {
    $d775a7189e817c48$var$$ArrayBuffer = function ArrayBuffer(length) {
        $bws30(this, $d775a7189e817c48$var$$ArrayBuffer, $d775a7189e817c48$var$ARRAY_BUFFER);
        var byteLength = $4YEeq(length);
        this._b = $fC6rw.call(new Array(byteLength), 0);
        this[$d775a7189e817c48$var$$LENGTH] = byteLength;
    };
    $d775a7189e817c48$var$$DataView = function DataView(buffer, byteOffset, byteLength) {
        $bws30(this, $d775a7189e817c48$var$$DataView, $d775a7189e817c48$var$DATA_VIEW);
        $bws30(buffer, $d775a7189e817c48$var$$ArrayBuffer, $d775a7189e817c48$var$DATA_VIEW);
        var bufferLength = buffer[$d775a7189e817c48$var$$LENGTH];
        var offset = $U0K0I(byteOffset);
        if (offset < 0 || offset > bufferLength) throw $d775a7189e817c48$var$RangeError('Wrong offset!');
        byteLength = byteLength === undefined ? bufferLength - offset : $igR5o(byteLength);
        if (offset + byteLength > bufferLength) throw $d775a7189e817c48$var$RangeError($d775a7189e817c48$var$WRONG_LENGTH);
        this[$d775a7189e817c48$var$$BUFFER] = buffer;
        this[$d775a7189e817c48$var$$OFFSET] = offset;
        this[$d775a7189e817c48$var$$LENGTH] = byteLength;
    };
    if ($cAHsA) {
        $d775a7189e817c48$var$addGetter($d775a7189e817c48$var$$ArrayBuffer, $d775a7189e817c48$var$BYTE_LENGTH, '_l');
        $d775a7189e817c48$var$addGetter($d775a7189e817c48$var$$DataView, $d775a7189e817c48$var$BUFFER, '_b');
        $d775a7189e817c48$var$addGetter($d775a7189e817c48$var$$DataView, $d775a7189e817c48$var$BYTE_LENGTH, '_l');
        $d775a7189e817c48$var$addGetter($d775a7189e817c48$var$$DataView, $d775a7189e817c48$var$BYTE_OFFSET, '_o');
    }
    $2aUHX($d775a7189e817c48$var$$DataView[$d775a7189e817c48$var$PROTOTYPE], {
        getInt8: function getInt8(byteOffset) {
            return $d775a7189e817c48$var$get(this, 1, byteOffset)[0] << 24 >> 24;
        },
        getUint8: function getUint8(byteOffset) {
            return $d775a7189e817c48$var$get(this, 1, byteOffset)[0];
        },
        getInt16: function getInt16(byteOffset /* , littleEndian */ ) {
            var bytes = $d775a7189e817c48$var$get(this, 2, byteOffset, arguments[1]);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
        },
        getUint16: function getUint16(byteOffset /* , littleEndian */ ) {
            var bytes = $d775a7189e817c48$var$get(this, 2, byteOffset, arguments[1]);
            return bytes[1] << 8 | bytes[0];
        },
        getInt32: function getInt32(byteOffset /* , littleEndian */ ) {
            return $d775a7189e817c48$var$unpackI32($d775a7189e817c48$var$get(this, 4, byteOffset, arguments[1]));
        },
        getUint32: function getUint32(byteOffset /* , littleEndian */ ) {
            return $d775a7189e817c48$var$unpackI32($d775a7189e817c48$var$get(this, 4, byteOffset, arguments[1])) >>> 0;
        },
        getFloat32: function getFloat32(byteOffset /* , littleEndian */ ) {
            return $d775a7189e817c48$var$unpackIEEE754($d775a7189e817c48$var$get(this, 4, byteOffset, arguments[1]), 23, 4);
        },
        getFloat64: function getFloat64(byteOffset /* , littleEndian */ ) {
            return $d775a7189e817c48$var$unpackIEEE754($d775a7189e817c48$var$get(this, 8, byteOffset, arguments[1]), 52, 8);
        },
        setInt8: function setInt8(byteOffset, value) {
            $d775a7189e817c48$var$set(this, 1, byteOffset, $d775a7189e817c48$var$packI8, value);
        },
        setUint8: function setUint8(byteOffset, value) {
            $d775a7189e817c48$var$set(this, 1, byteOffset, $d775a7189e817c48$var$packI8, value);
        },
        setInt16: function setInt16(byteOffset, value /* , littleEndian */ ) {
            $d775a7189e817c48$var$set(this, 2, byteOffset, $d775a7189e817c48$var$packI16, value, arguments[2]);
        },
        setUint16: function setUint16(byteOffset, value /* , littleEndian */ ) {
            $d775a7189e817c48$var$set(this, 2, byteOffset, $d775a7189e817c48$var$packI16, value, arguments[2]);
        },
        setInt32: function setInt32(byteOffset, value /* , littleEndian */ ) {
            $d775a7189e817c48$var$set(this, 4, byteOffset, $d775a7189e817c48$var$packI32, value, arguments[2]);
        },
        setUint32: function setUint32(byteOffset, value /* , littleEndian */ ) {
            $d775a7189e817c48$var$set(this, 4, byteOffset, $d775a7189e817c48$var$packI32, value, arguments[2]);
        },
        setFloat32: function setFloat32(byteOffset, value /* , littleEndian */ ) {
            $d775a7189e817c48$var$set(this, 4, byteOffset, $d775a7189e817c48$var$packF32, value, arguments[2]);
        },
        setFloat64: function setFloat64(byteOffset, value /* , littleEndian */ ) {
            $d775a7189e817c48$var$set(this, 8, byteOffset, $d775a7189e817c48$var$packF64, value, arguments[2]);
        }
    });
} else {
    if (!$gtdMs(function() {
        $d775a7189e817c48$var$$ArrayBuffer(1);
    }) || !$gtdMs(function() {
        new $d775a7189e817c48$var$$ArrayBuffer(-1); // eslint-disable-line no-new
    }) || $gtdMs(function() {
        new $d775a7189e817c48$var$$ArrayBuffer(); // eslint-disable-line no-new
        new $d775a7189e817c48$var$$ArrayBuffer(1.5); // eslint-disable-line no-new
        new $d775a7189e817c48$var$$ArrayBuffer(NaN); // eslint-disable-line no-new
        return $d775a7189e817c48$var$$ArrayBuffer.name != $d775a7189e817c48$var$ARRAY_BUFFER;
    })) {
        $d775a7189e817c48$var$$ArrayBuffer = function ArrayBuffer(length) {
            $bws30(this, $d775a7189e817c48$var$$ArrayBuffer);
            return new $d775a7189e817c48$var$BaseBuffer($4YEeq(length));
        };
        var $d775a7189e817c48$var$ArrayBufferProto = $d775a7189e817c48$var$$ArrayBuffer[$d775a7189e817c48$var$PROTOTYPE] = $d775a7189e817c48$var$BaseBuffer[$d775a7189e817c48$var$PROTOTYPE];
        for(var $d775a7189e817c48$var$keys = $d775a7189e817c48$require$gOPN($d775a7189e817c48$var$BaseBuffer), $d775a7189e817c48$var$j = 0, $d775a7189e817c48$var$key; $d775a7189e817c48$var$keys.length > $d775a7189e817c48$var$j;)if (!(($d775a7189e817c48$var$key = $d775a7189e817c48$var$keys[$d775a7189e817c48$var$j++]) in $d775a7189e817c48$var$$ArrayBuffer)) $fMiEZ($d775a7189e817c48$var$$ArrayBuffer, $d775a7189e817c48$var$key, $d775a7189e817c48$var$BaseBuffer[$d775a7189e817c48$var$key]);
        if (!$cE8bo) $d775a7189e817c48$var$ArrayBufferProto.constructor = $d775a7189e817c48$var$$ArrayBuffer;
    }
    // iOS Safari 7.x bug
    var $d775a7189e817c48$var$view = new $d775a7189e817c48$var$$DataView(new $d775a7189e817c48$var$$ArrayBuffer(2));
    var $d775a7189e817c48$var$$setInt8 = $d775a7189e817c48$var$$DataView[$d775a7189e817c48$var$PROTOTYPE].setInt8;
    $d775a7189e817c48$var$view.setInt8(0, 2147483648);
    $d775a7189e817c48$var$view.setInt8(1, 2147483649);
    if ($d775a7189e817c48$var$view.getInt8(0) || !$d775a7189e817c48$var$view.getInt8(1)) $2aUHX($d775a7189e817c48$var$$DataView[$d775a7189e817c48$var$PROTOTYPE], {
        setInt8: function setInt8(byteOffset, value) {
            $d775a7189e817c48$var$$setInt8.call(this, byteOffset, value << 24 >> 24);
        },
        setUint8: function setUint8(byteOffset, value) {
            $d775a7189e817c48$var$$setInt8.call(this, byteOffset, value << 24 >> 24);
        }
    }, true);
}
$6DkCi($d775a7189e817c48$var$$ArrayBuffer, $d775a7189e817c48$var$ARRAY_BUFFER);
$6DkCi($d775a7189e817c48$var$$DataView, $d775a7189e817c48$var$DATA_VIEW);
$fMiEZ($d775a7189e817c48$var$$DataView[$d775a7189e817c48$var$PROTOTYPE], $erNx4.VIEW, true);
module.exports[$d775a7189e817c48$var$ARRAY_BUFFER] = $d775a7189e817c48$var$$ArrayBuffer;
module.exports[$d775a7189e817c48$var$DATA_VIEW] = $d775a7189e817c48$var$$DataView;

});
parcelRegister("4YEeq", function(module, exports) {
// https://tc39.github.io/ecma262/#sec-toindex

var $U0K0I = parcelRequire("U0K0I");

var $igR5o = parcelRequire("igR5o");
module.exports = function(it) {
    if (it === undefined) return 0;
    var number = $U0K0I(it);
    var length = $igR5o(number);
    if (number !== length) throw RangeError('Wrong length!');
    return length;
};

});


parcelRegister("iwJAL", function(module, exports) {
'use strict';







































if ((parcelRequire("cAHsA"))) {
    var $d7ce94c999dcd738$var$LIBRARY = (parcelRequire("cE8bo"));
    var $d7ce94c999dcd738$var$global = (parcelRequire("jFKHr"));
    var $d7ce94c999dcd738$var$fails = (parcelRequire("gtdMs"));
    var $d7ce94c999dcd738$var$$export = (parcelRequire("fO65L"));
    var $d7ce94c999dcd738$var$$typed = (parcelRequire("erNx4"));
    var $d7ce94c999dcd738$var$$buffer = (parcelRequire("iuSWU"));
    var $d7ce94c999dcd738$var$ctx = (parcelRequire("ATdaw"));
    var $d7ce94c999dcd738$var$anInstance = (parcelRequire("bws30"));
    var $d7ce94c999dcd738$var$propertyDesc = (parcelRequire("fTxIB"));
    var $d7ce94c999dcd738$var$hide = (parcelRequire("fMiEZ"));
    var $d7ce94c999dcd738$var$redefineAll = (parcelRequire("2aUHX"));
    var $d7ce94c999dcd738$var$toInteger = (parcelRequire("U0K0I"));
    var $d7ce94c999dcd738$var$toLength = (parcelRequire("igR5o"));
    var $d7ce94c999dcd738$var$toIndex = (parcelRequire("4YEeq"));
    var $d7ce94c999dcd738$var$toAbsoluteIndex = (parcelRequire("iWPS0"));
    var $d7ce94c999dcd738$var$toPrimitive = (parcelRequire("ltjni"));
    var $d7ce94c999dcd738$var$has = (parcelRequire("jdXyk"));
    var $d7ce94c999dcd738$var$classof = (parcelRequire("8iPtU"));
    var $d7ce94c999dcd738$var$isObject = (parcelRequire("1WkAz"));
    var $d7ce94c999dcd738$var$toObject = (parcelRequire("eb8lU"));
    var $d7ce94c999dcd738$var$isArrayIter = (parcelRequire("bRXyE"));
    var $d7ce94c999dcd738$var$create = (parcelRequire("lUyCu"));
    var $d7ce94c999dcd738$var$getPrototypeOf = (parcelRequire("6yhFg"));
    var $d7ce94c999dcd738$var$gOPN = (parcelRequire("9B1GU")).f;
    var $d7ce94c999dcd738$var$getIterFn = (parcelRequire("fm12X"));
    var $d7ce94c999dcd738$var$uid = (parcelRequire("kZJHg"));
    var $d7ce94c999dcd738$var$wks = (parcelRequire("kC7Sb"));
    var $d7ce94c999dcd738$var$createArrayMethod = (parcelRequire("d90U1"));
    var $d7ce94c999dcd738$var$createArrayIncludes = (parcelRequire("fhIl3"));
    var $d7ce94c999dcd738$var$speciesConstructor = (parcelRequire("cn7DE"));
    var $d7ce94c999dcd738$var$ArrayIterators = (parcelRequire("lA4ZU"));
    var $d7ce94c999dcd738$var$Iterators = (parcelRequire("3QMgK"));
    var $d7ce94c999dcd738$var$$iterDetect = (parcelRequire("5HrAP"));
    var $d7ce94c999dcd738$var$setSpecies = (parcelRequire("68OYb"));
    var $d7ce94c999dcd738$var$arrayFill = (parcelRequire("fC6rw"));
    var $d7ce94c999dcd738$var$arrayCopyWithin = (parcelRequire("blz7k"));
    var $d7ce94c999dcd738$var$$DP = (parcelRequire("lhvOa"));
    var $d7ce94c999dcd738$var$$GOPD = (parcelRequire("6VRFP"));
    var $d7ce94c999dcd738$var$dP = $d7ce94c999dcd738$var$$DP.f;
    var $d7ce94c999dcd738$var$gOPD = $d7ce94c999dcd738$var$$GOPD.f;
    var $d7ce94c999dcd738$var$RangeError = $d7ce94c999dcd738$var$global.RangeError;
    var $d7ce94c999dcd738$var$TypeError = $d7ce94c999dcd738$var$global.TypeError;
    var $d7ce94c999dcd738$var$Uint8Array = $d7ce94c999dcd738$var$global.Uint8Array;
    var $d7ce94c999dcd738$var$ARRAY_BUFFER = 'ArrayBuffer';
    var $d7ce94c999dcd738$var$SHARED_BUFFER = 'Shared' + $d7ce94c999dcd738$var$ARRAY_BUFFER;
    var $d7ce94c999dcd738$var$BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
    var $d7ce94c999dcd738$var$PROTOTYPE = 'prototype';
    var $d7ce94c999dcd738$var$ArrayProto = Array[$d7ce94c999dcd738$var$PROTOTYPE];
    var $d7ce94c999dcd738$var$$ArrayBuffer = $d7ce94c999dcd738$var$$buffer.ArrayBuffer;
    var $d7ce94c999dcd738$var$$DataView = $d7ce94c999dcd738$var$$buffer.DataView;
    var $d7ce94c999dcd738$var$arrayForEach = $d7ce94c999dcd738$var$createArrayMethod(0);
    var $d7ce94c999dcd738$var$arrayFilter = $d7ce94c999dcd738$var$createArrayMethod(2);
    var $d7ce94c999dcd738$var$arraySome = $d7ce94c999dcd738$var$createArrayMethod(3);
    var $d7ce94c999dcd738$var$arrayEvery = $d7ce94c999dcd738$var$createArrayMethod(4);
    var $d7ce94c999dcd738$var$arrayFind = $d7ce94c999dcd738$var$createArrayMethod(5);
    var $d7ce94c999dcd738$var$arrayFindIndex = $d7ce94c999dcd738$var$createArrayMethod(6);
    var $d7ce94c999dcd738$var$arrayIncludes = $d7ce94c999dcd738$var$createArrayIncludes(true);
    var $d7ce94c999dcd738$var$arrayIndexOf = $d7ce94c999dcd738$var$createArrayIncludes(false);
    var $d7ce94c999dcd738$var$arrayValues = $d7ce94c999dcd738$var$ArrayIterators.values;
    var $d7ce94c999dcd738$var$arrayKeys = $d7ce94c999dcd738$var$ArrayIterators.keys;
    var $d7ce94c999dcd738$var$arrayEntries = $d7ce94c999dcd738$var$ArrayIterators.entries;
    var $d7ce94c999dcd738$var$arrayLastIndexOf = $d7ce94c999dcd738$var$ArrayProto.lastIndexOf;
    var $d7ce94c999dcd738$var$arrayReduce = $d7ce94c999dcd738$var$ArrayProto.reduce;
    var $d7ce94c999dcd738$var$arrayReduceRight = $d7ce94c999dcd738$var$ArrayProto.reduceRight;
    var $d7ce94c999dcd738$var$arrayJoin = $d7ce94c999dcd738$var$ArrayProto.join;
    var $d7ce94c999dcd738$var$arraySort = $d7ce94c999dcd738$var$ArrayProto.sort;
    var $d7ce94c999dcd738$var$arraySlice = $d7ce94c999dcd738$var$ArrayProto.slice;
    var $d7ce94c999dcd738$var$arrayToString = $d7ce94c999dcd738$var$ArrayProto.toString;
    var $d7ce94c999dcd738$var$arrayToLocaleString = $d7ce94c999dcd738$var$ArrayProto.toLocaleString;
    var $d7ce94c999dcd738$var$ITERATOR = $d7ce94c999dcd738$var$wks('iterator');
    var $d7ce94c999dcd738$var$TAG = $d7ce94c999dcd738$var$wks('toStringTag');
    var $d7ce94c999dcd738$var$TYPED_CONSTRUCTOR = $d7ce94c999dcd738$var$uid('typed_constructor');
    var $d7ce94c999dcd738$var$DEF_CONSTRUCTOR = $d7ce94c999dcd738$var$uid('def_constructor');
    var $d7ce94c999dcd738$var$ALL_CONSTRUCTORS = $d7ce94c999dcd738$var$$typed.CONSTR;
    var $d7ce94c999dcd738$var$TYPED_ARRAY = $d7ce94c999dcd738$var$$typed.TYPED;
    var $d7ce94c999dcd738$var$VIEW = $d7ce94c999dcd738$var$$typed.VIEW;
    var $d7ce94c999dcd738$var$WRONG_LENGTH = 'Wrong length!';
    var $d7ce94c999dcd738$var$$map = $d7ce94c999dcd738$var$createArrayMethod(1, function(O, length) {
        return $d7ce94c999dcd738$var$allocate($d7ce94c999dcd738$var$speciesConstructor(O, O[$d7ce94c999dcd738$var$DEF_CONSTRUCTOR]), length);
    });
    var $d7ce94c999dcd738$var$LITTLE_ENDIAN = $d7ce94c999dcd738$var$fails(function() {
        // eslint-disable-next-line no-undef
        return new $d7ce94c999dcd738$var$Uint8Array(new Uint16Array([
            1
        ]).buffer)[0] === 1;
    });
    var $d7ce94c999dcd738$var$FORCED_SET = !!$d7ce94c999dcd738$var$Uint8Array && !!$d7ce94c999dcd738$var$Uint8Array[$d7ce94c999dcd738$var$PROTOTYPE].set && $d7ce94c999dcd738$var$fails(function() {
        new $d7ce94c999dcd738$var$Uint8Array(1).set({});
    });
    var $d7ce94c999dcd738$var$toOffset = function(it, BYTES) {
        var offset = $d7ce94c999dcd738$var$toInteger(it);
        if (offset < 0 || offset % BYTES) throw $d7ce94c999dcd738$var$RangeError('Wrong offset!');
        return offset;
    };
    var $d7ce94c999dcd738$var$validate = function(it) {
        if ($d7ce94c999dcd738$var$isObject(it) && $d7ce94c999dcd738$var$TYPED_ARRAY in it) return it;
        throw $d7ce94c999dcd738$var$TypeError(it + ' is not a typed array!');
    };
    var $d7ce94c999dcd738$var$allocate = function(C, length) {
        if (!($d7ce94c999dcd738$var$isObject(C) && $d7ce94c999dcd738$var$TYPED_CONSTRUCTOR in C)) throw $d7ce94c999dcd738$var$TypeError('It is not a typed array constructor!');
        return new C(length);
    };
    var $d7ce94c999dcd738$var$speciesFromList = function(O, list) {
        return $d7ce94c999dcd738$var$fromList($d7ce94c999dcd738$var$speciesConstructor(O, O[$d7ce94c999dcd738$var$DEF_CONSTRUCTOR]), list);
    };
    var $d7ce94c999dcd738$var$fromList = function(C, list) {
        var index = 0;
        var length = list.length;
        var result = $d7ce94c999dcd738$var$allocate(C, length);
        while(length > index)result[index] = list[index++];
        return result;
    };
    var $d7ce94c999dcd738$var$addGetter = function(it, key, internal) {
        $d7ce94c999dcd738$var$dP(it, key, {
            get: function() {
                return this._d[internal];
            }
        });
    };
    var $d7ce94c999dcd738$var$$from = function from(source /* , mapfn, thisArg */ ) {
        var O = $d7ce94c999dcd738$var$toObject(source);
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var iterFn = $d7ce94c999dcd738$var$getIterFn(O);
        var i, length, values, result, step, iterator;
        if (iterFn != undefined && !$d7ce94c999dcd738$var$isArrayIter(iterFn)) {
            for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++)values.push(step.value);
            O = values;
        }
        if (mapping && aLen > 2) mapfn = $d7ce94c999dcd738$var$ctx(mapfn, arguments[2], 2);
        for(i = 0, length = $d7ce94c999dcd738$var$toLength(O.length), result = $d7ce94c999dcd738$var$allocate(this, length); length > i; i++)result[i] = mapping ? mapfn(O[i], i) : O[i];
        return result;
    };
    var $d7ce94c999dcd738$var$$of = function of() {
        var index = 0;
        var length = arguments.length;
        var result = $d7ce94c999dcd738$var$allocate(this, length);
        while(length > index)result[index] = arguments[index++];
        return result;
    };
    // iOS Safari 6.x fails here
    var $d7ce94c999dcd738$var$TO_LOCALE_BUG = !!$d7ce94c999dcd738$var$Uint8Array && $d7ce94c999dcd738$var$fails(function() {
        $d7ce94c999dcd738$var$arrayToLocaleString.call(new $d7ce94c999dcd738$var$Uint8Array(1));
    });
    var $d7ce94c999dcd738$var$$toLocaleString = function toLocaleString() {
        return $d7ce94c999dcd738$var$arrayToLocaleString.apply($d7ce94c999dcd738$var$TO_LOCALE_BUG ? $d7ce94c999dcd738$var$arraySlice.call($d7ce94c999dcd738$var$validate(this)) : $d7ce94c999dcd738$var$validate(this), arguments);
    };
    var $d7ce94c999dcd738$var$proto = {
        copyWithin: function copyWithin(target, start /* , end */ ) {
            return $d7ce94c999dcd738$var$arrayCopyWithin.call($d7ce94c999dcd738$var$validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
        },
        every: function every(callbackfn /* , thisArg */ ) {
            return $d7ce94c999dcd738$var$arrayEvery($d7ce94c999dcd738$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        fill: function fill(value /* , start, end */ ) {
            return $d7ce94c999dcd738$var$arrayFill.apply($d7ce94c999dcd738$var$validate(this), arguments);
        },
        filter: function filter(callbackfn /* , thisArg */ ) {
            return $d7ce94c999dcd738$var$speciesFromList(this, $d7ce94c999dcd738$var$arrayFilter($d7ce94c999dcd738$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
        },
        find: function find(predicate /* , thisArg */ ) {
            return $d7ce94c999dcd738$var$arrayFind($d7ce94c999dcd738$var$validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        },
        findIndex: function findIndex(predicate /* , thisArg */ ) {
            return $d7ce94c999dcd738$var$arrayFindIndex($d7ce94c999dcd738$var$validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        },
        forEach: function forEach(callbackfn /* , thisArg */ ) {
            $d7ce94c999dcd738$var$arrayForEach($d7ce94c999dcd738$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        indexOf: function indexOf(searchElement /* , fromIndex */ ) {
            return $d7ce94c999dcd738$var$arrayIndexOf($d7ce94c999dcd738$var$validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        },
        includes: function includes(searchElement /* , fromIndex */ ) {
            return $d7ce94c999dcd738$var$arrayIncludes($d7ce94c999dcd738$var$validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        },
        join: function join(separator) {
            return $d7ce94c999dcd738$var$arrayJoin.apply($d7ce94c999dcd738$var$validate(this), arguments);
        },
        lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */ ) {
            return $d7ce94c999dcd738$var$arrayLastIndexOf.apply($d7ce94c999dcd738$var$validate(this), arguments);
        },
        map: function map(mapfn /* , thisArg */ ) {
            return $d7ce94c999dcd738$var$$map($d7ce94c999dcd738$var$validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        reduce: function reduce(callbackfn /* , initialValue */ ) {
            return $d7ce94c999dcd738$var$arrayReduce.apply($d7ce94c999dcd738$var$validate(this), arguments);
        },
        reduceRight: function reduceRight(callbackfn /* , initialValue */ ) {
            return $d7ce94c999dcd738$var$arrayReduceRight.apply($d7ce94c999dcd738$var$validate(this), arguments);
        },
        reverse: function reverse() {
            var that = this;
            var length = $d7ce94c999dcd738$var$validate(that).length;
            var middle = Math.floor(length / 2);
            var index = 0;
            var value;
            while(index < middle){
                value = that[index];
                that[index++] = that[--length];
                that[length] = value;
            }
            return that;
        },
        some: function some(callbackfn /* , thisArg */ ) {
            return $d7ce94c999dcd738$var$arraySome($d7ce94c999dcd738$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        sort: function sort(comparefn) {
            return $d7ce94c999dcd738$var$arraySort.call($d7ce94c999dcd738$var$validate(this), comparefn);
        },
        subarray: function subarray(begin, end) {
            var O = $d7ce94c999dcd738$var$validate(this);
            var length = O.length;
            var $begin = $d7ce94c999dcd738$var$toAbsoluteIndex(begin, length);
            return new ($d7ce94c999dcd738$var$speciesConstructor(O, O[$d7ce94c999dcd738$var$DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, $d7ce94c999dcd738$var$toLength((end === undefined ? length : $d7ce94c999dcd738$var$toAbsoluteIndex(end, length)) - $begin));
        }
    };
    var $d7ce94c999dcd738$var$$slice = function slice(start, end) {
        return $d7ce94c999dcd738$var$speciesFromList(this, $d7ce94c999dcd738$var$arraySlice.call($d7ce94c999dcd738$var$validate(this), start, end));
    };
    var $d7ce94c999dcd738$var$$set = function set(arrayLike /* , offset */ ) {
        $d7ce94c999dcd738$var$validate(this);
        var offset = $d7ce94c999dcd738$var$toOffset(arguments[1], 1);
        var length = this.length;
        var src = $d7ce94c999dcd738$var$toObject(arrayLike);
        var len = $d7ce94c999dcd738$var$toLength(src.length);
        var index = 0;
        if (len + offset > length) throw $d7ce94c999dcd738$var$RangeError($d7ce94c999dcd738$var$WRONG_LENGTH);
        while(index < len)this[offset + index] = src[index++];
    };
    var $d7ce94c999dcd738$var$$iterators = {
        entries: function entries() {
            return $d7ce94c999dcd738$var$arrayEntries.call($d7ce94c999dcd738$var$validate(this));
        },
        keys: function keys() {
            return $d7ce94c999dcd738$var$arrayKeys.call($d7ce94c999dcd738$var$validate(this));
        },
        values: function values() {
            return $d7ce94c999dcd738$var$arrayValues.call($d7ce94c999dcd738$var$validate(this));
        }
    };
    var $d7ce94c999dcd738$var$isTAIndex = function(target, key) {
        return $d7ce94c999dcd738$var$isObject(target) && target[$d7ce94c999dcd738$var$TYPED_ARRAY] && typeof key != 'symbol' && key in target && String(+key) == String(key);
    };
    var $d7ce94c999dcd738$var$$getDesc = function getOwnPropertyDescriptor(target, key) {
        return $d7ce94c999dcd738$var$isTAIndex(target, key = $d7ce94c999dcd738$var$toPrimitive(key, true)) ? $d7ce94c999dcd738$var$propertyDesc(2, target[key]) : $d7ce94c999dcd738$var$gOPD(target, key);
    };
    var $d7ce94c999dcd738$var$$setDesc = function defineProperty(target, key, desc) {
        if ($d7ce94c999dcd738$var$isTAIndex(target, key = $d7ce94c999dcd738$var$toPrimitive(key, true)) && $d7ce94c999dcd738$var$isObject(desc) && $d7ce94c999dcd738$var$has(desc, 'value') && !$d7ce94c999dcd738$var$has(desc, 'get') && !$d7ce94c999dcd738$var$has(desc, 'set') && !desc.configurable && (!$d7ce94c999dcd738$var$has(desc, 'writable') || desc.writable) && (!$d7ce94c999dcd738$var$has(desc, 'enumerable') || desc.enumerable)) {
            target[key] = desc.value;
            return target;
        }
        return $d7ce94c999dcd738$var$dP(target, key, desc);
    };
    if (!$d7ce94c999dcd738$var$ALL_CONSTRUCTORS) {
        $d7ce94c999dcd738$var$$GOPD.f = $d7ce94c999dcd738$var$$getDesc;
        $d7ce94c999dcd738$var$$DP.f = $d7ce94c999dcd738$var$$setDesc;
    }
    $d7ce94c999dcd738$var$$export($d7ce94c999dcd738$var$$export.S + $d7ce94c999dcd738$var$$export.F * !$d7ce94c999dcd738$var$ALL_CONSTRUCTORS, 'Object', {
        getOwnPropertyDescriptor: $d7ce94c999dcd738$var$$getDesc,
        defineProperty: $d7ce94c999dcd738$var$$setDesc
    });
    if ($d7ce94c999dcd738$var$fails(function() {
        $d7ce94c999dcd738$var$arrayToString.call({});
    })) $d7ce94c999dcd738$var$arrayToString = $d7ce94c999dcd738$var$arrayToLocaleString = function toString() {
        return $d7ce94c999dcd738$var$arrayJoin.call(this);
    };
    var $d7ce94c999dcd738$var$$TypedArrayPrototype$ = $d7ce94c999dcd738$var$redefineAll({}, $d7ce94c999dcd738$var$proto);
    $d7ce94c999dcd738$var$redefineAll($d7ce94c999dcd738$var$$TypedArrayPrototype$, $d7ce94c999dcd738$var$$iterators);
    $d7ce94c999dcd738$var$hide($d7ce94c999dcd738$var$$TypedArrayPrototype$, $d7ce94c999dcd738$var$ITERATOR, $d7ce94c999dcd738$var$$iterators.values);
    $d7ce94c999dcd738$var$redefineAll($d7ce94c999dcd738$var$$TypedArrayPrototype$, {
        slice: $d7ce94c999dcd738$var$$slice,
        set: $d7ce94c999dcd738$var$$set,
        constructor: function() {},
        toString: $d7ce94c999dcd738$var$arrayToString,
        toLocaleString: $d7ce94c999dcd738$var$$toLocaleString
    });
    $d7ce94c999dcd738$var$addGetter($d7ce94c999dcd738$var$$TypedArrayPrototype$, 'buffer', 'b');
    $d7ce94c999dcd738$var$addGetter($d7ce94c999dcd738$var$$TypedArrayPrototype$, 'byteOffset', 'o');
    $d7ce94c999dcd738$var$addGetter($d7ce94c999dcd738$var$$TypedArrayPrototype$, 'byteLength', 'l');
    $d7ce94c999dcd738$var$addGetter($d7ce94c999dcd738$var$$TypedArrayPrototype$, 'length', 'e');
    $d7ce94c999dcd738$var$dP($d7ce94c999dcd738$var$$TypedArrayPrototype$, $d7ce94c999dcd738$var$TAG, {
        get: function() {
            return this[$d7ce94c999dcd738$var$TYPED_ARRAY];
        }
    });
    // eslint-disable-next-line max-statements
    module.exports = function(KEY, BYTES, wrapper, CLAMPED) {
        CLAMPED = !!CLAMPED;
        var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
        var GETTER = 'get' + KEY;
        var SETTER = 'set' + KEY;
        var TypedArray = $d7ce94c999dcd738$var$global[NAME];
        var Base = TypedArray || {};
        var TAC = TypedArray && $d7ce94c999dcd738$var$getPrototypeOf(TypedArray);
        var FORCED = !TypedArray || !$d7ce94c999dcd738$var$$typed.ABV;
        var O = {};
        var TypedArrayPrototype = TypedArray && TypedArray[$d7ce94c999dcd738$var$PROTOTYPE];
        var getter = function(that, index) {
            var data = that._d;
            return data.v[GETTER](index * BYTES + data.o, $d7ce94c999dcd738$var$LITTLE_ENDIAN);
        };
        var setter = function(that, index, value) {
            var data = that._d;
            if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
            data.v[SETTER](index * BYTES + data.o, value, $d7ce94c999dcd738$var$LITTLE_ENDIAN);
        };
        var addElement = function(that, index) {
            $d7ce94c999dcd738$var$dP(that, index, {
                get: function() {
                    return getter(this, index);
                },
                set: function(value) {
                    return setter(this, index, value);
                },
                enumerable: true
            });
        };
        if (FORCED) {
            TypedArray = wrapper(function(that, data, $offset, $length) {
                $d7ce94c999dcd738$var$anInstance(that, TypedArray, NAME, '_d');
                var index = 0;
                var offset = 0;
                var buffer, byteLength, length, klass;
                if (!$d7ce94c999dcd738$var$isObject(data)) {
                    length = $d7ce94c999dcd738$var$toIndex(data);
                    byteLength = length * BYTES;
                    buffer = new $d7ce94c999dcd738$var$$ArrayBuffer(byteLength);
                } else if (data instanceof $d7ce94c999dcd738$var$$ArrayBuffer || (klass = $d7ce94c999dcd738$var$classof(data)) == $d7ce94c999dcd738$var$ARRAY_BUFFER || klass == $d7ce94c999dcd738$var$SHARED_BUFFER) {
                    buffer = data;
                    offset = $d7ce94c999dcd738$var$toOffset($offset, BYTES);
                    var $len = data.byteLength;
                    if ($length === undefined) {
                        if ($len % BYTES) throw $d7ce94c999dcd738$var$RangeError($d7ce94c999dcd738$var$WRONG_LENGTH);
                        byteLength = $len - offset;
                        if (byteLength < 0) throw $d7ce94c999dcd738$var$RangeError($d7ce94c999dcd738$var$WRONG_LENGTH);
                    } else {
                        byteLength = $d7ce94c999dcd738$var$toLength($length) * BYTES;
                        if (byteLength + offset > $len) throw $d7ce94c999dcd738$var$RangeError($d7ce94c999dcd738$var$WRONG_LENGTH);
                    }
                    length = byteLength / BYTES;
                } else if ($d7ce94c999dcd738$var$TYPED_ARRAY in data) return $d7ce94c999dcd738$var$fromList(TypedArray, data);
                else return $d7ce94c999dcd738$var$$from.call(TypedArray, data);
                $d7ce94c999dcd738$var$hide(that, '_d', {
                    b: buffer,
                    o: offset,
                    l: byteLength,
                    e: length,
                    v: new $d7ce94c999dcd738$var$$DataView(buffer)
                });
                while(index < length)addElement(that, index++);
            });
            TypedArrayPrototype = TypedArray[$d7ce94c999dcd738$var$PROTOTYPE] = $d7ce94c999dcd738$var$create($d7ce94c999dcd738$var$$TypedArrayPrototype$);
            $d7ce94c999dcd738$var$hide(TypedArrayPrototype, 'constructor', TypedArray);
        } else if (!$d7ce94c999dcd738$var$fails(function() {
            TypedArray(1);
        }) || !$d7ce94c999dcd738$var$fails(function() {
            new TypedArray(-1); // eslint-disable-line no-new
        }) || !$d7ce94c999dcd738$var$$iterDetect(function(iter) {
            new TypedArray(); // eslint-disable-line no-new
            new TypedArray(null); // eslint-disable-line no-new
            new TypedArray(1.5); // eslint-disable-line no-new
            new TypedArray(iter); // eslint-disable-line no-new
        }, true)) {
            TypedArray = wrapper(function(that, data, $offset, $length) {
                $d7ce94c999dcd738$var$anInstance(that, TypedArray, NAME);
                var klass;
                // `ws` module bug, temporarily remove validation length for Uint8Array
                // https://github.com/websockets/ws/pull/645
                if (!$d7ce94c999dcd738$var$isObject(data)) return new Base($d7ce94c999dcd738$var$toIndex(data));
                if (data instanceof $d7ce94c999dcd738$var$$ArrayBuffer || (klass = $d7ce94c999dcd738$var$classof(data)) == $d7ce94c999dcd738$var$ARRAY_BUFFER || klass == $d7ce94c999dcd738$var$SHARED_BUFFER) return $length !== undefined ? new Base(data, $d7ce94c999dcd738$var$toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, $d7ce94c999dcd738$var$toOffset($offset, BYTES)) : new Base(data);
                if ($d7ce94c999dcd738$var$TYPED_ARRAY in data) return $d7ce94c999dcd738$var$fromList(TypedArray, data);
                return $d7ce94c999dcd738$var$$from.call(TypedArray, data);
            });
            $d7ce94c999dcd738$var$arrayForEach(TAC !== Function.prototype ? $d7ce94c999dcd738$var$gOPN(Base).concat($d7ce94c999dcd738$var$gOPN(TAC)) : $d7ce94c999dcd738$var$gOPN(Base), function(key) {
                if (!(key in TypedArray)) $d7ce94c999dcd738$var$hide(TypedArray, key, Base[key]);
            });
            TypedArray[$d7ce94c999dcd738$var$PROTOTYPE] = TypedArrayPrototype;
            if (!$d7ce94c999dcd738$var$LIBRARY) TypedArrayPrototype.constructor = TypedArray;
        }
        var $nativeIterator = TypedArrayPrototype[$d7ce94c999dcd738$var$ITERATOR];
        var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
        var $iterator = $d7ce94c999dcd738$var$$iterators.values;
        $d7ce94c999dcd738$var$hide(TypedArray, $d7ce94c999dcd738$var$TYPED_CONSTRUCTOR, true);
        $d7ce94c999dcd738$var$hide(TypedArrayPrototype, $d7ce94c999dcd738$var$TYPED_ARRAY, NAME);
        $d7ce94c999dcd738$var$hide(TypedArrayPrototype, $d7ce94c999dcd738$var$VIEW, true);
        $d7ce94c999dcd738$var$hide(TypedArrayPrototype, $d7ce94c999dcd738$var$DEF_CONSTRUCTOR, TypedArray);
        if (CLAMPED ? new TypedArray(1)[$d7ce94c999dcd738$var$TAG] != NAME : !($d7ce94c999dcd738$var$TAG in TypedArrayPrototype)) $d7ce94c999dcd738$var$dP(TypedArrayPrototype, $d7ce94c999dcd738$var$TAG, {
            get: function() {
                return NAME;
            }
        });
        O[NAME] = TypedArray;
        $d7ce94c999dcd738$var$$export($d7ce94c999dcd738$var$$export.G + $d7ce94c999dcd738$var$$export.W + $d7ce94c999dcd738$var$$export.F * (TypedArray != Base), O);
        $d7ce94c999dcd738$var$$export($d7ce94c999dcd738$var$$export.S, NAME, {
            BYTES_PER_ELEMENT: BYTES
        });
        $d7ce94c999dcd738$var$$export($d7ce94c999dcd738$var$$export.S + $d7ce94c999dcd738$var$$export.F * $d7ce94c999dcd738$var$fails(function() {
            Base.of.call(TypedArray, 1);
        }), NAME, {
            from: $d7ce94c999dcd738$var$$from,
            of: $d7ce94c999dcd738$var$$of
        });
        if (!($d7ce94c999dcd738$var$BYTES_PER_ELEMENT in TypedArrayPrototype)) $d7ce94c999dcd738$var$hide(TypedArrayPrototype, $d7ce94c999dcd738$var$BYTES_PER_ELEMENT, BYTES);
        $d7ce94c999dcd738$var$$export($d7ce94c999dcd738$var$$export.P, NAME, $d7ce94c999dcd738$var$proto);
        $d7ce94c999dcd738$var$setSpecies(NAME);
        $d7ce94c999dcd738$var$$export($d7ce94c999dcd738$var$$export.P + $d7ce94c999dcd738$var$$export.F * $d7ce94c999dcd738$var$FORCED_SET, NAME, {
            set: $d7ce94c999dcd738$var$$set
        });
        $d7ce94c999dcd738$var$$export($d7ce94c999dcd738$var$$export.P + $d7ce94c999dcd738$var$$export.F * !CORRECT_ITER_NAME, NAME, $d7ce94c999dcd738$var$$iterators);
        if (!$d7ce94c999dcd738$var$LIBRARY && TypedArrayPrototype.toString != $d7ce94c999dcd738$var$arrayToString) TypedArrayPrototype.toString = $d7ce94c999dcd738$var$arrayToString;
        $d7ce94c999dcd738$var$$export($d7ce94c999dcd738$var$$export.P + $d7ce94c999dcd738$var$$export.F * $d7ce94c999dcd738$var$fails(function() {
            new TypedArray(1).slice();
        }), NAME, {
            slice: $d7ce94c999dcd738$var$$slice
        });
        $d7ce94c999dcd738$var$$export($d7ce94c999dcd738$var$$export.P + $d7ce94c999dcd738$var$$export.F * ($d7ce94c999dcd738$var$fails(function() {
            return [
                1,
                2
            ].toLocaleString() != new TypedArray([
                1,
                2
            ]).toLocaleString();
        }) || !$d7ce94c999dcd738$var$fails(function() {
            TypedArrayPrototype.toLocaleString.call([
                1,
                2
            ]);
        })), NAME, {
            toLocaleString: $d7ce94c999dcd738$var$$toLocaleString
        });
        $d7ce94c999dcd738$var$Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
        if (!$d7ce94c999dcd738$var$LIBRARY && !CORRECT_ITER_NAME) $d7ce94c999dcd738$var$hide(TypedArrayPrototype, $d7ce94c999dcd738$var$ITERATOR, $iterator);
    };
} else module.exports = function() {};

});

parcelRegister("qCZj5", function(module, exports) {
// all object keys, includes non-enumerable and symbols

var $9B1GU = parcelRequire("9B1GU");

var $1idHk = parcelRequire("1idHk");

var $978rB = parcelRequire("978rB");

var $jFKHr = parcelRequire("jFKHr");
var $0500abfdec983865$require$Reflect = $jFKHr.Reflect;
module.exports = $0500abfdec983865$require$Reflect && $0500abfdec983865$require$Reflect.ownKeys || function ownKeys(it) {
    var keys = $9B1GU.f($978rB(it));
    var getSymbols = $1idHk.f;
    return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

});

parcelRegister("bW4tA", function(module, exports) {

var $cAHsA = parcelRequire("cAHsA");

var $62EBp = parcelRequire("62EBp");

var $3hDAb = parcelRequire("3hDAb");

var $1iccq = parcelRequire("1iccq");
var $8b089560ed724697$require$isEnum = $1iccq.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $3hDAb(it);
        var keys = $62EBp(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$cAHsA || $8b089560ed724697$require$isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

});

parcelRegister("9PRTm", function(module, exports) {
parcelRequire("2Nwq6");

module.exports = (parcelRequire("7YFBm")).global;

});
parcelRegister("2Nwq6", function(module, exports) {
// https://github.com/tc39/proposal-global

var $1ll82 = parcelRequire("1ll82");

$1ll82($1ll82.G, {
    global: (parcelRequire("htVSy"))
});

});
parcelRegister("1ll82", function(module, exports) {

var $htVSy = parcelRequire("htVSy");

var $7YFBm = parcelRequire("7YFBm");

var $8AGx5 = parcelRequire("8AGx5");

var $639fb = parcelRequire("639fb");

var $lKcpp = parcelRequire("lKcpp");
var $0fa824538d159939$var$PROTOTYPE = 'prototype';
var $0fa824538d159939$var$$export = function(type, name, source) {
    var IS_FORCED = type & $0fa824538d159939$var$$export.F;
    var IS_GLOBAL = type & $0fa824538d159939$var$$export.G;
    var IS_STATIC = type & $0fa824538d159939$var$$export.S;
    var IS_PROTO = type & $0fa824538d159939$var$$export.P;
    var IS_BIND = type & $0fa824538d159939$var$$export.B;
    var IS_WRAP = type & $0fa824538d159939$var$$export.W;
    var exports = IS_GLOBAL ? $7YFBm : $7YFBm[name] || ($7YFBm[name] = {});
    var expProto = exports[$0fa824538d159939$var$PROTOTYPE];
    var target = IS_GLOBAL ? $htVSy : IS_STATIC ? $htVSy[name] : ($htVSy[name] || {})[$0fa824538d159939$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $lKcpp(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $8AGx5(out, $htVSy) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$0fa824538d159939$var$PROTOTYPE] = C[$0fa824538d159939$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $8AGx5(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $0fa824538d159939$var$$export.R && expProto && !expProto[key]) $639fb(expProto, key, out);
        }
    }
};
// type bitmap
$0fa824538d159939$var$$export.F = 1; // forced
$0fa824538d159939$var$$export.G = 2; // global
$0fa824538d159939$var$$export.S = 4; // static
$0fa824538d159939$var$$export.P = 8; // proto
$0fa824538d159939$var$$export.B = 16; // bind
$0fa824538d159939$var$$export.W = 32; // wrap
$0fa824538d159939$var$$export.U = 64; // safe
$0fa824538d159939$var$$export.R = 128; // real proto method for `library`
module.exports = $0fa824538d159939$var$$export;

});
parcelRegister("htVSy", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $cba20aabf55975d6$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $cba20aabf55975d6$var$global; // eslint-disable-line no-undef

});

parcelRegister("7YFBm", function(module, exports) {
var $5cee6835e9da8ec2$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $5cee6835e9da8ec2$var$core; // eslint-disable-line no-undef

});

parcelRegister("8AGx5", function(module, exports) {
// optional / simple context binding

var $7bVtq = parcelRequire("7bVtq");
module.exports = function(fn, that, length) {
    $7bVtq(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("7bVtq", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("639fb", function(module, exports) {

var $6ch21 = parcelRequire("6ch21");

var $fP2G4 = parcelRequire("fP2G4");

module.exports = (parcelRequire("2pbds")) ? function(object, key, value) {
    return $6ch21.f(object, key, $fP2G4(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("6ch21", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $483113348b0d5dd8$export$2d1720544b23b823; }, function (v) { return $483113348b0d5dd8$export$2d1720544b23b823 = v; });
var $483113348b0d5dd8$export$2d1720544b23b823;

var $cSiec = parcelRequire("cSiec");

var $dWWat = parcelRequire("dWWat");

var $fgM76 = parcelRequire("fgM76");
var $483113348b0d5dd8$var$dP = Object.defineProperty;

$483113348b0d5dd8$export$2d1720544b23b823 = (parcelRequire("2pbds")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $cSiec(O);
    P = $fgM76(P, true);
    $cSiec(Attributes);
    if ($dWWat) try {
        return $483113348b0d5dd8$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("cSiec", function(module, exports) {

var $8VkWk = parcelRequire("8VkWk");
module.exports = function(it) {
    if (!$8VkWk(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("8VkWk", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("dWWat", function(module, exports) {



module.exports = !(parcelRequire("2pbds")) && !(parcelRequire("bUTld"))(function() {
    return Object.defineProperty((parcelRequire("4anee"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("2pbds", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("bUTld"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("bUTld", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("4anee", function(module, exports) {

var $8VkWk = parcelRequire("8VkWk");

var $htVSy = parcelRequire("htVSy");
var $308a1d4d1ca1ffac$require$document = $htVSy.document;
// typeof document.createElement is 'object' in old IE
var $308a1d4d1ca1ffac$var$is = $8VkWk($308a1d4d1ca1ffac$require$document) && $8VkWk($308a1d4d1ca1ffac$require$document.createElement);
module.exports = function(it) {
    return $308a1d4d1ca1ffac$var$is ? $308a1d4d1ca1ffac$require$document.createElement(it) : {};
};

});


parcelRegister("fgM76", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $8VkWk = parcelRequire("8VkWk");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$8VkWk(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$8VkWk(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$8VkWk(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$8VkWk(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("fP2G4", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("lKcpp", function(module, exports) {
var $fd4784f9533868d9$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $fd4784f9533868d9$var$hasOwnProperty.call(it, key);
};

});




parcelRegister("gC2Xz", function(module, exports) {
'use strict';

var $jWVYe = parcelRequire("jWVYe");

var $cjLWW = parcelRequire("cjLWW");

var $3PuK2 = parcelRequire("3PuK2");

var $9e9Hx = parcelRequire("9e9Hx");

var $heXBy = parcelRequire("heXBy");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $c1827db99c57b3b6$var$createInstance(defaultConfig) {
    var context = new $3PuK2(defaultConfig);
    var instance = $cjLWW($3PuK2.prototype.request, context);
    // Copy axios.prototype to instance
    $jWVYe.extend(instance, $3PuK2.prototype, context);
    // Copy context to instance
    $jWVYe.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $c1827db99c57b3b6$var$axios = $c1827db99c57b3b6$var$createInstance($heXBy);
// Expose Axios class to allow class inheritance
$c1827db99c57b3b6$var$axios.Axios = $3PuK2;
// Factory for creating new instances
$c1827db99c57b3b6$var$axios.create = function create(instanceConfig) {
    return $c1827db99c57b3b6$var$createInstance($9e9Hx($c1827db99c57b3b6$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$c1827db99c57b3b6$var$axios.Cancel = (parcelRequire("lE63L"));

$c1827db99c57b3b6$var$axios.CancelToken = (parcelRequire("iAp0B"));

$c1827db99c57b3b6$var$axios.isCancel = (parcelRequire("fhjbJ"));
// Expose all/spread
$c1827db99c57b3b6$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$c1827db99c57b3b6$var$axios.spread = (parcelRequire("aMUrJ"));

// Expose isAxiosError
$c1827db99c57b3b6$var$axios.isAxiosError = (parcelRequire("9TlaP"));
module.exports = $c1827db99c57b3b6$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $c1827db99c57b3b6$var$axios;

});
parcelRegister("jWVYe", function(module, exports) {
'use strict';

var $cjLWW = parcelRequire("cjLWW");
// utils is a library of generic helper functions non-specific to axios
var $e86066d3b181b540$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $e86066d3b181b540$var$isArray(val) {
    return $e86066d3b181b540$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $e86066d3b181b540$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $e86066d3b181b540$var$isBuffer(val) {
    return val !== null && !$e86066d3b181b540$var$isUndefined(val) && val.constructor !== null && !$e86066d3b181b540$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $e86066d3b181b540$var$isArrayBuffer(val) {
    return $e86066d3b181b540$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $e86066d3b181b540$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $e86066d3b181b540$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $e86066d3b181b540$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $e86066d3b181b540$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $e86066d3b181b540$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $e86066d3b181b540$var$isPlainObject(val) {
    if ($e86066d3b181b540$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $e86066d3b181b540$var$isDate(val) {
    return $e86066d3b181b540$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $e86066d3b181b540$var$isFile(val) {
    return $e86066d3b181b540$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $e86066d3b181b540$var$isBlob(val) {
    return $e86066d3b181b540$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $e86066d3b181b540$var$isFunction(val) {
    return $e86066d3b181b540$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $e86066d3b181b540$var$isStream(val) {
    return $e86066d3b181b540$var$isObject(val) && $e86066d3b181b540$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $e86066d3b181b540$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $e86066d3b181b540$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $e86066d3b181b540$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $e86066d3b181b540$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($e86066d3b181b540$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $e86066d3b181b540$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($e86066d3b181b540$var$isPlainObject(result[key]) && $e86066d3b181b540$var$isPlainObject(val)) result[key] = $e86066d3b181b540$var$merge(result[key], val);
        else if ($e86066d3b181b540$var$isPlainObject(val)) result[key] = $e86066d3b181b540$var$merge({}, val);
        else if ($e86066d3b181b540$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$e86066d3b181b540$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $e86066d3b181b540$var$extend(a, b, thisArg) {
    $e86066d3b181b540$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $cjLWW(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $e86066d3b181b540$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $e86066d3b181b540$var$isArray,
    isArrayBuffer: $e86066d3b181b540$var$isArrayBuffer,
    isBuffer: $e86066d3b181b540$var$isBuffer,
    isFormData: $e86066d3b181b540$var$isFormData,
    isArrayBufferView: $e86066d3b181b540$var$isArrayBufferView,
    isString: $e86066d3b181b540$var$isString,
    isNumber: $e86066d3b181b540$var$isNumber,
    isObject: $e86066d3b181b540$var$isObject,
    isPlainObject: $e86066d3b181b540$var$isPlainObject,
    isUndefined: $e86066d3b181b540$var$isUndefined,
    isDate: $e86066d3b181b540$var$isDate,
    isFile: $e86066d3b181b540$var$isFile,
    isBlob: $e86066d3b181b540$var$isBlob,
    isFunction: $e86066d3b181b540$var$isFunction,
    isStream: $e86066d3b181b540$var$isStream,
    isURLSearchParams: $e86066d3b181b540$var$isURLSearchParams,
    isStandardBrowserEnv: $e86066d3b181b540$var$isStandardBrowserEnv,
    forEach: $e86066d3b181b540$var$forEach,
    merge: $e86066d3b181b540$var$merge,
    extend: $e86066d3b181b540$var$extend,
    trim: $e86066d3b181b540$var$trim,
    stripBOM: $e86066d3b181b540$var$stripBOM
};

});
parcelRegister("cjLWW", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("3PuK2", function(module, exports) {
'use strict';

var $jWVYe = parcelRequire("jWVYe");

var $fBe44 = parcelRequire("fBe44");

var $6IoMU = parcelRequire("6IoMU");

var $jWGPg = parcelRequire("jWGPg");

var $9e9Hx = parcelRequire("9e9Hx");

var $4mBXD = parcelRequire("4mBXD");
var $2c9dfb2ab45f67fb$var$validators = $4mBXD.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $2c9dfb2ab45f67fb$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $6IoMU(),
        response: new $6IoMU()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $2c9dfb2ab45f67fb$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $9e9Hx(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $4mBXD.assertOptions(transitional, {
        silentJSONParsing: $2c9dfb2ab45f67fb$var$validators.transitional($2c9dfb2ab45f67fb$var$validators.boolean, '1.0.0'),
        forcedJSONParsing: $2c9dfb2ab45f67fb$var$validators.transitional($2c9dfb2ab45f67fb$var$validators.boolean, '1.0.0'),
        clarifyTimeoutError: $2c9dfb2ab45f67fb$var$validators.transitional($2c9dfb2ab45f67fb$var$validators.boolean, '1.0.0')
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $jWGPg,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $jWGPg(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$2c9dfb2ab45f67fb$var$Axios.prototype.getUri = function getUri(config) {
    config = $9e9Hx(this.defaults, config);
    return $fBe44(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$jWVYe.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $2c9dfb2ab45f67fb$var$Axios.prototype[method] = function(url, config) {
        return this.request($9e9Hx(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$jWVYe.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $2c9dfb2ab45f67fb$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($9e9Hx(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $2c9dfb2ab45f67fb$var$Axios;

});
parcelRegister("fBe44", function(module, exports) {
'use strict';

var $jWVYe = parcelRequire("jWVYe");
function $b5b538a8bc733915$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($jWVYe.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $jWVYe.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($jWVYe.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $jWVYe.forEach(val, function parseValue(v) {
                if ($jWVYe.isDate(v)) v = v.toISOString();
                else if ($jWVYe.isObject(v)) v = JSON.stringify(v);
                parts.push($b5b538a8bc733915$var$encode(key) + '=' + $b5b538a8bc733915$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("6IoMU", function(module, exports) {
'use strict';

var $jWVYe = parcelRequire("jWVYe");
function $4e3a147e1110e478$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $4e3a147e1110e478$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $4e3a147e1110e478$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $4e3a147e1110e478$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $jWVYe.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $4e3a147e1110e478$var$InterceptorManager;

});

parcelRegister("jWGPg", function(module, exports) {
'use strict';

var $jWVYe = parcelRequire("jWVYe");

var $fNK83 = parcelRequire("fNK83");

var $fhjbJ = parcelRequire("fhjbJ");

var $heXBy = parcelRequire("heXBy");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $e854a770034ec5ec$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $e854a770034ec5ec$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $fNK83.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $jWVYe.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $jWVYe.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $heXBy.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $e854a770034ec5ec$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $fNK83.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$fhjbJ(reason)) {
            $e854a770034ec5ec$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $fNK83.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("fNK83", function(module, exports) {
'use strict';

var $jWVYe = parcelRequire("jWVYe");

var $heXBy = parcelRequire("heXBy");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $heXBy;
    /*eslint no-param-reassign:0*/ $jWVYe.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("heXBy", function(module, exports) {
'use strict';

var $jWVYe = parcelRequire("jWVYe");

var $bEECg = parcelRequire("bEECg");

var $6RXAL = parcelRequire("6RXAL");
var $c8d1fac00ee72ecb$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $c8d1fac00ee72ecb$var$setContentTypeIfUnset(headers, value) {
    if (!$jWVYe.isUndefined(headers) && $jWVYe.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $c8d1fac00ee72ecb$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("6P8Rv"));
    return adapter;
}
function $c8d1fac00ee72ecb$var$stringifySafely(rawValue, parser, encoder) {
    if ($jWVYe.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $jWVYe.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $c8d1fac00ee72ecb$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $c8d1fac00ee72ecb$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $bEECg(headers, 'Accept');
            $bEECg(headers, 'Content-Type');
            if ($jWVYe.isFormData(data) || $jWVYe.isArrayBuffer(data) || $jWVYe.isBuffer(data) || $jWVYe.isStream(data) || $jWVYe.isFile(data) || $jWVYe.isBlob(data)) return data;
            if ($jWVYe.isArrayBufferView(data)) return data.buffer;
            if ($jWVYe.isURLSearchParams(data)) {
                $c8d1fac00ee72ecb$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($jWVYe.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
                $c8d1fac00ee72ecb$var$setContentTypeIfUnset(headers, 'application/json');
                return $c8d1fac00ee72ecb$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $jWVYe.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $6RXAL(e, this, 'E_JSON_PARSE');
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$c8d1fac00ee72ecb$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$jWVYe.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $c8d1fac00ee72ecb$var$defaults.headers[method] = {};
});
$jWVYe.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $c8d1fac00ee72ecb$var$defaults.headers[method] = $jWVYe.merge($c8d1fac00ee72ecb$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $c8d1fac00ee72ecb$var$defaults;

});
parcelRegister("bEECg", function(module, exports) {
'use strict';

var $jWVYe = parcelRequire("jWVYe");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $jWVYe.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("6RXAL", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRegister("6P8Rv", function(module, exports) {
'use strict';

var $jWVYe = parcelRequire("jWVYe");

var $eeX7w = parcelRequire("eeX7w");

var $14jKE = parcelRequire("14jKE");

var $fBe44 = parcelRequire("fBe44");

var $ecixf = parcelRequire("ecixf");

var $1aBEU = parcelRequire("1aBEU");

var $6J7dE = parcelRequire("6J7dE");

var $1oric = parcelRequire("1oric");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($jWVYe.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $ecixf(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $fBe44(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $1aBEU(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $eeX7w(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($1oric('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($1oric('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($1oric(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($jWVYe.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $6J7dE(fullPath)) && config.xsrfCookieName ? $14jKE.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $jWVYe.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$jWVYe.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("eeX7w", function(module, exports) {
'use strict';

var $1oric = parcelRequire("1oric");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($1oric('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("1oric", function(module, exports) {
'use strict';

var $6RXAL = parcelRequire("6RXAL");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $6RXAL(error, config, code, request, response);
};

});


parcelRegister("14jKE", function(module, exports) {
'use strict';

var $jWVYe = parcelRequire("jWVYe");
module.exports = $jWVYe.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($jWVYe.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($jWVYe.isString(path)) cookie.push('path=' + path);
            if ($jWVYe.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("ecixf", function(module, exports) {
'use strict';

var $dV3Xn = parcelRequire("dV3Xn");

var $iZldU = parcelRequire("iZldU");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$dV3Xn(requestedURL)) return $iZldU(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("dV3Xn", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("iZldU", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("1aBEU", function(module, exports) {
'use strict';

var $jWVYe = parcelRequire("jWVYe");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $0da3efe314de2bbe$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $jWVYe.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $jWVYe.trim(line.substr(0, i)).toLowerCase();
        val = $jWVYe.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $0da3efe314de2bbe$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("6J7dE", function(module, exports) {
'use strict';

var $jWVYe = parcelRequire("jWVYe");
module.exports = $jWVYe.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $jWVYe.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("fhjbJ", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("9e9Hx", function(module, exports) {
'use strict';

var $jWVYe = parcelRequire("jWVYe");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy',
        'params'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'timeoutMessage',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'decompress',
        'maxContentLength',
        'maxBodyLength',
        'maxRedirects',
        'transport',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath',
        'responseEncoding'
    ];
    var directMergeKeys = [
        'validateStatus'
    ];
    function getMergedValue(target, source) {
        if ($jWVYe.isPlainObject(target) && $jWVYe.isPlainObject(source)) return $jWVYe.merge(target, source);
        else if ($jWVYe.isPlainObject(source)) return $jWVYe.merge({}, source);
        else if ($jWVYe.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$jWVYe.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$jWVYe.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $jWVYe.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$jWVYe.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $jWVYe.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $jWVYe.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$jWVYe.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$jWVYe.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $jWVYe.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $jWVYe.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRegister("4mBXD", function(module, exports) {
'use strict';

var $7kRQC = parcelRequire("7kRQC");
var $32d6a9b9df1b1517$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $32d6a9b9df1b1517$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $32d6a9b9df1b1517$var$deprecatedWarnings = {};
var $32d6a9b9df1b1517$var$currentVerArr = $7kRQC.version.split('.');
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $32d6a9b9df1b1517$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split('.') : $32d6a9b9df1b1517$var$currentVerArr;
    var destVer = version.split('.');
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $32d6a9b9df1b1517$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $32d6a9b9df1b1517$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return '[Axios v' + $7kRQC.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, ' has been removed in ' + version));
        if (isDeprecated && !$32d6a9b9df1b1517$var$deprecatedWarnings[opt]) {
            $32d6a9b9df1b1517$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $32d6a9b9df1b1517$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new TypeError('options must be an object');
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError('option ' + opt + ' must be ' + result);
            continue;
        }
        if (allowUnknown !== true) throw Error('Unknown option ' + opt);
    }
}
module.exports = {
    isOlderVersion: $32d6a9b9df1b1517$var$isOlderVersion,
    assertOptions: $32d6a9b9df1b1517$var$assertOptions,
    validators: $32d6a9b9df1b1517$var$validators
};

});
parcelRegister("7kRQC", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"axios\",\"version\":\"0.21.4\",\"description\":\"Promise based HTTP client for the browser and node.js\",\"main\":\"index.js\",\"scripts\":{\"test\":\"grunt test\",\"start\":\"node ./sandbox/server.js\",\"build\":\"NODE_ENV=production grunt build\",\"preversion\":\"npm test\",\"version\":\"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json\",\"postversion\":\"git push && git push --tags\",\"examples\":\"node ./examples/server.js\",\"coveralls\":\"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js\",\"fix\":\"eslint --fix lib/**/*.js\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/axios/axios.git\"},\"keywords\":[\"xhr\",\"http\",\"ajax\",\"promise\",\"node\"],\"author\":\"Matt Zabriskie\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/axios/axios/issues\"},\"homepage\":\"https://axios-http.com\",\"devDependencies\":{\"coveralls\":\"^3.0.0\",\"es6-promise\":\"^4.2.4\",\"grunt\":\"^1.3.0\",\"grunt-banner\":\"^0.6.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-clean\":\"^1.1.0\",\"grunt-contrib-watch\":\"^1.0.0\",\"grunt-eslint\":\"^23.0.0\",\"grunt-karma\":\"^4.0.0\",\"grunt-mocha-test\":\"^0.13.3\",\"grunt-ts\":\"^6.0.0-beta.19\",\"grunt-webpack\":\"^4.0.2\",\"istanbul-instrumenter-loader\":\"^1.0.0\",\"jasmine-core\":\"^2.4.1\",\"karma\":\"^6.3.2\",\"karma-chrome-launcher\":\"^3.1.0\",\"karma-firefox-launcher\":\"^2.1.0\",\"karma-jasmine\":\"^1.1.1\",\"karma-jasmine-ajax\":\"^0.1.13\",\"karma-safari-launcher\":\"^1.0.0\",\"karma-sauce-launcher\":\"^4.3.6\",\"karma-sinon\":\"^1.0.5\",\"karma-sourcemap-loader\":\"^0.3.8\",\"karma-webpack\":\"^4.0.2\",\"load-grunt-tasks\":\"^3.5.2\",\"minimist\":\"^1.2.0\",\"mocha\":\"^8.2.1\",\"sinon\":\"^4.5.0\",\"terser-webpack-plugin\":\"^4.2.3\",\"typescript\":\"^4.0.5\",\"url-search-params\":\"^0.10.0\",\"webpack\":\"^4.44.2\",\"webpack-dev-server\":\"^3.11.0\"},\"browser\":{\"./lib/adapters/http.js\":\"./lib/adapters/xhr.js\"},\"jsdelivr\":\"dist/axios.min.js\",\"unpkg\":\"dist/axios.min.js\",\"typings\":\"./index.d.ts\",\"dependencies\":{\"follow-redirects\":\"^1.14.0\"},\"bundlesize\":[{\"path\":\"./dist/axios.min.js\",\"threshold\":\"5kB\"}]}");

});



parcelRegister("lE63L", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $fc2208b6d65685f0$var$Cancel(message) {
    this.message = message;
}
$fc2208b6d65685f0$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$fc2208b6d65685f0$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $fc2208b6d65685f0$var$Cancel;

});

parcelRegister("iAp0B", function(module, exports) {
'use strict';

var $lE63L = parcelRequire("lE63L");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $d87efd02b08b4411$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $lE63L(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $d87efd02b08b4411$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $d87efd02b08b4411$var$CancelToken.source = function source() {
    var cancel;
    var token = new $d87efd02b08b4411$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $d87efd02b08b4411$var$CancelToken;

});

parcelRegister("aMUrJ", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("9TlaP", function(module, exports) {
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === 'object' && payload.isAxiosError === true;
};

});


/* eslint-disable */ "use strict";
"use strict";
var $15c57ad75b16da55$exports = {};
'use strict';

var $jFKHr = parcelRequire("jFKHr");

var $jdXyk = parcelRequire("jdXyk");

var $cAHsA = parcelRequire("cAHsA");

var $fO65L = parcelRequire("fO65L");

var $10sdZ = parcelRequire("10sdZ");

var $khJao = parcelRequire("khJao");
var $6ec563ec8aed2983$require$META = $khJao.KEY;

var $gtdMs = parcelRequire("gtdMs");

var $bW5w6 = parcelRequire("bW5w6");

var $6DkCi = parcelRequire("6DkCi");

var $kZJHg = parcelRequire("kZJHg");

var $kC7Sb = parcelRequire("kC7Sb");

var $iUlRw = parcelRequire("iUlRw");

var $4z7mj = parcelRequire("4z7mj");
var $1d7a8bc568b935fa$exports = {};
// all enumerable object keys, includes symbols

var $62EBp = parcelRequire("62EBp");

var $1idHk = parcelRequire("1idHk");

var $1iccq = parcelRequire("1iccq");
$1d7a8bc568b935fa$exports = function(it) {
    var result = $62EBp(it);
    var getSymbols = $1idHk.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $1iccq.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};



var $hRWRg = parcelRequire("hRWRg");

var $978rB = parcelRequire("978rB");

var $1WkAz = parcelRequire("1WkAz");

var $eb8lU = parcelRequire("eb8lU");

var $3hDAb = parcelRequire("3hDAb");

var $ltjni = parcelRequire("ltjni");

var $fTxIB = parcelRequire("fTxIB");

var $lUyCu = parcelRequire("lUyCu");

var $7cjSp = parcelRequire("7cjSp");

var $6VRFP = parcelRequire("6VRFP");

var $1idHk = parcelRequire("1idHk");

var $lhvOa = parcelRequire("lhvOa");

var $62EBp = parcelRequire("62EBp");
var $6ec563ec8aed2983$var$gOPD = $6VRFP.f;
var $6ec563ec8aed2983$var$dP = $lhvOa.f;
var $6ec563ec8aed2983$var$gOPN = $7cjSp.f;
var $6ec563ec8aed2983$var$$Symbol = $jFKHr.Symbol;
var $6ec563ec8aed2983$var$$JSON = $jFKHr.JSON;
var $6ec563ec8aed2983$var$_stringify = $6ec563ec8aed2983$var$$JSON && $6ec563ec8aed2983$var$$JSON.stringify;
var $6ec563ec8aed2983$var$PROTOTYPE = 'prototype';
var $6ec563ec8aed2983$var$HIDDEN = $kC7Sb('_hidden');
var $6ec563ec8aed2983$var$TO_PRIMITIVE = $kC7Sb('toPrimitive');
var $6ec563ec8aed2983$var$isEnum = {}.propertyIsEnumerable;
var $6ec563ec8aed2983$var$SymbolRegistry = $bW5w6('symbol-registry');
var $6ec563ec8aed2983$var$AllSymbols = $bW5w6('symbols');
var $6ec563ec8aed2983$var$OPSymbols = $bW5w6('op-symbols');
var $6ec563ec8aed2983$var$ObjectProto = Object[$6ec563ec8aed2983$var$PROTOTYPE];
var $6ec563ec8aed2983$var$USE_NATIVE = typeof $6ec563ec8aed2983$var$$Symbol == 'function' && !!$1idHk.f;
var $6ec563ec8aed2983$var$QObject = $jFKHr.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $6ec563ec8aed2983$var$setter = !$6ec563ec8aed2983$var$QObject || !$6ec563ec8aed2983$var$QObject[$6ec563ec8aed2983$var$PROTOTYPE] || !$6ec563ec8aed2983$var$QObject[$6ec563ec8aed2983$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $6ec563ec8aed2983$var$setSymbolDesc = $cAHsA && $gtdMs(function() {
    return $lUyCu($6ec563ec8aed2983$var$dP({}, 'a', {
        get: function() {
            return $6ec563ec8aed2983$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $6ec563ec8aed2983$var$gOPD($6ec563ec8aed2983$var$ObjectProto, key);
    if (protoDesc) delete $6ec563ec8aed2983$var$ObjectProto[key];
    $6ec563ec8aed2983$var$dP(it, key, D);
    if (protoDesc && it !== $6ec563ec8aed2983$var$ObjectProto) $6ec563ec8aed2983$var$dP($6ec563ec8aed2983$var$ObjectProto, key, protoDesc);
} : $6ec563ec8aed2983$var$dP;
var $6ec563ec8aed2983$var$wrap = function(tag) {
    var sym = $6ec563ec8aed2983$var$AllSymbols[tag] = $lUyCu($6ec563ec8aed2983$var$$Symbol[$6ec563ec8aed2983$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $6ec563ec8aed2983$var$isSymbol = $6ec563ec8aed2983$var$USE_NATIVE && typeof $6ec563ec8aed2983$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $6ec563ec8aed2983$var$$Symbol;
};
var $6ec563ec8aed2983$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $6ec563ec8aed2983$var$ObjectProto) $6ec563ec8aed2983$var$$defineProperty($6ec563ec8aed2983$var$OPSymbols, key, D);
    $978rB(it);
    key = $ltjni(key, true);
    $978rB(D);
    if ($jdXyk($6ec563ec8aed2983$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$jdXyk(it, $6ec563ec8aed2983$var$HIDDEN)) $6ec563ec8aed2983$var$dP(it, $6ec563ec8aed2983$var$HIDDEN, $fTxIB(1, {}));
            it[$6ec563ec8aed2983$var$HIDDEN][key] = true;
        } else {
            if ($jdXyk(it, $6ec563ec8aed2983$var$HIDDEN) && it[$6ec563ec8aed2983$var$HIDDEN][key]) it[$6ec563ec8aed2983$var$HIDDEN][key] = false;
            D = $lUyCu(D, {
                enumerable: $fTxIB(0, false)
            });
        }
        return $6ec563ec8aed2983$var$setSymbolDesc(it, key, D);
    }
    return $6ec563ec8aed2983$var$dP(it, key, D);
};
var $6ec563ec8aed2983$var$$defineProperties = function defineProperties(it, P) {
    $978rB(it);
    var keys = $1d7a8bc568b935fa$exports(P = $3hDAb(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$6ec563ec8aed2983$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $6ec563ec8aed2983$var$$create = function create(it, P) {
    return P === undefined ? $lUyCu(it) : $6ec563ec8aed2983$var$$defineProperties($lUyCu(it), P);
};
var $6ec563ec8aed2983$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $6ec563ec8aed2983$var$isEnum.call(this, key = $ltjni(key, true));
    if (this === $6ec563ec8aed2983$var$ObjectProto && $jdXyk($6ec563ec8aed2983$var$AllSymbols, key) && !$jdXyk($6ec563ec8aed2983$var$OPSymbols, key)) return false;
    return E || !$jdXyk(this, key) || !$jdXyk($6ec563ec8aed2983$var$AllSymbols, key) || $jdXyk(this, $6ec563ec8aed2983$var$HIDDEN) && this[$6ec563ec8aed2983$var$HIDDEN][key] ? E : true;
};
var $6ec563ec8aed2983$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $3hDAb(it);
    key = $ltjni(key, true);
    if (it === $6ec563ec8aed2983$var$ObjectProto && $jdXyk($6ec563ec8aed2983$var$AllSymbols, key) && !$jdXyk($6ec563ec8aed2983$var$OPSymbols, key)) return;
    var D = $6ec563ec8aed2983$var$gOPD(it, key);
    if (D && $jdXyk($6ec563ec8aed2983$var$AllSymbols, key) && !($jdXyk(it, $6ec563ec8aed2983$var$HIDDEN) && it[$6ec563ec8aed2983$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $6ec563ec8aed2983$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $6ec563ec8aed2983$var$gOPN($3hDAb(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$jdXyk($6ec563ec8aed2983$var$AllSymbols, key = names[i++]) && key != $6ec563ec8aed2983$var$HIDDEN && key != $6ec563ec8aed2983$require$META) result.push(key);
    return result;
};
var $6ec563ec8aed2983$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $6ec563ec8aed2983$var$ObjectProto;
    var names = $6ec563ec8aed2983$var$gOPN(IS_OP ? $6ec563ec8aed2983$var$OPSymbols : $3hDAb(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($jdXyk($6ec563ec8aed2983$var$AllSymbols, key = names[i++]) && (IS_OP ? $jdXyk($6ec563ec8aed2983$var$ObjectProto, key) : true)) result.push($6ec563ec8aed2983$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$6ec563ec8aed2983$var$USE_NATIVE) {
    $6ec563ec8aed2983$var$$Symbol = function Symbol() {
        if (this instanceof $6ec563ec8aed2983$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $kZJHg(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $6ec563ec8aed2983$var$ObjectProto) $set.call($6ec563ec8aed2983$var$OPSymbols, value);
            if ($jdXyk(this, $6ec563ec8aed2983$var$HIDDEN) && $jdXyk(this[$6ec563ec8aed2983$var$HIDDEN], tag)) this[$6ec563ec8aed2983$var$HIDDEN][tag] = false;
            $6ec563ec8aed2983$var$setSymbolDesc(this, tag, $fTxIB(1, value));
        };
        if ($cAHsA && $6ec563ec8aed2983$var$setter) $6ec563ec8aed2983$var$setSymbolDesc($6ec563ec8aed2983$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $6ec563ec8aed2983$var$wrap(tag);
    };
    $10sdZ($6ec563ec8aed2983$var$$Symbol[$6ec563ec8aed2983$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $6VRFP.f = $6ec563ec8aed2983$var$$getOwnPropertyDescriptor;
    $lhvOa.f = $6ec563ec8aed2983$var$$defineProperty;
    (parcelRequire("9B1GU")).f = $7cjSp.f = $6ec563ec8aed2983$var$$getOwnPropertyNames;
    (parcelRequire("1iccq")).f = $6ec563ec8aed2983$var$$propertyIsEnumerable;
    $1idHk.f = $6ec563ec8aed2983$var$$getOwnPropertySymbols;
    if ($cAHsA && !(parcelRequire("cE8bo"))) $10sdZ($6ec563ec8aed2983$var$ObjectProto, 'propertyIsEnumerable', $6ec563ec8aed2983$var$$propertyIsEnumerable, true);
    $iUlRw.f = function(name) {
        return $6ec563ec8aed2983$var$wrap($kC7Sb(name));
    };
}
$fO65L($fO65L.G + $fO65L.W + $fO65L.F * !$6ec563ec8aed2983$var$USE_NATIVE, {
    Symbol: $6ec563ec8aed2983$var$$Symbol
});
for(var $6ec563ec8aed2983$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $6ec563ec8aed2983$var$j = 0; $6ec563ec8aed2983$var$es6Symbols.length > $6ec563ec8aed2983$var$j;)$kC7Sb($6ec563ec8aed2983$var$es6Symbols[$6ec563ec8aed2983$var$j++]);
for(var $6ec563ec8aed2983$var$wellKnownSymbols = $62EBp($kC7Sb.store), $6ec563ec8aed2983$var$k = 0; $6ec563ec8aed2983$var$wellKnownSymbols.length > $6ec563ec8aed2983$var$k;)$4z7mj($6ec563ec8aed2983$var$wellKnownSymbols[$6ec563ec8aed2983$var$k++]);
$fO65L($fO65L.S + $fO65L.F * !$6ec563ec8aed2983$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $jdXyk($6ec563ec8aed2983$var$SymbolRegistry, key += '') ? $6ec563ec8aed2983$var$SymbolRegistry[key] : $6ec563ec8aed2983$var$SymbolRegistry[key] = $6ec563ec8aed2983$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$6ec563ec8aed2983$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $6ec563ec8aed2983$var$SymbolRegistry)if ($6ec563ec8aed2983$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $6ec563ec8aed2983$var$setter = true;
    },
    useSimple: function() {
        $6ec563ec8aed2983$var$setter = false;
    }
});
$fO65L($fO65L.S + $fO65L.F * !$6ec563ec8aed2983$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $6ec563ec8aed2983$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $6ec563ec8aed2983$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $6ec563ec8aed2983$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $6ec563ec8aed2983$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $6ec563ec8aed2983$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $6ec563ec8aed2983$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $6ec563ec8aed2983$var$FAILS_ON_PRIMITIVES = $gtdMs(function() {
    $1idHk.f(1);
});
$fO65L($fO65L.S + $fO65L.F * $6ec563ec8aed2983$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $1idHk.f($eb8lU(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$6ec563ec8aed2983$var$$JSON && $fO65L($fO65L.S + $fO65L.F * (!$6ec563ec8aed2983$var$USE_NATIVE || $gtdMs(function() {
    var S = $6ec563ec8aed2983$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $6ec563ec8aed2983$var$_stringify([
        S
    ]) != '[null]' || $6ec563ec8aed2983$var$_stringify({
        a: S
    }) != '{}' || $6ec563ec8aed2983$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$1WkAz(replacer) && it === undefined || $6ec563ec8aed2983$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$hRWRg(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$6ec563ec8aed2983$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $6ec563ec8aed2983$var$_stringify.apply($6ec563ec8aed2983$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$6ec563ec8aed2983$var$$Symbol[$6ec563ec8aed2983$var$PROTOTYPE][$6ec563ec8aed2983$var$TO_PRIMITIVE] || (parcelRequire("fMiEZ"))($6ec563ec8aed2983$var$$Symbol[$6ec563ec8aed2983$var$PROTOTYPE], $6ec563ec8aed2983$var$TO_PRIMITIVE, $6ec563ec8aed2983$var$$Symbol[$6ec563ec8aed2983$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$6DkCi($6ec563ec8aed2983$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$6DkCi(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$6DkCi($jFKHr.JSON, 'JSON', true);



var $fO65L = parcelRequire("fO65L");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$fO65L($fO65L.S, 'Object', {
    create: (parcelRequire("lUyCu"))
});



var $fO65L = parcelRequire("fO65L");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$fO65L($fO65L.S + $fO65L.F * !(parcelRequire("cAHsA")), 'Object', {
    defineProperty: (parcelRequire("lhvOa")).f
});



var $fO65L = parcelRequire("fO65L");


// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$fO65L($fO65L.S + $fO65L.F * !(parcelRequire("cAHsA")), 'Object', {
    defineProperties: (parcelRequire("ag4eO"))
});


// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $3hDAb = parcelRequire("3hDAb");

var $6VRFP = parcelRequire("6VRFP");
var $4ea93d7d92d2eea1$require$$getOwnPropertyDescriptor = $6VRFP.f;

(parcelRequire("bwayZ"))('getOwnPropertyDescriptor', function() {
    return function getOwnPropertyDescriptor(it, key) {
        return $4ea93d7d92d2eea1$require$$getOwnPropertyDescriptor($3hDAb(it), key);
    };
});


// 19.1.2.9 Object.getPrototypeOf(O)

var $eb8lU = parcelRequire("eb8lU");

var $6yhFg = parcelRequire("6yhFg");

(parcelRequire("bwayZ"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $6yhFg($eb8lU(it));
    };
});


// 19.1.2.14 Object.keys(O)

var $eb8lU = parcelRequire("eb8lU");

var $62EBp = parcelRequire("62EBp");

(parcelRequire("bwayZ"))('keys', function() {
    return function keys(it) {
        return $62EBp($eb8lU(it));
    };
});


// 19.1.2.7 Object.getOwnPropertyNames(O)


(parcelRequire("bwayZ"))('getOwnPropertyNames', function() {
    return (parcelRequire("7cjSp")).f;
});


// 19.1.2.5 Object.freeze(O)

var $1WkAz = parcelRequire("1WkAz");

var $khJao = parcelRequire("khJao");
var $dc64851dd54867aa$require$meta = $khJao.onFreeze;

(parcelRequire("bwayZ"))('freeze', function($freeze) {
    return function freeze(it) {
        return $freeze && $1WkAz(it) ? $freeze($dc64851dd54867aa$require$meta(it)) : it;
    };
});


// 19.1.2.17 Object.seal(O)

var $1WkAz = parcelRequire("1WkAz");

var $khJao = parcelRequire("khJao");
var $26f2a1dc49b84263$require$meta = $khJao.onFreeze;

(parcelRequire("bwayZ"))('seal', function($seal) {
    return function seal(it) {
        return $seal && $1WkAz(it) ? $seal($26f2a1dc49b84263$require$meta(it)) : it;
    };
});


// 19.1.2.15 Object.preventExtensions(O)

var $1WkAz = parcelRequire("1WkAz");

var $khJao = parcelRequire("khJao");
var $36edfdbf92e4b015$require$meta = $khJao.onFreeze;

(parcelRequire("bwayZ"))('preventExtensions', function($preventExtensions) {
    return function preventExtensions(it) {
        return $preventExtensions && $1WkAz(it) ? $preventExtensions($36edfdbf92e4b015$require$meta(it)) : it;
    };
});


// 19.1.2.12 Object.isFrozen(O)

var $1WkAz = parcelRequire("1WkAz");

(parcelRequire("bwayZ"))('isFrozen', function($isFrozen) {
    return function isFrozen(it) {
        return $1WkAz(it) ? $isFrozen ? $isFrozen(it) : false : true;
    };
});


// 19.1.2.13 Object.isSealed(O)

var $1WkAz = parcelRequire("1WkAz");

(parcelRequire("bwayZ"))('isSealed', function($isSealed) {
    return function isSealed(it) {
        return $1WkAz(it) ? $isSealed ? $isSealed(it) : false : true;
    };
});


// 19.1.2.11 Object.isExtensible(O)

var $1WkAz = parcelRequire("1WkAz");

(parcelRequire("bwayZ"))('isExtensible', function($isExtensible) {
    return function isExtensible(it) {
        return $1WkAz(it) ? $isExtensible ? $isExtensible(it) : true : false;
    };
});


// 19.1.3.1 Object.assign(target, source)

var $fO65L = parcelRequire("fO65L");

$fO65L($fO65L.S + $fO65L.F, 'Object', {
    assign: (parcelRequire("3YyFT"))
});


// 19.1.3.10 Object.is(value1, value2)

var $fO65L = parcelRequire("fO65L");

$fO65L($fO65L.S, 'Object', {
    is: (parcelRequire("gsEkn"))
});


// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $fO65L = parcelRequire("fO65L");

$fO65L($fO65L.S, 'Object', {
    setPrototypeOf: (parcelRequire("bDxU1")).set
});


'use strict';

var $8iPtU = parcelRequire("8iPtU");
var $aa13cf06388afb37$var$test = {};

var $kC7Sb = parcelRequire("kC7Sb");
$aa13cf06388afb37$var$test[$kC7Sb('toStringTag')] = 'z';

if ($aa13cf06388afb37$var$test + '' != '[object z]') (parcelRequire("10sdZ"))(Object.prototype, 'toString', function toString() {
    return '[object ' + $8iPtU(this) + ']';
}, true);


// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)

var $fO65L = parcelRequire("fO65L");

$fO65L($fO65L.P, 'Function', {
    bind: (parcelRequire("7xMFU"))
});



var $lhvOa = parcelRequire("lhvOa");
var $6f474cb136e3f6eb$require$dP = $lhvOa.f;
var $6f474cb136e3f6eb$var$FProto = Function.prototype;
var $6f474cb136e3f6eb$var$nameRE = /^\s*function ([^ (]*)/;
var $6f474cb136e3f6eb$var$NAME = 'name';

// 19.2.4.2 name
$6f474cb136e3f6eb$var$NAME in $6f474cb136e3f6eb$var$FProto || (parcelRequire("cAHsA")) && $6f474cb136e3f6eb$require$dP($6f474cb136e3f6eb$var$FProto, $6f474cb136e3f6eb$var$NAME, {
    configurable: true,
    get: function() {
        try {
            return ('' + this).match($6f474cb136e3f6eb$var$nameRE)[1];
        } catch (e) {
            return '';
        }
    }
});


'use strict';

var $1WkAz = parcelRequire("1WkAz");

var $6yhFg = parcelRequire("6yhFg");

var $368e1e70de8c21ab$var$HAS_INSTANCE = (parcelRequire("kC7Sb"))('hasInstance');
var $368e1e70de8c21ab$var$FunctionProto = Function.prototype;

// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!($368e1e70de8c21ab$var$HAS_INSTANCE in $368e1e70de8c21ab$var$FunctionProto)) (parcelRequire("lhvOa")).f($368e1e70de8c21ab$var$FunctionProto, $368e1e70de8c21ab$var$HAS_INSTANCE, {
    value: function(O) {
        if (typeof this != 'function' || !$1WkAz(O)) return false;
        if (!$1WkAz(this.prototype)) return O instanceof this;
        // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
        while(O = $6yhFg(O))if (this.prototype === O) return true;
        return false;
    }
});



var $fO65L = parcelRequire("fO65L");
var $c2e5a0b81b23af58$exports = {};

var $jFKHr = parcelRequire("jFKHr");
var $c2e5a0b81b23af58$require$$parseInt = $jFKHr.parseInt;

var $218jD = parcelRequire("218jD");
var $c2e5a0b81b23af58$require$$trim = $218jD.trim;

var $aOJxG = parcelRequire("aOJxG");
var $c2e5a0b81b23af58$var$hex = /^[-+]?0[xX]/;
$c2e5a0b81b23af58$exports = $c2e5a0b81b23af58$require$$parseInt($aOJxG + '08') !== 8 || $c2e5a0b81b23af58$require$$parseInt($aOJxG + '0x16') !== 22 ? function parseInt(str, radix) {
    var string = $c2e5a0b81b23af58$require$$trim(String(str), 3);
    return $c2e5a0b81b23af58$require$$parseInt(string, radix >>> 0 || ($c2e5a0b81b23af58$var$hex.test(string) ? 16 : 10));
} : $c2e5a0b81b23af58$require$$parseInt;


// 18.2.5 parseInt(string, radix)
$fO65L($fO65L.G + $fO65L.F * (parseInt != $c2e5a0b81b23af58$exports), {
    parseInt: $c2e5a0b81b23af58$exports
});



var $fO65L = parcelRequire("fO65L");
var $1b32e59a36a78eeb$exports = {};

var $jFKHr = parcelRequire("jFKHr");
var $1b32e59a36a78eeb$require$$parseFloat = $jFKHr.parseFloat;

var $218jD = parcelRequire("218jD");
var $1b32e59a36a78eeb$require$$trim = $218jD.trim;

$1b32e59a36a78eeb$exports = 1 / $1b32e59a36a78eeb$require$$parseFloat((parcelRequire("aOJxG")) + '-0') !== -Infinity ? function parseFloat(str) {
    var string = $1b32e59a36a78eeb$require$$trim(String(str), 3);
    var result = $1b32e59a36a78eeb$require$$parseFloat(string);
    return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $1b32e59a36a78eeb$require$$parseFloat;


// 18.2.4 parseFloat(string)
$fO65L($fO65L.G + $fO65L.F * (parseFloat != $1b32e59a36a78eeb$exports), {
    parseFloat: $1b32e59a36a78eeb$exports
});


'use strict';

var $jFKHr = parcelRequire("jFKHr");

var $jdXyk = parcelRequire("jdXyk");

var $k4Th0 = parcelRequire("k4Th0");

var $6yI0d = parcelRequire("6yI0d");

var $ltjni = parcelRequire("ltjni");

var $gtdMs = parcelRequire("gtdMs");

var $9B1GU = parcelRequire("9B1GU");
var $b26666339bc3c5b5$require$gOPN = $9B1GU.f;

var $6VRFP = parcelRequire("6VRFP");
var $b26666339bc3c5b5$require$gOPD = $6VRFP.f;

var $lhvOa = parcelRequire("lhvOa");
var $b26666339bc3c5b5$require$dP = $lhvOa.f;

var $218jD = parcelRequire("218jD");
var $b26666339bc3c5b5$require$$trim = $218jD.trim;
var $b26666339bc3c5b5$var$NUMBER = 'Number';
var $b26666339bc3c5b5$var$$Number = $jFKHr[$b26666339bc3c5b5$var$NUMBER];
var $b26666339bc3c5b5$var$Base = $b26666339bc3c5b5$var$$Number;
var $b26666339bc3c5b5$var$proto = $b26666339bc3c5b5$var$$Number.prototype;

// Opera ~12 has broken Object#toString
var $b26666339bc3c5b5$var$BROKEN_COF = $k4Th0((parcelRequire("lUyCu"))($b26666339bc3c5b5$var$proto)) == $b26666339bc3c5b5$var$NUMBER;
var $b26666339bc3c5b5$var$TRIM = 'trim' in String.prototype;
// 7.1.3 ToNumber(argument)
var $b26666339bc3c5b5$var$toNumber = function(argument) {
    var it = $ltjni(argument, false);
    if (typeof it == 'string' && it.length > 2) {
        it = $b26666339bc3c5b5$var$TRIM ? it.trim() : $b26666339bc3c5b5$require$$trim(it, 3);
        var first = it.charCodeAt(0);
        var third, radix, maxCode;
        if (first === 43 || first === 45) {
            third = it.charCodeAt(2);
            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
        } else if (first === 48) {
            switch(it.charCodeAt(1)){
                case 66:
                case 98:
                    radix = 2;
                    maxCode = 49;
                    break; // fast equal /^0b[01]+$/i
                case 79:
                case 111:
                    radix = 8;
                    maxCode = 55;
                    break; // fast equal /^0o[0-7]+$/i
                default:
                    return +it;
            }
            for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
                code = digits.charCodeAt(i);
                // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols
                if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
        }
    }
    return +it;
};


if (!$b26666339bc3c5b5$var$$Number(' 0o1') || !$b26666339bc3c5b5$var$$Number('0b1') || $b26666339bc3c5b5$var$$Number('+0x1')) {
    $b26666339bc3c5b5$var$$Number = function Number(value) {
        var it = arguments.length < 1 ? 0 : value;
        var that = this;
        return that instanceof $b26666339bc3c5b5$var$$Number && ($b26666339bc3c5b5$var$BROKEN_COF ? $gtdMs(function() {
            $b26666339bc3c5b5$var$proto.valueOf.call(that);
        }) : $k4Th0(that) != $b26666339bc3c5b5$var$NUMBER) ? $6yI0d(new $b26666339bc3c5b5$var$Base($b26666339bc3c5b5$var$toNumber(it)), that, $b26666339bc3c5b5$var$$Number) : $b26666339bc3c5b5$var$toNumber(it);
    };
    for(var $b26666339bc3c5b5$var$keys = (parcelRequire("cAHsA")) ? $b26666339bc3c5b5$require$gOPN($b26666339bc3c5b5$var$Base) : // ES3:
    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(','), $b26666339bc3c5b5$var$j = 0, $b26666339bc3c5b5$var$key; $b26666339bc3c5b5$var$keys.length > $b26666339bc3c5b5$var$j; $b26666339bc3c5b5$var$j++)if ($jdXyk($b26666339bc3c5b5$var$Base, $b26666339bc3c5b5$var$key = $b26666339bc3c5b5$var$keys[$b26666339bc3c5b5$var$j]) && !$jdXyk($b26666339bc3c5b5$var$$Number, $b26666339bc3c5b5$var$key)) $b26666339bc3c5b5$require$dP($b26666339bc3c5b5$var$$Number, $b26666339bc3c5b5$var$key, $b26666339bc3c5b5$require$gOPD($b26666339bc3c5b5$var$Base, $b26666339bc3c5b5$var$key));
    $b26666339bc3c5b5$var$$Number.prototype = $b26666339bc3c5b5$var$proto;
    $b26666339bc3c5b5$var$proto.constructor = $b26666339bc3c5b5$var$$Number;
    (parcelRequire("10sdZ"))($jFKHr, $b26666339bc3c5b5$var$NUMBER, $b26666339bc3c5b5$var$$Number);
}


'use strict';

var $fO65L = parcelRequire("fO65L");

var $U0K0I = parcelRequire("U0K0I");
var $aa3b2aa1c98c0cc8$exports = {};

var $k4Th0 = parcelRequire("k4Th0");
$aa3b2aa1c98c0cc8$exports = function(it, msg) {
    if (typeof it != 'number' && $k4Th0(it) != 'Number') throw TypeError(msg);
    return +it;
};



var $2sMRG = parcelRequire("2sMRG");
var $5dc548b156d28b6d$var$$toFixed = 1.0.toFixed;
var $5dc548b156d28b6d$var$floor = Math.floor;
var $5dc548b156d28b6d$var$data = [
    0,
    0,
    0,
    0,
    0,
    0
];
var $5dc548b156d28b6d$var$ERROR = 'Number.toFixed: incorrect invocation!';
var $5dc548b156d28b6d$var$ZERO = '0';
var $5dc548b156d28b6d$var$multiply = function(n, c) {
    var i = -1;
    var c2 = c;
    while(++i < 6){
        c2 += n * $5dc548b156d28b6d$var$data[i];
        $5dc548b156d28b6d$var$data[i] = c2 % 1e7;
        c2 = $5dc548b156d28b6d$var$floor(c2 / 1e7);
    }
};
var $5dc548b156d28b6d$var$divide = function(n) {
    var i = 6;
    var c = 0;
    while(--i >= 0){
        c += $5dc548b156d28b6d$var$data[i];
        $5dc548b156d28b6d$var$data[i] = $5dc548b156d28b6d$var$floor(c / n);
        c = c % n * 1e7;
    }
};
var $5dc548b156d28b6d$var$numToString = function() {
    var i = 6;
    var s = '';
    while(--i >= 0)if (s !== '' || i === 0 || $5dc548b156d28b6d$var$data[i] !== 0) {
        var t = String($5dc548b156d28b6d$var$data[i]);
        s = s === '' ? t : s + $2sMRG.call($5dc548b156d28b6d$var$ZERO, 7 - t.length) + t;
    }
    return s;
};
var $5dc548b156d28b6d$var$pow = function(x, n, acc) {
    return n === 0 ? acc : n % 2 === 1 ? $5dc548b156d28b6d$var$pow(x, n - 1, acc * x) : $5dc548b156d28b6d$var$pow(x * x, n / 2, acc);
};
var $5dc548b156d28b6d$var$log = function(x) {
    var n = 0;
    var x2 = x;
    while(x2 >= 4096){
        n += 12;
        x2 /= 4096;
    }
    while(x2 >= 2){
        n += 1;
        x2 /= 2;
    }
    return n;
};

$fO65L($fO65L.P + $fO65L.F * (!!$5dc548b156d28b6d$var$$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128.0.toFixed(0) !== '1000000000000000128') || !(parcelRequire("gtdMs"))(function() {
    // V8 ~ Android 4.3-
    $5dc548b156d28b6d$var$$toFixed.call({});
})), 'Number', {
    toFixed: function toFixed(fractionDigits) {
        var x = $aa3b2aa1c98c0cc8$exports(this, $5dc548b156d28b6d$var$ERROR);
        var f = $U0K0I(fractionDigits);
        var s = '';
        var m = $5dc548b156d28b6d$var$ZERO;
        var e, z, j, k;
        if (f < 0 || f > 20) throw RangeError($5dc548b156d28b6d$var$ERROR);
        // eslint-disable-next-line no-self-compare
        if (x != x) return 'NaN';
        if (x <= -1000000000000000000000 || x >= 1e21) return String(x);
        if (x < 0) {
            s = '-';
            x = -x;
        }
        if (x > 1e-21) {
            e = $5dc548b156d28b6d$var$log(x * $5dc548b156d28b6d$var$pow(2, 69, 1)) - 69;
            z = e < 0 ? x * $5dc548b156d28b6d$var$pow(2, -e, 1) : x / $5dc548b156d28b6d$var$pow(2, e, 1);
            z *= 0x10000000000000;
            e = 52 - e;
            if (e > 0) {
                $5dc548b156d28b6d$var$multiply(0, z);
                j = f;
                while(j >= 7){
                    $5dc548b156d28b6d$var$multiply(1e7, 0);
                    j -= 7;
                }
                $5dc548b156d28b6d$var$multiply($5dc548b156d28b6d$var$pow(10, j, 1), 0);
                j = e - 1;
                while(j >= 23){
                    $5dc548b156d28b6d$var$divide(8388608);
                    j -= 23;
                }
                $5dc548b156d28b6d$var$divide(1 << j);
                $5dc548b156d28b6d$var$multiply(1, 1);
                $5dc548b156d28b6d$var$divide(2);
                m = $5dc548b156d28b6d$var$numToString();
            } else {
                $5dc548b156d28b6d$var$multiply(0, z);
                $5dc548b156d28b6d$var$multiply(1 << -e, 0);
                m = $5dc548b156d28b6d$var$numToString() + $2sMRG.call($5dc548b156d28b6d$var$ZERO, f);
            }
        }
        if (f > 0) {
            k = m.length;
            m = s + (k <= f ? '0.' + $2sMRG.call($5dc548b156d28b6d$var$ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
        } else m = s + m;
        return m;
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");

var $gtdMs = parcelRequire("gtdMs");

var $438e0ec4ee9f93e2$var$$toPrecision = 1.0.toPrecision;
$fO65L($fO65L.P + $fO65L.F * ($gtdMs(function() {
    // IE7-
    return $438e0ec4ee9f93e2$var$$toPrecision.call(1, undefined) !== '1';
}) || !$gtdMs(function() {
    // V8 ~ Android 4.3-
    $438e0ec4ee9f93e2$var$$toPrecision.call({});
})), 'Number', {
    toPrecision: function toPrecision(precision) {
        var that = $aa3b2aa1c98c0cc8$exports(this, 'Number#toPrecision: incorrect invocation!');
        return precision === undefined ? $438e0ec4ee9f93e2$var$$toPrecision.call(that) : $438e0ec4ee9f93e2$var$$toPrecision.call(that, precision);
    }
});


// 20.1.2.1 Number.EPSILON

var $fO65L = parcelRequire("fO65L");
$fO65L($fO65L.S, 'Number', {
    EPSILON: Math.pow(2, -52)
});


// 20.1.2.2 Number.isFinite(number)

var $fO65L = parcelRequire("fO65L");

var $jFKHr = parcelRequire("jFKHr");
var $861186241c22c888$require$_isFinite = $jFKHr.isFinite;
$fO65L($fO65L.S, 'Number', {
    isFinite: function isFinite(it) {
        return typeof it == 'number' && $861186241c22c888$require$_isFinite(it);
    }
});


// 20.1.2.3 Number.isInteger(number)

var $fO65L = parcelRequire("fO65L");

$fO65L($fO65L.S, 'Number', {
    isInteger: (parcelRequire("01OvM"))
});


// 20.1.2.4 Number.isNaN(number)

var $fO65L = parcelRequire("fO65L");
$fO65L($fO65L.S, 'Number', {
    isNaN: function isNaN(number) {
        // eslint-disable-next-line no-self-compare
        return number != number;
    }
});


// 20.1.2.5 Number.isSafeInteger(number)

var $fO65L = parcelRequire("fO65L");

var $01OvM = parcelRequire("01OvM");
var $98b8c1f90f90436a$var$abs = Math.abs;
$fO65L($fO65L.S, 'Number', {
    isSafeInteger: function isSafeInteger(number) {
        return $01OvM(number) && $98b8c1f90f90436a$var$abs(number) <= 0x1fffffffffffff;
    }
});


// 20.1.2.6 Number.MAX_SAFE_INTEGER

var $fO65L = parcelRequire("fO65L");
$fO65L($fO65L.S, 'Number', {
    MAX_SAFE_INTEGER: 0x1fffffffffffff
});


// 20.1.2.10 Number.MIN_SAFE_INTEGER

var $fO65L = parcelRequire("fO65L");
$fO65L($fO65L.S, 'Number', {
    MIN_SAFE_INTEGER: -9007199254740991
});



var $fO65L = parcelRequire("fO65L");

// 20.1.2.12 Number.parseFloat(string)
$fO65L($fO65L.S + $fO65L.F * (Number.parseFloat != $1b32e59a36a78eeb$exports), 'Number', {
    parseFloat: $1b32e59a36a78eeb$exports
});



var $fO65L = parcelRequire("fO65L");

// 20.1.2.13 Number.parseInt(string, radix)
$fO65L($fO65L.S + $fO65L.F * (Number.parseInt != $c2e5a0b81b23af58$exports), 'Number', {
    parseInt: $c2e5a0b81b23af58$exports
});


// 20.2.2.3 Math.acosh(x)

var $fO65L = parcelRequire("fO65L");

var $dg6i7 = parcelRequire("dg6i7");
var $4a868d0de29f17d1$var$sqrt = Math.sqrt;
var $4a868d0de29f17d1$var$$acosh = Math.acosh;
$fO65L($fO65L.S + $fO65L.F * !($4a868d0de29f17d1$var$$acosh && Math.floor($4a868d0de29f17d1$var$$acosh(Number.MAX_VALUE)) == 710 && $4a868d0de29f17d1$var$$acosh(Infinity) == Infinity), 'Math', {
    acosh: function acosh(x) {
        return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : $dg6i7(x - 1 + $4a868d0de29f17d1$var$sqrt(x - 1) * $4a868d0de29f17d1$var$sqrt(x + 1));
    }
});


// 20.2.2.5 Math.asinh(x)

var $fO65L = parcelRequire("fO65L");
var $56e4d0aacd389a7c$var$$asinh = Math.asinh;
function $56e4d0aacd389a7c$var$asinh(x) {
    return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -$56e4d0aacd389a7c$var$asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}
// Tor Browser bug: Math.asinh(0) -> -0
$fO65L($fO65L.S + $fO65L.F * !($56e4d0aacd389a7c$var$$asinh && 1 / $56e4d0aacd389a7c$var$$asinh(0) > 0), 'Math', {
    asinh: $56e4d0aacd389a7c$var$asinh
});


// 20.2.2.7 Math.atanh(x)

var $fO65L = parcelRequire("fO65L");
var $837584f6aa43d389$var$$atanh = Math.atanh;
// Tor Browser bug: Math.atanh(-0) -> 0
$fO65L($fO65L.S + $fO65L.F * !($837584f6aa43d389$var$$atanh && 1 / $837584f6aa43d389$var$$atanh(-0) < 0), 'Math', {
    atanh: function atanh(x) {
        return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
    }
});


// 20.2.2.9 Math.cbrt(x)

var $fO65L = parcelRequire("fO65L");

var $liGgn = parcelRequire("liGgn");
$fO65L($fO65L.S, 'Math', {
    cbrt: function cbrt(x) {
        return $liGgn(x = +x) * Math.pow(Math.abs(x), 1 / 3);
    }
});


// 20.2.2.11 Math.clz32(x)

var $fO65L = parcelRequire("fO65L");
$fO65L($fO65L.S, 'Math', {
    clz32: function clz32(x) {
        return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
    }
});


// 20.2.2.12 Math.cosh(x)

var $fO65L = parcelRequire("fO65L");
var $500378933902f485$var$exp = Math.exp;
$fO65L($fO65L.S, 'Math', {
    cosh: function cosh(x) {
        return ($500378933902f485$var$exp(x = +x) + $500378933902f485$var$exp(-x)) / 2;
    }
});


// 20.2.2.14 Math.expm1(x)

var $fO65L = parcelRequire("fO65L");
var $05eb99c25af4e120$exports = {};
// 20.2.2.14 Math.expm1(x)
var $05eb99c25af4e120$var$$expm1 = Math.expm1;
$05eb99c25af4e120$exports = !$05eb99c25af4e120$var$$expm1 || $05eb99c25af4e120$var$$expm1(10) > 22025.465794806719 || $05eb99c25af4e120$var$$expm1(10) < 22025.4657948067165168 || $05eb99c25af4e120$var$$expm1(-0.00000000000000002) != -0.00000000000000002 ? function expm1(x) {
    return (x = +x) == 0 ? x : x > -0.000001 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $05eb99c25af4e120$var$$expm1;


$fO65L($fO65L.S + $fO65L.F * ($05eb99c25af4e120$exports != Math.expm1), 'Math', {
    expm1: $05eb99c25af4e120$exports
});


// 20.2.2.16 Math.fround(x)

var $fO65L = parcelRequire("fO65L");

$fO65L($fO65L.S, 'Math', {
    fround: (parcelRequire("e0ukR"))
});


// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])

var $fO65L = parcelRequire("fO65L");
var $45fb4fc2fce25a9a$var$abs = Math.abs;
$fO65L($fO65L.S, 'Math', {
    hypot: function hypot(value1, value2) {
        var sum = 0;
        var i = 0;
        var aLen = arguments.length;
        var larg = 0;
        var arg, div;
        while(i < aLen){
            arg = $45fb4fc2fce25a9a$var$abs(arguments[i++]);
            if (larg < arg) {
                div = larg / arg;
                sum = sum * div * div + 1;
                larg = arg;
            } else if (arg > 0) {
                div = arg / larg;
                sum += div * div;
            } else sum += arg;
        }
        return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
    }
});


// 20.2.2.18 Math.imul(x, y)

var $fO65L = parcelRequire("fO65L");
var $a897538f990139e1$var$$imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$fO65L($fO65L.S + $fO65L.F * (parcelRequire("gtdMs"))(function() {
    return $a897538f990139e1$var$$imul(0xffffffff, 5) != -5 || $a897538f990139e1$var$$imul.length != 2;
}), 'Math', {
    imul: function imul(x, y) {
        var UINT16 = 0xffff;
        var xn = +x;
        var yn = +y;
        var xl = UINT16 & xn;
        var yl = UINT16 & yn;
        return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
    }
});


// 20.2.2.21 Math.log10(x)

var $fO65L = parcelRequire("fO65L");
$fO65L($fO65L.S, 'Math', {
    log10: function log10(x) {
        return Math.log(x) * Math.LOG10E;
    }
});


// 20.2.2.20 Math.log1p(x)

var $fO65L = parcelRequire("fO65L");

$fO65L($fO65L.S, 'Math', {
    log1p: (parcelRequire("dg6i7"))
});


// 20.2.2.22 Math.log2(x)

var $fO65L = parcelRequire("fO65L");
$fO65L($fO65L.S, 'Math', {
    log2: function log2(x) {
        return Math.log(x) / Math.LN2;
    }
});


// 20.2.2.28 Math.sign(x)

var $fO65L = parcelRequire("fO65L");

$fO65L($fO65L.S, 'Math', {
    sign: (parcelRequire("liGgn"))
});


// 20.2.2.30 Math.sinh(x)

var $fO65L = parcelRequire("fO65L");

var $917b7eae93bfa313$var$exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$fO65L($fO65L.S + $fO65L.F * (parcelRequire("gtdMs"))(function() {
    return !Math.sinh(-0.00000000000000002) != -0.00000000000000002;
}), 'Math', {
    sinh: function sinh(x) {
        return Math.abs(x = +x) < 1 ? ($05eb99c25af4e120$exports(x) - $05eb99c25af4e120$exports(-x)) / 2 : ($917b7eae93bfa313$var$exp(x - 1) - $917b7eae93bfa313$var$exp(-x - 1)) * (Math.E / 2);
    }
});


// 20.2.2.33 Math.tanh(x)

var $fO65L = parcelRequire("fO65L");

var $a101b688e9c1c0c9$var$exp = Math.exp;
$fO65L($fO65L.S, 'Math', {
    tanh: function tanh(x) {
        var a = $05eb99c25af4e120$exports(x = +x);
        var b = $05eb99c25af4e120$exports(-x);
        return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / ($a101b688e9c1c0c9$var$exp(x) + $a101b688e9c1c0c9$var$exp(-x));
    }
});


// 20.2.2.34 Math.trunc(x)

var $fO65L = parcelRequire("fO65L");
$fO65L($fO65L.S, 'Math', {
    trunc: function trunc(it) {
        return (it > 0 ? Math.floor : Math.ceil)(it);
    }
});



var $fO65L = parcelRequire("fO65L");

var $iWPS0 = parcelRequire("iWPS0");
var $9236357e5007d251$var$fromCharCode = String.fromCharCode;
var $9236357e5007d251$var$$fromCodePoint = String.fromCodePoint;
// length should be 1, old FF problem
$fO65L($fO65L.S + $fO65L.F * (!!$9236357e5007d251$var$$fromCodePoint && $9236357e5007d251$var$$fromCodePoint.length != 1), 'String', {
    // 21.1.2.2 String.fromCodePoint(...codePoints)
    fromCodePoint: function fromCodePoint(x) {
        var res = [];
        var aLen = arguments.length;
        var i = 0;
        var code;
        while(aLen > i){
            code = +arguments[i++];
            if ($iWPS0(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
            res.push(code < 0x10000 ? $9236357e5007d251$var$fromCharCode(code) : $9236357e5007d251$var$fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
        }
        return res.join('');
    }
});



var $fO65L = parcelRequire("fO65L");

var $3hDAb = parcelRequire("3hDAb");

var $igR5o = parcelRequire("igR5o");
$fO65L($fO65L.S, 'String', {
    // 21.1.2.4 String.raw(callSite, ...substitutions)
    raw: function raw(callSite) {
        var tpl = $3hDAb(callSite.raw);
        var len = $igR5o(tpl.length);
        var aLen = arguments.length;
        var res = [];
        var i = 0;
        while(len > i){
            res.push(String(tpl[i++]));
            if (i < aLen) res.push(String(arguments[i]));
        }
        return res.join('');
    }
});


'use strict';

// 21.1.3.25 String.prototype.trim()
(parcelRequire("218jD"))('trim', function($trim) {
    return function trim() {
        return $trim(this, 3);
    };
});


'use strict';

var $9f8cb04ee88a638e$var$$at = (parcelRequire("gBqgj"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("iHG7p"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $9f8cb04ee88a638e$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});


'use strict';

var $fO65L = parcelRequire("fO65L");

var $621c47e2b96a75a7$var$$at = (parcelRequire("gBqgj"))(false);
$fO65L($fO65L.P, 'String', {
    // 21.1.3.3 String.prototype.codePointAt(pos)
    codePointAt: function codePointAt(pos) {
        return $621c47e2b96a75a7$var$$at(this, pos);
    }
});


// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';

var $fO65L = parcelRequire("fO65L");

var $igR5o = parcelRequire("igR5o");
var $e541d9afc2c2e20d$exports = {};
// helper for String#{startsWith, endsWith, includes}
var $5c5d83a18f7afeaf$exports = {};
// 7.2.8 IsRegExp(argument)

var $1WkAz = parcelRequire("1WkAz");

var $k4Th0 = parcelRequire("k4Th0");

var $5c5d83a18f7afeaf$var$MATCH = (parcelRequire("kC7Sb"))('match');
$5c5d83a18f7afeaf$exports = function(it) {
    var isRegExp;
    return $1WkAz(it) && ((isRegExp = it[$5c5d83a18f7afeaf$var$MATCH]) !== undefined ? !!isRegExp : $k4Th0(it) == 'RegExp');
};



var $7kSv5 = parcelRequire("7kSv5");
$e541d9afc2c2e20d$exports = function(that, searchString, NAME) {
    if ($5c5d83a18f7afeaf$exports(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
    return String($7kSv5(that));
};


var $0e24be5bf12866d8$var$ENDS_WITH = 'endsWith';
var $0e24be5bf12866d8$var$$endsWith = ''[$0e24be5bf12866d8$var$ENDS_WITH];

$fO65L($fO65L.P + $fO65L.F * (parcelRequire("4epiS"))($0e24be5bf12866d8$var$ENDS_WITH), 'String', {
    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
        var that = $e541d9afc2c2e20d$exports(this, searchString, $0e24be5bf12866d8$var$ENDS_WITH);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = $igR5o(that.length);
        var end = endPosition === undefined ? len : Math.min($igR5o(endPosition), len);
        var search = String(searchString);
        return $0e24be5bf12866d8$var$$endsWith ? $0e24be5bf12866d8$var$$endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
    }
});


// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';

var $fO65L = parcelRequire("fO65L");

var $d6c0c2254d123689$var$INCLUDES = 'includes';

$fO65L($fO65L.P + $fO65L.F * (parcelRequire("4epiS"))($d6c0c2254d123689$var$INCLUDES), 'String', {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$e541d9afc2c2e20d$exports(this, searchString, $d6c0c2254d123689$var$INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
    }
});



var $fO65L = parcelRequire("fO65L");

$fO65L($fO65L.P, 'String', {
    // 21.1.3.13 String.prototype.repeat(count)
    repeat: (parcelRequire("2sMRG"))
});


// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';

var $fO65L = parcelRequire("fO65L");

var $igR5o = parcelRequire("igR5o");

var $fa5363f8873bca43$var$STARTS_WITH = 'startsWith';
var $fa5363f8873bca43$var$$startsWith = ''[$fa5363f8873bca43$var$STARTS_WITH];

$fO65L($fO65L.P + $fO65L.F * (parcelRequire("4epiS"))($fa5363f8873bca43$var$STARTS_WITH), 'String', {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $e541d9afc2c2e20d$exports(this, searchString, $fa5363f8873bca43$var$STARTS_WITH);
        var index = $igR5o(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = String(searchString);
        return $fa5363f8873bca43$var$$startsWith ? $fa5363f8873bca43$var$$startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
    }
});


'use strict';

// B.2.3.2 String.prototype.anchor(name)
(parcelRequire("21MH9"))('anchor', function(createHTML) {
    return function anchor(name) {
        return createHTML(this, 'a', 'name', name);
    };
});


'use strict';

// B.2.3.3 String.prototype.big()
(parcelRequire("21MH9"))('big', function(createHTML) {
    return function big() {
        return createHTML(this, 'big', '', '');
    };
});


'use strict';

// B.2.3.4 String.prototype.blink()
(parcelRequire("21MH9"))('blink', function(createHTML) {
    return function blink() {
        return createHTML(this, 'blink', '', '');
    };
});


'use strict';

// B.2.3.5 String.prototype.bold()
(parcelRequire("21MH9"))('bold', function(createHTML) {
    return function bold() {
        return createHTML(this, 'b', '', '');
    };
});


'use strict';

// B.2.3.6 String.prototype.fixed()
(parcelRequire("21MH9"))('fixed', function(createHTML) {
    return function fixed() {
        return createHTML(this, 'tt', '', '');
    };
});


'use strict';

// B.2.3.7 String.prototype.fontcolor(color)
(parcelRequire("21MH9"))('fontcolor', function(createHTML) {
    return function fontcolor(color) {
        return createHTML(this, 'font', 'color', color);
    };
});


'use strict';

// B.2.3.8 String.prototype.fontsize(size)
(parcelRequire("21MH9"))('fontsize', function(createHTML) {
    return function fontsize(size) {
        return createHTML(this, 'font', 'size', size);
    };
});


'use strict';

// B.2.3.9 String.prototype.italics()
(parcelRequire("21MH9"))('italics', function(createHTML) {
    return function italics() {
        return createHTML(this, 'i', '', '');
    };
});


'use strict';

// B.2.3.10 String.prototype.link(url)
(parcelRequire("21MH9"))('link', function(createHTML) {
    return function link(url) {
        return createHTML(this, 'a', 'href', url);
    };
});


'use strict';

// B.2.3.11 String.prototype.small()
(parcelRequire("21MH9"))('small', function(createHTML) {
    return function small() {
        return createHTML(this, 'small', '', '');
    };
});


'use strict';

// B.2.3.12 String.prototype.strike()
(parcelRequire("21MH9"))('strike', function(createHTML) {
    return function strike() {
        return createHTML(this, 'strike', '', '');
    };
});


'use strict';

// B.2.3.13 String.prototype.sub()
(parcelRequire("21MH9"))('sub', function(createHTML) {
    return function sub() {
        return createHTML(this, 'sub', '', '');
    };
});


'use strict';

// B.2.3.14 String.prototype.sup()
(parcelRequire("21MH9"))('sup', function(createHTML) {
    return function sup() {
        return createHTML(this, 'sup', '', '');
    };
});


// 20.3.3.1 / 15.9.4.4 Date.now()

var $fO65L = parcelRequire("fO65L");
$fO65L($fO65L.S, 'Date', {
    now: function() {
        return new Date().getTime();
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");

var $eb8lU = parcelRequire("eb8lU");

var $ltjni = parcelRequire("ltjni");

$fO65L($fO65L.P + $fO65L.F * (parcelRequire("gtdMs"))(function() {
    return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
        toISOString: function() {
            return 1;
        }
    }) !== 1;
}), 'Date', {
    // eslint-disable-next-line no-unused-vars
    toJSON: function toJSON(key) {
        var O = $eb8lU(this);
        var pv = $ltjni(O);
        return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
    }
});


// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()

var $fO65L = parcelRequire("fO65L");
var $af6bbac9ca71a5ee$exports = {};
'use strict';

var $gtdMs = parcelRequire("gtdMs");
var $af6bbac9ca71a5ee$var$getTime = Date.prototype.getTime;
var $af6bbac9ca71a5ee$var$$toISOString = Date.prototype.toISOString;
var $af6bbac9ca71a5ee$var$lz = function(num) {
    return num > 9 ? num : '0' + num;
};
// PhantomJS / old WebKit has a broken implementations
$af6bbac9ca71a5ee$exports = $gtdMs(function() {
    return $af6bbac9ca71a5ee$var$$toISOString.call(new Date(-50000000000000 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !$gtdMs(function() {
    $af6bbac9ca71a5ee$var$$toISOString.call(new Date(NaN));
}) ? function toISOString() {
    if (!isFinite($af6bbac9ca71a5ee$var$getTime.call(this))) throw RangeError('Invalid time value');
    var d = this;
    var y = d.getUTCFullYear();
    var m = d.getUTCMilliseconds();
    var s = y < 0 ? '-' : y > 9999 ? '+' : '';
    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + $af6bbac9ca71a5ee$var$lz(d.getUTCMonth() + 1) + '-' + $af6bbac9ca71a5ee$var$lz(d.getUTCDate()) + 'T' + $af6bbac9ca71a5ee$var$lz(d.getUTCHours()) + ':' + $af6bbac9ca71a5ee$var$lz(d.getUTCMinutes()) + ':' + $af6bbac9ca71a5ee$var$lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + $af6bbac9ca71a5ee$var$lz(m)) + 'Z';
} : $af6bbac9ca71a5ee$var$$toISOString;


// PhantomJS / old WebKit has a broken implementations
$fO65L($fO65L.P + $fO65L.F * (Date.prototype.toISOString !== $af6bbac9ca71a5ee$exports), 'Date', {
    toISOString: $af6bbac9ca71a5ee$exports
});


var $503f802eaefb9299$var$DateProto = Date.prototype;
var $503f802eaefb9299$var$INVALID_DATE = 'Invalid Date';
var $503f802eaefb9299$var$TO_STRING = 'toString';
var $503f802eaefb9299$var$$toString = $503f802eaefb9299$var$DateProto[$503f802eaefb9299$var$TO_STRING];
var $503f802eaefb9299$var$getTime = $503f802eaefb9299$var$DateProto.getTime;

if (new Date(NaN) + '' != $503f802eaefb9299$var$INVALID_DATE) (parcelRequire("10sdZ"))($503f802eaefb9299$var$DateProto, $503f802eaefb9299$var$TO_STRING, function toString() {
    var value = $503f802eaefb9299$var$getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $503f802eaefb9299$var$$toString.call(this) : $503f802eaefb9299$var$INVALID_DATE;
});



var $af0ff5f2f434d1fa$var$TO_PRIMITIVE = (parcelRequire("kC7Sb"))('toPrimitive');
var $af0ff5f2f434d1fa$var$proto = Date.prototype;


if (!($af0ff5f2f434d1fa$var$TO_PRIMITIVE in $af0ff5f2f434d1fa$var$proto)) (parcelRequire("fMiEZ"))($af0ff5f2f434d1fa$var$proto, $af0ff5f2f434d1fa$var$TO_PRIMITIVE, (parcelRequire("ipaqp")));


// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)

var $fO65L = parcelRequire("fO65L");

$fO65L($fO65L.S, 'Array', {
    isArray: (parcelRequire("hRWRg"))
});


'use strict';

var $ATdaw = parcelRequire("ATdaw");

var $fO65L = parcelRequire("fO65L");

var $eb8lU = parcelRequire("eb8lU");

var $cVo8z = parcelRequire("cVo8z");

var $bRXyE = parcelRequire("bRXyE");

var $igR5o = parcelRequire("igR5o");
var $88c57f683c4f232c$exports = {};
'use strict';

var $lhvOa = parcelRequire("lhvOa");

var $fTxIB = parcelRequire("fTxIB");
$88c57f683c4f232c$exports = function(object, index, value) {
    if (index in object) $lhvOa.f(object, index, $fTxIB(0, value));
    else object[index] = value;
};



var $fm12X = parcelRequire("fm12X");

$fO65L($fO65L.S + $fO65L.F * !(parcelRequire("5HrAP"))(function(iter) {
    Array.from(iter);
}), 'Array', {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
        var O = $eb8lU(arrayLike);
        var C = typeof this == 'function' ? this : Array;
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var index = 0;
        var iterFn = $fm12X(O);
        var length, result, step, iterator;
        if (mapping) mapfn = $ATdaw(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
        // if object isn't iterable or it's array with default iterator - use simple case
        if (iterFn != undefined && !(C == Array && $bRXyE(iterFn))) for(iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++)$88c57f683c4f232c$exports(result, index, mapping ? $cVo8z(iterator, mapfn, [
            step.value,
            index
        ], true) : step.value);
        else {
            length = $igR5o(O.length);
            for(result = new C(length); length > index; index++)$88c57f683c4f232c$exports(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
        result.length = index;
        return result;
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");


// WebKit Array.of isn't generic
$fO65L($fO65L.S + $fO65L.F * (parcelRequire("gtdMs"))(function() {
    function F() {}
    return !(Array.of.call(F) instanceof F);
}), 'Array', {
    // 22.1.2.3 Array.of( ...items)
    of: function of() {
        var index = 0;
        var aLen = arguments.length;
        var result = new (typeof this == 'function' ? this : Array)(aLen);
        while(aLen > index)$88c57f683c4f232c$exports(result, index, arguments[index++]);
        result.length = aLen;
        return result;
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");

var $3hDAb = parcelRequire("3hDAb");
var $8895ebcf3e0ba4cb$var$arrayJoin = [].join;


// fallback for not array-like strings
$fO65L($fO65L.P + $fO65L.F * ((parcelRequire("dz1a9")) != Object || !(parcelRequire("iWRb1"))($8895ebcf3e0ba4cb$var$arrayJoin)), 'Array', {
    join: function join(separator) {
        return $8895ebcf3e0ba4cb$var$arrayJoin.call($3hDAb(this), separator === undefined ? ',' : separator);
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");

var $e7ZIo = parcelRequire("e7ZIo");

var $k4Th0 = parcelRequire("k4Th0");

var $iWPS0 = parcelRequire("iWPS0");

var $igR5o = parcelRequire("igR5o");
var $955e3bcc0eb93792$var$arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$fO65L($fO65L.P + $fO65L.F * (parcelRequire("gtdMs"))(function() {
    if ($e7ZIo) $955e3bcc0eb93792$var$arraySlice.call($e7ZIo);
}), 'Array', {
    slice: function slice(begin, end) {
        var len = $igR5o(this.length);
        var klass = $k4Th0(this);
        end = end === undefined ? len : end;
        if (klass == 'Array') return $955e3bcc0eb93792$var$arraySlice.call(this, begin, end);
        var start = $iWPS0(begin, len);
        var upTo = $iWPS0(end, len);
        var size = $igR5o(upTo - start);
        var cloned = new Array(size);
        var i = 0;
        for(; i < size; i++)cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
        return cloned;
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");

var $bCxjV = parcelRequire("bCxjV");

var $eb8lU = parcelRequire("eb8lU");

var $gtdMs = parcelRequire("gtdMs");
var $bc550e248404eb86$var$$sort = [].sort;
var $bc550e248404eb86$var$test = [
    1,
    2,
    3
];

$fO65L($fO65L.P + $fO65L.F * ($gtdMs(function() {
    // IE8-
    $bc550e248404eb86$var$test.sort(undefined);
}) || !$gtdMs(function() {
    // V8 bug
    $bc550e248404eb86$var$test.sort(null);
// Old WebKit
}) || !(parcelRequire("iWRb1"))($bc550e248404eb86$var$$sort)), 'Array', {
    // 22.1.3.25 Array.prototype.sort(comparefn)
    sort: function sort(comparefn) {
        return comparefn === undefined ? $bc550e248404eb86$var$$sort.call($eb8lU(this)) : $bc550e248404eb86$var$$sort.call($eb8lU(this), $bCxjV(comparefn));
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");

var $c804a6b43ffad9a0$var$$forEach = (parcelRequire("d90U1"))(0);

var $c804a6b43ffad9a0$var$STRICT = (parcelRequire("iWRb1"))([].forEach, true);
$fO65L($fO65L.P + $fO65L.F * !$c804a6b43ffad9a0$var$STRICT, 'Array', {
    // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
    forEach: function forEach(callbackfn /* , thisArg */ ) {
        return $c804a6b43ffad9a0$var$$forEach(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");

var $6a0742d1bf1a67eb$var$$map = (parcelRequire("d90U1"))(1);

$fO65L($fO65L.P + $fO65L.F * !(parcelRequire("iWRb1"))([].map, true), 'Array', {
    // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
    map: function map(callbackfn /* , thisArg */ ) {
        return $6a0742d1bf1a67eb$var$$map(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");

var $1ea4680fde68056a$var$$filter = (parcelRequire("d90U1"))(2);

$fO65L($fO65L.P + $fO65L.F * !(parcelRequire("iWRb1"))([].filter, true), 'Array', {
    // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $1ea4680fde68056a$var$$filter(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");

var $c59bd9e8a0873cb5$var$$some = (parcelRequire("d90U1"))(3);

$fO65L($fO65L.P + $fO65L.F * !(parcelRequire("iWRb1"))([].some, true), 'Array', {
    // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
    some: function some(callbackfn /* , thisArg */ ) {
        return $c59bd9e8a0873cb5$var$$some(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");

var $200df111b658ef65$var$$every = (parcelRequire("d90U1"))(4);

$fO65L($fO65L.P + $fO65L.F * !(parcelRequire("iWRb1"))([].every, true), 'Array', {
    // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
    every: function every(callbackfn /* , thisArg */ ) {
        return $200df111b658ef65$var$$every(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");
var $801cfb897eda4b7f$exports = {};

var $bCxjV = parcelRequire("bCxjV");

var $eb8lU = parcelRequire("eb8lU");

var $dz1a9 = parcelRequire("dz1a9");

var $igR5o = parcelRequire("igR5o");
$801cfb897eda4b7f$exports = function(that, callbackfn, aLen, memo, isRight) {
    $bCxjV(callbackfn);
    var O = $eb8lU(that);
    var self = $dz1a9(O);
    var length = $igR5o(O.length);
    var index = isRight ? length - 1 : 0;
    var i = isRight ? -1 : 1;
    if (aLen < 2) for(;;){
        if (index in self) {
            memo = self[index];
            index += i;
            break;
        }
        index += i;
        if (isRight ? index < 0 : length <= index) throw TypeError('Reduce of empty array with no initial value');
    }
    for(; isRight ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
    return memo;
};



$fO65L($fO65L.P + $fO65L.F * !(parcelRequire("iWRb1"))([].reduce, true), 'Array', {
    // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        return $801cfb897eda4b7f$exports(this, callbackfn, arguments.length, arguments[1], false);
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");


$fO65L($fO65L.P + $fO65L.F * !(parcelRequire("iWRb1"))([].reduceRight, true), 'Array', {
    // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
    reduceRight: function reduceRight(callbackfn /* , initialValue */ ) {
        return $801cfb897eda4b7f$exports(this, callbackfn, arguments.length, arguments[1], true);
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");

var $2c3d164a46eeda64$var$$indexOf = (parcelRequire("fhIl3"))(false);
var $2c3d164a46eeda64$var$$native = [].indexOf;
var $2c3d164a46eeda64$var$NEGATIVE_ZERO = !!$2c3d164a46eeda64$var$$native && 1 / [
    1
].indexOf(1, -0) < 0;

$fO65L($fO65L.P + $fO65L.F * ($2c3d164a46eeda64$var$NEGATIVE_ZERO || !(parcelRequire("iWRb1"))($2c3d164a46eeda64$var$$native)), 'Array', {
    // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
        return $2c3d164a46eeda64$var$NEGATIVE_ZERO ? $2c3d164a46eeda64$var$$native.apply(this, arguments) || 0 : $2c3d164a46eeda64$var$$indexOf(this, searchElement, arguments[1]);
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");

var $3hDAb = parcelRequire("3hDAb");

var $U0K0I = parcelRequire("U0K0I");

var $igR5o = parcelRequire("igR5o");
var $76edbe6366392bf4$var$$native = [].lastIndexOf;
var $76edbe6366392bf4$var$NEGATIVE_ZERO = !!$76edbe6366392bf4$var$$native && 1 / [
    1
].lastIndexOf(1, -0) < 0;

$fO65L($fO65L.P + $fO65L.F * ($76edbe6366392bf4$var$NEGATIVE_ZERO || !(parcelRequire("iWRb1"))($76edbe6366392bf4$var$$native)), 'Array', {
    // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */ ) {
        // convert -0 to +0
        if ($76edbe6366392bf4$var$NEGATIVE_ZERO) return $76edbe6366392bf4$var$$native.apply(this, arguments) || 0;
        var O = $3hDAb(this);
        var length = $igR5o(O.length);
        var index = length - 1;
        if (arguments.length > 1) index = Math.min(index, $U0K0I(arguments[1]));
        if (index < 0) index = length + index;
        for(; index >= 0; index--)if (index in O) {
            if (O[index] === searchElement) return index || 0;
        }
        return -1;
    }
});


// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var $fO65L = parcelRequire("fO65L");

$fO65L($fO65L.P, 'Array', {
    copyWithin: (parcelRequire("blz7k"))
});

(parcelRequire("elzBR"))('copyWithin');


// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var $fO65L = parcelRequire("fO65L");

$fO65L($fO65L.P, 'Array', {
    fill: (parcelRequire("fC6rw"))
});

(parcelRequire("elzBR"))('fill');


'use strict';

var $fO65L = parcelRequire("fO65L");

var $12cb51fe1fb476ca$var$$find = (parcelRequire("d90U1"))(5);
var $12cb51fe1fb476ca$var$KEY = 'find';
var $12cb51fe1fb476ca$var$forced = true;
// Shouldn't skip holes
if ($12cb51fe1fb476ca$var$KEY in []) Array(1)[$12cb51fe1fb476ca$var$KEY](function() {
    $12cb51fe1fb476ca$var$forced = false;
});
$fO65L($fO65L.P + $fO65L.F * $12cb51fe1fb476ca$var$forced, 'Array', {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $12cb51fe1fb476ca$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("elzBR"))($12cb51fe1fb476ca$var$KEY);


'use strict';

var $fO65L = parcelRequire("fO65L");

var $b80c1778f0ebb146$var$$find = (parcelRequire("d90U1"))(6);
var $b80c1778f0ebb146$var$KEY = 'findIndex';
var $b80c1778f0ebb146$var$forced = true;
// Shouldn't skip holes
if ($b80c1778f0ebb146$var$KEY in []) Array(1)[$b80c1778f0ebb146$var$KEY](function() {
    $b80c1778f0ebb146$var$forced = false;
});
$fO65L($fO65L.P + $fO65L.F * $b80c1778f0ebb146$var$forced, 'Array', {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $b80c1778f0ebb146$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("elzBR"))($b80c1778f0ebb146$var$KEY);



(parcelRequire("68OYb"))('Array');


parcelRequire("lA4ZU");

var $jFKHr = parcelRequire("jFKHr");

var $6yI0d = parcelRequire("6yI0d");

var $lhvOa = parcelRequire("lhvOa");
var $8871a0c84c404b8c$require$dP = $lhvOa.f;

var $9B1GU = parcelRequire("9B1GU");
var $8871a0c84c404b8c$require$gOPN = $9B1GU.f;


var $kuOKi = parcelRequire("kuOKi");
var $8871a0c84c404b8c$var$$RegExp = $jFKHr.RegExp;
var $8871a0c84c404b8c$var$Base = $8871a0c84c404b8c$var$$RegExp;
var $8871a0c84c404b8c$var$proto = $8871a0c84c404b8c$var$$RegExp.prototype;
var $8871a0c84c404b8c$var$re1 = /a/g;
var $8871a0c84c404b8c$var$re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var $8871a0c84c404b8c$var$CORRECT_NEW = new $8871a0c84c404b8c$var$$RegExp($8871a0c84c404b8c$var$re1) !== $8871a0c84c404b8c$var$re1;



var $kC7Sb = parcelRequire("kC7Sb");

if ((parcelRequire("cAHsA")) && (!$8871a0c84c404b8c$var$CORRECT_NEW || (parcelRequire("gtdMs"))(function() {
    $8871a0c84c404b8c$var$re2[$kC7Sb('match')] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return $8871a0c84c404b8c$var$$RegExp($8871a0c84c404b8c$var$re1) != $8871a0c84c404b8c$var$re1 || $8871a0c84c404b8c$var$$RegExp($8871a0c84c404b8c$var$re2) == $8871a0c84c404b8c$var$re2 || $8871a0c84c404b8c$var$$RegExp($8871a0c84c404b8c$var$re1, 'i') != '/a/i';
}))) {
    $8871a0c84c404b8c$var$$RegExp = function RegExp(p, f) {
        var tiRE = this instanceof $8871a0c84c404b8c$var$$RegExp;
        var piRE = $5c5d83a18f7afeaf$exports(p);
        var fiU = f === undefined;
        return !tiRE && piRE && p.constructor === $8871a0c84c404b8c$var$$RegExp && fiU ? p : $6yI0d($8871a0c84c404b8c$var$CORRECT_NEW ? new $8871a0c84c404b8c$var$Base(piRE && !fiU ? p.source : p, f) : $8871a0c84c404b8c$var$Base((piRE = p instanceof $8871a0c84c404b8c$var$$RegExp) ? p.source : p, piRE && fiU ? $kuOKi.call(p) : f), tiRE ? this : $8871a0c84c404b8c$var$proto, $8871a0c84c404b8c$var$$RegExp);
    };
    var $8871a0c84c404b8c$var$proxy = function(key) {
        key in $8871a0c84c404b8c$var$$RegExp || $8871a0c84c404b8c$require$dP($8871a0c84c404b8c$var$$RegExp, key, {
            configurable: true,
            get: function() {
                return $8871a0c84c404b8c$var$Base[key];
            },
            set: function(it) {
                $8871a0c84c404b8c$var$Base[key] = it;
            }
        });
    };
    for(var $8871a0c84c404b8c$var$keys = $8871a0c84c404b8c$require$gOPN($8871a0c84c404b8c$var$Base), $8871a0c84c404b8c$var$i = 0; $8871a0c84c404b8c$var$keys.length > $8871a0c84c404b8c$var$i;)$8871a0c84c404b8c$var$proxy($8871a0c84c404b8c$var$keys[$8871a0c84c404b8c$var$i++]);
    $8871a0c84c404b8c$var$proto.constructor = $8871a0c84c404b8c$var$$RegExp;
    $8871a0c84c404b8c$var$$RegExp.prototype = $8871a0c84c404b8c$var$proto;
    (parcelRequire("10sdZ"))($jFKHr, 'RegExp', $8871a0c84c404b8c$var$$RegExp);
}

(parcelRequire("68OYb"))('RegExp');


parcelRequire("irY8l");
'use strict';
// 21.2.5.3 get RegExp.prototype.flags()



if ((parcelRequire("cAHsA")) && /./g.flags != 'g') (parcelRequire("lhvOa")).f(RegExp.prototype, 'flags', {
    configurable: true,
    get: (parcelRequire("kuOKi"))
});



var $978rB = parcelRequire("978rB");

var $kuOKi = parcelRequire("kuOKi");

var $cAHsA = parcelRequire("cAHsA");
var $4ba8959cafee3c06$var$TO_STRING = 'toString';
var $4ba8959cafee3c06$var$$toString = /./[$4ba8959cafee3c06$var$TO_STRING];

var $4ba8959cafee3c06$var$define = function(fn) {
    (parcelRequire("10sdZ"))(RegExp.prototype, $4ba8959cafee3c06$var$TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if ((parcelRequire("gtdMs"))(function() {
    return $4ba8959cafee3c06$var$$toString.call({
        source: 'a',
        flags: 'b'
    }) != '/a/b';
})) $4ba8959cafee3c06$var$define(function toString() {
    var R = $978rB(this);
    return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !$cAHsA && R instanceof RegExp ? $kuOKi.call(R) : undefined);
});
else if ($4ba8959cafee3c06$var$$toString.name != $4ba8959cafee3c06$var$TO_STRING) $4ba8959cafee3c06$var$define(function toString() {
    return $4ba8959cafee3c06$var$$toString.call(this);
});



'use strict';

var $978rB = parcelRequire("978rB");

var $igR5o = parcelRequire("igR5o");
var $d428d46d5632ea4b$exports = {};
'use strict';

var $d428d46d5632ea4b$var$at = (parcelRequire("gBqgj"))(true);
// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
$d428d46d5632ea4b$exports = function(S, index, unicode) {
    return index + (unicode ? $d428d46d5632ea4b$var$at(S, index).length : 1);
};


var $a584b86c356b3adc$exports = {};
'use strict';

var $8iPtU = parcelRequire("8iPtU");
var $a584b86c356b3adc$var$builtinExec = RegExp.prototype.exec;
// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
$a584b86c356b3adc$exports = function(R, S) {
    var exec = R.exec;
    if (typeof exec === 'function') {
        var result = exec.call(R, S);
        if (typeof result !== 'object') throw new TypeError('RegExp exec method returned something other than an Object or null');
        return result;
    }
    if ($8iPtU(R) !== 'RegExp') throw new TypeError('RegExp#exec called on incompatible receiver');
    return $a584b86c356b3adc$var$builtinExec.call(R, S);
};



// @@match logic
(parcelRequire("7TKGE"))('match', 1, function(defined, MATCH, $match, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[MATCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
        function(regexp) {
            var res = maybeCallNative($match, regexp, this);
            if (res.done) return res.value;
            var rx = $978rB(regexp);
            var S = String(this);
            if (!rx.global) return $a584b86c356b3adc$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $a584b86c356b3adc$exports(rx, S)) !== null){
                var matchStr = String(result[0]);
                A[n] = matchStr;
                if (matchStr === '') rx.lastIndex = $d428d46d5632ea4b$exports(S, $igR5o(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


'use strict';

var $978rB = parcelRequire("978rB");

var $eb8lU = parcelRequire("eb8lU");

var $igR5o = parcelRequire("igR5o");

var $U0K0I = parcelRequire("U0K0I");


var $0abf91a45bda400c$var$max = Math.max;
var $0abf91a45bda400c$var$min = Math.min;
var $0abf91a45bda400c$var$floor = Math.floor;
var $0abf91a45bda400c$var$SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var $0abf91a45bda400c$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
var $0abf91a45bda400c$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};

// @@replace logic
(parcelRequire("7TKGE"))('replace', 2, function(defined, REPLACE, $replace, maybeCallNative) {
    return [
        // `String.prototype.replace` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = defined(this);
            var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
            return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
        function(regexp, replaceValue) {
            var res = maybeCallNative($replace, regexp, this, replaceValue);
            if (res.done) return res.value;
            var rx = $978rB(regexp);
            var S = String(this);
            var functionalReplace = typeof replaceValue === 'function';
            if (!functionalReplace) replaceValue = String(replaceValue);
            var global = rx.global;
            if (global) {
                var fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            while(true){
                var result = $a584b86c356b3adc$exports(rx, S);
                if (result === null) break;
                results.push(result);
                if (!global) break;
                var matchStr = String(result[0]);
                if (matchStr === '') rx.lastIndex = $d428d46d5632ea4b$exports(S, $igR5o(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = '';
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = String(result[0]);
                var position = $0abf91a45bda400c$var$max($0abf91a45bda400c$var$min($U0K0I(result.index), S.length), 0);
                var captures = [];
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)captures.push($0abf91a45bda400c$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = [
                        matched
                    ].concat(captures, position, S);
                    if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
                    var replacement = String(replaceValue.apply(undefined, replacerArgs));
                } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + S.slice(nextSourcePosition);
        }
    ];
    // https://tc39.github.io/ecma262/#sec-getsubstitution
    function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
        var tailPos = position + matched.length;
        var m = captures.length;
        var symbols = $0abf91a45bda400c$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
        if (namedCaptures !== undefined) {
            namedCaptures = $eb8lU(namedCaptures);
            symbols = $0abf91a45bda400c$var$SUBSTITUTION_SYMBOLS;
        }
        return $replace.call(replacement, symbols, function(match, ch) {
            var capture;
            switch(ch.charAt(0)){
                case '$':
                    return '$';
                case '&':
                    return matched;
                case '`':
                    return str.slice(0, position);
                case "'":
                    return str.slice(tailPos);
                case '<':
                    capture = namedCaptures[ch.slice(1, -1)];
                    break;
                default:
                    var n = +ch;
                    if (n === 0) return match;
                    if (n > m) {
                        var f = $0abf91a45bda400c$var$floor(n / 10);
                        if (f === 0) return match;
                        if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                        return match;
                    }
                    capture = captures[n - 1];
            }
            return capture === undefined ? '' : capture;
        });
    }
});


'use strict';

var $978rB = parcelRequire("978rB");

var $gsEkn = parcelRequire("gsEkn");


// @@search logic
(parcelRequire("7TKGE"))('search', 1, function(defined, SEARCH, $search, maybeCallNative) {
    return [
        // `String.prototype.search` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.search
        function search(regexp) {
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[SEARCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
        },
        // `RegExp.prototype[@@search]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
        function(regexp) {
            var res = maybeCallNative($search, regexp, this);
            if (res.done) return res.value;
            var rx = $978rB(regexp);
            var S = String(this);
            var previousLastIndex = rx.lastIndex;
            if (!$gsEkn(previousLastIndex, 0)) rx.lastIndex = 0;
            var result = $a584b86c356b3adc$exports(rx, S);
            if (!$gsEkn(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
            return result === null ? -1 : result.index;
        }
    ];
});


'use strict';


var $978rB = parcelRequire("978rB");

var $cn7DE = parcelRequire("cn7DE");


var $igR5o = parcelRequire("igR5o");


var $3KKCO = parcelRequire("3KKCO");

var $gtdMs = parcelRequire("gtdMs");
var $e3afc1f0f45c2f4c$var$$min = Math.min;
var $e3afc1f0f45c2f4c$var$$push = [].push;
var $e3afc1f0f45c2f4c$var$$SPLIT = 'split';
var $e3afc1f0f45c2f4c$var$LENGTH = 'length';
var $e3afc1f0f45c2f4c$var$LAST_INDEX = 'lastIndex';
var $e3afc1f0f45c2f4c$var$MAX_UINT32 = 0xffffffff;
// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var $e3afc1f0f45c2f4c$var$SUPPORTS_Y = !$gtdMs(function() {
    RegExp($e3afc1f0f45c2f4c$var$MAX_UINT32, 'y');
});

// @@split logic
(parcelRequire("7TKGE"))('split', 2, function(defined, SPLIT, $split, maybeCallNative) {
    var internalSplit;
    if ('abbc'[$e3afc1f0f45c2f4c$var$$SPLIT](/(b)*/)[1] == 'c' || 'test'[$e3afc1f0f45c2f4c$var$$SPLIT](/(?:)/, -1)[$e3afc1f0f45c2f4c$var$LENGTH] != 4 || 'ab'[$e3afc1f0f45c2f4c$var$$SPLIT](/(?:ab)*/)[$e3afc1f0f45c2f4c$var$LENGTH] != 2 || '.'[$e3afc1f0f45c2f4c$var$$SPLIT](/(.?)(.?)/)[$e3afc1f0f45c2f4c$var$LENGTH] != 4 || '.'[$e3afc1f0f45c2f4c$var$$SPLIT](/()()/)[$e3afc1f0f45c2f4c$var$LENGTH] > 1 || ''[$e3afc1f0f45c2f4c$var$$SPLIT](/.?/)[$e3afc1f0f45c2f4c$var$LENGTH]) // based on es5-shim implementation, need to rework it
    internalSplit = function(separator, limit) {
        var string = String(this);
        if (separator === undefined && limit === 0) return [];
        // If `separator` is not a regex, use native split
        if (!$5c5d83a18f7afeaf$exports(separator)) return $split.call(string, separator, limit);
        var output = [];
        var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
        var lastLastIndex = 0;
        var splitLimit = limit === undefined ? $e3afc1f0f45c2f4c$var$MAX_UINT32 : limit >>> 0;
        // Make `global` and avoid `lastIndex` issues by working with a copy
        var separatorCopy = new RegExp(separator.source, flags + 'g');
        var match, lastIndex, lastLength;
        while(match = $3KKCO.call(separatorCopy, string)){
            lastIndex = separatorCopy[$e3afc1f0f45c2f4c$var$LAST_INDEX];
            if (lastIndex > lastLastIndex) {
                output.push(string.slice(lastLastIndex, match.index));
                if (match[$e3afc1f0f45c2f4c$var$LENGTH] > 1 && match.index < string[$e3afc1f0f45c2f4c$var$LENGTH]) $e3afc1f0f45c2f4c$var$$push.apply(output, match.slice(1));
                lastLength = match[0][$e3afc1f0f45c2f4c$var$LENGTH];
                lastLastIndex = lastIndex;
                if (output[$e3afc1f0f45c2f4c$var$LENGTH] >= splitLimit) break;
            }
            if (separatorCopy[$e3afc1f0f45c2f4c$var$LAST_INDEX] === match.index) separatorCopy[$e3afc1f0f45c2f4c$var$LAST_INDEX]++; // Avoid an infinite loop
        }
        if (lastLastIndex === string[$e3afc1f0f45c2f4c$var$LENGTH]) {
            if (lastLength || !separatorCopy.test('')) output.push('');
        } else output.push(string.slice(lastLastIndex));
        return output[$e3afc1f0f45c2f4c$var$LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
    else if ('0'[$e3afc1f0f45c2f4c$var$$SPLIT](undefined, 0)[$e3afc1f0f45c2f4c$var$LENGTH]) internalSplit = function(separator, limit) {
        return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
    else internalSplit = $split;
    return [
        // `String.prototype.split` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = defined(this);
            var splitter = separator == undefined ? undefined : separator[SPLIT];
            return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(regexp, limit) {
            var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
            if (res.done) return res.value;
            var rx = $978rB(regexp);
            var S = String(this);
            var C = $cn7DE(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + ($e3afc1f0f45c2f4c$var$SUPPORTS_Y ? 'y' : 'g');
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C($e3afc1f0f45c2f4c$var$SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
            var lim = limit === undefined ? $e3afc1f0f45c2f4c$var$MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return $a584b86c356b3adc$exports(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = $e3afc1f0f45c2f4c$var$SUPPORTS_Y ? q : 0;
                var z = $a584b86c356b3adc$exports(splitter, $e3afc1f0f45c2f4c$var$SUPPORTS_Y ? S : S.slice(q));
                var e;
                if (z === null || (e = $e3afc1f0f45c2f4c$var$$min($igR5o(splitter.lastIndex + ($e3afc1f0f45c2f4c$var$SUPPORTS_Y ? 0 : q)), S.length)) === p) q = $d428d46d5632ea4b$exports(S, q, unicodeMatching);
                else {
                    A.push(S.slice(p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        A.push(z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            A.push(S.slice(p));
            return A;
        }
    ];
});


'use strict';

var $cE8bo = parcelRequire("cE8bo");

var $jFKHr = parcelRequire("jFKHr");

var $ATdaw = parcelRequire("ATdaw");

var $8iPtU = parcelRequire("8iPtU");

var $fO65L = parcelRequire("fO65L");

var $1WkAz = parcelRequire("1WkAz");

var $bCxjV = parcelRequire("bCxjV");

var $bws30 = parcelRequire("bws30");

var $d1wID = parcelRequire("d1wID");

var $cn7DE = parcelRequire("cn7DE");

var $7gc9z = parcelRequire("7gc9z");
var $4122c788ac63a873$require$task = $7gc9z.set;

var $4122c788ac63a873$var$microtask = (parcelRequire("epQAv"))();
var $88f8d99f4ec813d8$exports = {};

$parcel$export($88f8d99f4ec813d8$exports, "f", function () { return $88f8d99f4ec813d8$export$2d1720544b23b823; }, function (v) { return $88f8d99f4ec813d8$export$2d1720544b23b823 = v; });
var $88f8d99f4ec813d8$export$2d1720544b23b823;
'use strict';

var $bCxjV = parcelRequire("bCxjV");
function $88f8d99f4ec813d8$var$PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $bCxjV(resolve);
    this.reject = $bCxjV(reject);
}
$88f8d99f4ec813d8$export$2d1720544b23b823 = function(C) {
    return new $88f8d99f4ec813d8$var$PromiseCapability(C);
};


var $29af1fd5df57feba$exports = {};
$29af1fd5df57feba$exports = function(exec) {
    try {
        return {
            e: false,
            v: exec()
        };
    } catch (e) {
        return {
            e: true,
            v: e
        };
    }
};


var $df79f3b24bb220c5$exports = {};

var $jFKHr = parcelRequire("jFKHr");
var $df79f3b24bb220c5$var$navigator = $jFKHr.navigator;
$df79f3b24bb220c5$exports = $df79f3b24bb220c5$var$navigator && $df79f3b24bb220c5$var$navigator.userAgent || '';


var $88b3177d98cfbde4$exports = {};

var $978rB = parcelRequire("978rB");

var $1WkAz = parcelRequire("1WkAz");

$88b3177d98cfbde4$exports = function(C, x) {
    $978rB(C);
    if ($1WkAz(x) && x.constructor === C) return x;
    var promiseCapability = $88f8d99f4ec813d8$export$2d1720544b23b823(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};


var $4122c788ac63a873$var$PROMISE = 'Promise';
var $4122c788ac63a873$var$TypeError = $jFKHr.TypeError;
var $4122c788ac63a873$var$process = $jFKHr.process;
var $4122c788ac63a873$var$versions = $4122c788ac63a873$var$process && $4122c788ac63a873$var$process.versions;
var $4122c788ac63a873$var$v8 = $4122c788ac63a873$var$versions && $4122c788ac63a873$var$versions.v8 || '';
var $4122c788ac63a873$var$$Promise = $jFKHr[$4122c788ac63a873$var$PROMISE];
var $4122c788ac63a873$var$isNode = $8iPtU($4122c788ac63a873$var$process) == 'process';
var $4122c788ac63a873$var$empty = function() {};
var $4122c788ac63a873$var$Internal, $4122c788ac63a873$var$newGenericPromiseCapability, $4122c788ac63a873$var$OwnPromiseCapability, $4122c788ac63a873$var$Wrapper;
var $4122c788ac63a873$var$newPromiseCapability = $4122c788ac63a873$var$newGenericPromiseCapability = $88f8d99f4ec813d8$export$2d1720544b23b823;

var $4122c788ac63a873$var$USE_NATIVE = !!function() {
    try {
        // correct subclassing with @@species support
        var promise = $4122c788ac63a873$var$$Promise.resolve(1);
        var FakePromise = (promise.constructor = {})[(parcelRequire("kC7Sb"))('species')] = function(exec) {
            exec($4122c788ac63a873$var$empty, $4122c788ac63a873$var$empty);
        };
        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return ($4122c788ac63a873$var$isNode || typeof PromiseRejectionEvent == 'function') && promise.then($4122c788ac63a873$var$empty) instanceof FakePromise && $4122c788ac63a873$var$v8.indexOf('6.6') !== 0 && $df79f3b24bb220c5$exports.indexOf('Chrome/66') === -1;
    } catch (e) {}
}();
// helpers
var $4122c788ac63a873$var$isThenable = function(it) {
    var then;
    return $1WkAz(it) && typeof (then = it.then) == 'function' ? then : false;
};
var $4122c788ac63a873$var$notify = function(promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    $4122c788ac63a873$var$microtask(function() {
        var value = promise._v;
        var ok = promise._s == 1;
        var i = 0;
        var run = function(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (promise._h == 2) $4122c788ac63a873$var$onHandleUnhandled(promise);
                        promise._h = 1;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // may throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject($4122c788ac63a873$var$TypeError('Promise-chain cycle'));
                    else if (then = $4122c788ac63a873$var$isThenable(result)) then.call(result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (e) {
                if (domain && !exited) domain.exit();
                reject(e);
            }
        };
        while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
        promise._c = [];
        promise._n = false;
        if (isReject && !promise._h) $4122c788ac63a873$var$onUnhandled(promise);
    });
};
var $4122c788ac63a873$var$onUnhandled = function(promise) {
    $4122c788ac63a873$require$task.call($jFKHr, function() {
        var value = promise._v;
        var unhandled = $4122c788ac63a873$var$isUnhandled(promise);
        var result, handler, console;
        if (unhandled) {
            result = $29af1fd5df57feba$exports(function() {
                if ($4122c788ac63a873$var$isNode) $4122c788ac63a873$var$process.emit('unhandledRejection', value, promise);
                else if (handler = $jFKHr.onunhandledrejection) handler({
                    promise: promise,
                    reason: value
                });
                else if ((console = $jFKHr.console) && console.error) console.error('Unhandled promise rejection', value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = $4122c788ac63a873$var$isNode || $4122c788ac63a873$var$isUnhandled(promise) ? 2 : 1;
        }
        promise._a = undefined;
        if (unhandled && result.e) throw result.v;
    });
};
var $4122c788ac63a873$var$isUnhandled = function(promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var $4122c788ac63a873$var$onHandleUnhandled = function(promise) {
    $4122c788ac63a873$require$task.call($jFKHr, function() {
        var handler;
        if ($4122c788ac63a873$var$isNode) $4122c788ac63a873$var$process.emit('rejectionHandled', promise);
        else if (handler = $jFKHr.onrejectionhandled) handler({
            promise: promise,
            reason: promise._v
        });
    });
};
var $4122c788ac63a873$var$$reject = function(value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    $4122c788ac63a873$var$notify(promise, true);
};
var $4122c788ac63a873$var$$resolve = function(value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    try {
        if (promise === value) throw $4122c788ac63a873$var$TypeError("Promise can't be resolved itself");
        if (then = $4122c788ac63a873$var$isThenable(value)) $4122c788ac63a873$var$microtask(function() {
            var wrapper = {
                _w: promise,
                _d: false
            }; // wrap
            try {
                then.call(value, $ATdaw($4122c788ac63a873$var$$resolve, wrapper, 1), $ATdaw($4122c788ac63a873$var$$reject, wrapper, 1));
            } catch (e) {
                $4122c788ac63a873$var$$reject.call(wrapper, e);
            }
        });
        else {
            promise._v = value;
            promise._s = 1;
            $4122c788ac63a873$var$notify(promise, false);
        }
    } catch (e) {
        $4122c788ac63a873$var$$reject.call({
            _w: promise,
            _d: false
        }, e); // wrap
    }
};

// constructor polyfill
if (!$4122c788ac63a873$var$USE_NATIVE) {
    // 25.4.3.1 Promise(executor)
    $4122c788ac63a873$var$$Promise = function Promise(executor) {
        $bws30(this, $4122c788ac63a873$var$$Promise, $4122c788ac63a873$var$PROMISE, '_h');
        $bCxjV(executor);
        $4122c788ac63a873$var$Internal.call(this);
        try {
            executor($ATdaw($4122c788ac63a873$var$$resolve, this, 1), $ATdaw($4122c788ac63a873$var$$reject, this, 1));
        } catch (err) {
            $4122c788ac63a873$var$$reject.call(this, err);
        }
    };
    // eslint-disable-next-line no-unused-vars
    $4122c788ac63a873$var$Internal = function Promise(executor) {
        this._c = []; // <- awaiting reactions
        this._a = undefined; // <- checked in isUnhandled reactions
        this._s = 0; // <- state
        this._d = false; // <- done
        this._v = undefined; // <- value
        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
        this._n = false; // <- notify
    };
    $4122c788ac63a873$var$Internal.prototype = (parcelRequire("2aUHX"))($4122c788ac63a873$var$$Promise.prototype, {
        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
        then: function then(onFulfilled, onRejected) {
            var reaction = $4122c788ac63a873$var$newPromiseCapability($cn7DE(this, $4122c788ac63a873$var$$Promise));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = $4122c788ac63a873$var$isNode ? $4122c788ac63a873$var$process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) $4122c788ac63a873$var$notify(this, false);
            return reaction.promise;
        },
        // 25.4.5.1 Promise.prototype.catch(onRejected)
        'catch': function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    $4122c788ac63a873$var$OwnPromiseCapability = function() {
        var promise = new $4122c788ac63a873$var$Internal();
        this.promise = promise;
        this.resolve = $ATdaw($4122c788ac63a873$var$$resolve, promise, 1);
        this.reject = $ATdaw($4122c788ac63a873$var$$reject, promise, 1);
    };
    $88f8d99f4ec813d8$exports.f = $4122c788ac63a873$var$newPromiseCapability = function(C) {
        return C === $4122c788ac63a873$var$$Promise || C === $4122c788ac63a873$var$Wrapper ? new $4122c788ac63a873$var$OwnPromiseCapability(C) : $4122c788ac63a873$var$newGenericPromiseCapability(C);
    };
}
$fO65L($fO65L.G + $fO65L.W + $fO65L.F * !$4122c788ac63a873$var$USE_NATIVE, {
    Promise: $4122c788ac63a873$var$$Promise
});

(parcelRequire("6DkCi"))($4122c788ac63a873$var$$Promise, $4122c788ac63a873$var$PROMISE);

(parcelRequire("68OYb"))($4122c788ac63a873$var$PROMISE);

$4122c788ac63a873$var$Wrapper = (parcelRequire("fMnFl"))[$4122c788ac63a873$var$PROMISE];
// statics
$fO65L($fO65L.S + $fO65L.F * !$4122c788ac63a873$var$USE_NATIVE, $4122c788ac63a873$var$PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
        var capability = $4122c788ac63a873$var$newPromiseCapability(this);
        var $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
    }
});
$fO65L($fO65L.S + $fO65L.F * ($cE8bo || !$4122c788ac63a873$var$USE_NATIVE), $4122c788ac63a873$var$PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
        return $88b3177d98cfbde4$exports($cE8bo && this === $4122c788ac63a873$var$Wrapper ? $4122c788ac63a873$var$$Promise : this, x);
    }
});

$fO65L($fO65L.S + $fO65L.F * !($4122c788ac63a873$var$USE_NATIVE && (parcelRequire("5HrAP"))(function(iter) {
    $4122c788ac63a873$var$$Promise.all(iter)['catch']($4122c788ac63a873$var$empty);
})), $4122c788ac63a873$var$PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
        var C = this;
        var capability = $4122c788ac63a873$var$newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $29af1fd5df57feba$exports(function() {
            var values = [];
            var index = 0;
            var remaining = 1;
            $d1wID(iterable, false, function(promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[$index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.e) reject(result.v);
        return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
        var C = this;
        var capability = $4122c788ac63a873$var$newPromiseCapability(C);
        var reject = capability.reject;
        var result = $29af1fd5df57feba$exports(function() {
            $d1wID(iterable, false, function(promise) {
                C.resolve(promise).then(capability.resolve, reject);
            });
        });
        if (result.e) reject(result.v);
        return capability.promise;
    }
});


var $10b221c1a9a4f4ee$exports = {};
'use strict';
var $a00ed97606049fb7$exports = {};
'use strict';

var $lhvOa = parcelRequire("lhvOa");
var $a00ed97606049fb7$require$dP = $lhvOa.f;

var $lUyCu = parcelRequire("lUyCu");

var $2aUHX = parcelRequire("2aUHX");

var $ATdaw = parcelRequire("ATdaw");

var $bws30 = parcelRequire("bws30");

var $d1wID = parcelRequire("d1wID");

var $iHG7p = parcelRequire("iHG7p");

var $h8jrd = parcelRequire("h8jrd");

var $68OYb = parcelRequire("68OYb");

var $cAHsA = parcelRequire("cAHsA");

var $khJao = parcelRequire("khJao");
var $a00ed97606049fb7$require$fastKey = $khJao.fastKey;
var $bade6cf2d0fd4484$exports = {};

var $1WkAz = parcelRequire("1WkAz");
$bade6cf2d0fd4484$exports = function(it, TYPE) {
    if (!$1WkAz(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
    return it;
};


var $a00ed97606049fb7$var$SIZE = $cAHsA ? '_s' : 'size';
var $a00ed97606049fb7$var$getEntry = function(that, key) {
    // fast case
    var index = $a00ed97606049fb7$require$fastKey(key);
    var entry;
    if (index !== 'F') return that._i[index];
    // frozen object case
    for(entry = that._f; entry; entry = entry.n){
        if (entry.k == key) return entry;
    }
};
$a00ed97606049fb7$exports = {
    getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function(that, iterable) {
            $bws30(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = $lUyCu(null); // index
            that._f = undefined; // first entry
            that._l = undefined; // last entry
            that[$a00ed97606049fb7$var$SIZE] = 0; // size
            if (iterable != undefined) $d1wID(iterable, IS_MAP, that[ADDER], that);
        });
        $2aUHX(C.prototype, {
            // 23.1.3.1 Map.prototype.clear()
            // 23.2.3.2 Set.prototype.clear()
            clear: function clear() {
                for(var that = $bade6cf2d0fd4484$exports(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n){
                    entry.r = true;
                    if (entry.p) entry.p = entry.p.n = undefined;
                    delete data[entry.i];
                }
                that._f = that._l = undefined;
                that[$a00ed97606049fb7$var$SIZE] = 0;
            },
            // 23.1.3.3 Map.prototype.delete(key)
            // 23.2.3.4 Set.prototype.delete(value)
            'delete': function(key) {
                var that = $bade6cf2d0fd4484$exports(this, NAME);
                var entry = $a00ed97606049fb7$var$getEntry(that, key);
                if (entry) {
                    var next = entry.n;
                    var prev = entry.p;
                    delete that._i[entry.i];
                    entry.r = true;
                    if (prev) prev.n = next;
                    if (next) next.p = prev;
                    if (that._f == entry) that._f = next;
                    if (that._l == entry) that._l = prev;
                    that[$a00ed97606049fb7$var$SIZE]--;
                }
                return !!entry;
            },
            // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
            // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                $bade6cf2d0fd4484$exports(this, NAME);
                var f = $ATdaw(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
                var entry;
                while(entry = entry ? entry.n : this._f){
                    f(entry.v, entry.k, this);
                    // revert to the last existing entry
                    while(entry && entry.r)entry = entry.p;
                }
            },
            // 23.1.3.7 Map.prototype.has(key)
            // 23.2.3.7 Set.prototype.has(value)
            has: function has(key) {
                return !!$a00ed97606049fb7$var$getEntry($bade6cf2d0fd4484$exports(this, NAME), key);
            }
        });
        if ($cAHsA) $a00ed97606049fb7$require$dP(C.prototype, 'size', {
            get: function() {
                return $bade6cf2d0fd4484$exports(this, NAME)[$a00ed97606049fb7$var$SIZE];
            }
        });
        return C;
    },
    def: function(that, key, value) {
        var entry = $a00ed97606049fb7$var$getEntry(that, key);
        var prev, index;
        // change existing entry
        if (entry) entry.v = value;
        else {
            that._l = entry = {
                i: index = $a00ed97606049fb7$require$fastKey(key, true),
                k: key,
                v: value,
                p: prev = that._l,
                n: undefined,
                r: false // <- removed
            };
            if (!that._f) that._f = entry;
            if (prev) prev.n = entry;
            that[$a00ed97606049fb7$var$SIZE]++;
            // add to index
            if (index !== 'F') that._i[index] = entry;
        }
        return that;
    },
    getEntry: $a00ed97606049fb7$var$getEntry,
    setStrong: function(C, NAME, IS_MAP) {
        // add .keys, .values, .entries, [@@iterator]
        // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
        $iHG7p(C, NAME, function(iterated, kind) {
            this._t = $bade6cf2d0fd4484$exports(iterated, NAME); // target
            this._k = kind; // kind
            this._l = undefined; // previous
        }, function() {
            var that = this;
            var kind = that._k;
            var entry = that._l;
            // revert to the last existing entry
            while(entry && entry.r)entry = entry.p;
            // get next entry
            if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
                // or finish the iteration
                that._t = undefined;
                return $h8jrd(1);
            }
            // return step by kind
            if (kind == 'keys') return $h8jrd(0, entry.k);
            if (kind == 'values') return $h8jrd(0, entry.v);
            return $h8jrd(0, [
                entry.k,
                entry.v
            ]);
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
        // add [@@species], 23.1.2.2, 23.2.2.2
        $68OYb(NAME);
    }
};



var $10b221c1a9a4f4ee$var$MAP = 'Map';

// 23.1 Map Objects
$10b221c1a9a4f4ee$exports = (parcelRequire("i4WpZ"))($10b221c1a9a4f4ee$var$MAP, function(get) {
    return function Map() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.1.3.6 Map.prototype.get(key)
    get: function get(key) {
        var entry = $a00ed97606049fb7$exports.getEntry($bade6cf2d0fd4484$exports(this, $10b221c1a9a4f4ee$var$MAP), key);
        return entry && entry.v;
    },
    // 23.1.3.9 Map.prototype.set(key, value)
    set: function set(key, value) {
        return $a00ed97606049fb7$exports.def($bade6cf2d0fd4484$exports(this, $10b221c1a9a4f4ee$var$MAP), key === 0 ? 0 : key, value);
    }
}, $a00ed97606049fb7$exports, true);


var $4726a3da5d339c9f$exports = {};
'use strict';


var $4726a3da5d339c9f$var$SET = 'Set';

// 23.2 Set Objects
$4726a3da5d339c9f$exports = (parcelRequire("i4WpZ"))($4726a3da5d339c9f$var$SET, function(get) {
    return function Set() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.2.3.1 Set.prototype.add(value)
    add: function add(value) {
        return $a00ed97606049fb7$exports.def($bade6cf2d0fd4484$exports(this, $4726a3da5d339c9f$var$SET), value = value === 0 ? 0 : value, value);
    }
}, $a00ed97606049fb7$exports);


var $7c254168504ecb0f$exports = {};
'use strict';

var $jFKHr = parcelRequire("jFKHr");

var $7c254168504ecb0f$var$each = (parcelRequire("d90U1"))(0);

var $10sdZ = parcelRequire("10sdZ");

var $khJao = parcelRequire("khJao");

var $3YyFT = parcelRequire("3YyFT");
var $ee3d81775fa1bfe2$exports = {};
'use strict';

var $2aUHX = parcelRequire("2aUHX");

var $khJao = parcelRequire("khJao");
var $ee3d81775fa1bfe2$require$getWeak = $khJao.getWeak;

var $978rB = parcelRequire("978rB");

var $1WkAz = parcelRequire("1WkAz");

var $bws30 = parcelRequire("bws30");

var $d1wID = parcelRequire("d1wID");

var $d90U1 = parcelRequire("d90U1");

var $jdXyk = parcelRequire("jdXyk");

var $ee3d81775fa1bfe2$var$arrayFind = $d90U1(5);
var $ee3d81775fa1bfe2$var$arrayFindIndex = $d90U1(6);
var $ee3d81775fa1bfe2$var$id = 0;
// fallback for uncaught frozen keys
var $ee3d81775fa1bfe2$var$uncaughtFrozenStore = function(that) {
    return that._l || (that._l = new $ee3d81775fa1bfe2$var$UncaughtFrozenStore());
};
var $ee3d81775fa1bfe2$var$UncaughtFrozenStore = function() {
    this.a = [];
};
var $ee3d81775fa1bfe2$var$findUncaughtFrozen = function(store, key) {
    return $ee3d81775fa1bfe2$var$arrayFind(store.a, function(it) {
        return it[0] === key;
    });
};
$ee3d81775fa1bfe2$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $ee3d81775fa1bfe2$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$ee3d81775fa1bfe2$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $ee3d81775fa1bfe2$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.a.push([
            key,
            value
        ]);
    },
    'delete': function(key) {
        var index = $ee3d81775fa1bfe2$var$arrayFindIndex(this.a, function(it) {
            return it[0] === key;
        });
        if (~index) this.a.splice(index, 1);
        return !!~index;
    }
};
$ee3d81775fa1bfe2$exports = {
    getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function(that, iterable) {
            $bws30(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = $ee3d81775fa1bfe2$var$id++; // collection id
            that._l = undefined; // leak store for uncaught frozen objects
            if (iterable != undefined) $d1wID(iterable, IS_MAP, that[ADDER], that);
        });
        $2aUHX(C.prototype, {
            // 23.3.3.2 WeakMap.prototype.delete(key)
            // 23.4.3.3 WeakSet.prototype.delete(value)
            'delete': function(key) {
                if (!$1WkAz(key)) return false;
                var data = $ee3d81775fa1bfe2$require$getWeak(key);
                if (data === true) return $ee3d81775fa1bfe2$var$uncaughtFrozenStore($bade6cf2d0fd4484$exports(this, NAME))['delete'](key);
                return data && $jdXyk(data, this._i) && delete data[this._i];
            },
            // 23.3.3.4 WeakMap.prototype.has(key)
            // 23.4.3.4 WeakSet.prototype.has(value)
            has: function has(key) {
                if (!$1WkAz(key)) return false;
                var data = $ee3d81775fa1bfe2$require$getWeak(key);
                if (data === true) return $ee3d81775fa1bfe2$var$uncaughtFrozenStore($bade6cf2d0fd4484$exports(this, NAME)).has(key);
                return data && $jdXyk(data, this._i);
            }
        });
        return C;
    },
    def: function(that, key, value) {
        var data = $ee3d81775fa1bfe2$require$getWeak($978rB(key), true);
        if (data === true) $ee3d81775fa1bfe2$var$uncaughtFrozenStore(that).set(key, value);
        else data[that._i] = value;
        return that;
    },
    ufstore: $ee3d81775fa1bfe2$var$uncaughtFrozenStore
};



var $1WkAz = parcelRequire("1WkAz");


var $7c254168504ecb0f$var$IS_IE11 = !$jFKHr.ActiveXObject && 'ActiveXObject' in $jFKHr;
var $7c254168504ecb0f$var$WEAK_MAP = 'WeakMap';
var $7c254168504ecb0f$var$getWeak = $khJao.getWeak;
var $7c254168504ecb0f$var$isExtensible = Object.isExtensible;
var $7c254168504ecb0f$var$uncaughtFrozenStore = $ee3d81775fa1bfe2$exports.ufstore;
var $7c254168504ecb0f$var$InternalMap;
var $7c254168504ecb0f$var$wrapper = function(get) {
    return function WeakMap() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
};
var $7c254168504ecb0f$var$methods = {
    // 23.3.3.3 WeakMap.prototype.get(key)
    get: function get(key) {
        if ($1WkAz(key)) {
            var data = $7c254168504ecb0f$var$getWeak(key);
            if (data === true) return $7c254168504ecb0f$var$uncaughtFrozenStore($bade6cf2d0fd4484$exports(this, $7c254168504ecb0f$var$WEAK_MAP)).get(key);
            return data ? data[this._i] : undefined;
        }
    },
    // 23.3.3.5 WeakMap.prototype.set(key, value)
    set: function set(key, value) {
        return $ee3d81775fa1bfe2$exports.def($bade6cf2d0fd4484$exports(this, $7c254168504ecb0f$var$WEAK_MAP), key, value);
    }
};

// 23.3 WeakMap Objects
var $7c254168504ecb0f$var$$WeakMap = $7c254168504ecb0f$exports = (parcelRequire("i4WpZ"))($7c254168504ecb0f$var$WEAK_MAP, $7c254168504ecb0f$var$wrapper, $7c254168504ecb0f$var$methods, $ee3d81775fa1bfe2$exports, true, true);
// IE11 WeakMap frozen keys fix
if ($bade6cf2d0fd4484$exports && $7c254168504ecb0f$var$IS_IE11) {
    $7c254168504ecb0f$var$InternalMap = $ee3d81775fa1bfe2$exports.getConstructor($7c254168504ecb0f$var$wrapper, $7c254168504ecb0f$var$WEAK_MAP);
    $3YyFT($7c254168504ecb0f$var$InternalMap.prototype, $7c254168504ecb0f$var$methods);
    $khJao.NEED = true;
    $7c254168504ecb0f$var$each([
        'delete',
        'has',
        'get',
        'set'
    ], function(key) {
        var proto = $7c254168504ecb0f$var$$WeakMap.prototype;
        var method = proto[key];
        $10sdZ(proto, key, function(a, b) {
            // store frozen objects on internal weakmap shim
            if ($1WkAz(a) && !$7c254168504ecb0f$var$isExtensible(a)) {
                if (!this._f) this._f = new $7c254168504ecb0f$var$InternalMap();
                var result = this._f[key](a, b);
                return key == 'set' ? this : result;
            // store all the rest on native weakmap
            }
            return method.call(this, a, b);
        });
    });
}


'use strict';


var $bd9bf15cb7953d1e$var$WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
(parcelRequire("i4WpZ"))($bd9bf15cb7953d1e$var$WEAK_SET, function(get) {
    return function WeakSet() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.4.3.1 WeakSet.prototype.add(value)
    add: function add(value) {
        return $ee3d81775fa1bfe2$exports.def($bade6cf2d0fd4484$exports(this, $bd9bf15cb7953d1e$var$WEAK_SET), value, true);
    }
}, $ee3d81775fa1bfe2$exports, false, true);


'use strict';

var $fO65L = parcelRequire("fO65L");

var $erNx4 = parcelRequire("erNx4");

var $iuSWU = parcelRequire("iuSWU");

var $978rB = parcelRequire("978rB");

var $iWPS0 = parcelRequire("iWPS0");

var $igR5o = parcelRequire("igR5o");

var $1WkAz = parcelRequire("1WkAz");

var $jFKHr = parcelRequire("jFKHr");
var $0ec0bc318ce2bf56$require$ArrayBuffer = $jFKHr.ArrayBuffer;

var $cn7DE = parcelRequire("cn7DE");
var $0ec0bc318ce2bf56$var$$ArrayBuffer = $iuSWU.ArrayBuffer;
var $0ec0bc318ce2bf56$var$$DataView = $iuSWU.DataView;
var $0ec0bc318ce2bf56$var$$isView = $erNx4.ABV && $0ec0bc318ce2bf56$require$ArrayBuffer.isView;
var $0ec0bc318ce2bf56$var$$slice = $0ec0bc318ce2bf56$var$$ArrayBuffer.prototype.slice;
var $0ec0bc318ce2bf56$var$VIEW = $erNx4.VIEW;
var $0ec0bc318ce2bf56$var$ARRAY_BUFFER = 'ArrayBuffer';
$fO65L($fO65L.G + $fO65L.W + $fO65L.F * ($0ec0bc318ce2bf56$require$ArrayBuffer !== $0ec0bc318ce2bf56$var$$ArrayBuffer), {
    ArrayBuffer: $0ec0bc318ce2bf56$var$$ArrayBuffer
});
$fO65L($fO65L.S + $fO65L.F * !$erNx4.CONSTR, $0ec0bc318ce2bf56$var$ARRAY_BUFFER, {
    // 24.1.3.1 ArrayBuffer.isView(arg)
    isView: function isView(it) {
        return $0ec0bc318ce2bf56$var$$isView && $0ec0bc318ce2bf56$var$$isView(it) || $1WkAz(it) && $0ec0bc318ce2bf56$var$VIEW in it;
    }
});

$fO65L($fO65L.P + $fO65L.U + $fO65L.F * (parcelRequire("gtdMs"))(function() {
    return !new $0ec0bc318ce2bf56$var$$ArrayBuffer(2).slice(1, undefined).byteLength;
}), $0ec0bc318ce2bf56$var$ARRAY_BUFFER, {
    // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
    slice: function slice(start, end) {
        if ($0ec0bc318ce2bf56$var$$slice !== undefined && end === undefined) return $0ec0bc318ce2bf56$var$$slice.call($978rB(this), start); // FF fix
        var len = $978rB(this).byteLength;
        var first = $iWPS0(start, len);
        var fin = $iWPS0(end === undefined ? len : end, len);
        var result = new ($cn7DE(this, $0ec0bc318ce2bf56$var$$ArrayBuffer))($igR5o(fin - first));
        var viewS = new $0ec0bc318ce2bf56$var$$DataView(this);
        var viewT = new $0ec0bc318ce2bf56$var$$DataView(result);
        var index = 0;
        while(first < fin)viewT.setUint8(index++, viewS.getUint8(first++));
        return result;
    }
});

(parcelRequire("68OYb"))($0ec0bc318ce2bf56$var$ARRAY_BUFFER);



var $fO65L = parcelRequire("fO65L");


$fO65L($fO65L.G + $fO65L.W + $fO65L.F * !(parcelRequire("erNx4")).ABV, {
    DataView: (parcelRequire("iuSWU")).DataView
});



(parcelRequire("iwJAL"))('Int8', 1, function(init) {
    return function Int8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("iwJAL"))('Uint8', 1, function(init) {
    return function Uint8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("iwJAL"))('Uint8', 1, function(init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
}, true);



(parcelRequire("iwJAL"))('Int16', 2, function(init) {
    return function Int16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("iwJAL"))('Uint16', 2, function(init) {
    return function Uint16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("iwJAL"))('Int32', 4, function(init) {
    return function Int32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("iwJAL"))('Uint32', 4, function(init) {
    return function Uint32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("iwJAL"))('Float32', 4, function(init) {
    return function Float32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("iwJAL"))('Float64', 8, function(init) {
    return function Float64Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)

var $fO65L = parcelRequire("fO65L");

var $bCxjV = parcelRequire("bCxjV");

var $978rB = parcelRequire("978rB");

var $c7d77700dc44b3b9$var$rApply = ((parcelRequire("jFKHr")).Reflect || {}).apply;
var $c7d77700dc44b3b9$var$fApply = Function.apply;

// MS Edge argumentsList argument is optional
$fO65L($fO65L.S + $fO65L.F * !(parcelRequire("gtdMs"))(function() {
    $c7d77700dc44b3b9$var$rApply(function() {});
}), 'Reflect', {
    apply: function apply(target, thisArgument, argumentsList) {
        var T = $bCxjV(target);
        var L = $978rB(argumentsList);
        return $c7d77700dc44b3b9$var$rApply ? $c7d77700dc44b3b9$var$rApply(T, thisArgument, L) : $c7d77700dc44b3b9$var$fApply.call(T, thisArgument, L);
    }
});


// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])

var $fO65L = parcelRequire("fO65L");

var $lUyCu = parcelRequire("lUyCu");

var $bCxjV = parcelRequire("bCxjV");

var $978rB = parcelRequire("978rB");

var $1WkAz = parcelRequire("1WkAz");

var $gtdMs = parcelRequire("gtdMs");

var $7xMFU = parcelRequire("7xMFU");

var $a9a118cb90768bf6$var$rConstruct = ((parcelRequire("jFKHr")).Reflect || {}).construct;
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var $a9a118cb90768bf6$var$NEW_TARGET_BUG = $gtdMs(function() {
    function F() {}
    return !($a9a118cb90768bf6$var$rConstruct(function() {}, [], F) instanceof F);
});
var $a9a118cb90768bf6$var$ARGS_BUG = !$gtdMs(function() {
    $a9a118cb90768bf6$var$rConstruct(function() {});
});
$fO65L($fO65L.S + $fO65L.F * ($a9a118cb90768bf6$var$NEW_TARGET_BUG || $a9a118cb90768bf6$var$ARGS_BUG), 'Reflect', {
    construct: function construct(Target, args /* , newTarget */ ) {
        $bCxjV(Target);
        $978rB(args);
        var newTarget = arguments.length < 3 ? Target : $bCxjV(arguments[2]);
        if ($a9a118cb90768bf6$var$ARGS_BUG && !$a9a118cb90768bf6$var$NEW_TARGET_BUG) return $a9a118cb90768bf6$var$rConstruct(Target, args, newTarget);
        if (Target == newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            $args.push.apply($args, args);
            return new ($7xMFU.apply(Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = $lUyCu($1WkAz(proto) ? proto : Object.prototype);
        var result = Function.apply.call(Target, instance, args);
        return $1WkAz(result) ? result : instance;
    }
});


// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)

var $lhvOa = parcelRequire("lhvOa");

var $fO65L = parcelRequire("fO65L");

var $978rB = parcelRequire("978rB");

var $ltjni = parcelRequire("ltjni");

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$fO65L($fO65L.S + $fO65L.F * (parcelRequire("gtdMs"))(function() {
    // eslint-disable-next-line no-undef
    Reflect.defineProperty($lhvOa.f({}, 1, {
        value: 1
    }), 1, {
        value: 2
    });
}), 'Reflect', {
    defineProperty: function defineProperty(target, propertyKey, attributes) {
        $978rB(target);
        propertyKey = $ltjni(propertyKey, true);
        $978rB(attributes);
        try {
            $lhvOa.f(target, propertyKey, attributes);
            return true;
        } catch (e) {
            return false;
        }
    }
});


// 26.1.4 Reflect.deleteProperty(target, propertyKey)

var $fO65L = parcelRequire("fO65L");

var $6VRFP = parcelRequire("6VRFP");
var $5c9dca97c1085742$require$gOPD = $6VRFP.f;

var $978rB = parcelRequire("978rB");
$fO65L($fO65L.S, 'Reflect', {
    deleteProperty: function deleteProperty(target, propertyKey) {
        var desc = $5c9dca97c1085742$require$gOPD($978rB(target), propertyKey);
        return desc && !desc.configurable ? false : delete target[propertyKey];
    }
});


'use strict';

var $fO65L = parcelRequire("fO65L");

var $978rB = parcelRequire("978rB");
var $e2504e5c957986f9$var$Enumerate = function(iterated) {
    this._t = $978rB(iterated); // target
    this._i = 0; // next index
    var keys = this._k = []; // keys
    var key;
    for(key in iterated)keys.push(key);
};

(parcelRequire("bLWpp"))($e2504e5c957986f9$var$Enumerate, 'Object', function() {
    var that = this;
    var keys = that._k;
    var key;
    do {
        if (that._i >= keys.length) return {
            value: undefined,
            done: true
        };
    }while (!((key = keys[that._i++]) in that._t));
    return {
        value: key,
        done: false
    };
});
$fO65L($fO65L.S, 'Reflect', {
    enumerate: function enumerate(target) {
        return new $e2504e5c957986f9$var$Enumerate(target);
    }
});


// 26.1.6 Reflect.get(target, propertyKey [, receiver])

var $6VRFP = parcelRequire("6VRFP");

var $6yhFg = parcelRequire("6yhFg");

var $jdXyk = parcelRequire("jdXyk");

var $fO65L = parcelRequire("fO65L");

var $1WkAz = parcelRequire("1WkAz");

var $978rB = parcelRequire("978rB");
function $6d1ce7fa6fac38f4$var$get(target, propertyKey /* , receiver */ ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var desc, proto;
    if ($978rB(target) === receiver) return target[propertyKey];
    if (desc = $6VRFP.f(target, propertyKey)) return $jdXyk(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
    if ($1WkAz(proto = $6yhFg(target))) return $6d1ce7fa6fac38f4$var$get(proto, propertyKey, receiver);
}
$fO65L($fO65L.S, 'Reflect', {
    get: $6d1ce7fa6fac38f4$var$get
});


// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)

var $6VRFP = parcelRequire("6VRFP");

var $fO65L = parcelRequire("fO65L");

var $978rB = parcelRequire("978rB");
$fO65L($fO65L.S, 'Reflect', {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
        return $6VRFP.f($978rB(target), propertyKey);
    }
});


// 26.1.8 Reflect.getPrototypeOf(target)

var $fO65L = parcelRequire("fO65L");

var $6yhFg = parcelRequire("6yhFg");

var $978rB = parcelRequire("978rB");
$fO65L($fO65L.S, 'Reflect', {
    getPrototypeOf: function getPrototypeOf(target) {
        return $6yhFg($978rB(target));
    }
});


// 26.1.9 Reflect.has(target, propertyKey)

var $fO65L = parcelRequire("fO65L");
$fO65L($fO65L.S, 'Reflect', {
    has: function has(target, propertyKey) {
        return propertyKey in target;
    }
});


// 26.1.10 Reflect.isExtensible(target)

var $fO65L = parcelRequire("fO65L");

var $978rB = parcelRequire("978rB");
var $32263e3c6b2e72ba$var$$isExtensible = Object.isExtensible;
$fO65L($fO65L.S, 'Reflect', {
    isExtensible: function isExtensible(target) {
        $978rB(target);
        return $32263e3c6b2e72ba$var$$isExtensible ? $32263e3c6b2e72ba$var$$isExtensible(target) : true;
    }
});


// 26.1.11 Reflect.ownKeys(target)

var $fO65L = parcelRequire("fO65L");

$fO65L($fO65L.S, 'Reflect', {
    ownKeys: (parcelRequire("qCZj5"))
});


// 26.1.12 Reflect.preventExtensions(target)

var $fO65L = parcelRequire("fO65L");

var $978rB = parcelRequire("978rB");
var $0bcb5a09965c3462$var$$preventExtensions = Object.preventExtensions;
$fO65L($fO65L.S, 'Reflect', {
    preventExtensions: function preventExtensions(target) {
        $978rB(target);
        try {
            if ($0bcb5a09965c3462$var$$preventExtensions) $0bcb5a09965c3462$var$$preventExtensions(target);
            return true;
        } catch (e) {
            return false;
        }
    }
});


// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])

var $lhvOa = parcelRequire("lhvOa");

var $6VRFP = parcelRequire("6VRFP");

var $6yhFg = parcelRequire("6yhFg");

var $jdXyk = parcelRequire("jdXyk");

var $fO65L = parcelRequire("fO65L");

var $fTxIB = parcelRequire("fTxIB");

var $978rB = parcelRequire("978rB");

var $1WkAz = parcelRequire("1WkAz");
function $f6234feb2963b215$var$set(target, propertyKey, V /* , receiver */ ) {
    var receiver = arguments.length < 4 ? target : arguments[3];
    var ownDesc = $6VRFP.f($978rB(target), propertyKey);
    var existingDescriptor, proto;
    if (!ownDesc) {
        if ($1WkAz(proto = $6yhFg(target))) return $f6234feb2963b215$var$set(proto, propertyKey, V, receiver);
        ownDesc = $fTxIB(0);
    }
    if ($jdXyk(ownDesc, 'value')) {
        if (ownDesc.writable === false || !$1WkAz(receiver)) return false;
        if (existingDescriptor = $6VRFP.f(receiver, propertyKey)) {
            if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
            existingDescriptor.value = V;
            $lhvOa.f(receiver, propertyKey, existingDescriptor);
        } else $lhvOa.f(receiver, propertyKey, $fTxIB(0, V));
        return true;
    }
    return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}
$fO65L($fO65L.S, 'Reflect', {
    set: $f6234feb2963b215$var$set
});


// 26.1.14 Reflect.setPrototypeOf(target, proto)

var $fO65L = parcelRequire("fO65L");

var $bDxU1 = parcelRequire("bDxU1");
if ($bDxU1) $fO65L($fO65L.S, 'Reflect', {
    setPrototypeOf: function setPrototypeOf(target, proto) {
        $bDxU1.check(target, proto);
        try {
            $bDxU1.set(target, proto);
            return true;
        } catch (e) {
            return false;
        }
    }
});



$15c57ad75b16da55$exports = (parcelRequire("fMnFl"));


var $ec484936aaa6b494$exports = {};
'use strict';

var $fO65L = parcelRequire("fO65L");

var $7bb0a95456927f09$var$$includes = (parcelRequire("fhIl3"))(true);
$fO65L($fO65L.P, 'Array', {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $7bb0a95456927f09$var$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("elzBR"))('includes');



$ec484936aaa6b494$exports = (parcelRequire("fMnFl")).Array.includes;


var $e65927386614895d$exports = {};
'use strict';

var $fO65L = parcelRequire("fO65L");
var $fc6048407fe1c0bd$exports = {};
'use strict';

var $hRWRg = parcelRequire("hRWRg");

var $1WkAz = parcelRequire("1WkAz");

var $igR5o = parcelRequire("igR5o");

var $ATdaw = parcelRequire("ATdaw");

var $fc6048407fe1c0bd$var$IS_CONCAT_SPREADABLE = (parcelRequire("kC7Sb"))('isConcatSpreadable');
function $fc6048407fe1c0bd$var$flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? $ATdaw(mapper, thisArg, 3) : false;
    var element, spreadable;
    while(sourceIndex < sourceLen){
        if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            spreadable = false;
            if ($1WkAz(element)) {
                spreadable = element[$fc6048407fe1c0bd$var$IS_CONCAT_SPREADABLE];
                spreadable = spreadable !== undefined ? !!spreadable : $hRWRg(element);
            }
            if (spreadable && depth > 0) targetIndex = $fc6048407fe1c0bd$var$flattenIntoArray(target, original, element, $igR5o(element.length), targetIndex, depth - 1) - 1;
            else {
                if (targetIndex >= 0x1fffffffffffff) throw TypeError();
                target[targetIndex] = element;
            }
            targetIndex++;
        }
        sourceIndex++;
    }
    return targetIndex;
}
$fc6048407fe1c0bd$exports = $fc6048407fe1c0bd$var$flattenIntoArray;



var $eb8lU = parcelRequire("eb8lU");

var $igR5o = parcelRequire("igR5o");

var $bCxjV = parcelRequire("bCxjV");

var $3ybrc = parcelRequire("3ybrc");
$fO65L($fO65L.P, 'Array', {
    flatMap: function flatMap(callbackfn /* , thisArg */ ) {
        var O = $eb8lU(this);
        var sourceLen, A;
        $bCxjV(callbackfn);
        sourceLen = $igR5o(O.length);
        A = $3ybrc(O, 0);
        $fc6048407fe1c0bd$exports(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
        return A;
    }
});

(parcelRequire("elzBR"))('flatMap');



$e65927386614895d$exports = (parcelRequire("fMnFl")).Array.flatMap;


var $764b0cffc49fb2c7$exports = {};
'use strict';

var $fO65L = parcelRequire("fO65L");
var $9d1a102cb55747eb$exports = {};
// https://github.com/tc39/proposal-string-pad-start-end

var $igR5o = parcelRequire("igR5o");

var $2sMRG = parcelRequire("2sMRG");

var $7kSv5 = parcelRequire("7kSv5");
$9d1a102cb55747eb$exports = function(that, maxLength, fillString, left) {
    var S = String($7kSv5(that));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : String(fillString);
    var intMaxLength = $igR5o(maxLength);
    if (intMaxLength <= stringLength || fillStr == '') return S;
    var fillLen = intMaxLength - stringLength;
    var stringFiller = $2sMRG.call(fillStr, Math.ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return left ? stringFiller + S : S + stringFiller;
};



// https://github.com/zloirock/core-js/issues/280
var $2be4a23b0b54d8e5$var$WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test($df79f3b24bb220c5$exports);
$fO65L($fO65L.P + $fO65L.F * $2be4a23b0b54d8e5$var$WEBKIT_BUG, 'String', {
    padStart: function padStart(maxLength /* , fillString = ' ' */ ) {
        return $9d1a102cb55747eb$exports(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
    }
});



$764b0cffc49fb2c7$exports = (parcelRequire("fMnFl")).String.padStart;


var $dcb252182d08eca7$exports = {};
'use strict';

var $fO65L = parcelRequire("fO65L");


// https://github.com/zloirock/core-js/issues/280
var $c894fb7e3afedb2f$var$WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test($df79f3b24bb220c5$exports);
$fO65L($fO65L.P + $fO65L.F * $c894fb7e3afedb2f$var$WEBKIT_BUG, 'String', {
    padEnd: function padEnd(maxLength /* , fillString = ' ' */ ) {
        return $9d1a102cb55747eb$exports(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
    }
});



$dcb252182d08eca7$exports = (parcelRequire("fMnFl")).String.padEnd;


var $a09cd2d475d3dcec$exports = {};
'use strict';

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
(parcelRequire("218jD"))('trimLeft', function($trim) {
    return function trimLeft() {
        return $trim(this, 1);
    };
}, 'trimStart');



$a09cd2d475d3dcec$exports = (parcelRequire("fMnFl")).String.trimLeft;


var $08f5638e42ef62ac$exports = {};
'use strict';

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
(parcelRequire("218jD"))('trimRight', function($trim) {
    return function trimRight() {
        return $trim(this, 2);
    };
}, 'trimEnd');



$08f5638e42ef62ac$exports = (parcelRequire("fMnFl")).String.trimRight;


var $6e509289f54caaed$exports = {};

(parcelRequire("4z7mj"))('asyncIterator');



$6e509289f54caaed$exports = (parcelRequire("iUlRw")).f('asyncIterator');


var $bcf88a08310fd54e$exports = {};
// https://github.com/tc39/proposal-object-getownpropertydescriptors

var $fO65L = parcelRequire("fO65L");

var $qCZj5 = parcelRequire("qCZj5");

var $3hDAb = parcelRequire("3hDAb");

var $6VRFP = parcelRequire("6VRFP");

$fO65L($fO65L.S, 'Object', {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = $3hDAb(object);
        var getDesc = $6VRFP.f;
        var keys = $qCZj5(O);
        var result = {};
        var i = 0;
        var key, desc;
        while(keys.length > i){
            desc = getDesc(O, key = keys[i++]);
            if (desc !== undefined) $88c57f683c4f232c$exports(result, key, desc);
        }
        return result;
    }
});



$bcf88a08310fd54e$exports = (parcelRequire("fMnFl")).Object.getOwnPropertyDescriptors;


var $93f2ff0d098a7b4a$exports = {};
// https://github.com/tc39/proposal-object-values-entries

var $fO65L = parcelRequire("fO65L");

var $e3c337a8c5f11a03$var$$values = (parcelRequire("bW4tA"))(false);
$fO65L($fO65L.S, 'Object', {
    values: function values(it) {
        return $e3c337a8c5f11a03$var$$values(it);
    }
});



$93f2ff0d098a7b4a$exports = (parcelRequire("fMnFl")).Object.values;


var $9d81b2f1afd10418$exports = {};
// https://github.com/tc39/proposal-object-values-entries

var $fO65L = parcelRequire("fO65L");

var $7c9305869469ebd8$var$$entries = (parcelRequire("bW4tA"))(true);
$fO65L($fO65L.S, 'Object', {
    entries: function entries(it) {
        return $7c9305869469ebd8$var$$entries(it);
    }
});



$9d81b2f1afd10418$exports = (parcelRequire("fMnFl")).Object.entries;


var $bc669725b4af9a63$exports = {};
'use strict';

// https://github.com/tc39/proposal-promise-finally
'use strict';

var $fO65L = parcelRequire("fO65L");

var $fMnFl = parcelRequire("fMnFl");

var $jFKHr = parcelRequire("jFKHr");

var $cn7DE = parcelRequire("cn7DE");

$fO65L($fO65L.P + $fO65L.R, 'Promise', {
    'finally': function(onFinally) {
        var C = $cn7DE(this, $fMnFl.Promise || $jFKHr.Promise);
        var isFunction = typeof onFinally == 'function';
        return this.then(isFunction ? function(x) {
            return $88b3177d98cfbde4$exports(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $88b3177d98cfbde4$exports(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});



$bc669725b4af9a63$exports = (parcelRequire("fMnFl")).Promise['finally'];


var $fb7ff4ebdec0c5d5$exports = {};
// ie9- setTimeout & setInterval additional parameters fix

var $jFKHr = parcelRequire("jFKHr");

var $fO65L = parcelRequire("fO65L");

var $2e399122f9681f67$var$slice = [].slice;
var $2e399122f9681f67$var$MSIE = /MSIE .\./.test($df79f3b24bb220c5$exports); // <- dirty ie9- check
var $2e399122f9681f67$var$wrap = function(set) {
    return function(fn, time /* , ...args */ ) {
        var boundArgs = arguments.length > 2;
        var args = boundArgs ? $2e399122f9681f67$var$slice.call(arguments, 2) : false;
        return set(boundArgs ? function() {
            // eslint-disable-next-line no-new-func
            (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
        } : fn, time);
    };
};
$fO65L($fO65L.G + $fO65L.B + $fO65L.F * $2e399122f9681f67$var$MSIE, {
    setTimeout: $2e399122f9681f67$var$wrap($jFKHr.setTimeout),
    setInterval: $2e399122f9681f67$var$wrap($jFKHr.setInterval)
});



var $fO65L = parcelRequire("fO65L");

var $7gc9z = parcelRequire("7gc9z");
$fO65L($fO65L.G + $fO65L.B, {
    setImmediate: $7gc9z.set,
    clearImmediate: $7gc9z.clear
});



var $lA4ZU = parcelRequire("lA4ZU");

var $62EBp = parcelRequire("62EBp");

var $10sdZ = parcelRequire("10sdZ");

var $jFKHr = parcelRequire("jFKHr");

var $fMiEZ = parcelRequire("fMiEZ");

var $3QMgK = parcelRequire("3QMgK");

var $kC7Sb = parcelRequire("kC7Sb");
var $4c092ad5080a6229$var$ITERATOR = $kC7Sb('iterator');
var $4c092ad5080a6229$var$TO_STRING_TAG = $kC7Sb('toStringTag');
var $4c092ad5080a6229$var$ArrayValues = $3QMgK.Array;
var $4c092ad5080a6229$var$DOMIterables = {
    CSSRuleList: true,
    CSSStyleDeclaration: false,
    CSSValueList: false,
    ClientRectList: false,
    DOMRectList: false,
    DOMStringList: false,
    DOMTokenList: true,
    DataTransferItemList: false,
    FileList: false,
    HTMLAllCollection: false,
    HTMLCollection: false,
    HTMLFormElement: false,
    HTMLSelectElement: false,
    MediaList: true,
    MimeTypeArray: false,
    NamedNodeMap: false,
    NodeList: true,
    PaintRequestList: false,
    Plugin: false,
    PluginArray: false,
    SVGLengthList: false,
    SVGNumberList: false,
    SVGPathSegList: false,
    SVGPointList: false,
    SVGStringList: false,
    SVGTransformList: false,
    SourceBufferList: false,
    StyleSheetList: true,
    TextTrackCueList: false,
    TextTrackList: false,
    TouchList: false
};
for(var $4c092ad5080a6229$var$collections = $62EBp($4c092ad5080a6229$var$DOMIterables), $4c092ad5080a6229$var$i = 0; $4c092ad5080a6229$var$i < $4c092ad5080a6229$var$collections.length; $4c092ad5080a6229$var$i++){
    var $4c092ad5080a6229$var$NAME = $4c092ad5080a6229$var$collections[$4c092ad5080a6229$var$i];
    var $4c092ad5080a6229$var$explicit = $4c092ad5080a6229$var$DOMIterables[$4c092ad5080a6229$var$NAME];
    var $4c092ad5080a6229$var$Collection = $jFKHr[$4c092ad5080a6229$var$NAME];
    var $4c092ad5080a6229$var$proto = $4c092ad5080a6229$var$Collection && $4c092ad5080a6229$var$Collection.prototype;
    var $4c092ad5080a6229$var$key;
    if ($4c092ad5080a6229$var$proto) {
        if (!$4c092ad5080a6229$var$proto[$4c092ad5080a6229$var$ITERATOR]) $fMiEZ($4c092ad5080a6229$var$proto, $4c092ad5080a6229$var$ITERATOR, $4c092ad5080a6229$var$ArrayValues);
        if (!$4c092ad5080a6229$var$proto[$4c092ad5080a6229$var$TO_STRING_TAG]) $fMiEZ($4c092ad5080a6229$var$proto, $4c092ad5080a6229$var$TO_STRING_TAG, $4c092ad5080a6229$var$NAME);
        $3QMgK[$4c092ad5080a6229$var$NAME] = $4c092ad5080a6229$var$ArrayValues;
        if ($4c092ad5080a6229$var$explicit) {
            for($4c092ad5080a6229$var$key in $lA4ZU)if (!$4c092ad5080a6229$var$proto[$4c092ad5080a6229$var$key]) $10sdZ($4c092ad5080a6229$var$proto, $4c092ad5080a6229$var$key, $lA4ZU[$4c092ad5080a6229$var$key], true);
        }
    }
}



$fb7ff4ebdec0c5d5$exports = (parcelRequire("fMnFl"));


var $91ef966608fa0f95$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $91ef966608fa0f95$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $91ef966608fa0f95$exports));
try {
    regeneratorRuntime = $91ef966608fa0f95$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $91ef966608fa0f95$var$runtime;
    else Function("r", "regeneratorRuntime = r")($91ef966608fa0f95$var$runtime);
}





var $3efe6a28c718a116$var$_global = $3efe6a28c718a116$var$_interopRequireDefault((parcelRequire("9PRTm")));
function $3efe6a28c718a116$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
if ($3efe6a28c718a116$var$_global["default"]._babelPolyfill && typeof console !== "undefined" && console.warn) console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended and may have consequences if different versions of the polyfills are applied sequentially. If you do need to load the polyfill more than once, use @babel/polyfill/noConflict instead to bypass the warning.");
$3efe6a28c718a116$var$_global["default"]._babelPolyfill = true;


/* eslint-disable */ var $6ea372c62c4145c1$exports = {};

$6ea372c62c4145c1$exports = (parcelRequire("gC2Xz"));


/* eslint-disable */ const $3a240f7f35a56d48$export$516836c6a9dfc573 = ()=>{
    const el = document.querySelector('.alert');
    if (el) el.parentElement.removeChild(el);
};
const $3a240f7f35a56d48$export$de026b00723010c1 = (type, msg, time = 3)=>{
    $3a240f7f35a56d48$export$516836c6a9dfc573();
    const markup = `<div class=" alert alert--${type}">${msg}</div>`;
    document.querySelector('body').insertAdjacentHTML('afterbegin', markup);
    window.setTimeout($3a240f7f35a56d48$export$516836c6a9dfc573, time * 1000);
};


const $10efc1afc555d5ce$export$596d806903d1f59e = async (email, password)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'POST',
            url: '/api/v1/users/login',
            data: {
                email: email,
                password: password
            }
        });
        if (res.data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Welkom in de mediatheek');
            window.setTimeout(()=>{
                location.assign('/newArticles');
            }, 1500);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', 'Paswoord of email is niet correct');
    }
};



/* eslint-disable */ 

const $cd982ef93548d73b$export$9c1a45fa87f90634 = async (data)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'POST',
            url: '/api/v1/games',
            data: data
        });
        if (res.status === 201) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het spel is succesvol toegevoegd');
            window.setTimeout(()=>{
                location.assign('/controlpanel/games/overview');
            }, 1500);
        }
    } catch (err) {
        document.getElementById('createGame').disabled = false;
        document.getElementById('createGame').value = 'Voeg toe';
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};
const $cd982ef93548d73b$export$2a7976ab39c03e48 = async (data)=>{
    const id = data.get('_id');
    const role = data.get('role');
    let redirect;
    if (role === 'user') redirect = '/account/department/games/overview';
    else redirect = '/controlpanel/games/overview';
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/games/${id}`,
            data: data
        });
        if (res.status === 200) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het spel is succesvol gewijzigd');
            window.setTimeout(()=>{
                location.assign(redirect);
            }, 1500);
        }
    } catch (err) {
        document.getElementById('updateGame').disabled = false;
        document.getElementById('updateGame').value = 'Pas aan';
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};
const $cd982ef93548d73b$export$e5d662caddcef523 = async (id)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'DELETE',
            url: `/api/v1/games/${id}`
        });
        if (res.status === 204) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het spel is succesvol verwijderd');
            location.reload(true);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};


/* eslint-disable */ 

const $a673f07f331b4e65$export$7856dcda102a774f = async (data)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'POST',
            url: '/api/v1/didacticMaterials',
            data: data
        });
        if (res.status === 201) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het didactisch materiaal is succesvol toegevoegd');
            window.setTimeout(()=>{
                location.assign('/controlpanel/didacticMaterials/overview');
            }, 1500);
        }
    } catch (err) {
        document.getElementById('createDidacticMaterial').disabled = false;
        document.getElementById('createDidacticMaterial').value = 'Voeg toe';
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};
const $a673f07f331b4e65$export$696d5b0683e1dd92 = async (data)=>{
    const id = data.get('_id');
    const role = data.get('role');
    let redirect;
    if (role === 'user') redirect = '/account/department/didacticMaterials/overview';
    else redirect = '/controlpanel/didacticMaterials/overview';
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/didacticMaterials/${id}`,
            data: data
        });
        if (res.status === 200) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het didactisch materiaal is succesvol gewijzigd');
            window.setTimeout(()=>{
                location.assign(redirect);
            }, 1500);
        }
    } catch (err) {
        document.getElementById('updateDidacticMaterial').disabled = false;
        document.getElementById('updateDidacticMaterial').value = 'Pas aan';
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};
const $a673f07f331b4e65$export$f1876dab6d6878d9 = async (id)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'DELETE',
            url: `/api/v1/didacticMaterials/${id}`
        });
        if (res.status === 204) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het didactisch materiaal is succesvol verwijderd');
            location.reload(true);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};


/* eslint-disable */ 

const $8ffaf538a50e3471$export$7d4f9cbad33e58b3 = async (data)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'POST',
            url: '/api/v1/learningBooks',
            data: data
        });
        if (res.status === 201) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het leerboek is succesvol toegevoegd');
            window.setTimeout(()=>{
                location.assign('/controlpanel/learningBooks/overview');
            }, 1500);
        }
    } catch (err) {
        document.getElementById('createLearningBook').disabled = false;
        document.getElementById('createLearningBook').value = 'Voeg toe';
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};
const $8ffaf538a50e3471$export$8f85d7239543baff = async (data)=>{
    const id = data.get('_id');
    const role = data.get('role');
    let redirect;
    if (role === 'user') redirect = '/account/department/learningBooks/overview';
    else redirect = '/controlpanel/learningBooks/overview';
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/learningBooks/${id}`,
            data: data
        });
        if (res.status === 200) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het leerboek is succesvol gewijzigd');
            window.setTimeout(()=>{
                location.assign(redirect);
            }, 1500);
        }
    } catch (err) {
        document.getElementById('updateLearningBook').disabled = false;
        document.getElementById('updateLearningBook').value = 'Pas aan';
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};
const $8ffaf538a50e3471$export$50ce213ed62b9ab0 = async (id)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'DELETE',
            url: `/api/v1/learningBooks/${id}`
        });
        if (res.status === 204) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het leerboek is succesvol verwijderd');
            location.reload(true);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};


/* eslint-disable */ 

const $09919c021e3c55d2$export$d32fbee3742ef204 = async (data)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'POST',
            url: '/api/v1/informativeBooks',
            data: data
        });
        if (res.status === 201) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het informatief boek is succesvol toegevoegd');
            window.setTimeout(()=>{
                location.assign('/controlpanel/informativeBooks/overview');
            }, 1500);
        }
    } catch (err) {
        document.getElementById('createInformativeBook').disabled = false;
        document.getElementById('createInformativeBook').value = 'Voeg toe';
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};
const $09919c021e3c55d2$export$114d2caabdf67d90 = async (data)=>{
    const id = data.get('_id');
    const role = data.get('role');
    let redirect;
    if (role === 'user') redirect = '/account/department/informativeBooks/overview';
    else redirect = '/controlpanel/informativeBooks/overview';
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/informativeBooks/${id}`,
            data: data
        });
        if (res.status === 200) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het informatief boek is succesvol gewijzigd');
            window.setTimeout(()=>{
                location.assign(redirect);
            }, 1500);
        }
    } catch (err) {
        document.getElementById('updateInformativeBook').disabled = false;
        document.getElementById('updateInformativeBook').value = 'Pas aan';
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};
const $09919c021e3c55d2$export$daee55bd8346dd9d = async (id)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'DELETE',
            url: `/api/v1/informativeBooks/${id}`
        });
        if (res.status === 204) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het informatief boek is succesvol verwijderd');
            location.reload(true);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};


/* eslint-disable */ 

const $c965e34cfa1f2763$export$4c5224da3115d2b9 = async (data)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'POST',
            url: '/api/v1/readingAndPictureBooks',
            data: data
        });
        if (res.status === 201) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het lees- en prentenboek is succesvol toegevoegd');
            window.setTimeout(()=>{
                location.assign('/controlpanel/readingAndPictureBooks/overview');
            }, 1500);
        }
    } catch (err) {
        document.getElementById('createReadingAndPictureBook').disabled = false;
        document.getElementById('createReadingAndPictureBook').value = 'Voeg toe';
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};
const $c965e34cfa1f2763$export$a75aafadbe1c7f5d = async (data)=>{
    const id = data.get('_id');
    const role = data.get('role');
    let redirect;
    if (role === 'user') redirect = '/account/department/readingAndPictureBooks/overview';
    else redirect = '/controlpanel/readingAndPictureBooks/overview';
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/readingAndPictureBooks/${id}`,
            data: data
        });
        if (res.status === 200) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het lees- en prentenboek is succesvol gewijzigd');
            window.setTimeout(()=>{
                location.assign(redirect);
            }, 1500);
        }
    } catch (err) {
        document.getElementById('updateReadingAndPictureBook').disabled = false;
        document.getElementById('updateReadingAndPictureBook').value = 'Pas aan';
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};
const $c965e34cfa1f2763$export$316e3d2b823f3dd9 = async (id)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'DELETE',
            url: `/api/v1/readingAndPictureBooks/${id}`
        });
        if (res.status === 204) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het lees- en prentenboek is succesvol verwijderd');
            location.reload(true);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};


/* eslint-disable */ 

const $f9cbaefb61efebd4$export$3493b8991d49f558 = async (data)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'POST',
            url: '/api/v1/users/signup',
            data: {
                name: data.get('name'),
                email: data.get('email'),
                department: data.getAll('department'),
                password: data.get('password'),
                passwordConfirm: data.get('passwordConfirm')
            }
        });
        if (res.data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', `Gebruiker is succesvol toegevoegd`);
            window.setTimeout(()=>{
                location.assign('/controlpanel/users/overview');
            }, 1500);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};
const $f9cbaefb61efebd4$export$e3ac7a5d19605772 = async (data)=>{
    const id = data.get('_id');
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/users/${id}`,
            data: {
                name: data.get('name'),
                role: data.get('role'),
                department: data.getAll('department')
            }
        });
        if (res.data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', `Gebruiker is succesvol aangepast`);
            window.setTimeout(()=>{
                location.assign('/controlpanel/users/overview');
            }, 1500);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};
const $f9cbaefb61efebd4$export$7d0f10f273c0438a = async (id)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'DELETE',
            url: `/api/v1/users/${id}`
        });
        if (res.status === 204) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'De gebruiker is succesvol verwijderd');
            location.reload(true);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message);
    }
};
const $f9cbaefb61efebd4$export$e6af0f282bef35a9 = async (passwordCurrent, password, passwordConfirm)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: '/api/v1/users/updateMyPassword',
            data: {
                passwordCurrent: passwordCurrent,
                password: password,
                passwordConfirm: passwordConfirm
            }
        });
        if (res.data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', `Paswoord succesvol aangepast`, 5);
            window.setTimeout(()=>{
                location.reload(true);
            }, 5000);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message, 5);
    }
};
const $f9cbaefb61efebd4$export$9fb5a9381b4171d1 = async (email)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'POST',
            url: '/api/v1/users/forgotPassword',
            data: {
                email: email
            }
        });
        if (res.data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', `Indien het e-mailadres bestaat zal je zo dadelijk een e-mail ontvangen met verdere instructies`, 5);
            window.setTimeout(()=>{
                location.assign('/login');
            }, 5000);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message, 5);
    }
};
const $f9cbaefb61efebd4$export$11a4d06436cf93e2 = async (data)=>{
    const token = data.get('token');
    const password = data.get('password');
    const passwordConfirm = data.get('passwordConfirm');
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/users/resetPassword/${token}`,
            data: {
                password: password,
                passwordConfirm: passwordConfirm
            }
        });
        if (res.data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', `Paswoord succesvol aangepast`, 5);
            window.setTimeout(()=>{
                location.assign('/login');
            }, 5000);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', err.response.data.message, 5);
    }
};


/* eslint-disable */ 

const $97e72fab7582660d$export$9b8f2347534a9be9 = async (userId, gameId)=>{
    try {
        const gameReservation = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'POST',
            url: '/api/v1/gameBookings',
            data: {
                user: userId,
                game: gameId
            }
        });
        const changeGameStatus = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/games/${gameId}`,
            data: {
                uitgeleend: true
            }
        });
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports))).all([
            gameReservation,
            changeGameStatus
        ]);
        if (res[0].data.status === 'success' && res[1].data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het spel werd toegevoegd aan uitleningen');
            window.setTimeout(()=>{
                location.assign('/account/reservations/overview');
            }, 1500);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', 'Fout tijdens het ontlenen');
        window.setTimeout(()=>{
            location.reload();
        }, 1500);
    }
};
const $97e72fab7582660d$export$af5039b866f8025b = async (userId, didacticMaterialId)=>{
    try {
        const didacticMaterialBooking = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'POST',
            url: '/api/v1/didacticMaterialBookings',
            data: {
                user: userId,
                didacticMaterial: didacticMaterialId
            }
        });
        const changeDidacticMaterialStatus = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/didacticMaterials/${didacticMaterialId}`,
            data: {
                uitgeleend: true
            }
        });
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports))).all([
            didacticMaterialBooking,
            changeDidacticMaterialStatus
        ]);
        if (res[0].data.status === 'success' && res[1].data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het didactisch materiaal werd toegevoegd aan uitleningen');
            window.setTimeout(()=>{
                location.assign('/account/reservations/overview');
            }, 1500);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', 'Fout tijdens het ontlenen');
        window.setTimeout(()=>{
            location.reload();
        }, 1500);
    }
};
const $97e72fab7582660d$export$8a88153ac8ec8461 = async (userId, learningBookId)=>{
    try {
        const learningBookBooking = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'POST',
            url: '/api/v1/learningBookBookings',
            data: {
                user: userId,
                learningBook: learningBookId
            }
        });
        const changeLearningBookStatus = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/learningBooks/${learningBookId}`,
            data: {
                uitgeleend: true
            }
        });
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports))).all([
            learningBookBooking,
            changeLearningBookStatus
        ]);
        if (res[0].data.status === 'success' && res[1].data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het leerboek werd toegevoegd aan uitleningen');
            window.setTimeout(()=>{
                location.assign('/account/reservations/overview');
            }, 1500);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', 'Fout tijdens het ontlenen');
        window.setTimeout(()=>{
            location.reload();
        }, 1500);
    }
};
const $97e72fab7582660d$export$f82dec1db363b56c = async (learningBookBookingId, learningBookId)=>{
    try {
        const deleteLearningBookReservation = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/learningBookBookings/${learningBookBookingId}`,
            data: {
                loan: false
            }
        });
        const changeLearningBookStatus = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/learningBooks/${learningBookId}`,
            data: {
                uitgeleend: false
            }
        });
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports))).all([
            deleteLearningBookReservation,
            changeLearningBookStatus
        ]);
        if (res[0].data.status === 'success' && res[1].data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het leerboek werd teruggebracht');
            window.setTimeout(()=>{
                location.assign('/account/reservations/learningBooks');
            }, 1500);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', 'Fout tijdens het inleveren');
    }
};
const $97e72fab7582660d$export$2a4e2b736a1dcc9f = async (gameBookingId, gameId)=>{
    try {
        const deleteGameReservation = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/gameBookings/${gameBookingId}`,
            data: {
                loan: false
            }
        });
        const changeGameStatus = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/games/${gameId}`,
            data: {
                uitgeleend: false
            }
        });
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports))).all([
            deleteGameReservation,
            changeGameStatus
        ]);
        if (res[0].data.status === 'success' && res[1].data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het spel werd teruggebracht');
            window.setTimeout(()=>{
                location.assign('/account/reservations/games');
            }, 1500);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', 'Fout tijdens het inleveren');
    }
};
const $97e72fab7582660d$export$3b954c12d0e6d349 = async (didacticMaterialBookingId, didacticMaterialId)=>{
    try {
        const deleteDidacticMaterialBooking = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/didacticMaterialBookings/${didacticMaterialBookingId}`,
            data: {
                loan: false
            }
        });
        const changeDidacticMaterialStatus = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/didacticMaterials/${didacticMaterialId}`,
            data: {
                uitgeleend: false
            }
        });
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports))).all([
            deleteDidacticMaterialBooking,
            changeDidacticMaterialStatus
        ]);
        if (res[0].data.status === 'success' && res[1].data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het didactisch materiaal werd teruggebracht');
            window.setTimeout(()=>{
                location.assign('/account/reservations/didacticMaterials');
            }, 1500);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', 'Fout tijdens het inleveren');
    }
};
const $97e72fab7582660d$export$3029092f488b9534 = async (gamebookingId)=>{
    try {
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/gameBookings/${gamebookingId}`,
            data: {
                prolongation: true,
                prolongationDate: Date.now()
            }
        });
        res.data.status = 'success';
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het spel werd met succes verlengd voor 14 dagen');
        window.setTimeout(()=>{
            location.assign('account/reservations/games');
        }, 1500);
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', 'Fout tijdens het verlengen');
    }
};
const $97e72fab7582660d$export$1996c4600e8f05a4 = async (userId, informativeBookId)=>{
    try {
        const informativeBookBooking = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'POST',
            url: '/api/v1/informativeBookBookings',
            data: {
                user: userId,
                informativeBook: informativeBookId
            }
        });
        const changeInformativeBookStatus = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/informativeBooks/${informativeBookId}`,
            data: {
                uitgeleend: true
            }
        });
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports))).all([
            informativeBookBooking,
            changeInformativeBookStatus
        ]);
        if (res[0].data.status === 'success' && res[1].data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het informative boek werd toegevoegd aan uitleningen');
            window.setTimeout(()=>{
                location.assign('/account/reservations/overview');
            }, 1500);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', 'Fout tijdens het ontlenen');
        window.setTimeout(()=>{
            location.reload();
        }, 1500);
    }
};
const $97e72fab7582660d$export$b1d8e3261b652d5c = async (informativeBookBookingId, informativeBookId)=>{
    try {
        const deleteInformativeBookReservation = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/informativeBookBookings/${informativeBookBookingId}`,
            data: {
                loan: false
            }
        });
        const changeInformativeBookStatus = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/informativeBooks/${informativeBookId}`,
            data: {
                uitgeleend: false
            }
        });
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports))).all([
            deleteInformativeBookReservation,
            changeInformativeBookStatus
        ]);
        if (res[0].data.status === 'success' && res[1].data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het informatieve boek werd teruggebracht');
            window.setTimeout(()=>{
                location.assign('/account/reservations/informativeBooks');
            }, 1500);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', 'Fout tijdens het inleveren');
    }
};
const $97e72fab7582660d$export$9b41f7c8fbe19296 = async (userId, readingAndPictureBookId)=>{
    try {
        const readingAndPictureBookBooking = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'POST',
            url: '/api/v1/readingAndPictureBookBookings',
            data: {
                user: userId,
                readingAndPictureBook: readingAndPictureBookId
            }
        });
        const changeReadingAndPictureBookStatus = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/readingAndPictureBooks/${readingAndPictureBookId}`,
            data: {
                uitgeleend: true
            }
        });
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports))).all([
            readingAndPictureBookBooking,
            changeReadingAndPictureBookStatus
        ]);
        if (res[0].data.status === 'success' && res[1].data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het lees- en prentenboek werd toegevoegd aan uitleningen');
            window.setTimeout(()=>{
                location.assign('/account/reservations/overview');
            }, 1500);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', 'Fout tijdens het ontlenen');
        window.setTimeout(()=>{
            location.reload();
        }, 1500);
    }
};
const $97e72fab7582660d$export$e0fdf5f754ea8c87 = async (readBookBookingId, readingAndPictureBookId)=>{
    try {
        const deleteReadingAndPictureBookReservation = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/readingAndPictureBookBookings/${readBookBookingId}`,
            data: {
                loan: false
            }
        });
        const changeReadingAndPictureBookStatus = (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports)))({
            method: 'PATCH',
            url: `/api/v1/readingAndPictureBooks/${readingAndPictureBookId}`,
            data: {
                uitgeleend: false
            }
        });
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($6ea372c62c4145c1$exports))).all([
            deleteReadingAndPictureBookReservation,
            changeReadingAndPictureBookStatus
        ]);
        if (res[0].data.status === 'success' && res[1].data.status === 'success') {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('success', 'Het lees- en prentenboek werd teruggebracht');
            window.setTimeout(()=>{
                location.assign('/account/reservations/readingAndPictureBooks');
            }, 1500);
        }
    } catch (err) {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', 'Fout tijdens het inleveren');
    }
};


/* eslint-disable */ var $9bfd3b6981a1f084$exports = {};
"use strict";
Object.defineProperty($9bfd3b6981a1f084$exports, "__esModule", {
    value: true
});
var $9bfd3b6981a1f084$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $9bfd3b6981a1f084$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $701191df7e2bbc1e$exports = {};
"use strict";
Object.defineProperty($701191df7e2bbc1e$exports, "__esModule", {
    value: true
});
var $701191df7e2bbc1e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $701191df7e2bbc1e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $701191df7e2bbc1e$var$allowedAttributes = {
    value: "data-value",
    disabled: "data-disabled",
    class: "class",
    type: "type"
};
var $701191df7e2bbc1e$var$Element = function() {
    function Element(element) {
        var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var i18n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $701191df7e2bbc1e$var$_classCallCheck(this, Element);
        this._node = element instanceof HTMLElement ? element : document.createElement(element);
        this._config = {
            i18n: i18n
        };
        this._setAttributes(attributes);
        if (attributes.textContent) this._setTextContent(attributes.textContent);
        return this;
    }
    $701191df7e2bbc1e$var$_createClass(Element, [
        {
            key: "get",
            value: function get() {
                return this._node;
            }
        },
        {
            key: "append",
            value: function append(element) {
                this._node.appendChild(element);
                return this;
            }
        },
        {
            key: "addClass",
            value: function addClass(className) {
                this._node.classList.add(className);
                return this;
            }
        },
        {
            key: "removeClass",
            value: function removeClass(className) {
                this._node.classList.remove(className);
                return this;
            }
        },
        {
            key: "toggleClass",
            value: function toggleClass(className) {
                this._node.classList.toggle(className);
                return this;
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(type, callback) {
                this._node.addEventListener(type, callback);
                return this;
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(type, callback) {
                this._node.removeEventListener(type, callback);
                return this;
            }
        },
        {
            key: "setText",
            value: function setText(text) {
                this._setTextContent(text);
                return this;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                return window.getComputedStyle(this._node).height;
            }
        },
        {
            key: "setTop",
            value: function setTop(top) {
                this._node.style.top = top + "px";
                return this;
            }
        },
        {
            key: "focus",
            value: function focus() {
                this._node.focus();
                return this;
            }
        },
        {
            key: "_setTextContent",
            value: function _setTextContent(textContent) {
                this._node.textContent = textContent;
            }
        },
        {
            key: "_setAttributes",
            value: function _setAttributes(attributes) {
                for(var key in attributes)if ($701191df7e2bbc1e$var$allowedAttributes[key] && attributes[key]) this._setAttribute($701191df7e2bbc1e$var$allowedAttributes[key], attributes[key]);
            }
        },
        {
            key: "_setAttribute",
            value: function _setAttribute(key, value) {
                this._node.setAttribute(key, value);
            }
        }
    ]);
    return Element;
}();
$701191df7e2bbc1e$exports.default = $701191df7e2bbc1e$var$Element;


var $9bfd3b6981a1f084$var$_Element2 = $9bfd3b6981a1f084$var$_interopRequireDefault($701191df7e2bbc1e$exports);
function $9bfd3b6981a1f084$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9bfd3b6981a1f084$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function $9bfd3b6981a1f084$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $9bfd3b6981a1f084$var$CLASSES = {
    select: "select-pure__select",
    dropdownShown: "select-pure__select--opened",
    multiselect: "select-pure__select--multiple",
    label: "select-pure__label",
    placeholder: "select-pure__placeholder",
    dropdown: "select-pure__options",
    option: "select-pure__option",
    autocompleteInput: "select-pure__autocomplete",
    selectedLabel: "select-pure__selected-label",
    selectedOption: "select-pure__option--selected",
    placeholderHidden: "select-pure__placeholder--hidden",
    optionHidden: "select-pure__option--hidden"
};
var $9bfd3b6981a1f084$var$SelectPure = function() {
    function SelectPure(element, config) {
        $9bfd3b6981a1f084$var$_classCallCheck(this, SelectPure);
        this._config = $9bfd3b6981a1f084$var$_extends({}, config, {
            classNames: $9bfd3b6981a1f084$var$_extends({}, $9bfd3b6981a1f084$var$CLASSES, config.classNames)
        });
        this._state = {
            opened: false
        };
        this._icons = [];
        this._boundHandleClick = this._handleClick.bind(this);
        this._boundUnselectOption = this._unselectOption.bind(this);
        this._boundSortOptions = this._sortOptions.bind(this);
        this._body = new $9bfd3b6981a1f084$var$_Element2.default(document.body);
        this._create(element);
        if (!this._config.value) return;
        this._setValue();
    }
    // Public API
    $9bfd3b6981a1f084$var$_createClass(SelectPure, [
        {
            key: "value",
            value: function value() {
                return this._config.value;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this._config.value = this._config.multiple ? [] : null;
                this._setValue();
            }
        },
        {
            key: "_create",
            value: function _create(_element) {
                var element = typeof _element === "string" ? document.querySelector(_element) : _element;
                this._parent = new $9bfd3b6981a1f084$var$_Element2.default(element);
                this._select = new $9bfd3b6981a1f084$var$_Element2.default("div", {
                    class: this._config.classNames.select
                });
                this._label = new $9bfd3b6981a1f084$var$_Element2.default("span", {
                    class: this._config.classNames.label
                });
                this._optionsWrapper = new $9bfd3b6981a1f084$var$_Element2.default("div", {
                    class: this._config.classNames.dropdown
                });
                if (this._config.multiple) this._select.addClass(this._config.classNames.multiselect);
                this._options = this._generateOptions();
                this._select.addEventListener("click", this._boundHandleClick);
                this._select.append(this._label.get());
                this._select.append(this._optionsWrapper.get());
                this._parent.append(this._select.get());
                this._placeholder = new $9bfd3b6981a1f084$var$_Element2.default("span", {
                    class: this._config.classNames.placeholder,
                    textContent: this._config.placeholder
                });
                this._select.append(this._placeholder.get());
            }
        },
        {
            key: "_generateOptions",
            value: function _generateOptions() {
                var _this = this;
                if (this._config.autocomplete) {
                    this._autocomplete = new $9bfd3b6981a1f084$var$_Element2.default("input", {
                        class: this._config.classNames.autocompleteInput,
                        type: "text"
                    });
                    this._autocomplete.addEventListener("input", this._boundSortOptions);
                    this._optionsWrapper.append(this._autocomplete.get());
                }
                return this._config.options.map(function(_option) {
                    var option = new $9bfd3b6981a1f084$var$_Element2.default("div", {
                        class: _this._config.classNames.option,
                        value: _option.value,
                        textContent: _option.label,
                        disabled: _option.disabled
                    });
                    _this._optionsWrapper.append(option.get());
                    return option;
                });
            }
        },
        {
            key: "_handleClick",
            value: function _handleClick(event) {
                event.stopPropagation();
                if (event.target.className === this._config.classNames.autocompleteInput) return;
                if (this._state.opened) {
                    var option = this._options.find(function(_option) {
                        return _option.get() === event.target;
                    });
                    if (option) this._setValue(option.get().getAttribute("data-value"), true);
                    this._select.removeClass(this._config.classNames.dropdownShown);
                    this._body.removeEventListener("click", this._boundHandleClick);
                    this._select.addEventListener("click", this._boundHandleClick);
                    this._state.opened = false;
                    return;
                }
                if (event.target.className === this._config.icon) return;
                this._select.addClass(this._config.classNames.dropdownShown);
                this._body.addEventListener("click", this._boundHandleClick);
                this._select.removeEventListener("click", this._boundHandleClick);
                this._state.opened = true;
                if (this._autocomplete) this._autocomplete.focus();
            }
        },
        {
            key: "_setValue",
            value: function _setValue(value, manual, unselected) {
                var _this2 = this;
                if (value && !unselected) this._config.value = this._config.multiple ? [].concat($9bfd3b6981a1f084$var$_toConsumableArray(this._config.value || []), [
                    value
                ]) : value;
                if (value && unselected) this._config.value = value;
                this._options.forEach(function(_option) {
                    _option.removeClass(_this2._config.classNames.selectedOption);
                });
                this._placeholder.removeClass(this._config.classNames.placeholderHidden);
                if (this._config.multiple) {
                    var options = this._config.value.map(function(_value) {
                        var option = _this2._config.options.find(function(_option) {
                            return _option.value === _value;
                        });
                        var optionNode = _this2._options.find(function(_option) {
                            return _option.get().getAttribute("data-value") === option.value.toString();
                        });
                        optionNode.addClass(_this2._config.classNames.selectedOption);
                        return option;
                    });
                    if (options.length) this._placeholder.addClass(this._config.classNames.placeholderHidden);
                    this._selectOptions(options, manual);
                    return;
                }
                var option = this._config.value ? this._config.options.find(function(_option) {
                    return _option.value.toString() === _this2._config.value;
                }) : this._config.options[0];
                var optionNode = this._options.find(function(_option) {
                    return _option.get().getAttribute("data-value") === option.value.toString();
                });
                if (!this._config.value) {
                    this._label.setText("");
                    return;
                }
                optionNode.addClass(this._config.classNames.selectedOption);
                this._placeholder.addClass(this._config.classNames.placeholderHidden);
                this._selectOption(option, manual);
            }
        },
        {
            key: "_selectOption",
            value: function _selectOption(option, manual) {
                this._selectedOption = option;
                this._label.setText(option.label);
                if (this._config.onChange && manual) this._config.onChange(option.value);
            }
        },
        {
            key: "_selectOptions",
            value: function _selectOptions(options, manual) {
                var _this3 = this;
                this._label.setText("");
                this._icons = options.map(function(_option) {
                    var selectedLabel = new $9bfd3b6981a1f084$var$_Element2.default("span", {
                        class: _this3._config.classNames.selectedLabel,
                        textContent: _option.label
                    });
                    var icon = new $9bfd3b6981a1f084$var$_Element2.default(_this3._config.inlineIcon ? _this3._config.inlineIcon.cloneNode(true) : "i", {
                        class: _this3._config.icon,
                        value: _option.value
                    });
                    icon.addEventListener("click", _this3._boundUnselectOption);
                    selectedLabel.append(icon.get());
                    _this3._label.append(selectedLabel.get());
                    return icon.get();
                });
                if (manual) // eslint-disable-next-line no-magic-numbers
                this._optionsWrapper.setTop(Number(this._select.getHeight().split("px")[0]) + 5);
                if (this._config.onChange && manual) this._config.onChange(this._config.value);
            }
        },
        {
            key: "_unselectOption",
            value: function _unselectOption(event) {
                var newValue = [].concat($9bfd3b6981a1f084$var$_toConsumableArray(this._config.value));
                var index = newValue.indexOf(event.target.getAttribute("data-value"));
                // eslint-disable-next-line no-magic-numbers
                if (index !== -1) newValue.splice(index, 1);
                this._setValue(newValue, true, true);
            }
        },
        {
            key: "_sortOptions",
            value: function _sortOptions(event) {
                var _this4 = this;
                this._options.forEach(function(_option) {
                    if (!_option.get().textContent.toLowerCase().startsWith(event.target.value.toLowerCase())) {
                        _option.addClass(_this4._config.classNames.optionHidden);
                        return;
                    }
                    _option.removeClass(_this4._config.classNames.optionHidden);
                });
            }
        }
    ]);
    return SelectPure;
}();
$9bfd3b6981a1f084$exports.default = $9bfd3b6981a1f084$var$SelectPure;


const $e9351b49dacdb3de$var$multiSelectDropDownCss = {
    select: 'select-pure__select',
    dropdownShown: 'select-pure__select--opened',
    multiselect: 'select-pure__select--multiple',
    label: 'select-pure__label',
    placeholder: 'select-pure__placeholder',
    dropdown: 'select-pure__options',
    option: 'select-pure__option',
    autocompleteInput: 'select-pure__autocomplete',
    selectedLabel: 'select-pure__selected-label',
    selectedOption: 'select-pure__option--selected',
    placeholderHidden: 'select-pure__placeholder--hidden',
    optionHidden: 'select-pure__option--hidden'
};
const $e9351b49dacdb3de$export$8d0de60f0f916a94 = (dropdown, niveau, meerVoudigeSelectie)=>{
    let niveauDropDown = '';
    if (niveau === undefined || niveau === 'undefined' || niveau.trim().length === 0) niveauDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
        options: [
            {
                label: '1ste kleuterklas',
                value: '1ste kleuterklas'
            },
            {
                label: '2de kleuterklas',
                value: '2de kleuterklas'
            },
            {
                label: '3de kleuterklas',
                value: '3de kleuterklas'
            },
            {
                label: '1ste leerjaar',
                value: '1ste leerjaar'
            },
            {
                label: '2de leerjaar',
                value: '2de leerjaar'
            },
            {
                label: '3de leerjaar',
                value: '3de leerjaar'
            },
            {
                label: '4de leerjaar',
                value: '4de leerjaar'
            },
            {
                label: '5de leerjaar',
                value: '5de leerjaar'
            },
            {
                label: '6de leerjaar',
                value: '6de leerjaar'
            },
            {
                label: '1ste middelbaar',
                value: '1ste middelbaar'
            },
            {
                label: '2de middelbaar',
                value: '2de middelbaar'
            },
            {
                label: '3de middelbaar',
                value: '3de middelbaar'
            },
            {
                label: '4de middelbaar',
                value: '4de middelbaar'
            },
            {
                label: '5de middelbaar',
                value: '5de middelbaar'
            },
            {
                label: '6de middelbaar',
                value: '6de middelbaar'
            },
            {
                label: '7de middelbaar',
                value: '7de middelbaar'
            },
            {
                label: 'Leerkrachten',
                value: 'Leerkrachten'
            }
        ],
        multiple: meerVoudigeSelectie,
        autocomplete: true,
        icon: 'icon-close',
        placeholder: 'Niveau',
        classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
    });
    else {
        const niveauValues = niveau.split(',');
        niveauDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
            options: [
                {
                    label: '1ste kleuterklas',
                    value: '1ste kleuterklas'
                },
                {
                    label: '2de kleuterklas',
                    value: '2de kleuterklas'
                },
                {
                    label: '3de kleuterklas',
                    value: '3de kleuterklas'
                },
                {
                    label: '1ste leerjaar',
                    value: '1ste leerjaar'
                },
                {
                    label: '2de leerjaar',
                    value: '2de leerjaar'
                },
                {
                    label: '3de leerjaar',
                    value: '3de leerjaar'
                },
                {
                    label: '4de leerjaar',
                    value: '4de leerjaar'
                },
                {
                    label: '5de leerjaar',
                    value: '5de leerjaar'
                },
                {
                    label: '6de leerjaar',
                    value: '6de leerjaar'
                },
                {
                    label: '1ste middelbaar',
                    value: '1ste middelbaar'
                },
                {
                    label: '2de middelbaar',
                    value: '2de middelbaar'
                },
                {
                    label: '3de middelbaar',
                    value: '3de middelbaar'
                },
                {
                    label: '4de middelbaar',
                    value: '4de middelbaar'
                },
                {
                    label: '5de middelbaar',
                    value: '5de middelbaar'
                },
                {
                    label: '6de middelbaar',
                    value: '6de middelbaar'
                },
                {
                    label: '7de middelbaar',
                    value: '7de middelbaar'
                },
                {
                    label: 'Leerkrachten',
                    value: 'Leerkrachten'
                }
            ],
            value: niveauValues,
            multiple: meerVoudigeSelectie,
            autocomplete: true,
            icon: 'icon-close',
            placeholder: 'Niveau',
            classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
        });
    }
    return niveauDropDown;
};
const $e9351b49dacdb3de$export$1eec3e886f01dfe2 = (dropdown, role)=>{
    const rolDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
        options: [
            {
                label: 'Admin',
                value: 'admin'
            },
            {
                label: 'User',
                value: 'user'
            }
        ],
        value: role,
        icon: 'icon-close',
        placeholder: 'Rol',
        classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
    });
    return rolDropDown;
};
const $e9351b49dacdb3de$export$19eb1dd3ff45e9b = (dropdown, handleiding)=>{
    const handleidingDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
        options: [
            {
                label: 'Handleiding aanwezig',
                value: 'true'
            },
            {
                label: 'Handleiding afwezig',
                value: 'false'
            }
        ],
        value: handleiding,
        icon: 'icon-close',
        placeholder: 'Handleiding',
        classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
    });
    return handleidingDropDown;
};
const $e9351b49dacdb3de$export$18444686970a42c4 = (dropdown, location)=>{
    let locatieDropDown = '';
    if (location !== undefined) locatieDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
        options: [
            {
                label: 'De Sleutel - RKJ',
                value: 'De Sleutel - RKJ'
            },
            {
                label: 'Guislain - De Steiger',
                value: 'Guislain - De Steiger'
            },
            {
                label: 'Guislain - Fioretti',
                value: 'Guislain - Fioretti'
            },
            {
                label: 'Jan Palfijn',
                value: 'Jan Palfijn'
            },
            {
                label: 'Karus - Branding',
                value: 'Karus - Branding'
            },
            {
                label: 'Karus - Dageraad',
                value: 'Karus - Dageraad'
            },
            {
                label: 'Karus - DAM',
                value: 'Karus - DAM'
            },
            {
                label: 'Karus - JOVO',
                value: 'Karus - JOVO'
            },
            {
                label: 'Karus - LG1',
                value: 'Karus - LG1'
            },
            {
                label: 'Karus - LG2',
                value: 'Karus - LG2'
            },
            {
                label: 'Karus - LG3',
                value: 'Karus - LG3'
            },
            {
                label: 'Karus - LG4',
                value: 'Karus - LG4'
            },
            {
                label: 'Karus - Kaap Klas 1',
                value: 'Karus - Kaap Klas 1'
            },
            {
                label: 'Karus - Kaap Klas 2',
                value: 'Karus - Kaap Klas 2'
            },
            {
                label: 'Karus - Kaap Klas 3',
                value: 'Karus - Kaap Klas 3'
            },
            {
                label: 'Karus - Kaap Klas 4',
                value: 'Karus - Kaap Klas 4'
            },
            {
                label: 'Karus - Kaap Klas 5',
                value: 'Karus - Kaap Klas 5'
            },
            {
                label: 'Karus - Kaap Leraarskamer',
                value: 'Karus - Kaap Leraarskamer'
            },
            {
                label: 'Karus - Kaap Knutselkast',
                value: 'Karus - Kaap Knutselkast'
            },
            {
                label: 'Karus - Getijden Klas 1',
                value: 'Karus - Getijden Klas 1'
            },
            {
                label: 'Karus - Getijden Klas 2',
                value: 'Karus - Getijden Klas 2'
            },
            {
                label: 'Karus - Getijden Klas 3',
                value: 'Karus - Getijden Klas 3'
            },
            {
                label: 'Karus - Getijden Klas 4',
                value: 'Karus - Getijden Klas 4'
            },
            {
                label: 'Karus - Getijden Klas 5',
                value: 'Karus - Getijden Klas 5'
            },
            {
                label: 'Karus - Getijden Project',
                value: 'Karus - Getijden Project'
            },
            {
                label: 'Karus - Getijden Praktijk',
                value: 'Karus - Getijden Praktijk'
            },
            {
                label: 'Karus - Getijden STEM',
                value: 'Karus - Getijden STEM'
            },
            {
                label: 'Karus - Getijden Leraarskamer',
                value: 'Karus - Getijden Leraarskamer'
            },
            {
                label: 'Karus - Getijden Klastitularis',
                value: 'Karus - Getijden Klastitularis'
            },
            {
                label: 'Karus - Getijden Gangkast',
                value: 'Karus - Getijden Gangkast'
            },
            {
                label: 'Karus - Branding Praktijk',
                value: 'Karus - Branding Praktijk'
            },
            {
                label: 'Karus - Branding Klas',
                value: 'Karus - Branding Klas'
            },
            {
                label: 'Sint-Lucas',
                value: 'Sint-Lucas'
            },
            {
                label: 'UZ - 1K5',
                value: 'UZ - 1K5'
            },
            {
                label: 'UZ - 4K12D',
                value: 'UZ - 4K12D'
            },
            {
                label: 'UZ - 5K12D',
                value: 'UZ - 5K12D'
            },
            {
                label: 'UZ - ES',
                value: 'UZ - ES'
            },
            {
                label: 'UZ - K7',
                value: 'UZ - K7'
            },
            {
                label: 'UZ - KJP',
                value: 'UZ - KJP'
            },
            {
                label: 'UZ - KRC',
                value: 'UZ - KRC'
            }
        ],
        value: location.trim(),
        icon: 'icon-close',
        placeholder: 'Locatie',
        classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
    });
    else locatieDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
        options: [
            {
                label: 'De Sleutel - RKJ',
                value: 'De Sleutel - RKJ'
            },
            {
                label: 'Guislain - De Steiger',
                value: 'Guislain - De Steiger'
            },
            {
                label: 'Guislain - Fioretti',
                value: 'Guislain - Fioretti'
            },
            {
                label: 'Jan Palfijn',
                value: 'Jan Palfijn'
            },
            {
                label: 'Karus - Branding',
                value: 'Karus - Branding'
            },
            {
                label: 'Karus - Dageraad',
                value: 'Karus - Dageraad'
            },
            {
                label: 'Karus - DAM',
                value: 'Karus - DAM'
            },
            {
                label: 'Karus - JOVO',
                value: 'Karus - JOVO'
            },
            {
                label: 'Karus - LG1',
                value: 'Karus - LG1'
            },
            {
                label: 'Karus - LG2',
                value: 'Karus - LG2'
            },
            {
                label: 'Karus - LG3',
                value: 'Karus - LG3'
            },
            {
                label: 'Karus - LG4',
                value: 'Karus - LG4'
            },
            {
                label: 'Karus - Kaap Klas 1',
                value: 'Karus - Kaap Klas 1'
            },
            {
                label: 'Karus - Kaap Klas 2',
                value: 'Karus - Kaap Klas 2'
            },
            {
                label: 'Karus - Kaap Klas 3',
                value: 'Karus - Kaap Klas 3'
            },
            {
                label: 'Karus - Kaap Klas 4',
                value: 'Karus - Kaap Klas 4'
            },
            {
                label: 'Karus - Kaap Klas 5',
                value: 'Karus - Kaap Klas 5'
            },
            {
                label: 'Karus - Kaap Leraarskamer',
                value: 'Karus - Kaap Leraarskamer'
            },
            {
                label: 'Karus - Kaap Knutselkast',
                value: 'Karus - Kaap Knutselkast'
            },
            {
                label: 'Karus - Getijden Klas 1',
                value: 'Karus - Getijden Klas 1'
            },
            {
                label: 'Karus - Getijden Klas 2',
                value: 'Karus - Getijden Klas 2'
            },
            {
                label: 'Karus - Getijden Klas 3',
                value: 'Karus - Getijden Klas 3'
            },
            {
                label: 'Karus - Getijden Klas 4',
                value: 'Karus - Getijden Klas 4'
            },
            {
                label: 'Karus - Getijden Klas 5',
                value: 'Karus - Getijden Klas 5'
            },
            {
                label: 'Karus - Getijden Project',
                value: 'Karus - Getijden Project'
            },
            {
                label: 'Karus - Getijden Praktijk',
                value: 'Karus - Getijden Praktijk'
            },
            {
                label: 'Karus - Getijden STEM',
                value: 'Karus - Getijden STEM'
            },
            {
                label: 'Karus - Getijden Leraarskamer',
                value: 'Karus - Getijden Leraarskamer'
            },
            {
                label: 'Karus - Getijden Klastitularis',
                value: 'Karus - Getijden Klastitularis'
            },
            {
                label: 'Karus - Getijden Gangkast',
                value: 'Karus - Getijden Gangkast'
            },
            {
                label: 'Karus - Branding Praktijk',
                value: 'Karus - Branding Praktijk'
            },
            {
                label: 'Karus - Branding Klas',
                value: 'Karus - Branding Klas'
            },
            {
                label: 'Sint-Lucas',
                value: 'Sint-Lucas'
            },
            {
                label: 'UZ - 1K5',
                value: 'UZ - 1K5'
            },
            {
                label: 'UZ - 4K12D',
                value: 'UZ - 4K12D'
            },
            {
                label: 'UZ - 5K12D',
                value: 'UZ - 5K12D'
            },
            {
                label: 'UZ - ES',
                value: 'UZ - ES'
            },
            {
                label: 'UZ - K7',
                value: 'UZ - K7'
            },
            {
                label: 'UZ - KJP',
                value: 'UZ - KJP'
            },
            {
                label: 'UZ - KRC',
                value: 'UZ - KRC'
            }
        ],
        icon: 'icon-close',
        placeholder: 'Locatie',
        classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
    });
    return locatieDropDown;
};
const $e9351b49dacdb3de$export$4014023b4d854e4b = (dropdown, userDepartment)=>{
    let departmentDropDown = '';
    if (userDepartment === undefined || userDepartment === 'undefined' || userDepartment.trim().length === 0) departmentDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
        options: [
            {
                label: 'De Sleutel - RKJ',
                value: 'De Sleutel - RKJ'
            },
            {
                label: 'Guislain - De Steiger',
                value: 'Guislain - De Steiger'
            },
            {
                label: 'Guislain - Fioretti',
                value: 'Guislain - Fioretti'
            },
            {
                label: 'Jan Palfijn',
                value: 'Jan Palfijn'
            },
            {
                label: 'Karus - Branding',
                value: 'Karus - Branding'
            },
            {
                label: 'Karus - Dageraad',
                value: 'Karus - Dageraad'
            },
            {
                label: 'Karus - DAM',
                value: 'Karus - DAM'
            },
            {
                label: 'Karus - JOVO',
                value: 'Karus - JOVO'
            },
            {
                label: 'Karus - LG1',
                value: 'Karus - LG1'
            },
            {
                label: 'Karus - LG2',
                value: 'Karus - LG2'
            },
            {
                label: 'Karus - LG3',
                value: 'Karus - LG3'
            },
            {
                label: 'Karus - LG4',
                value: 'Karus - LG4'
            },
            {
                label: 'Karus - Kaap Klas 1',
                value: 'Karus - Kaap Klas 1'
            },
            {
                label: 'Karus - Kaap Klas 2',
                value: 'Karus - Kaap Klas 2'
            },
            {
                label: 'Karus - Kaap Klas 3',
                value: 'Karus - Kaap Klas 3'
            },
            {
                label: 'Karus - Kaap Klas 4',
                value: 'Karus - Kaap Klas 4'
            },
            {
                label: 'Karus - Kaap Klas 5',
                value: 'Karus - Kaap Klas 5'
            },
            {
                label: 'Karus - Kaap Leraarskamer',
                value: 'Karus - Kaap Leraarskamer'
            },
            {
                label: 'Karus - Kaap Knutselkast',
                value: 'Karus - Kaap Knutselkast'
            },
            {
                label: 'Karus - Getijden Klas 1',
                value: 'Karus - Getijden Klas 1'
            },
            {
                label: 'Karus - Getijden Klas 2',
                value: 'Karus - Getijden Klas 2'
            },
            {
                label: 'Karus - Getijden Klas 3',
                value: 'Karus - Getijden Klas 3'
            },
            {
                label: 'Karus - Getijden Klas 4',
                value: 'Karus - Getijden Klas 4'
            },
            {
                label: 'Karus - Getijden Klas 5',
                value: 'Karus - Getijden Klas 5'
            },
            {
                label: 'Karus - Getijden Project',
                value: 'Karus - Getijden Project'
            },
            {
                label: 'Karus - Getijden Praktijk',
                value: 'Karus - Getijden Praktijk'
            },
            {
                label: 'Karus - Getijden STEM',
                value: 'Karus - Getijden STEM'
            },
            {
                label: 'Karus - Getijden Leraarskamer',
                value: 'Karus - Getijden Leraarskamer'
            },
            {
                label: 'Karus - Getijden Klastitularis',
                value: 'Karus - Getijden Klastitularis'
            },
            {
                label: 'Karus - Getijden Gangkast',
                value: 'Karus - Getijden Gangkast'
            },
            {
                label: 'Karus - Branding Praktijk',
                value: 'Karus - Branding Praktijk'
            },
            {
                label: 'Karus - Branding Klas',
                value: 'Karus - Branding Klas'
            },
            {
                label: 'Sint-Lucas',
                value: 'Sint-Lucas'
            },
            {
                label: 'UZ - 1K5',
                value: 'UZ - 1K5'
            },
            {
                label: 'UZ - 4K12D',
                value: 'UZ - 4K12D'
            },
            {
                label: 'UZ - 5K12D',
                value: 'UZ - 5K12D'
            },
            {
                label: 'UZ - ES',
                value: 'UZ - ES'
            },
            {
                label: 'UZ - K7',
                value: 'UZ - K7'
            },
            {
                label: 'UZ - KJP',
                value: 'UZ - KJP'
            },
            {
                label: 'UZ - KRC',
                value: 'UZ - KRC'
            }
        ],
        multiple: true,
        autocomplete: true,
        icon: 'icon-close',
        placeholder: 'Afdeling',
        classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
    });
    else {
        const userDepartmentValues = userDepartment.split(',');
        departmentDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
            options: [
                {
                    label: 'De Sleutel - RKJ',
                    value: 'De Sleutel - RKJ'
                },
                {
                    label: 'Guislain - De Steiger',
                    value: 'Guislain - De Steiger'
                },
                {
                    label: 'Guislain - Fioretti',
                    value: 'Guislain - Fioretti'
                },
                {
                    label: 'Jan Palfijn',
                    value: 'Jan Palfijn'
                },
                {
                    label: 'Karus - Branding',
                    value: 'Karus - Branding'
                },
                {
                    label: 'Karus - Dageraad',
                    value: 'Karus - Dageraad'
                },
                {
                    label: 'Karus - DAM',
                    value: 'Karus - DAM'
                },
                {
                    label: 'Karus - JOVO',
                    value: 'Karus - JOVO'
                },
                {
                    label: 'Karus - LG1',
                    value: 'Karus - LG1'
                },
                {
                    label: 'Karus - LG2',
                    value: 'Karus - LG2'
                },
                {
                    label: 'Karus - LG3',
                    value: 'Karus - LG3'
                },
                {
                    label: 'Karus - LG4',
                    value: 'Karus - LG4'
                },
                {
                    label: 'Karus - Kaap Klas 1',
                    value: 'Karus - Kaap Klas 1'
                },
                {
                    label: 'Karus - Kaap Klas 2',
                    value: 'Karus - Kaap Klas 2'
                },
                {
                    label: 'Karus - Kaap Klas 3',
                    value: 'Karus - Kaap Klas 3'
                },
                {
                    label: 'Karus - Kaap Klas 4',
                    value: 'Karus - Kaap Klas 4'
                },
                {
                    label: 'Karus - Kaap Klas 5',
                    value: 'Karus - Kaap Klas 5'
                },
                {
                    label: 'Karus - Kaap Leraarskamer',
                    value: 'Karus - Kaap Leraarskamer'
                },
                {
                    label: 'Karus - Kaap Knutselkast',
                    value: 'Karus - Kaap Knutselkast'
                },
                {
                    label: 'Karus - Getijden Klas 1',
                    value: 'Karus - Getijden Klas 1'
                },
                {
                    label: 'Karus - Getijden Klas 2',
                    value: 'Karus - Getijden Klas 2'
                },
                {
                    label: 'Karus - Getijden Klas 3',
                    value: 'Karus - Getijden Klas 3'
                },
                {
                    label: 'Karus - Getijden Klas 4',
                    value: 'Karus - Getijden Klas 4'
                },
                {
                    label: 'Karus - Getijden Klas 5',
                    value: 'Karus - Getijden Klas 5'
                },
                {
                    label: 'Karus - Getijden Project',
                    value: 'Karus - Getijden Project'
                },
                {
                    label: 'Karus - Getijden Praktijk',
                    value: 'Karus - Getijden Praktijk'
                },
                {
                    label: 'Karus - Getijden STEM',
                    value: 'Karus - Getijden STEM'
                },
                {
                    label: 'Karus - Getijden Leraarskamer',
                    value: 'Karus - Getijden Leraarskamer'
                },
                {
                    label: 'Karus - Getijden Klastitularis',
                    value: 'Karus - Getijden Klastitularis'
                },
                {
                    label: 'Karus - Getijden Gangkast',
                    value: 'Karus - Getijden Gangkast'
                },
                {
                    label: 'Karus - Branding Praktijk',
                    value: 'Karus - Branding Praktijk'
                },
                {
                    label: 'Karus - Branding Klas',
                    value: 'Karus - Branding Klas'
                },
                {
                    label: 'Sint-Lucas',
                    value: 'Sint-Lucas'
                },
                {
                    label: 'UZ - 1K5',
                    value: 'UZ - 1K5'
                },
                {
                    label: 'UZ - 4K12D',
                    value: 'UZ - 4K12D'
                },
                {
                    label: 'UZ - 5K12D',
                    value: 'UZ - 5K12D'
                },
                {
                    label: 'UZ - ES',
                    value: 'UZ - ES'
                },
                {
                    label: 'UZ - K7',
                    value: 'UZ - K7'
                },
                {
                    label: 'UZ - KJP',
                    value: 'UZ - KJP'
                },
                {
                    label: 'UZ - KRC',
                    value: 'UZ - KRC'
                }
            ],
            value: userDepartmentValues,
            multiple: true,
            autocomplete: true,
            icon: 'icon-close',
            placeholder: 'Afdeling',
            classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
        });
    }
    return departmentDropDown;
};
const $e9351b49dacdb3de$export$bd4e270cafd52145 = (dropdown, gameVak, meerVoudigeSelectie)=>{
    let vakDropDown = '';
    if (gameVak === undefined || gameVak === 'undefined' || gameVak.trim().length === 0) vakDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
        options: [
            {
                label: 'Aardrijkskunde',
                value: 'Aardrijkskunde'
            },
            {
                label: 'ADL',
                value: 'ADL'
            },
            {
                label: 'Duits',
                value: 'Duits'
            },
            {
                label: 'Economie',
                value: 'Economie'
            },
            {
                label: 'Engels',
                value: 'Engels'
            },
            {
                label: 'Frans',
                value: 'Frans'
            },
            {
                label: 'Geschiedenis',
                value: 'Geschiedenis'
            },
            {
                label: 'ICT',
                value: 'ICT'
            },
            {
                label: 'Latijn',
                value: 'Latijn'
            },
            {
                label: 'Lichamelijke opvoeding',
                value: 'Lichamelijke opvoeding'
            },
            {
                label: 'Mens en maatschappij',
                value: 'Mens en maatschappij'
            },
            {
                label: 'Muzische vorming',
                value: 'Muzische vorming'
            },
            {
                label: 'Nederlands',
                value: 'Nederlands'
            },
            {
                label: 'PAV',
                value: 'PAV'
            },
            {
                label: 'Plastische vorming',
                value: 'Plastische vorming'
            },
            {
                label: 'Praktijk',
                value: 'Praktijk'
            },
            {
                label: 'Project',
                value: 'Project'
            },
            {
                label: 'Rijbewijs',
                value: 'Rijbewijs'
            },
            {
                label: 'Sociale wetenschappen',
                value: 'Sociale wetenschappen'
            },
            {
                label: 'STEM',
                value: 'STEM'
            },
            {
                label: 'Wetenschappen',
                value: 'Wetenschappen'
            },
            {
                label: 'Wiskunde',
                value: 'Wiskunde'
            }
        ],
        multiple: meerVoudigeSelectie,
        autocomplete: true,
        icon: 'icon-close',
        placeholder: 'Vakken',
        classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
    });
    else {
        const gameVakValues = gameVak.split(',');
        vakDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
            options: [
                {
                    label: 'Aardrijkskunde',
                    value: 'Aardrijkskunde'
                },
                {
                    label: 'ADL',
                    value: 'ADL'
                },
                {
                    label: 'Duits',
                    value: 'Duits'
                },
                {
                    label: 'Economie',
                    value: 'Economie'
                },
                {
                    label: 'Engels',
                    value: 'Engels'
                },
                {
                    label: 'Frans',
                    value: 'Frans'
                },
                {
                    label: 'Geschiedenis',
                    value: 'Geschiedenis'
                },
                {
                    label: 'ICT',
                    value: 'ICT'
                },
                {
                    label: 'Latijn',
                    value: 'Latijn'
                },
                {
                    label: 'Lichamelijke opvoeding',
                    value: 'Lichamelijke opvoeding'
                },
                {
                    label: 'Mens en maatschappij',
                    value: 'Mens en maatschappij'
                },
                {
                    label: 'Muzische vorming',
                    value: 'Muzische vorming'
                },
                {
                    label: 'Nederlands',
                    value: 'Nederlands'
                },
                {
                    label: 'PAV',
                    value: 'PAV'
                },
                {
                    label: 'Plastische vorming',
                    value: 'Plastische vorming'
                },
                {
                    label: 'Praktijk',
                    value: 'Praktijk'
                },
                {
                    label: 'Project',
                    value: 'Project'
                },
                {
                    label: 'Rijbewijs',
                    value: 'Rijbewijs'
                },
                {
                    label: 'Sociale wetenschappen',
                    value: 'Sociale wetenschappen'
                },
                {
                    label: 'STEM',
                    value: 'STEM'
                },
                {
                    label: 'Wetenschappen',
                    value: 'Wetenschappen'
                },
                {
                    label: 'Wiskunde',
                    value: 'Wiskunde'
                }
            ],
            value: gameVakValues,
            multiple: meerVoudigeSelectie,
            autocomplete: true,
            icon: 'icon-close',
            placeholder: 'Vakken',
            classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
        });
    }
    return vakDropDown;
};
const $e9351b49dacdb3de$export$77214a3ba76484c0 = (dropdown, kindGesprek)=>{
    let kindGesprekDropDown = '';
    if (kindGesprek === undefined || kindGesprek === 'undefined' || kindGesprek.trim().length === 0) kindGesprekDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
        options: [
            {
                label: 'Doelen',
                value: 'Doelen'
            },
            {
                label: 'Feedback',
                value: 'Feedback'
            },
            {
                label: 'Kennismaking',
                value: 'Kennismaking'
            },
            {
                label: 'Probleemverkenning',
                value: 'Probleemverkenning'
            }
        ],
        multiple: true,
        icon: 'icon-close',
        placeholder: 'Kindgesprek',
        classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
    });
    else {
        const kindGesprekValues = kindGesprek.split(',');
        kindGesprekDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
            options: [
                {
                    label: 'Doelen',
                    value: 'Doelen'
                },
                {
                    label: 'Feedback',
                    value: 'Feedback'
                },
                {
                    label: 'Kennismaking',
                    value: 'Kennismaking'
                },
                {
                    label: 'Probleemverkenning',
                    value: 'Probleemverkenning'
                }
            ],
            value: kindGesprekValues,
            multiple: true,
            icon: 'icon-close',
            placeholder: 'Kindgesprek',
            classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
        });
    }
    return kindGesprekDropDown;
};
const $e9351b49dacdb3de$export$c7abf3a563086090 = (dropdown, gameIsolatie)=>{
    let isolatieDropDown = '';
    if (gameIsolatie !== undefined) isolatieDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
        options: [
            {
                label: 'Geschikt',
                value: 'true'
            },
            {
                label: 'Niet geschikt',
                value: 'false'
            }
        ],
        value: gameIsolatie,
        icon: 'icon-close',
        placeholder: 'Isolatie',
        classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
    });
    else isolatieDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
        options: [
            {
                label: 'Geschikt',
                value: 'true'
            },
            {
                label: 'Niet geschikt',
                value: 'false'
            }
        ],
        icon: 'icon-close',
        placeholder: 'Isolatie',
        classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
    });
    return isolatieDropDown;
};
const $e9351b49dacdb3de$export$6ec9326aba4fe8d7 = (dropdown, gameUitleenbaar)=>{
    let uitleenbaarDropDown = '';
    if (gameUitleenbaar !== undefined) uitleenbaarDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
        options: [
            {
                label: 'Uitleenbaar',
                value: 'true'
            },
            {
                label: 'Niet uitleenbaar',
                value: 'false'
            }
        ],
        value: gameUitleenbaar,
        icon: 'icon-close',
        placeholder: 'Uitleenbaar',
        classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
    });
    else uitleenbaarDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
        options: [
            {
                label: 'Uitleenbaar',
                value: 'true'
            },
            {
                label: 'Niet uitleenbaar',
                value: 'false'
            }
        ],
        icon: 'icon-close',
        placeholder: 'Uitleenbaar',
        classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
    });
    return uitleenbaarDropDown;
};
const $e9351b49dacdb3de$export$841576e3d080987b = (dropdown, gameLeerprofiel)=>{
    let leerprofielDropDown = '';
    if (gameLeerprofiel === undefined || gameLeerprofiel === 'undefined' || gameLeerprofiel.trim().length === 0) leerprofielDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
        options: [
            {
                label: 'Cognitief functioneren',
                value: 'Cognitief functioneren'
            },
            {
                label: 'Groepsfunctioneren',
                value: 'Groepsfunctioneren'
            },
            {
                label: 'Leer- en werkhouding',
                value: 'Leer- en werkhouding'
            },
            {
                label: 'Leerbereidheid',
                value: 'Leerbereidheid'
            },
            {
                label: 'Lichamelijk functioneren',
                value: 'Lichamelijk functioneren'
            }
        ],
        multiple: true,
        icon: 'icon-close',
        placeholder: 'Leerprofiel',
        classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
    });
    else {
        const gameLeerprofielValues = gameLeerprofiel.split(',');
        leerprofielDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
            options: [
                {
                    label: 'Cognitief functioneren',
                    value: 'Cognitief functioneren'
                },
                {
                    label: 'Groepsfunctioneren',
                    value: 'Groepsfunctioneren'
                },
                {
                    label: 'Leer- en werkhouding',
                    value: 'Leer- en werkhouding'
                },
                {
                    label: 'Leerbereidheid',
                    value: 'Leerbereidheid'
                },
                {
                    label: 'Lichamelijk functioneren',
                    value: 'Lichamelijk functioneren'
                }
            ],
            value: gameLeerprofielValues,
            multiple: true,
            icon: 'icon-close',
            placeholder: 'Leerprofiel',
            classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
        });
    }
    return leerprofielDropDown;
};
const $e9351b49dacdb3de$export$72dec94571b996c5 = (dropdown, executieveFunctie)=>{
    let executieveFunctieDropDown = '';
    if (executieveFunctie === undefined || executieveFunctie === 'undefined' || executieveFunctie.trim().length === 0) executieveFunctieDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
        options: [
            {
                label: 'Flexibiliteit',
                value: 'Flexibiliteit'
            },
            {
                label: 'Inhibitie',
                value: 'Inhibitie'
            },
            {
                label: 'Doelgericht gedrag',
                value: 'Doelgericht gedrag'
            },
            {
                label: 'Plannen',
                value: 'Plannen'
            },
            {
                label: 'Timemanagement',
                value: 'Timemanagement'
            },
            {
                label: 'Werkgeheugen',
                value: 'Werkgeheugen'
            },
            {
                label: 'Volgehouden aandacht',
                value: 'Volgehouden aandacht'
            },
            {
                label: 'Emotieregulatie',
                value: 'Emotieregulatie'
            },
            {
                label: 'Organiseren',
                value: 'Organiseren'
            }
        ],
        multiple: true,
        icon: 'icon-close',
        placeholder: 'Executieve Functie',
        classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
    });
    else {
        const executieveFunctieValues = executieveFunctie.split(',');
        executieveFunctieDropDown = new (0, (/*@__PURE__*/$parcel$interopDefault($9bfd3b6981a1f084$exports)))(dropdown, {
            options: [
                {
                    label: 'Flexibiliteit',
                    value: 'Flexibiliteit'
                },
                {
                    label: 'Inhibitie',
                    value: 'Inhibitie'
                },
                {
                    label: 'Doelgericht gedrag',
                    value: 'Doelgericht gedrag'
                },
                {
                    label: 'Plannen',
                    value: 'Plannen'
                },
                {
                    label: 'Timemanagement',
                    value: 'Timemanagement'
                },
                {
                    label: 'Werkgeheugen',
                    value: 'Werkgeheugen'
                },
                {
                    label: 'Volgehouden aandacht',
                    value: 'Volgehouden aandacht'
                },
                {
                    label: 'Emotieregulatie',
                    value: 'Emotieregulatie'
                },
                {
                    label: 'Organiseren',
                    value: 'Organiseren'
                }
            ],
            value: executieveFunctieValues,
            multiple: true,
            icon: 'icon-close',
            placeholder: 'Executieve Functie',
            classNames: $e9351b49dacdb3de$var$multiSelectDropDownCss
        });
    }
    return executieveFunctieDropDown;
};


/* eslint-disable */ var $1a87f63a5aa52bae$exports = {};
/*! nouislider - 14.7.0 - 4/6/2021 */ (function(factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else $1a87f63a5aa52bae$exports = factory();
})(function() {
    "use strict";
    var VERSION = "14.7.0";
    //region Helper Methods
    function isValidFormatter(entry) {
        return typeof entry === "object" && typeof entry.to === "function" && typeof entry.from === "function";
    }
    function removeElement(el) {
        el.parentElement.removeChild(el);
    }
    function isSet(value) {
        return value !== null && value !== undefined;
    }
    // Bindable version
    function preventDefault(e) {
        e.preventDefault();
    }
    // Removes duplicates from an array.
    function unique(array) {
        return array.filter(function(a) {
            return !this[a] ? this[a] = true : false;
        }, {});
    }
    // Round a value to the closest 'to'.
    function closest(value, to) {
        return Math.round(value / to) * to;
    }
    // Current position of an element relative to the document.
    function offset(elem, orientation) {
        var rect = elem.getBoundingClientRect();
        var doc = elem.ownerDocument;
        var docElem = doc.documentElement;
        var pageOffset = getPageOffset(doc);
        // getBoundingClientRect contains left scroll in Chrome on Android.
        // I haven't found a feature detection that proves this. Worst case
        // scenario on mis-match: the 'tap' feature on horizontal sliders breaks.
        if (/webkit.*Chrome.*Mobile/i.test(navigator.userAgent)) pageOffset.x = 0;
        return orientation ? rect.top + pageOffset.y - docElem.clientTop : rect.left + pageOffset.x - docElem.clientLeft;
    }
    // Checks whether a value is numerical.
    function isNumeric(a) {
        return typeof a === "number" && !isNaN(a) && isFinite(a);
    }
    // Sets a class and removes it after [duration] ms.
    function addClassFor(element, className, duration) {
        if (duration > 0) {
            addClass(element, className);
            setTimeout(function() {
                removeClass(element, className);
            }, duration);
        }
    }
    // Limits a value to 0 - 100
    function limit(a) {
        return Math.max(Math.min(a, 100), 0);
    }
    // Wraps a variable as an array, if it isn't one yet.
    // Note that an input array is returned by reference!
    function asArray(a) {
        return Array.isArray(a) ? a : [
            a
        ];
    }
    // Counts decimals
    function countDecimals(numStr) {
        numStr = String(numStr);
        var pieces = numStr.split(".");
        return pieces.length > 1 ? pieces[1].length : 0;
    }
    // http://youmightnotneedjquery.com/#add_class
    function addClass(el, className) {
        if (el.classList && !/\s/.test(className)) el.classList.add(className);
        else el.className += " " + className;
    }
    // http://youmightnotneedjquery.com/#remove_class
    function removeClass(el, className) {
        if (el.classList && !/\s/.test(className)) el.classList.remove(className);
        else el.className = el.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
    // https://plainjs.com/javascript/attributes/adding-removing-and-testing-for-classes-9/
    function hasClass(el, className) {
        return el.classList ? el.classList.contains(className) : new RegExp("\\b" + className + "\\b").test(el.className);
    }
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY#Notes
    function getPageOffset(doc) {
        var supportPageOffset = window.pageXOffset !== undefined;
        var isCSS1Compat = (doc.compatMode || "") === "CSS1Compat";
        var x = supportPageOffset ? window.pageXOffset : isCSS1Compat ? doc.documentElement.scrollLeft : doc.body.scrollLeft;
        var y = supportPageOffset ? window.pageYOffset : isCSS1Compat ? doc.documentElement.scrollTop : doc.body.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    // we provide a function to compute constants instead
    // of accessing window.* as soon as the module needs it
    // so that we do not compute anything if not needed
    function getActions() {
        // Determine the events to bind. IE11 implements pointerEvents without
        // a prefix, which breaks compatibility with the IE10 implementation.
        return window.navigator.pointerEnabled ? {
            start: "pointerdown",
            move: "pointermove",
            end: "pointerup"
        } : window.navigator.msPointerEnabled ? {
            start: "MSPointerDown",
            move: "MSPointerMove",
            end: "MSPointerUp"
        } : {
            start: "mousedown touchstart",
            move: "mousemove touchmove",
            end: "mouseup touchend"
        };
    }
    // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
    // Issue #785
    function getSupportsPassive() {
        var supportsPassive = false;
        /* eslint-disable */ try {
            var opts = Object.defineProperty({}, "passive", {
                get: function() {
                    supportsPassive = true;
                }
            });
            window.addEventListener("test", null, opts);
        } catch (e) {}
        /* eslint-enable */ return supportsPassive;
    }
    function getSupportsTouchActionNone() {
        return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
    }
    //endregion
    //region Range Calculation
    // Determine the size of a sub-range in relation to a full range.
    function subRangeRatio(pa, pb) {
        return 100 / (pb - pa);
    }
    // (percentage) How many percent is this value of this range?
    function fromPercentage(range, value, startRange) {
        return value * 100 / (range[startRange + 1] - range[startRange]);
    }
    // (percentage) Where is this value on this range?
    function toPercentage(range, value) {
        return fromPercentage(range, range[0] < 0 ? value + Math.abs(range[0]) : value - range[0], 0);
    }
    // (value) How much is this percentage on this range?
    function isPercentage(range, value) {
        return value * (range[1] - range[0]) / 100 + range[0];
    }
    function getJ(value, arr) {
        var j = 1;
        while(value >= arr[j])j += 1;
        return j;
    }
    // (percentage) Input a value, find where, on a scale of 0-100, it applies.
    function toStepping(xVal, xPct, value) {
        if (value >= xVal.slice(-1)[0]) return 100;
        var j = getJ(value, xVal);
        var va = xVal[j - 1];
        var vb = xVal[j];
        var pa = xPct[j - 1];
        var pb = xPct[j];
        return pa + toPercentage([
            va,
            vb
        ], value) / subRangeRatio(pa, pb);
    }
    // (value) Input a percentage, find where it is on the specified range.
    function fromStepping(xVal, xPct, value) {
        // There is no range group that fits 100
        if (value >= 100) return xVal.slice(-1)[0];
        var j = getJ(value, xPct);
        var va = xVal[j - 1];
        var vb = xVal[j];
        var pa = xPct[j - 1];
        var pb = xPct[j];
        return isPercentage([
            va,
            vb
        ], (value - pa) * subRangeRatio(pa, pb));
    }
    // (percentage) Get the step that applies at a certain value.
    function getStep(xPct, xSteps, snap, value) {
        if (value === 100) return value;
        var j = getJ(value, xPct);
        var a = xPct[j - 1];
        var b = xPct[j];
        // If 'snap' is set, steps are used as fixed points on the slider.
        if (snap) {
            // Find the closest position, a or b.
            if (value - a > (b - a) / 2) return b;
            return a;
        }
        if (!xSteps[j - 1]) return value;
        return xPct[j - 1] + closest(value - xPct[j - 1], xSteps[j - 1]);
    }
    function handleEntryPoint(index, value, that) {
        var percentage;
        // Wrap numerical input in an array.
        if (typeof value === "number") value = [
            value
        ];
        // Reject any invalid input, by testing whether value is an array.
        if (!Array.isArray(value)) throw new Error("noUiSlider (" + VERSION + "): 'range' contains invalid value.");
        // Covert min/max syntax to 0 and 100.
        if (index === "min") percentage = 0;
        else if (index === "max") percentage = 100;
        else percentage = parseFloat(index);
        // Check for correct input.
        if (!isNumeric(percentage) || !isNumeric(value[0])) throw new Error("noUiSlider (" + VERSION + "): 'range' value isn't numeric.");
        // Store values.
        that.xPct.push(percentage);
        that.xVal.push(value[0]);
        // NaN will evaluate to false too, but to keep
        // logging clear, set step explicitly. Make sure
        // not to override the 'step' setting with false.
        if (!percentage) {
            if (!isNaN(value[1])) that.xSteps[0] = value[1];
        } else that.xSteps.push(isNaN(value[1]) ? false : value[1]);
        that.xHighestCompleteStep.push(0);
    }
    function handleStepPoint(i, n, that) {
        // Ignore 'false' stepping.
        if (!n) return;
        // Step over zero-length ranges (#948);
        if (that.xVal[i] === that.xVal[i + 1]) {
            that.xSteps[i] = that.xHighestCompleteStep[i] = that.xVal[i];
            return;
        }
        // Factor to range ratio
        that.xSteps[i] = fromPercentage([
            that.xVal[i],
            that.xVal[i + 1]
        ], n, 0) / subRangeRatio(that.xPct[i], that.xPct[i + 1]);
        var totalSteps = (that.xVal[i + 1] - that.xVal[i]) / that.xNumSteps[i];
        var highestStep = Math.ceil(Number(totalSteps.toFixed(3)) - 1);
        var step = that.xVal[i] + that.xNumSteps[i] * highestStep;
        that.xHighestCompleteStep[i] = step;
    }
    //endregion
    //region Spectrum
    function Spectrum(entry, snap, singleStep) {
        this.xPct = [];
        this.xVal = [];
        this.xSteps = [
            singleStep || false
        ];
        this.xNumSteps = [
            false
        ];
        this.xHighestCompleteStep = [];
        this.snap = snap;
        var index;
        var ordered = []; // [0, 'min'], [1, '50%'], [2, 'max']
        // Map the object keys to an array.
        for(index in entry)if (entry.hasOwnProperty(index)) ordered.push([
            entry[index],
            index
        ]);
        // Sort all entries by value (numeric sort).
        if (ordered.length && typeof ordered[0][0] === "object") ordered.sort(function(a, b) {
            return a[0][0] - b[0][0];
        });
        else ordered.sort(function(a, b) {
            return a[0] - b[0];
        });
        // Convert all entries to subranges.
        for(index = 0; index < ordered.length; index++)handleEntryPoint(ordered[index][1], ordered[index][0], this);
        // Store the actual step values.
        // xSteps is sorted in the same order as xPct and xVal.
        this.xNumSteps = this.xSteps.slice(0);
        // Convert all numeric steps to the percentage of the subrange they represent.
        for(index = 0; index < this.xNumSteps.length; index++)handleStepPoint(index, this.xNumSteps[index], this);
    }
    Spectrum.prototype.getDistance = function(value) {
        var index;
        var distances = [];
        for(index = 0; index < this.xNumSteps.length - 1; index++){
            // last "range" can't contain step size as it is purely an endpoint.
            var step = this.xNumSteps[index];
            if (step && value / step % 1 !== 0) throw new Error("noUiSlider (" + VERSION + "): 'limit', 'margin' and 'padding' of " + this.xPct[index] + "% range must be divisible by step.");
            // Calculate percentual distance in current range of limit, margin or padding
            distances[index] = fromPercentage(this.xVal, value, index);
        }
        return distances;
    };
    // Calculate the percentual distance over the whole scale of ranges.
    // direction: 0 = backwards / 1 = forwards
    Spectrum.prototype.getAbsoluteDistance = function(value, distances, direction) {
        var xPct_index = 0;
        // Calculate range where to start calculation
        if (value < this.xPct[this.xPct.length - 1]) while(value > this.xPct[xPct_index + 1])xPct_index++;
        else if (value === this.xPct[this.xPct.length - 1]) xPct_index = this.xPct.length - 2;
        // If looking backwards and the value is exactly at a range separator then look one range further
        if (!direction && value === this.xPct[xPct_index + 1]) xPct_index++;
        var start_factor;
        var rest_factor = 1;
        var rest_rel_distance = distances[xPct_index];
        var range_pct = 0;
        var rel_range_distance = 0;
        var abs_distance_counter = 0;
        var range_counter = 0;
        // Calculate what part of the start range the value is
        if (direction) start_factor = (value - this.xPct[xPct_index]) / (this.xPct[xPct_index + 1] - this.xPct[xPct_index]);
        else start_factor = (this.xPct[xPct_index + 1] - value) / (this.xPct[xPct_index + 1] - this.xPct[xPct_index]);
        // Do until the complete distance across ranges is calculated
        while(rest_rel_distance > 0){
            // Calculate the percentage of total range
            range_pct = this.xPct[xPct_index + 1 + range_counter] - this.xPct[xPct_index + range_counter];
            // Detect if the margin, padding or limit is larger then the current range and calculate
            if (distances[xPct_index + range_counter] * rest_factor + 100 - start_factor * 100 > 100) {
                // If larger then take the percentual distance of the whole range
                rel_range_distance = range_pct * start_factor;
                // Rest factor of relative percentual distance still to be calculated
                rest_factor = (rest_rel_distance - 100 * start_factor) / distances[xPct_index + range_counter];
                // Set start factor to 1 as for next range it does not apply.
                start_factor = 1;
            } else {
                // If smaller or equal then take the percentual distance of the calculate percentual part of that range
                rel_range_distance = distances[xPct_index + range_counter] * range_pct / 100 * rest_factor;
                // No rest left as the rest fits in current range
                rest_factor = 0;
            }
            if (direction) {
                abs_distance_counter = abs_distance_counter - rel_range_distance;
                // Limit range to first range when distance becomes outside of minimum range
                if (this.xPct.length + range_counter >= 1) range_counter--;
            } else {
                abs_distance_counter = abs_distance_counter + rel_range_distance;
                // Limit range to last range when distance becomes outside of maximum range
                if (this.xPct.length - range_counter >= 1) range_counter++;
            }
            // Rest of relative percentual distance still to be calculated
            rest_rel_distance = distances[xPct_index + range_counter] * rest_factor;
        }
        return value + abs_distance_counter;
    };
    Spectrum.prototype.toStepping = function(value) {
        value = toStepping(this.xVal, this.xPct, value);
        return value;
    };
    Spectrum.prototype.fromStepping = function(value) {
        return fromStepping(this.xVal, this.xPct, value);
    };
    Spectrum.prototype.getStep = function(value) {
        value = getStep(this.xPct, this.xSteps, this.snap, value);
        return value;
    };
    Spectrum.prototype.getDefaultStep = function(value, isDown, size) {
        var j = getJ(value, this.xPct);
        // When at the top or stepping down, look at the previous sub-range
        if (value === 100 || isDown && value === this.xPct[j - 1]) j = Math.max(j - 1, 1);
        return (this.xVal[j] - this.xVal[j - 1]) / size;
    };
    Spectrum.prototype.getNearbySteps = function(value) {
        var j = getJ(value, this.xPct);
        return {
            stepBefore: {
                startValue: this.xVal[j - 2],
                step: this.xNumSteps[j - 2],
                highestStep: this.xHighestCompleteStep[j - 2]
            },
            thisStep: {
                startValue: this.xVal[j - 1],
                step: this.xNumSteps[j - 1],
                highestStep: this.xHighestCompleteStep[j - 1]
            },
            stepAfter: {
                startValue: this.xVal[j],
                step: this.xNumSteps[j],
                highestStep: this.xHighestCompleteStep[j]
            }
        };
    };
    Spectrum.prototype.countStepDecimals = function() {
        var stepDecimals = this.xNumSteps.map(countDecimals);
        return Math.max.apply(null, stepDecimals);
    };
    // Outside testing
    Spectrum.prototype.convert = function(value) {
        return this.getStep(this.toStepping(value));
    };
    //endregion
    //region Options
    /*	Every input option is tested and parsed. This'll prevent
        endless validation in internal methods. These tests are
        structured with an item for every option available. An
        option can be marked as required by setting the 'r' flag.
        The testing function is provided with three arguments:
            - The provided value for the option;
            - A reference to the options object;
            - The name for the option;
    
        The testing function returns false when an error is detected,
        or true when everything is OK. It can also modify the option
        object, to make sure all values can be correctly looped elsewhere. */ //region Defaults
    var defaultFormatter = {
        to: function(value) {
            return value !== undefined && value.toFixed(2);
        },
        from: Number
    };
    var cssClasses = {
        target: "target",
        base: "base",
        origin: "origin",
        handle: "handle",
        handleLower: "handle-lower",
        handleUpper: "handle-upper",
        touchArea: "touch-area",
        horizontal: "horizontal",
        vertical: "vertical",
        background: "background",
        connect: "connect",
        connects: "connects",
        ltr: "ltr",
        rtl: "rtl",
        textDirectionLtr: "txt-dir-ltr",
        textDirectionRtl: "txt-dir-rtl",
        draggable: "draggable",
        drag: "state-drag",
        tap: "state-tap",
        active: "active",
        tooltip: "tooltip",
        pips: "pips",
        pipsHorizontal: "pips-horizontal",
        pipsVertical: "pips-vertical",
        marker: "marker",
        markerHorizontal: "marker-horizontal",
        markerVertical: "marker-vertical",
        markerNormal: "marker-normal",
        markerLarge: "marker-large",
        markerSub: "marker-sub",
        value: "value",
        valueHorizontal: "value-horizontal",
        valueVertical: "value-vertical",
        valueNormal: "value-normal",
        valueLarge: "value-large",
        valueSub: "value-sub"
    };
    // Namespaces of internal event listeners
    var INTERNAL_EVENT_NS = {
        tooltips: ".__tooltips",
        aria: ".__aria"
    };
    //endregion
    function validateFormat(entry) {
        // Any object with a to and from method is supported.
        if (isValidFormatter(entry)) return true;
        throw new Error("noUiSlider (" + VERSION + "): 'format' requires 'to' and 'from' methods.");
    }
    function testStep(parsed, entry) {
        if (!isNumeric(entry)) throw new Error("noUiSlider (" + VERSION + "): 'step' is not numeric.");
        // The step option can still be used to set stepping
        // for linear sliders. Overwritten if set in 'range'.
        parsed.singleStep = entry;
    }
    function testKeyboardPageMultiplier(parsed, entry) {
        if (!isNumeric(entry)) throw new Error("noUiSlider (" + VERSION + "): 'keyboardPageMultiplier' is not numeric.");
        parsed.keyboardPageMultiplier = entry;
    }
    function testKeyboardDefaultStep(parsed, entry) {
        if (!isNumeric(entry)) throw new Error("noUiSlider (" + VERSION + "): 'keyboardDefaultStep' is not numeric.");
        parsed.keyboardDefaultStep = entry;
    }
    function testRange(parsed, entry) {
        // Filter incorrect input.
        if (typeof entry !== "object" || Array.isArray(entry)) throw new Error("noUiSlider (" + VERSION + "): 'range' is not an object.");
        // Catch missing start or end.
        if (entry.min === undefined || entry.max === undefined) throw new Error("noUiSlider (" + VERSION + "): Missing 'min' or 'max' in 'range'.");
        // Catch equal start or end.
        if (entry.min === entry.max) throw new Error("noUiSlider (" + VERSION + "): 'range' 'min' and 'max' cannot be equal.");
        parsed.spectrum = new Spectrum(entry, parsed.snap, parsed.singleStep);
    }
    function testStart(parsed, entry) {
        entry = asArray(entry);
        // Validate input. Values aren't tested, as the public .val method
        // will always provide a valid location.
        if (!Array.isArray(entry) || !entry.length) throw new Error("noUiSlider (" + VERSION + "): 'start' option is incorrect.");
        // Store the number of handles.
        parsed.handles = entry.length;
        // When the slider is initialized, the .val method will
        // be called with the start options.
        parsed.start = entry;
    }
    function testSnap(parsed, entry) {
        // Enforce 100% stepping within subranges.
        parsed.snap = entry;
        if (typeof entry !== "boolean") throw new Error("noUiSlider (" + VERSION + "): 'snap' option must be a boolean.");
    }
    function testAnimate(parsed, entry) {
        // Enforce 100% stepping within subranges.
        parsed.animate = entry;
        if (typeof entry !== "boolean") throw new Error("noUiSlider (" + VERSION + "): 'animate' option must be a boolean.");
    }
    function testAnimationDuration(parsed, entry) {
        parsed.animationDuration = entry;
        if (typeof entry !== "number") throw new Error("noUiSlider (" + VERSION + "): 'animationDuration' option must be a number.");
    }
    function testConnect(parsed, entry) {
        var connect = [
            false
        ];
        var i;
        // Map legacy options
        if (entry === "lower") entry = [
            true,
            false
        ];
        else if (entry === "upper") entry = [
            false,
            true
        ];
        // Handle boolean options
        if (entry === true || entry === false) {
            for(i = 1; i < parsed.handles; i++)connect.push(entry);
            connect.push(false);
        } else if (!Array.isArray(entry) || !entry.length || entry.length !== parsed.handles + 1) throw new Error("noUiSlider (" + VERSION + "): 'connect' option doesn't match handle count.");
        else connect = entry;
        parsed.connect = connect;
    }
    function testOrientation(parsed, entry) {
        // Set orientation to an a numerical value for easy
        // array selection.
        switch(entry){
            case "horizontal":
                parsed.ort = 0;
                break;
            case "vertical":
                parsed.ort = 1;
                break;
            default:
                throw new Error("noUiSlider (" + VERSION + "): 'orientation' option is invalid.");
        }
    }
    function testMargin(parsed, entry) {
        if (!isNumeric(entry)) throw new Error("noUiSlider (" + VERSION + "): 'margin' option must be numeric.");
        // Issue #582
        if (entry === 0) return;
        parsed.margin = parsed.spectrum.getDistance(entry);
    }
    function testLimit(parsed, entry) {
        if (!isNumeric(entry)) throw new Error("noUiSlider (" + VERSION + "): 'limit' option must be numeric.");
        parsed.limit = parsed.spectrum.getDistance(entry);
        if (!parsed.limit || parsed.handles < 2) throw new Error("noUiSlider (" + VERSION + "): 'limit' option is only supported on linear sliders with 2 or more handles.");
    }
    function testPadding(parsed, entry) {
        var index;
        if (!isNumeric(entry) && !Array.isArray(entry)) throw new Error("noUiSlider (" + VERSION + "): 'padding' option must be numeric or array of exactly 2 numbers.");
        if (Array.isArray(entry) && !(entry.length === 2 || isNumeric(entry[0]) || isNumeric(entry[1]))) throw new Error("noUiSlider (" + VERSION + "): 'padding' option must be numeric or array of exactly 2 numbers.");
        if (entry === 0) return;
        if (!Array.isArray(entry)) entry = [
            entry,
            entry
        ];
        // 'getDistance' returns false for invalid values.
        parsed.padding = [
            parsed.spectrum.getDistance(entry[0]),
            parsed.spectrum.getDistance(entry[1])
        ];
        for(index = 0; index < parsed.spectrum.xNumSteps.length - 1; index++){
            // last "range" can't contain step size as it is purely an endpoint.
            if (parsed.padding[0][index] < 0 || parsed.padding[1][index] < 0) throw new Error("noUiSlider (" + VERSION + "): 'padding' option must be a positive number(s).");
        }
        var totalPadding = entry[0] + entry[1];
        var firstValue = parsed.spectrum.xVal[0];
        var lastValue = parsed.spectrum.xVal[parsed.spectrum.xVal.length - 1];
        if (totalPadding / (lastValue - firstValue) > 1) throw new Error("noUiSlider (" + VERSION + "): 'padding' option must not exceed 100% of the range.");
    }
    function testDirection(parsed, entry) {
        // Set direction as a numerical value for easy parsing.
        // Invert connection for RTL sliders, so that the proper
        // handles get the connect/background classes.
        switch(entry){
            case "ltr":
                parsed.dir = 0;
                break;
            case "rtl":
                parsed.dir = 1;
                break;
            default:
                throw new Error("noUiSlider (" + VERSION + "): 'direction' option was not recognized.");
        }
    }
    function testBehaviour(parsed, entry) {
        // Make sure the input is a string.
        if (typeof entry !== "string") throw new Error("noUiSlider (" + VERSION + "): 'behaviour' must be a string containing options.");
        // Check if the string contains any keywords.
        // None are required.
        var tap = entry.indexOf("tap") >= 0;
        var drag = entry.indexOf("drag") >= 0;
        var fixed = entry.indexOf("fixed") >= 0;
        var snap = entry.indexOf("snap") >= 0;
        var hover = entry.indexOf("hover") >= 0;
        var unconstrained = entry.indexOf("unconstrained") >= 0;
        if (fixed) {
            if (parsed.handles !== 2) throw new Error("noUiSlider (" + VERSION + "): 'fixed' behaviour must be used with 2 handles");
            // Use margin to enforce fixed state
            testMargin(parsed, parsed.start[1] - parsed.start[0]);
        }
        if (unconstrained && (parsed.margin || parsed.limit)) throw new Error("noUiSlider (" + VERSION + "): 'unconstrained' behaviour cannot be used with margin or limit");
        parsed.events = {
            tap: tap || snap,
            drag: drag,
            fixed: fixed,
            snap: snap,
            hover: hover,
            unconstrained: unconstrained
        };
    }
    function testTooltips(parsed, entry) {
        if (entry === false) return;
        if (entry === true) {
            parsed.tooltips = [];
            for(var i = 0; i < parsed.handles; i++)parsed.tooltips.push(true);
        } else {
            parsed.tooltips = asArray(entry);
            if (parsed.tooltips.length !== parsed.handles) throw new Error("noUiSlider (" + VERSION + "): must pass a formatter for all handles.");
            parsed.tooltips.forEach(function(formatter) {
                if (typeof formatter !== "boolean" && (typeof formatter !== "object" || typeof formatter.to !== "function")) throw new Error("noUiSlider (" + VERSION + "): 'tooltips' must be passed a formatter or 'false'.");
            });
        }
    }
    function testAriaFormat(parsed, entry) {
        parsed.ariaFormat = entry;
        validateFormat(entry);
    }
    function testFormat(parsed, entry) {
        parsed.format = entry;
        validateFormat(entry);
    }
    function testKeyboardSupport(parsed, entry) {
        parsed.keyboardSupport = entry;
        if (typeof entry !== "boolean") throw new Error("noUiSlider (" + VERSION + "): 'keyboardSupport' option must be a boolean.");
    }
    function testDocumentElement(parsed, entry) {
        // This is an advanced option. Passed values are used without validation.
        parsed.documentElement = entry;
    }
    function testCssPrefix(parsed, entry) {
        if (typeof entry !== "string" && entry !== false) throw new Error("noUiSlider (" + VERSION + "): 'cssPrefix' must be a string or `false`.");
        parsed.cssPrefix = entry;
    }
    function testCssClasses(parsed, entry) {
        if (typeof entry !== "object") throw new Error("noUiSlider (" + VERSION + "): 'cssClasses' must be an object.");
        if (typeof parsed.cssPrefix === "string") {
            parsed.cssClasses = {};
            for(var key in entry){
                if (!entry.hasOwnProperty(key)) continue;
                parsed.cssClasses[key] = parsed.cssPrefix + entry[key];
            }
        } else parsed.cssClasses = entry;
    }
    // Test all developer settings and parse to assumption-safe values.
    function testOptions(options) {
        // To prove a fix for #537, freeze options here.
        // If the object is modified, an error will be thrown.
        // Object.freeze(options);
        var parsed = {
            margin: 0,
            limit: 0,
            padding: 0,
            animate: true,
            animationDuration: 300,
            ariaFormat: defaultFormatter,
            format: defaultFormatter
        };
        // Tests are executed in the order they are presented here.
        var tests = {
            step: {
                r: false,
                t: testStep
            },
            keyboardPageMultiplier: {
                r: false,
                t: testKeyboardPageMultiplier
            },
            keyboardDefaultStep: {
                r: false,
                t: testKeyboardDefaultStep
            },
            start: {
                r: true,
                t: testStart
            },
            connect: {
                r: true,
                t: testConnect
            },
            direction: {
                r: true,
                t: testDirection
            },
            snap: {
                r: false,
                t: testSnap
            },
            animate: {
                r: false,
                t: testAnimate
            },
            animationDuration: {
                r: false,
                t: testAnimationDuration
            },
            range: {
                r: true,
                t: testRange
            },
            orientation: {
                r: false,
                t: testOrientation
            },
            margin: {
                r: false,
                t: testMargin
            },
            limit: {
                r: false,
                t: testLimit
            },
            padding: {
                r: false,
                t: testPadding
            },
            behaviour: {
                r: true,
                t: testBehaviour
            },
            ariaFormat: {
                r: false,
                t: testAriaFormat
            },
            format: {
                r: false,
                t: testFormat
            },
            tooltips: {
                r: false,
                t: testTooltips
            },
            keyboardSupport: {
                r: true,
                t: testKeyboardSupport
            },
            documentElement: {
                r: false,
                t: testDocumentElement
            },
            cssPrefix: {
                r: true,
                t: testCssPrefix
            },
            cssClasses: {
                r: true,
                t: testCssClasses
            }
        };
        var defaults = {
            connect: false,
            direction: "ltr",
            behaviour: "tap",
            orientation: "horizontal",
            keyboardSupport: true,
            cssPrefix: "noUi-",
            cssClasses: cssClasses,
            keyboardPageMultiplier: 5,
            keyboardDefaultStep: 10
        };
        // AriaFormat defaults to regular format, if any.
        if (options.format && !options.ariaFormat) options.ariaFormat = options.format;
        // Run all options through a testing mechanism to ensure correct
        // input. It should be noted that options might get modified to
        // be handled properly. E.g. wrapping integers in arrays.
        Object.keys(tests).forEach(function(name) {
            // If the option isn't set, but it is required, throw an error.
            if (!isSet(options[name]) && defaults[name] === undefined) {
                if (tests[name].r) throw new Error("noUiSlider (" + VERSION + "): '" + name + "' is required.");
                return true;
            }
            tests[name].t(parsed, !isSet(options[name]) ? defaults[name] : options[name]);
        });
        // Forward pips options
        parsed.pips = options.pips;
        // All recent browsers accept unprefixed transform.
        // We need -ms- for IE9 and -webkit- for older Android;
        // Assume use of -webkit- if unprefixed and -ms- are not supported.
        // https://caniuse.com/#feat=transforms2d
        var d = document.createElement("div");
        var msPrefix = d.style.msTransform !== undefined;
        var noPrefix = d.style.transform !== undefined;
        parsed.transformRule = noPrefix ? "transform" : msPrefix ? "msTransform" : "webkitTransform";
        // Pips don't move, so we can place them using left/top.
        var styles = [
            [
                "left",
                "top"
            ],
            [
                "right",
                "bottom"
            ]
        ];
        parsed.style = styles[parsed.dir][parsed.ort];
        return parsed;
    }
    //endregion
    function scope(target, options, originalOptions) {
        var actions = getActions();
        var supportsTouchActionNone = getSupportsTouchActionNone();
        var supportsPassive = supportsTouchActionNone && getSupportsPassive();
        // All variables local to 'scope' are prefixed with 'scope_'
        // Slider DOM Nodes
        var scope_Target = target;
        var scope_Base;
        var scope_Handles;
        var scope_Connects;
        var scope_Pips;
        var scope_Tooltips;
        // Slider state values
        var scope_Spectrum = options.spectrum;
        var scope_Values = [];
        var scope_Locations = [];
        var scope_HandleNumbers = [];
        var scope_ActiveHandlesCount = 0;
        var scope_Events = {};
        // Exposed API
        var scope_Self;
        // Document Nodes
        var scope_Document = target.ownerDocument;
        var scope_DocumentElement = options.documentElement || scope_Document.documentElement;
        var scope_Body = scope_Document.body;
        // Pips constants
        var PIPS_NONE = -1;
        var PIPS_NO_VALUE = 0;
        var PIPS_LARGE_VALUE = 1;
        var PIPS_SMALL_VALUE = 2;
        // For horizontal sliders in standard ltr documents,
        // make .noUi-origin overflow to the left so the document doesn't scroll.
        var scope_DirOffset = scope_Document.dir === "rtl" || options.ort === 1 ? 0 : 100;
        // Creates a node, adds it to target, returns the new node.
        function addNodeTo(addTarget, className) {
            var div = scope_Document.createElement("div");
            if (className) addClass(div, className);
            addTarget.appendChild(div);
            return div;
        }
        // Append a origin to the base
        function addOrigin(base, handleNumber) {
            var origin = addNodeTo(base, options.cssClasses.origin);
            var handle = addNodeTo(origin, options.cssClasses.handle);
            addNodeTo(handle, options.cssClasses.touchArea);
            handle.setAttribute("data-handle", handleNumber);
            if (options.keyboardSupport) {
                // https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex
                // 0 = focusable and reachable
                handle.setAttribute("tabindex", "0");
                handle.addEventListener("keydown", function(event) {
                    return eventKeydown(event, handleNumber);
                });
            }
            handle.setAttribute("role", "slider");
            handle.setAttribute("aria-orientation", options.ort ? "vertical" : "horizontal");
            if (handleNumber === 0) addClass(handle, options.cssClasses.handleLower);
            else if (handleNumber === options.handles - 1) addClass(handle, options.cssClasses.handleUpper);
            return origin;
        }
        // Insert nodes for connect elements
        function addConnect(base, add) {
            if (!add) return false;
            return addNodeTo(base, options.cssClasses.connect);
        }
        // Add handles to the slider base.
        function addElements(connectOptions, base) {
            var connectBase = addNodeTo(base, options.cssClasses.connects);
            scope_Handles = [];
            scope_Connects = [];
            scope_Connects.push(addConnect(connectBase, connectOptions[0]));
            // [::::O====O====O====]
            // connectOptions = [0, 1, 1, 1]
            for(var i = 0; i < options.handles; i++){
                // Keep a list of all added handles.
                scope_Handles.push(addOrigin(base, i));
                scope_HandleNumbers[i] = i;
                scope_Connects.push(addConnect(connectBase, connectOptions[i + 1]));
            }
        }
        // Initialize a single slider.
        function addSlider(addTarget) {
            // Apply classes and data to the target.
            addClass(addTarget, options.cssClasses.target);
            if (options.dir === 0) addClass(addTarget, options.cssClasses.ltr);
            else addClass(addTarget, options.cssClasses.rtl);
            if (options.ort === 0) addClass(addTarget, options.cssClasses.horizontal);
            else addClass(addTarget, options.cssClasses.vertical);
            var textDirection = getComputedStyle(addTarget).direction;
            if (textDirection === "rtl") addClass(addTarget, options.cssClasses.textDirectionRtl);
            else addClass(addTarget, options.cssClasses.textDirectionLtr);
            return addNodeTo(addTarget, options.cssClasses.base);
        }
        function addTooltip(handle, handleNumber) {
            if (!options.tooltips[handleNumber]) return false;
            return addNodeTo(handle.firstChild, options.cssClasses.tooltip);
        }
        function isSliderDisabled() {
            return scope_Target.hasAttribute("disabled");
        }
        // Disable the slider dragging if any handle is disabled
        function isHandleDisabled(handleNumber) {
            var handleOrigin = scope_Handles[handleNumber];
            return handleOrigin.hasAttribute("disabled");
        }
        function removeTooltips() {
            if (scope_Tooltips) {
                removeEvent("update" + INTERNAL_EVENT_NS.tooltips);
                scope_Tooltips.forEach(function(tooltip) {
                    if (tooltip) removeElement(tooltip);
                });
                scope_Tooltips = null;
            }
        }
        // The tooltips option is a shorthand for using the 'update' event.
        function tooltips() {
            removeTooltips();
            // Tooltips are added with options.tooltips in original order.
            scope_Tooltips = scope_Handles.map(addTooltip);
            bindEvent("update" + INTERNAL_EVENT_NS.tooltips, function(values, handleNumber, unencoded) {
                if (!scope_Tooltips[handleNumber]) return;
                var formattedValue = values[handleNumber];
                if (options.tooltips[handleNumber] !== true) formattedValue = options.tooltips[handleNumber].to(unencoded[handleNumber]);
                scope_Tooltips[handleNumber].innerHTML = formattedValue;
            });
        }
        function aria() {
            removeEvent("update" + INTERNAL_EVENT_NS.aria);
            bindEvent("update" + INTERNAL_EVENT_NS.aria, function(values, handleNumber, unencoded, tap, positions) {
                // Update Aria Values for all handles, as a change in one changes min and max values for the next.
                scope_HandleNumbers.forEach(function(index) {
                    var handle = scope_Handles[index];
                    var min = checkHandlePosition(scope_Locations, index, 0, true, true, true);
                    var max = checkHandlePosition(scope_Locations, index, 100, true, true, true);
                    var now = positions[index];
                    // Formatted value for display
                    var text = options.ariaFormat.to(unencoded[index]);
                    // Map to slider range values
                    min = scope_Spectrum.fromStepping(min).toFixed(1);
                    max = scope_Spectrum.fromStepping(max).toFixed(1);
                    now = scope_Spectrum.fromStepping(now).toFixed(1);
                    handle.children[0].setAttribute("aria-valuemin", min);
                    handle.children[0].setAttribute("aria-valuemax", max);
                    handle.children[0].setAttribute("aria-valuenow", now);
                    handle.children[0].setAttribute("aria-valuetext", text);
                });
            });
        }
        function getGroup(mode, values, stepped) {
            // Use the range.
            if (mode === "range" || mode === "steps") return scope_Spectrum.xVal;
            if (mode === "count") {
                if (values < 2) throw new Error("noUiSlider (" + VERSION + "): 'values' (>= 2) required for mode 'count'.");
                // Divide 0 - 100 in 'count' parts.
                var interval = values - 1;
                var spread = 100 / interval;
                values = [];
                // List these parts and have them handled as 'positions'.
                while(interval--)values[interval] = interval * spread;
                values.push(100);
                mode = "positions";
            }
            if (mode === "positions") // Map all percentages to on-range values.
            return values.map(function(value) {
                return scope_Spectrum.fromStepping(stepped ? scope_Spectrum.getStep(value) : value);
            });
            if (mode === "values") {
                // If the value must be stepped, it needs to be converted to a percentage first.
                if (stepped) return values.map(function(value) {
                    // Convert to percentage, apply step, return to value.
                    return scope_Spectrum.fromStepping(scope_Spectrum.getStep(scope_Spectrum.toStepping(value)));
                });
                // Otherwise, we can simply use the values.
                return values;
            }
        }
        function generateSpread(density, mode, group) {
            function safeIncrement(value, increment) {
                // Avoid floating point variance by dropping the smallest decimal places.
                return (value + increment).toFixed(7) / 1;
            }
            var indexes = {};
            var firstInRange = scope_Spectrum.xVal[0];
            var lastInRange = scope_Spectrum.xVal[scope_Spectrum.xVal.length - 1];
            var ignoreFirst = false;
            var ignoreLast = false;
            var prevPct = 0;
            // Create a copy of the group, sort it and filter away all duplicates.
            group = unique(group.slice().sort(function(a, b) {
                return a - b;
            }));
            // Make sure the range starts with the first element.
            if (group[0] !== firstInRange) {
                group.unshift(firstInRange);
                ignoreFirst = true;
            }
            // Likewise for the last one.
            if (group[group.length - 1] !== lastInRange) {
                group.push(lastInRange);
                ignoreLast = true;
            }
            group.forEach(function(current, index) {
                // Get the current step and the lower + upper positions.
                var step;
                var i;
                var q;
                var low = current;
                var high = group[index + 1];
                var newPct;
                var pctDifference;
                var pctPos;
                var type;
                var steps;
                var realSteps;
                var stepSize;
                var isSteps = mode === "steps";
                // When using 'steps' mode, use the provided steps.
                // Otherwise, we'll step on to the next subrange.
                if (isSteps) step = scope_Spectrum.xNumSteps[index];
                // Default to a 'full' step.
                if (!step) step = high - low;
                // Low can be 0, so test for false. Index 0 is already handled.
                if (low === false) return;
                // If high is undefined we are at the last subrange. Make sure it iterates once (#1088)
                if (high === undefined) high = low;
                // Make sure step isn't 0, which would cause an infinite loop (#654)
                step = Math.max(step, 0.0000001);
                // Find all steps in the subrange.
                for(i = low; i <= high; i = safeIncrement(i, step)){
                    // Get the percentage value for the current step,
                    // calculate the size for the subrange.
                    newPct = scope_Spectrum.toStepping(i);
                    pctDifference = newPct - prevPct;
                    steps = pctDifference / density;
                    realSteps = Math.round(steps);
                    // This ratio represents the amount of percentage-space a point indicates.
                    // For a density 1 the points/percentage = 1. For density 2, that percentage needs to be re-divided.
                    // Round the percentage offset to an even number, then divide by two
                    // to spread the offset on both sides of the range.
                    stepSize = pctDifference / realSteps;
                    // Divide all points evenly, adding the correct number to this subrange.
                    // Run up to <= so that 100% gets a point, event if ignoreLast is set.
                    for(q = 1; q <= realSteps; q += 1){
                        // The ratio between the rounded value and the actual size might be ~1% off.
                        // Correct the percentage offset by the number of points
                        // per subrange. density = 1 will result in 100 points on the
                        // full range, 2 for 50, 4 for 25, etc.
                        pctPos = prevPct + q * stepSize;
                        indexes[pctPos.toFixed(5)] = [
                            scope_Spectrum.fromStepping(pctPos),
                            0
                        ];
                    }
                    // Determine the point type.
                    type = group.indexOf(i) > -1 ? PIPS_LARGE_VALUE : isSteps ? PIPS_SMALL_VALUE : PIPS_NO_VALUE;
                    // Enforce the 'ignoreFirst' option by overwriting the type for 0.
                    if (!index && ignoreFirst && i !== high) type = 0;
                    if (!(i === high && ignoreLast)) // Mark the 'type' of this point. 0 = plain, 1 = real value, 2 = step value.
                    indexes[newPct.toFixed(5)] = [
                        i,
                        type
                    ];
                    // Update the percentage count.
                    prevPct = newPct;
                }
            });
            return indexes;
        }
        function addMarking(spread, filterFunc, formatter) {
            var element = scope_Document.createElement("div");
            var valueSizeClasses = [];
            valueSizeClasses[PIPS_NO_VALUE] = options.cssClasses.valueNormal;
            valueSizeClasses[PIPS_LARGE_VALUE] = options.cssClasses.valueLarge;
            valueSizeClasses[PIPS_SMALL_VALUE] = options.cssClasses.valueSub;
            var markerSizeClasses = [];
            markerSizeClasses[PIPS_NO_VALUE] = options.cssClasses.markerNormal;
            markerSizeClasses[PIPS_LARGE_VALUE] = options.cssClasses.markerLarge;
            markerSizeClasses[PIPS_SMALL_VALUE] = options.cssClasses.markerSub;
            var valueOrientationClasses = [
                options.cssClasses.valueHorizontal,
                options.cssClasses.valueVertical
            ];
            var markerOrientationClasses = [
                options.cssClasses.markerHorizontal,
                options.cssClasses.markerVertical
            ];
            addClass(element, options.cssClasses.pips);
            addClass(element, options.ort === 0 ? options.cssClasses.pipsHorizontal : options.cssClasses.pipsVertical);
            function getClasses(type, source) {
                var a = source === options.cssClasses.value;
                var orientationClasses = a ? valueOrientationClasses : markerOrientationClasses;
                var sizeClasses = a ? valueSizeClasses : markerSizeClasses;
                return source + " " + orientationClasses[options.ort] + " " + sizeClasses[type];
            }
            function addSpread(offset, value, type) {
                // Apply the filter function, if it is set.
                type = filterFunc ? filterFunc(value, type) : type;
                if (type === PIPS_NONE) return;
                // Add a marker for every point
                var node = addNodeTo(element, false);
                node.className = getClasses(type, options.cssClasses.marker);
                node.style[options.style] = offset + "%";
                // Values are only appended for points marked '1' or '2'.
                if (type > PIPS_NO_VALUE) {
                    node = addNodeTo(element, false);
                    node.className = getClasses(type, options.cssClasses.value);
                    node.setAttribute("data-value", value);
                    node.style[options.style] = offset + "%";
                    node.innerHTML = formatter.to(value);
                }
            }
            // Append all points.
            Object.keys(spread).forEach(function(offset) {
                addSpread(offset, spread[offset][0], spread[offset][1]);
            });
            return element;
        }
        function removePips() {
            if (scope_Pips) {
                removeElement(scope_Pips);
                scope_Pips = null;
            }
        }
        function pips(grid) {
            // Fix #669
            removePips();
            var mode = grid.mode;
            var density = grid.density || 1;
            var filter = grid.filter || false;
            var values = grid.values || false;
            var stepped = grid.stepped || false;
            var group = getGroup(mode, values, stepped);
            var spread = generateSpread(density, mode, group);
            var format = grid.format || {
                to: Math.round
            };
            scope_Pips = scope_Target.appendChild(addMarking(spread, filter, format));
            return scope_Pips;
        }
        // Shorthand for base dimensions.
        function baseSize() {
            var rect = scope_Base.getBoundingClientRect();
            var alt = "offset" + [
                "Width",
                "Height"
            ][options.ort];
            return options.ort === 0 ? rect.width || scope_Base[alt] : rect.height || scope_Base[alt];
        }
        // Handler for attaching events trough a proxy.
        function attachEvent(events, element, callback, data) {
            // This function can be used to 'filter' events to the slider.
            // element is a node, not a nodeList
            var method = function(e) {
                e = fixEvent(e, data.pageOffset, data.target || element);
                // fixEvent returns false if this event has a different target
                // when handling (multi-) touch events;
                if (!e) return false;
                // doNotReject is passed by all end events to make sure released touches
                // are not rejected, leaving the slider "stuck" to the cursor;
                if (isSliderDisabled() && !data.doNotReject) return false;
                // Stop if an active 'tap' transition is taking place.
                if (hasClass(scope_Target, options.cssClasses.tap) && !data.doNotReject) return false;
                // Ignore right or middle clicks on start #454
                if (events === actions.start && e.buttons !== undefined && e.buttons > 1) return false;
                // Ignore right or middle clicks on start #454
                if (data.hover && e.buttons) return false;
                // 'supportsPassive' is only true if a browser also supports touch-action: none in CSS.
                // iOS safari does not, so it doesn't get to benefit from passive scrolling. iOS does support
                // touch-action: manipulation, but that allows panning, which breaks
                // sliders after zooming/on non-responsive pages.
                // See: https://bugs.webkit.org/show_bug.cgi?id=133112
                if (!supportsPassive) e.preventDefault();
                e.calcPoint = e.points[options.ort];
                // Call the event handler with the event [ and additional data ].
                callback(e, data);
            };
            var methods = [];
            // Bind a closure on the target for every event type.
            events.split(" ").forEach(function(eventName) {
                element.addEventListener(eventName, method, supportsPassive ? {
                    passive: true
                } : false);
                methods.push([
                    eventName,
                    method
                ]);
            });
            return methods;
        }
        // Provide a clean event with standardized offset values.
        function fixEvent(e, pageOffset, eventTarget) {
            // Filter the event to register the type, which can be
            // touch, mouse or pointer. Offset changes need to be
            // made on an event specific basis.
            var touch = e.type.indexOf("touch") === 0;
            var mouse = e.type.indexOf("mouse") === 0;
            var pointer = e.type.indexOf("pointer") === 0;
            var x;
            var y;
            // IE10 implemented pointer events with a prefix;
            if (e.type.indexOf("MSPointer") === 0) pointer = true;
            // Erroneous events seem to be passed in occasionally on iOS/iPadOS after user finishes interacting with
            // the slider. They appear to be of type MouseEvent, yet they don't have usual properties set. Ignore
            // events that have no touches or buttons associated with them. (#1057, #1079, #1095)
            if (e.type === "mousedown" && !e.buttons && !e.touches) return false;
            // The only thing one handle should be concerned about is the touches that originated on top of it.
            if (touch) {
                // Returns true if a touch originated on the target.
                var isTouchOnTarget = function(checkTouch) {
                    return checkTouch.target === eventTarget || eventTarget.contains(checkTouch.target) || checkTouch.target.shadowRoot && checkTouch.target.shadowRoot.contains(eventTarget);
                };
                // In the case of touchstart events, we need to make sure there is still no more than one
                // touch on the target so we look amongst all touches.
                if (e.type === "touchstart") {
                    var targetTouches = Array.prototype.filter.call(e.touches, isTouchOnTarget);
                    // Do not support more than one touch per handle.
                    if (targetTouches.length > 1) return false;
                    x = targetTouches[0].pageX;
                    y = targetTouches[0].pageY;
                } else {
                    // In the other cases, find on changedTouches is enough.
                    var targetTouch = Array.prototype.find.call(e.changedTouches, isTouchOnTarget);
                    // Cancel if the target touch has not moved.
                    if (!targetTouch) return false;
                    x = targetTouch.pageX;
                    y = targetTouch.pageY;
                }
            }
            pageOffset = pageOffset || getPageOffset(scope_Document);
            if (mouse || pointer) {
                x = e.clientX + pageOffset.x;
                y = e.clientY + pageOffset.y;
            }
            e.pageOffset = pageOffset;
            e.points = [
                x,
                y
            ];
            e.cursor = mouse || pointer; // Fix #435
            return e;
        }
        // Translate a coordinate in the document to a percentage on the slider
        function calcPointToPercentage(calcPoint) {
            var location = calcPoint - offset(scope_Base, options.ort);
            var proposal = location * 100 / baseSize();
            // Clamp proposal between 0% and 100%
            // Out-of-bound coordinates may occur when .noUi-base pseudo-elements
            // are used (e.g. contained handles feature)
            proposal = limit(proposal);
            return options.dir ? 100 - proposal : proposal;
        }
        // Find handle closest to a certain percentage on the slider
        function getClosestHandle(clickedPosition) {
            var smallestDifference = 100;
            var handleNumber = false;
            scope_Handles.forEach(function(handle, index) {
                // Disabled handles are ignored
                if (isHandleDisabled(index)) return;
                var handlePosition = scope_Locations[index];
                var differenceWithThisHandle = Math.abs(handlePosition - clickedPosition);
                // Initial state
                var clickAtEdge = differenceWithThisHandle === 100 && smallestDifference === 100;
                // Difference with this handle is smaller than the previously checked handle
                var isCloser = differenceWithThisHandle < smallestDifference;
                var isCloserAfter = differenceWithThisHandle <= smallestDifference && clickedPosition > handlePosition;
                if (isCloser || isCloserAfter || clickAtEdge) {
                    handleNumber = index;
                    smallestDifference = differenceWithThisHandle;
                }
            });
            return handleNumber;
        }
        // Fire 'end' when a mouse or pen leaves the document.
        function documentLeave(event, data) {
            if (event.type === "mouseout" && event.target.nodeName === "HTML" && event.relatedTarget === null) eventEnd(event, data);
        }
        // Handle movement on document for handle and range drag.
        function eventMove(event, data) {
            // Fix #498
            // Check value of .buttons in 'start' to work around a bug in IE10 mobile (data.buttonsProperty).
            // https://connect.microsoft.com/IE/feedback/details/927005/mobile-ie10-windows-phone-buttons-property-of-pointermove-event-always-zero
            // IE9 has .buttons and .which zero on mousemove.
            // Firefox breaks the spec MDN defines.
            if (navigator.appVersion.indexOf("MSIE 9") === -1 && event.buttons === 0 && data.buttonsProperty !== 0) return eventEnd(event, data);
            // Check if we are moving up or down
            var movement = (options.dir ? -1 : 1) * (event.calcPoint - data.startCalcPoint);
            // Convert the movement into a percentage of the slider width/height
            var proposal = movement * 100 / data.baseSize;
            moveHandles(movement > 0, proposal, data.locations, data.handleNumbers);
        }
        // Unbind move events on document, call callbacks.
        function eventEnd(event, data) {
            // The handle is no longer active, so remove the class.
            if (data.handle) {
                removeClass(data.handle, options.cssClasses.active);
                scope_ActiveHandlesCount -= 1;
            }
            // Unbind the move and end events, which are added on 'start'.
            data.listeners.forEach(function(c) {
                scope_DocumentElement.removeEventListener(c[0], c[1]);
            });
            if (scope_ActiveHandlesCount === 0) {
                // Remove dragging class.
                removeClass(scope_Target, options.cssClasses.drag);
                setZindex();
                // Remove cursor styles and text-selection events bound to the body.
                if (event.cursor) {
                    scope_Body.style.cursor = "";
                    scope_Body.removeEventListener("selectstart", preventDefault);
                }
            }
            data.handleNumbers.forEach(function(handleNumber) {
                fireEvent("change", handleNumber);
                fireEvent("set", handleNumber);
                fireEvent("end", handleNumber);
            });
        }
        // Bind move events on document.
        function eventStart(event, data) {
            // Ignore event if any handle is disabled
            if (data.handleNumbers.some(isHandleDisabled)) return false;
            var handle;
            if (data.handleNumbers.length === 1) {
                var handleOrigin = scope_Handles[data.handleNumbers[0]];
                handle = handleOrigin.children[0];
                scope_ActiveHandlesCount += 1;
                // Mark the handle as 'active' so it can be styled.
                addClass(handle, options.cssClasses.active);
            }
            // A drag should never propagate up to the 'tap' event.
            event.stopPropagation();
            // Record the event listeners.
            var listeners = [];
            // Attach the move and end events.
            var moveEvent = attachEvent(actions.move, scope_DocumentElement, eventMove, {
                // The event target has changed so we need to propagate the original one so that we keep
                // relying on it to extract target touches.
                target: event.target,
                handle: handle,
                listeners: listeners,
                startCalcPoint: event.calcPoint,
                baseSize: baseSize(),
                pageOffset: event.pageOffset,
                handleNumbers: data.handleNumbers,
                buttonsProperty: event.buttons,
                locations: scope_Locations.slice()
            });
            var endEvent = attachEvent(actions.end, scope_DocumentElement, eventEnd, {
                target: event.target,
                handle: handle,
                listeners: listeners,
                doNotReject: true,
                handleNumbers: data.handleNumbers
            });
            var outEvent = attachEvent("mouseout", scope_DocumentElement, documentLeave, {
                target: event.target,
                handle: handle,
                listeners: listeners,
                doNotReject: true,
                handleNumbers: data.handleNumbers
            });
            // We want to make sure we pushed the listeners in the listener list rather than creating
            // a new one as it has already been passed to the event handlers.
            listeners.push.apply(listeners, moveEvent.concat(endEvent, outEvent));
            // Text selection isn't an issue on touch devices,
            // so adding cursor styles can be skipped.
            if (event.cursor) {
                // Prevent the 'I' cursor and extend the range-drag cursor.
                scope_Body.style.cursor = getComputedStyle(event.target).cursor;
                // Mark the target with a dragging state.
                if (scope_Handles.length > 1) addClass(scope_Target, options.cssClasses.drag);
                // Prevent text selection when dragging the handles.
                // In noUiSlider <= 9.2.0, this was handled by calling preventDefault on mouse/touch start/move,
                // which is scroll blocking. The selectstart event is supported by FireFox starting from version 52,
                // meaning the only holdout is iOS Safari. This doesn't matter: text selection isn't triggered there.
                // The 'cursor' flag is false.
                // See: http://caniuse.com/#search=selectstart
                scope_Body.addEventListener("selectstart", preventDefault, false);
            }
            data.handleNumbers.forEach(function(handleNumber) {
                fireEvent("start", handleNumber);
            });
        }
        // Move closest handle to tapped location.
        function eventTap(event) {
            // The tap event shouldn't propagate up
            event.stopPropagation();
            var proposal = calcPointToPercentage(event.calcPoint);
            var handleNumber = getClosestHandle(proposal);
            // Tackle the case that all handles are 'disabled'.
            if (handleNumber === false) return false;
            // Flag the slider as it is now in a transitional state.
            // Transition takes a configurable amount of ms (default 300). Re-enable the slider after that.
            if (!options.events.snap) addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
            setHandle(handleNumber, proposal, true, true);
            setZindex();
            fireEvent("slide", handleNumber, true);
            fireEvent("update", handleNumber, true);
            fireEvent("change", handleNumber, true);
            fireEvent("set", handleNumber, true);
            if (options.events.snap) eventStart(event, {
                handleNumbers: [
                    handleNumber
                ]
            });
        }
        // Fires a 'hover' event for a hovered mouse/pen position.
        function eventHover(event) {
            var proposal = calcPointToPercentage(event.calcPoint);
            var to = scope_Spectrum.getStep(proposal);
            var value = scope_Spectrum.fromStepping(to);
            Object.keys(scope_Events).forEach(function(targetEvent) {
                if ("hover" === targetEvent.split(".")[0]) scope_Events[targetEvent].forEach(function(callback) {
                    callback.call(scope_Self, value);
                });
            });
        }
        // Handles keydown on focused handles
        // Don't move the document when pressing arrow keys on focused handles
        function eventKeydown(event, handleNumber) {
            if (isSliderDisabled() || isHandleDisabled(handleNumber)) return false;
            var horizontalKeys = [
                "Left",
                "Right"
            ];
            var verticalKeys = [
                "Down",
                "Up"
            ];
            var largeStepKeys = [
                "PageDown",
                "PageUp"
            ];
            var edgeKeys = [
                "Home",
                "End"
            ];
            if (options.dir && !options.ort) // On an right-to-left slider, the left and right keys act inverted
            horizontalKeys.reverse();
            else if (options.ort && !options.dir) {
                // On a top-to-bottom slider, the up and down keys act inverted
                verticalKeys.reverse();
                largeStepKeys.reverse();
            }
            // Strip "Arrow" for IE compatibility. https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
            var key = event.key.replace("Arrow", "");
            var isLargeDown = key === largeStepKeys[0];
            var isLargeUp = key === largeStepKeys[1];
            var isDown = key === verticalKeys[0] || key === horizontalKeys[0] || isLargeDown;
            var isUp = key === verticalKeys[1] || key === horizontalKeys[1] || isLargeUp;
            var isMin = key === edgeKeys[0];
            var isMax = key === edgeKeys[1];
            if (!isDown && !isUp && !isMin && !isMax) return true;
            event.preventDefault();
            var to;
            if (isUp || isDown) {
                var multiplier = options.keyboardPageMultiplier;
                var direction = isDown ? 0 : 1;
                var steps = getNextStepsForHandle(handleNumber);
                var step = steps[direction];
                // At the edge of a slider, do nothing
                if (step === null) return false;
                // No step set, use the default of 10% of the sub-range
                if (step === false) step = scope_Spectrum.getDefaultStep(scope_Locations[handleNumber], isDown, options.keyboardDefaultStep);
                if (isLargeUp || isLargeDown) step *= multiplier;
                // Step over zero-length ranges (#948);
                step = Math.max(step, 0.0000001);
                // Decrement for down steps
                step = (isDown ? -1 : 1) * step;
                to = scope_Values[handleNumber] + step;
            } else if (isMax) // End key
            to = options.spectrum.xVal[options.spectrum.xVal.length - 1];
            else // Home key
            to = options.spectrum.xVal[0];
            setHandle(handleNumber, scope_Spectrum.toStepping(to), true, true);
            fireEvent("slide", handleNumber);
            fireEvent("update", handleNumber);
            fireEvent("change", handleNumber);
            fireEvent("set", handleNumber);
            return false;
        }
        // Attach events to several slider parts.
        function bindSliderEvents(behaviour) {
            // Attach the standard drag event to the handles.
            if (!behaviour.fixed) scope_Handles.forEach(function(handle, index) {
                // These events are only bound to the visual handle
                // element, not the 'real' origin element.
                attachEvent(actions.start, handle.children[0], eventStart, {
                    handleNumbers: [
                        index
                    ]
                });
            });
            // Attach the tap event to the slider base.
            if (behaviour.tap) attachEvent(actions.start, scope_Base, eventTap, {});
            // Fire hover events
            if (behaviour.hover) attachEvent(actions.move, scope_Base, eventHover, {
                hover: true
            });
            // Make the range draggable.
            if (behaviour.drag) scope_Connects.forEach(function(connect, index) {
                if (connect === false || index === 0 || index === scope_Connects.length - 1) return;
                var handleBefore = scope_Handles[index - 1];
                var handleAfter = scope_Handles[index];
                var eventHolders = [
                    connect
                ];
                addClass(connect, options.cssClasses.draggable);
                // When the range is fixed, the entire range can
                // be dragged by the handles. The handle in the first
                // origin will propagate the start event upward,
                // but it needs to be bound manually on the other.
                if (behaviour.fixed) {
                    eventHolders.push(handleBefore.children[0]);
                    eventHolders.push(handleAfter.children[0]);
                }
                eventHolders.forEach(function(eventHolder) {
                    attachEvent(actions.start, eventHolder, eventStart, {
                        handles: [
                            handleBefore,
                            handleAfter
                        ],
                        handleNumbers: [
                            index - 1,
                            index
                        ]
                    });
                });
            });
        }
        // Attach an event to this slider, possibly including a namespace
        function bindEvent(namespacedEvent, callback) {
            scope_Events[namespacedEvent] = scope_Events[namespacedEvent] || [];
            scope_Events[namespacedEvent].push(callback);
            // If the event bound is 'update,' fire it immediately for all handles.
            if (namespacedEvent.split(".")[0] === "update") scope_Handles.forEach(function(a, index) {
                fireEvent("update", index);
            });
        }
        function isInternalNamespace(namespace) {
            return namespace === INTERNAL_EVENT_NS.aria || namespace === INTERNAL_EVENT_NS.tooltips;
        }
        // Undo attachment of event
        function removeEvent(namespacedEvent) {
            var event = namespacedEvent && namespacedEvent.split(".")[0];
            var namespace = event ? namespacedEvent.substring(event.length) : namespacedEvent;
            Object.keys(scope_Events).forEach(function(bind) {
                var tEvent = bind.split(".")[0];
                var tNamespace = bind.substring(tEvent.length);
                if ((!event || event === tEvent) && (!namespace || namespace === tNamespace)) // only delete protected internal event if intentional
                {
                    if (!isInternalNamespace(tNamespace) || namespace === tNamespace) delete scope_Events[bind];
                }
            });
        }
        // External event handling
        function fireEvent(eventName, handleNumber, tap) {
            Object.keys(scope_Events).forEach(function(targetEvent) {
                var eventType = targetEvent.split(".")[0];
                if (eventName === eventType) scope_Events[targetEvent].forEach(function(callback) {
                    callback.call(// Use the slider public API as the scope ('this')
                    scope_Self, // Return values as array, so arg_1[arg_2] is always valid.
                    scope_Values.map(options.format.to), // Handle index, 0 or 1
                    handleNumber, // Un-formatted slider values
                    scope_Values.slice(), // Event is fired by tap, true or false
                    tap || false, // Left offset of the handle, in relation to the slider
                    scope_Locations.slice(), // add the slider public API to an accessible parameter when this is unavailable
                    scope_Self);
                });
            });
        }
        // Split out the handle positioning logic so the Move event can use it, too
        function checkHandlePosition(reference, handleNumber, to, lookBackward, lookForward, getValue) {
            var distance;
            // For sliders with multiple handles, limit movement to the other handle.
            // Apply the margin option by adding it to the handle positions.
            if (scope_Handles.length > 1 && !options.events.unconstrained) {
                if (lookBackward && handleNumber > 0) {
                    distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber - 1], options.margin, 0);
                    to = Math.max(to, distance);
                }
                if (lookForward && handleNumber < scope_Handles.length - 1) {
                    distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber + 1], options.margin, 1);
                    to = Math.min(to, distance);
                }
            }
            // The limit option has the opposite effect, limiting handles to a
            // maximum distance from another. Limit must be > 0, as otherwise
            // handles would be unmovable.
            if (scope_Handles.length > 1 && options.limit) {
                if (lookBackward && handleNumber > 0) {
                    distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber - 1], options.limit, 0);
                    to = Math.min(to, distance);
                }
                if (lookForward && handleNumber < scope_Handles.length - 1) {
                    distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber + 1], options.limit, 1);
                    to = Math.max(to, distance);
                }
            }
            // The padding option keeps the handles a certain distance from the
            // edges of the slider. Padding must be > 0.
            if (options.padding) {
                if (handleNumber === 0) {
                    distance = scope_Spectrum.getAbsoluteDistance(0, options.padding[0], 0);
                    to = Math.max(to, distance);
                }
                if (handleNumber === scope_Handles.length - 1) {
                    distance = scope_Spectrum.getAbsoluteDistance(100, options.padding[1], 1);
                    to = Math.min(to, distance);
                }
            }
            to = scope_Spectrum.getStep(to);
            // Limit percentage to the 0 - 100 range
            to = limit(to);
            // Return false if handle can't move
            if (to === reference[handleNumber] && !getValue) return false;
            return to;
        }
        // Uses slider orientation to create CSS rules. a = base value;
        function inRuleOrder(v, a) {
            var o = options.ort;
            return (o ? a : v) + ", " + (o ? v : a);
        }
        // Moves handle(s) by a percentage
        // (bool, % to move, [% where handle started, ...], [index in scope_Handles, ...])
        function moveHandles(upward, proposal, locations, handleNumbers) {
            var proposals = locations.slice();
            var b = [
                !upward,
                upward
            ];
            var f = [
                upward,
                !upward
            ];
            // Copy handleNumbers so we don't change the dataset
            handleNumbers = handleNumbers.slice();
            // Check to see which handle is 'leading'.
            // If that one can't move the second can't either.
            if (upward) handleNumbers.reverse();
            // Step 1: get the maximum percentage that any of the handles can move
            if (handleNumbers.length > 1) handleNumbers.forEach(function(handleNumber, o) {
                var to = checkHandlePosition(proposals, handleNumber, proposals[handleNumber] + proposal, b[o], f[o], false);
                // Stop if one of the handles can't move.
                if (to === false) proposal = 0;
                else {
                    proposal = to - proposals[handleNumber];
                    proposals[handleNumber] = to;
                }
            });
            else b = f = [
                true
            ];
            var state = false;
            // Step 2: Try to set the handles with the found percentage
            handleNumbers.forEach(function(handleNumber, o) {
                state = setHandle(handleNumber, locations[handleNumber] + proposal, b[o], f[o]) || state;
            });
            // Step 3: If a handle moved, fire events
            if (state) handleNumbers.forEach(function(handleNumber) {
                fireEvent("update", handleNumber);
                fireEvent("slide", handleNumber);
            });
        }
        // Takes a base value and an offset. This offset is used for the connect bar size.
        // In the initial design for this feature, the origin element was 1% wide.
        // Unfortunately, a rounding bug in Chrome makes it impossible to implement this feature
        // in this manner: https://bugs.chromium.org/p/chromium/issues/detail?id=798223
        function transformDirection(a, b) {
            return options.dir ? 100 - a - b : a;
        }
        // Updates scope_Locations and scope_Values, updates visual state
        function updateHandlePosition(handleNumber, to) {
            // Update locations.
            scope_Locations[handleNumber] = to;
            // Convert the value to the slider stepping/range.
            scope_Values[handleNumber] = scope_Spectrum.fromStepping(to);
            var translation = 10 * (transformDirection(to, 0) - scope_DirOffset);
            var translateRule = "translate(" + inRuleOrder(translation + "%", "0") + ")";
            scope_Handles[handleNumber].style[options.transformRule] = translateRule;
            updateConnect(handleNumber);
            updateConnect(handleNumber + 1);
        }
        // Handles before the slider middle are stacked later = higher,
        // Handles after the middle later is lower
        // [[7] [8] .......... | .......... [5] [4]
        function setZindex() {
            scope_HandleNumbers.forEach(function(handleNumber) {
                var dir = scope_Locations[handleNumber] > 50 ? -1 : 1;
                var zIndex = 3 + (scope_Handles.length + dir * handleNumber);
                scope_Handles[handleNumber].style.zIndex = zIndex;
            });
        }
        // Test suggested values and apply margin, step.
        // if exactInput is true, don't run checkHandlePosition, then the handle can be placed in between steps (#436)
        function setHandle(handleNumber, to, lookBackward, lookForward, exactInput) {
            if (!exactInput) to = checkHandlePosition(scope_Locations, handleNumber, to, lookBackward, lookForward, false);
            if (to === false) return false;
            updateHandlePosition(handleNumber, to);
            return true;
        }
        // Updates style attribute for connect nodes
        function updateConnect(index) {
            // Skip connects set to false
            if (!scope_Connects[index]) return;
            var l = 0;
            var h = 100;
            if (index !== 0) l = scope_Locations[index - 1];
            if (index !== scope_Connects.length - 1) h = scope_Locations[index];
            // We use two rules:
            // 'translate' to change the left/top offset;
            // 'scale' to change the width of the element;
            // As the element has a width of 100%, a translation of 100% is equal to 100% of the parent (.noUi-base)
            var connectWidth = h - l;
            var translateRule = "translate(" + inRuleOrder(transformDirection(l, connectWidth) + "%", "0") + ")";
            var scaleRule = "scale(" + inRuleOrder(connectWidth / 100, "1") + ")";
            scope_Connects[index].style[options.transformRule] = translateRule + " " + scaleRule;
        }
        // Parses value passed to .set method. Returns current value if not parse-able.
        function resolveToValue(to, handleNumber) {
            // Setting with null indicates an 'ignore'.
            // Inputting 'false' is invalid.
            if (to === null || to === false || to === undefined) return scope_Locations[handleNumber];
            // If a formatted number was passed, attempt to decode it.
            if (typeof to === "number") to = String(to);
            to = options.format.from(to);
            to = scope_Spectrum.toStepping(to);
            // If parsing the number failed, use the current value.
            if (to === false || isNaN(to)) return scope_Locations[handleNumber];
            return to;
        }
        // Set the slider value.
        function valueSet(input, fireSetEvent, exactInput) {
            var values = asArray(input);
            var isInit = scope_Locations[0] === undefined;
            // Event fires by default
            fireSetEvent = fireSetEvent === undefined ? true : !!fireSetEvent;
            // Animation is optional.
            // Make sure the initial values were set before using animated placement.
            if (options.animate && !isInit) addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
            // First pass, without lookAhead but with lookBackward. Values are set from left to right.
            scope_HandleNumbers.forEach(function(handleNumber) {
                setHandle(handleNumber, resolveToValue(values[handleNumber], handleNumber), true, false, exactInput);
            });
            var i = scope_HandleNumbers.length === 1 ? 0 : 1;
            // Secondary passes. Now that all base values are set, apply constraints.
            // Iterate all handles to ensure constraints are applied for the entire slider (Issue #1009)
            for(; i < scope_HandleNumbers.length; ++i)scope_HandleNumbers.forEach(function(handleNumber) {
                setHandle(handleNumber, scope_Locations[handleNumber], true, true, exactInput);
            });
            setZindex();
            scope_HandleNumbers.forEach(function(handleNumber) {
                fireEvent("update", handleNumber);
                // Fire the event only for handles that received a new value, as per #579
                if (values[handleNumber] !== null && fireSetEvent) fireEvent("set", handleNumber);
            });
        }
        // Reset slider to initial values
        function valueReset(fireSetEvent) {
            valueSet(options.start, fireSetEvent);
        }
        // Set value for a single handle
        function valueSetHandle(handleNumber, value, fireSetEvent, exactInput) {
            // Ensure numeric input
            handleNumber = Number(handleNumber);
            if (!(handleNumber >= 0 && handleNumber < scope_HandleNumbers.length)) throw new Error("noUiSlider (" + VERSION + "): invalid handle number, got: " + handleNumber);
            // Look both backward and forward, since we don't want this handle to "push" other handles (#960);
            // The exactInput argument can be used to ignore slider stepping (#436)
            setHandle(handleNumber, resolveToValue(value, handleNumber), true, true, exactInput);
            fireEvent("update", handleNumber);
            if (fireSetEvent) fireEvent("set", handleNumber);
        }
        // Get the slider value.
        function valueGet() {
            var values = scope_Values.map(options.format.to);
            // If only one handle is used, return a single value.
            if (values.length === 1) return values[0];
            return values;
        }
        // Removes classes from the root and empties it.
        function destroy() {
            // remove protected internal listeners
            removeEvent(INTERNAL_EVENT_NS.aria);
            removeEvent(INTERNAL_EVENT_NS.tooltips);
            for(var key in options.cssClasses){
                if (!options.cssClasses.hasOwnProperty(key)) continue;
                removeClass(scope_Target, options.cssClasses[key]);
            }
            while(scope_Target.firstChild)scope_Target.removeChild(scope_Target.firstChild);
            delete scope_Target.noUiSlider;
        }
        function getNextStepsForHandle(handleNumber) {
            var location = scope_Locations[handleNumber];
            var nearbySteps = scope_Spectrum.getNearbySteps(location);
            var value = scope_Values[handleNumber];
            var increment = nearbySteps.thisStep.step;
            var decrement = null;
            // If snapped, directly use defined step value
            if (options.snap) return [
                value - nearbySteps.stepBefore.startValue || null,
                nearbySteps.stepAfter.startValue - value || null
            ];
            // If the next value in this step moves into the next step,
            // the increment is the start of the next step - the current value
            if (increment !== false) {
                if (value + increment > nearbySteps.stepAfter.startValue) increment = nearbySteps.stepAfter.startValue - value;
            }
            // If the value is beyond the starting point
            if (value > nearbySteps.thisStep.startValue) decrement = nearbySteps.thisStep.step;
            else if (nearbySteps.stepBefore.step === false) decrement = false;
            else decrement = value - nearbySteps.stepBefore.highestStep;
            // Now, if at the slider edges, there is no in/decrement
            if (location === 100) increment = null;
            else if (location === 0) decrement = null;
            // As per #391, the comparison for the decrement step can have some rounding issues.
            var stepDecimals = scope_Spectrum.countStepDecimals();
            // Round per #391
            if (increment !== null && increment !== false) increment = Number(increment.toFixed(stepDecimals));
            if (decrement !== null && decrement !== false) decrement = Number(decrement.toFixed(stepDecimals));
            return [
                decrement,
                increment
            ];
        }
        // Get the current step size for the slider.
        function getNextSteps() {
            return scope_HandleNumbers.map(getNextStepsForHandle);
        }
        // Updateable: margin, limit, padding, step, range, animate, snap
        function updateOptions(optionsToUpdate, fireSetEvent) {
            // Spectrum is created using the range, snap, direction and step options.
            // 'snap' and 'step' can be updated.
            // If 'snap' and 'step' are not passed, they should remain unchanged.
            var v = valueGet();
            var updateAble = [
                "margin",
                "limit",
                "padding",
                "range",
                "animate",
                "snap",
                "step",
                "format",
                "pips",
                "tooltips"
            ];
            // Only change options that we're actually passed to update.
            updateAble.forEach(function(name) {
                // Check for undefined. null removes the value.
                if (optionsToUpdate[name] !== undefined) originalOptions[name] = optionsToUpdate[name];
            });
            var newOptions = testOptions(originalOptions);
            // Load new options into the slider state
            updateAble.forEach(function(name) {
                if (optionsToUpdate[name] !== undefined) options[name] = newOptions[name];
            });
            scope_Spectrum = newOptions.spectrum;
            // Limit, margin and padding depend on the spectrum but are stored outside of it. (#677)
            options.margin = newOptions.margin;
            options.limit = newOptions.limit;
            options.padding = newOptions.padding;
            // Update pips, removes existing.
            if (options.pips) pips(options.pips);
            else removePips();
            // Update tooltips, removes existing.
            if (options.tooltips) tooltips();
            else removeTooltips();
            // Invalidate the current positioning so valueSet forces an update.
            scope_Locations = [];
            valueSet(isSet(optionsToUpdate.start) ? optionsToUpdate.start : v, fireSetEvent);
        }
        // Initialization steps
        function setupSlider() {
            // Create the base element, initialize HTML and set classes.
            // Add handles and connect elements.
            scope_Base = addSlider(scope_Target);
            addElements(options.connect, scope_Base);
            // Attach user events.
            bindSliderEvents(options.events);
            // Use the public value method to set the start values.
            valueSet(options.start);
            if (options.pips) pips(options.pips);
            if (options.tooltips) tooltips();
            aria();
        }
        setupSlider();
        // noinspection JSUnusedGlobalSymbols
        scope_Self = {
            destroy: destroy,
            steps: getNextSteps,
            on: bindEvent,
            off: removeEvent,
            get: valueGet,
            set: valueSet,
            setHandle: valueSetHandle,
            reset: valueReset,
            // Exposed for unit testing, don't use this in your application.
            __moveHandles: function(a, b, c) {
                moveHandles(a, b, scope_Locations, c);
            },
            options: originalOptions,
            updateOptions: updateOptions,
            target: scope_Target,
            removePips: removePips,
            removeTooltips: removeTooltips,
            getTooltips: function() {
                return scope_Tooltips;
            },
            getOrigins: function() {
                return scope_Handles;
            },
            pips: pips // Issue #594
        };
        return scope_Self;
    }
    // Run the standard initializer
    function initialize(target, originalOptions) {
        if (!target || !target.nodeName) throw new Error("noUiSlider (" + VERSION + "): create requires a single element, got: " + target);
        // Throw an error if the slider was already initialized.
        if (target.noUiSlider) throw new Error("noUiSlider (" + VERSION + "): Slider was already initialized.");
        // Test the options and create the slider environment;
        var options = testOptions(originalOptions);
        var api = scope(target, options, originalOptions);
        target.noUiSlider = api;
        return api;
    }
    // Use an object instead of a function for future expandability;
    return {
        // Exposed for unit testing, don't use this in your application.
        __spectrum: Spectrum,
        version: VERSION,
        // A reference to the default classes, allows global changes.
        // Use the cssClasses option for changes to one slider.
        cssClasses: cssClasses,
        create: initialize
    };
});


var $7619d6b45fe7035f$exports = {};
(function(factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else // Node/CommonJS
    $7619d6b45fe7035f$exports = factory();
})(function() {
    "use strict";
    var FormatOptions = [
        "decimals",
        "thousand",
        "mark",
        "prefix",
        "suffix",
        "encoder",
        "decoder",
        "negativeBefore",
        "negative",
        "edit",
        "undo"
    ];
    // General
    // Reverse a string
    function strReverse(a) {
        return a.split("").reverse().join("");
    }
    // Check if a string starts with a specified prefix.
    function strStartsWith(input, match) {
        return input.substring(0, match.length) === match;
    }
    // Check is a string ends in a specified suffix.
    function strEndsWith(input, match) {
        return input.slice(-1 * match.length) === match;
    }
    // Throw an error if formatting options are incompatible.
    function throwEqualError(F, a, b) {
        if ((F[a] || F[b]) && F[a] === F[b]) throw new Error(a);
    }
    // Check if a number is finite and not NaN
    function isValidNumber(input) {
        return typeof input === "number" && isFinite(input);
    }
    // Provide rounding-accurate toFixed method.
    // Borrowed: http://stackoverflow.com/a/21323330/775265
    function toFixed(value, exp) {
        value = value.toString().split("e");
        value = Math.round(+(value[0] + "e" + (value[1] ? +value[1] + exp : exp)));
        value = value.toString().split("e");
        return (+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp))).toFixed(exp);
    }
    // Formatting
    // Accept a number as input, output formatted string.
    function formatTo(decimals, thousand, mark, prefix, suffix, encoder, decoder, negativeBefore, negative, edit, undo, input) {
        var originalInput = input, inputIsNegative, inputPieces, inputBase, inputDecimals = "", output = "";
        // Apply user encoder to the input.
        // Expected outcome: number.
        if (encoder) input = encoder(input);
        // Stop if no valid number was provided, the number is infinite or NaN.
        if (!isValidNumber(input)) return false;
        // Rounding away decimals might cause a value of -0
        // when using very small ranges. Remove those cases.
        if (decimals !== false && parseFloat(input.toFixed(decimals)) === 0) input = 0;
        // Formatting is done on absolute numbers,
        // decorated by an optional negative symbol.
        if (input < 0) {
            inputIsNegative = true;
            input = Math.abs(input);
        }
        // Reduce the number of decimals to the specified option.
        if (decimals !== false) input = toFixed(input, decimals);
        // Transform the number into a string, so it can be split.
        input = input.toString();
        // Break the number on the decimal separator.
        if (input.indexOf(".") !== -1) {
            inputPieces = input.split(".");
            inputBase = inputPieces[0];
            if (mark) inputDecimals = mark + inputPieces[1];
        } else // If it isn't split, the entire number will do.
        inputBase = input;
        // Group numbers in sets of three.
        if (thousand) {
            inputBase = strReverse(inputBase).match(/.{1,3}/g);
            inputBase = strReverse(inputBase.join(strReverse(thousand)));
        }
        // If the number is negative, prefix with negation symbol.
        if (inputIsNegative && negativeBefore) output += negativeBefore;
        // Prefix the number
        if (prefix) output += prefix;
        // Normal negative option comes after the prefix. Defaults to '-'.
        if (inputIsNegative && negative) output += negative;
        // Append the actual number.
        output += inputBase;
        output += inputDecimals;
        // Apply the suffix.
        if (suffix) output += suffix;
        // Run the output through a user-specified post-formatter.
        if (edit) output = edit(output, originalInput);
        // All done.
        return output;
    }
    // Accept a sting as input, output decoded number.
    function formatFrom(decimals, thousand, mark, prefix, suffix, encoder, decoder, negativeBefore, negative, edit, undo, input) {
        var originalInput = input, inputIsNegative, output = "";
        // User defined pre-decoder. Result must be a non empty string.
        if (undo) input = undo(input);
        // Test the input. Can't be empty.
        if (!input || typeof input !== "string") return false;
        // If the string starts with the negativeBefore value: remove it.
        // Remember is was there, the number is negative.
        if (negativeBefore && strStartsWith(input, negativeBefore)) {
            input = input.replace(negativeBefore, "");
            inputIsNegative = true;
        }
        // Repeat the same procedure for the prefix.
        if (prefix && strStartsWith(input, prefix)) input = input.replace(prefix, "");
        // And again for negative.
        if (negative && strStartsWith(input, negative)) {
            input = input.replace(negative, "");
            inputIsNegative = true;
        }
        // Remove the suffix.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/slice
        if (suffix && strEndsWith(input, suffix)) input = input.slice(0, -1 * suffix.length);
        // Remove the thousand grouping.
        if (thousand) input = input.split(thousand).join("");
        // Set the decimal separator back to period.
        if (mark) input = input.replace(mark, ".");
        // Prepend the negative symbol.
        if (inputIsNegative) output += "-";
        // Add the number
        output += input;
        // Trim all non-numeric characters (allow '.' and '-');
        output = output.replace(/[^0-9\.\-.]/g, "");
        // The value contains no parse-able number.
        if (output === "") return false;
        // Covert to number.
        output = Number(output);
        // Run the user-specified post-decoder.
        if (decoder) output = decoder(output);
        // Check is the output is valid, otherwise: return false.
        if (!isValidNumber(output)) return false;
        return output;
    }
    // Framework
    // Validate formatting options
    function validate(inputOptions) {
        var i, optionName, optionValue, filteredOptions = {};
        if (inputOptions["suffix"] === undefined) inputOptions["suffix"] = inputOptions["postfix"];
        for(i = 0; i < FormatOptions.length; i += 1){
            optionName = FormatOptions[i];
            optionValue = inputOptions[optionName];
            if (optionValue === undefined) {
                // Only default if negativeBefore isn't set.
                if (optionName === "negative" && !filteredOptions.negativeBefore) filteredOptions[optionName] = "-";
                else if (optionName === "mark" && filteredOptions.thousand !== ".") filteredOptions[optionName] = ".";
                else filteredOptions[optionName] = false;
            // Floating points in JS are stable up to 7 decimals.
            } else if (optionName === "decimals") {
                if (optionValue >= 0 && optionValue < 8) filteredOptions[optionName] = optionValue;
                else throw new Error(optionName);
            // These options, when provided, must be functions.
            } else if (optionName === "encoder" || optionName === "decoder" || optionName === "edit" || optionName === "undo") {
                if (typeof optionValue === "function") filteredOptions[optionName] = optionValue;
                else throw new Error(optionName);
            // Other options are strings.
            } else {
                if (typeof optionValue === "string") filteredOptions[optionName] = optionValue;
                else throw new Error(optionName);
            }
        }
        // Some values can't be extracted from a
        // string if certain combinations are present.
        throwEqualError(filteredOptions, "mark", "thousand");
        throwEqualError(filteredOptions, "prefix", "negative");
        throwEqualError(filteredOptions, "prefix", "negativeBefore");
        return filteredOptions;
    }
    // Pass all options as function arguments
    function passAll(options, method, input) {
        var i, args = [];
        // Add all options in order of FormatOptions
        for(i = 0; i < FormatOptions.length; i += 1)args.push(options[FormatOptions[i]]);
        // Append the input, then call the method, presenting all
        // options as arguments.
        args.push(input);
        return method.apply("", args);
    }
    function wNumb(options) {
        if (!(this instanceof wNumb)) return new wNumb(options);
        if (typeof options !== "object") return;
        options = validate(options);
        // Call 'formatTo' with proper arguments.
        this.to = function(input) {
            return passAll(options, formatTo, input);
        };
        // Call 'formatFrom' with proper arguments.
        this.from = function(input) {
            return passAll(options, formatFrom, input);
        };
    }
    return wNumb;
});


const $903abfde81fce16c$export$6a05a8dbae351ecc = (slider, minValue, maxValue)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($1a87f63a5aa52bae$exports))).create(slider, {
        start: [
            minValue,
            maxValue
        ],
        connect: true,
        step: 1,
        tooltips: true,
        range: {
            min: minValue,
            max: maxValue
        },
        format: (0, (/*@__PURE__*/$parcel$interopDefault($7619d6b45fe7035f$exports)))({
            decimals: 0
        })
    });
};
const $903abfde81fce16c$export$92592c7118371ba1 = (slider, minValue, maxValue, nonLinearValue)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($1a87f63a5aa52bae$exports))).create(slider, {
        start: [
            minValue,
            maxValue
        ],
        connect: true,
        step: 1,
        tooltips: true,
        range: {
            min: [
                minValue
            ],
            '50%': [
                nonLinearValue
            ],
            max: [
                maxValue
            ]
        },
        format: (0, (/*@__PURE__*/$parcel$interopDefault($7619d6b45fe7035f$exports)))({
            decimals: 0
        })
    });
};


var $d5028c8da4192c16$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $d5028c8da4192c16$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


// ***** BUTTONS *****
const $29327506a7da108f$var$logInBtn = document.querySelector('.login-form');
const $29327506a7da108f$var$logoutBtn = document.getElementById('logout');
const $29327506a7da108f$var$passwordResetEmailBtn = document.getElementById('sendPasswordResetEmail');
const $29327506a7da108f$var$resetPasswordBtn = document.querySelector('.resetPassword');
const $29327506a7da108f$var$gameReservationBtn = document.getElementById('gameReservation');
const $29327506a7da108f$var$learningBookReservationBtn = document.getElementById('learningBookReservation');
const $29327506a7da108f$var$informativeBookReservationBtn = document.getElementById('informativeBookReservation');
const $29327506a7da108f$var$didacticMaterialReservationBtn = document.getElementById('didacticMaterialReservation');
const $29327506a7da108f$var$readingAndPictureBookReservationBtn = document.getElementById('readingAndPictureBookReservation');
const $29327506a7da108f$var$deleteReadingAndPictureBookReservationBtns = document.querySelectorAll('#deleteReadingAndPictureBookReservation');
const $29327506a7da108f$var$deleteDidacticMaterialReservationBtns = document.querySelectorAll('#deleteDidacticMaterialReservation');
const $29327506a7da108f$var$deleteGameReservationBtns = document.querySelectorAll('#deleteGameReservation');
const $29327506a7da108f$var$deleteLearningBookReservationBtns = document.querySelectorAll('#deleteLearningBookReservation');
const $29327506a7da108f$var$deleteInformativeBookReservationBtns = document.querySelectorAll('#deleteInformativeBookReservation');
const $29327506a7da108f$var$updateGameReservationBtns = document.querySelectorAll('#updateGameReservation');
const $29327506a7da108f$var$filterGamesBtn = document.getElementById('games-filter');
const $29327506a7da108f$var$filterDidacticMaterialBtn = document.getElementById('didacticMaterial-filter');
const $29327506a7da108f$var$filterLearningBookBtn = document.getElementById('learningBook-filter');
const $29327506a7da108f$var$filterInformativeBookBtn = document.getElementById('informativeBook-filter');
const $29327506a7da108f$var$filterVirtualRealityAppsBtn = document.getElementById('virtualRealityApps-filter');
const $29327506a7da108f$var$filterReadingAndPictureBookBtn = document.getElementById('readingAndPictureBook-filter');
const $29327506a7da108f$var$resetFilterVirtualRealityAppsBtn = document.getElementById('reset-virtualRealityApps-filter');
const $29327506a7da108f$var$resetFilterGamesBtn = document.getElementById('reset-games-filter');
const $29327506a7da108f$var$resetFilterDidacticMaterialBtn = document.getElementById('reset-didacticMaterial-filter');
const $29327506a7da108f$var$resetFilterLearningBookBtn = document.getElementById('reset-learningBook-filter');
const $29327506a7da108f$var$resetFilterInformativeBookBtn = document.getElementById('reset-informativeBook-filter');
const $29327506a7da108f$var$resetFilterReadingAndPictureBookBtn = document.getElementById('reset-readingAndPictureBook-filter');
const $29327506a7da108f$var$createGameBtn = document.querySelector('.createGame');
const $29327506a7da108f$var$deleteGameBtns = document.querySelectorAll('.icon-close#game');
const $29327506a7da108f$var$updateGameBtn = document.querySelector('.updateGame');
const $29327506a7da108f$var$createDidacticMaterialBtn = document.querySelector('.createDidacticMaterial');
const $29327506a7da108f$var$deleteDidacticMaterialBtns = document.querySelectorAll('.icon-close#didacticMaterial');
const $29327506a7da108f$var$updateDidacticMaterialBtn = document.querySelector('.updateDidacticMaterial');
const $29327506a7da108f$var$createLearningBookBtn = document.querySelector('.createLearningBook');
const $29327506a7da108f$var$updateLearningBookBtn = document.querySelector('.updateLearningBook');
const $29327506a7da108f$var$deleteLearningBookBtns = document.querySelectorAll('.icon-close#learningBook');
const $29327506a7da108f$var$createInformativeBookBtn = document.querySelector('.createInformativeBook');
const $29327506a7da108f$var$updateInformativeBookBtn = document.querySelector('.updateInformativeBook');
const $29327506a7da108f$var$deleteInformativeBookBtns = document.querySelectorAll('.icon-close#informativeBook');
const $29327506a7da108f$var$createUserBtn = document.querySelector('.createUser');
const $29327506a7da108f$var$deleteUserBtns = document.querySelectorAll('.icon-close#user');
const $29327506a7da108f$var$updateUserBtn = document.querySelector('.updateUser');
const $29327506a7da108f$var$createReadingAndPictureBookBtn = document.querySelector('.createReadingAndPictureBook');
const $29327506a7da108f$var$updateReadingAndPictureBookBtn = document.querySelector('.updateReadingAndPictureBook');
const $29327506a7da108f$var$deleteReadingAndPictureBookBtns = document.querySelectorAll('.icon-close#readingAndPictureBook');
const $29327506a7da108f$var$updateAccountSettingsBtn = document.querySelector('.settingsAccountData');
const $29327506a7da108f$var$updateAccountPasswordBtn = document.querySelector('.settingsAccountPassword');
const $29327506a7da108f$var$gameOverview = document.getElementById('gameOverview');
const $29327506a7da108f$var$didacticMaterialOverview = document.getElementById('didacticMaterialOverview');
const $29327506a7da108f$var$informativeBookOverview = document.getElementById('informativeBookOverview');
const $29327506a7da108f$var$readingAndPictureBookOverview = document.getElementById('readingAndPictureBookOverview');
const $29327506a7da108f$var$learningBookOverview = document.getElementById('learningBookOverview');
// ***** SLIDERS *****
const $29327506a7da108f$var$leeftijdSlider = document.getElementById('leeftijdSlider');
const $29327506a7da108f$var$gameSpelersSlider = document.getElementById('spelersSlider');
// ***** DROPDOWN *****
const $29327506a7da108f$var$gameUpdateKindgesprekDropDown = document.getElementById('updateKindgesprekDropDown');
const $29327506a7da108f$var$gameUpdateIsolatieDropDown = document.getElementById('updateIsolatieDropDown');
const $29327506a7da108f$var$gameUpdateLocatieDropDown = document.getElementById('updateLocatieDropDown');
const $29327506a7da108f$var$gameUpdateVakkenDropDown = document.getElementById('updateVakkenDropDown');
const $29327506a7da108f$var$gameUpdateLeerprofielDropDown = document.getElementById('updateLeerprofielDropDown');
const $29327506a7da108f$var$gameUpdateExecutieveFunctieDropDown = document.getElementById('updateExecutieveFunctieDropDown');
const $29327506a7da108f$var$userUpdateRolDropDown = document.getElementById('updateRolDropDown');
const $29327506a7da108f$var$userUpdateDepartmentDropDown = document.getElementById('updateDepartmentDropDown');
const $29327506a7da108f$var$userDepartmentDropDown = document.getElementById('userDepartmentDropDown');
const $29327506a7da108f$var$locatieDropDown = document.getElementById('locatieDropDown');
const $29327506a7da108f$var$niveauDropDown = document.getElementById('niveauDropDown');
const $29327506a7da108f$var$vakDropDown = document.getElementById('vakkenDropDown');
const $29327506a7da108f$var$isolatieDropDown = document.getElementById('isolatieDropDown');
const $29327506a7da108f$var$uitleenbaarDropDown = document.getElementById('uitleenbaarDropDown');
const $29327506a7da108f$var$handleidingDropDown = document.getElementById('handleidingDropDown');
const $29327506a7da108f$var$kindgesprekDropDown = document.getElementById('kindgesprekDropDown');
const $29327506a7da108f$var$leerprofielDropDown = document.getElementById('leerprofielDropDown');
const $29327506a7da108f$var$executieveFunctieDropDown = document.getElementById('executieveFunctieDropDown');
// ***** ALGEMEEN *****
//TODO verzend een mail bij uitlening (bekijken of dit mogelijk is).
//TODO bekijk eerder uitgeleende artikelen
// ***** SLIDERS *****
if ($29327506a7da108f$var$leeftijdSlider) (0, $903abfde81fce16c$export$92592c7118371ba1)($29327506a7da108f$var$leeftijdSlider, 1, 99, 18);
if ($29327506a7da108f$var$gameSpelersSlider) (0, $903abfde81fce16c$export$6a05a8dbae351ecc)($29327506a7da108f$var$gameSpelersSlider, 1, 10);
// ***** GENERAL BUTTONS *****
if ($29327506a7da108f$var$logInBtn) $29327506a7da108f$var$logInBtn.addEventListener('submit', (e)=>{
    e.preventDefault();
    const email = document.getElementById('email2').value;
    const password = document.getElementById('pass3').value;
    (0, $10efc1afc555d5ce$export$596d806903d1f59e)(email, password);
});
if ($29327506a7da108f$var$updateAccountPasswordBtn) $29327506a7da108f$var$updateAccountPasswordBtn.addEventListener('submit', async (e)=>{
    e.preventDefault();
    document.getElementById('settingsAccountPassword').value = 'Updating...';
    const passwordCurrent = document.getElementById('userPaswoord').value;
    const password = document.getElementById('userNieuwPaswoord').value;
    const passwordConfirm = document.getElementById('userNieuwPaswoordBevestig').value;
    await (0, $f9cbaefb61efebd4$export$e6af0f282bef35a9)(passwordCurrent, password, passwordConfirm);
    document.getElementById('settingsAccountPassword').value = 'Bewaar paswoord';
});
if ($29327506a7da108f$var$passwordResetEmailBtn) $29327506a7da108f$var$passwordResetEmailBtn.addEventListener('submit', (e)=>{
    e.preventDefault();
    const email = document.getElementById('userEmail').value;
    (0, $f9cbaefb61efebd4$export$9fb5a9381b4171d1)(email);
});
if ($29327506a7da108f$var$resetPasswordBtn) $29327506a7da108f$var$resetPasswordBtn.addEventListener('submit', (e)=>{
    e.preventDefault();
    document.getElementById('resetPassword').value = 'Updating...';
    const form = new FormData();
    form.append('token', window.location.href.split('/')[5]);
    form.append('password', document.getElementById('userNieuwPaswoord').value);
    form.append('passwordConfirm', document.getElementById('userNieuwPaswoordBevestig').value);
    if (form.get('password') === form.get('passwordConfirm')) (0, $f9cbaefb61efebd4$export$11a4d06436cf93e2)(form);
    else {
        (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', 'De ingevoerde paswoorden zijn niet identiek');
        document.getElementById('resetPassword').value = 'Bewaar paswoord';
    }
});
// ***** OVERVIEW *****
// Remove every Cookie en set all values to default when the overview loads
if ($29327506a7da108f$var$gameOverview) window.addEventListener('load', ()=>{
    const urlContainsSearchQuery = window.location.href.indexOf('/games/overview?') > -1;
    if (!urlContainsSearchQuery) {
        //Remove cookies
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-beschrijving');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-location');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-vakken');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-leerprofiel');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-leeftijd');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-spelers');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-executieveFuncties');
        //Set values to default
        document.getElementById('games-description-search').value = '';
        document.getElementById('games-location-search').selectedIndex = 0;
        document.getElementById('games-courses-search').selectedIndex = 0;
        document.getElementById('games-leerprofiel-search').selectedIndex = 0;
        document.getElementById('games-executieve-functies-search').selectedIndex = 0;
        $29327506a7da108f$var$leeftijdSlider.noUiSlider.reset();
        $29327506a7da108f$var$gameSpelersSlider.noUiSlider.reset();
    }
});
if ($29327506a7da108f$var$didacticMaterialOverview) window.addEventListener('load', ()=>{
    const urlContainsSearchQuery = window.location.href.indexOf('/didacticMaterials/overview?') > -1;
    if (!urlContainsSearchQuery) {
        //Remove cookies
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-beschrijving-didactischMateriaal');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-locatie-didactischMateriaal');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-niveau-didactischMateriaal');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-vak-didactischMateriaal');
        //Set values to default
        document.getElementById('didacticMaterial-description-search').value = '';
        document.getElementById('didacticMaterial-grade-search').selectedIndex = 0;
        document.getElementById('didacticMaterial-location-search').selectedIndex = 0;
        document.getElementById('didacticMaterial-courses-search').selectedIndex = 0;
    }
});
if ($29327506a7da108f$var$informativeBookOverview) window.addEventListener('load', ()=>{
    const urlContainsSearchQuery = window.location.href.indexOf('/informativeBooks/overview?') > -1;
    if (!urlContainsSearchQuery) {
        //Remove cookies
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-beschrijving-informatiefBoek');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-locatie-informatiefBoek');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-leerprofiel-informatiefBoek');
        //Set values to default
        document.getElementById('informativeBook-description-search').value = '';
        document.getElementById('informativeBook-location-search').selectedIndex = 0;
        document.getElementById('informativeBook-leerprofiel-search').selectedIndex = 0;
    }
});
if ($29327506a7da108f$var$readingAndPictureBookOverview) window.addEventListener('load', ()=>{
    const urlContainsSearchQuery = window.location.href.indexOf('/readingAndPictureBooks/overview?') > -1;
    if (!urlContainsSearchQuery) {
        //Remove cookies
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-beschrijving-readingAndPictureBook');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-locatie-readingAndPictureBook');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-leeftijd-readingAndPictureBook');
        //Set values to default
        document.getElementById('readingAndPictureBook-description-search').value = '';
        document.getElementById('readingAndPictureBook-location-search').selectedIndex = 0;
        $29327506a7da108f$var$leeftijdSlider.noUiSlider.reset();
    }
});
if ($29327506a7da108f$var$learningBookOverview) window.addEventListener('load', ()=>{
    const urlContainsSearchQuery = window.location.href.indexOf('/learningBooks/overview?') > -1;
    if (!urlContainsSearchQuery) {
        //Remove cookies
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-beschrijving-leerBoek');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-locatie-leerBoek');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-vak-leerBoek');
        (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-niveau-leerBoek');
        //Set values to default
        document.getElementById('learningBook-description-search').value = '';
        document.getElementById('learningBook-location-search').selectedIndex = 0;
        document.getElementById('learningBook-courses-search').selectedIndex = 0;
        document.getElementById('learningBook-grade-search').selectedIndex = 0;
    }
});
// ***** GAME BUTTONS *****
if ($29327506a7da108f$var$createGameBtn) {
    let gameKindgesprekDropDownValue = (0, $e9351b49dacdb3de$export$77214a3ba76484c0)($29327506a7da108f$var$kindgesprekDropDown);
    let gameIsolatieDropDownValue = (0, $e9351b49dacdb3de$export$c7abf3a563086090)($29327506a7da108f$var$isolatieDropDown);
    let locatieDropDownValue = (0, $e9351b49dacdb3de$export$18444686970a42c4)($29327506a7da108f$var$locatieDropDown);
    let uitleenbaarDropDownValue = (0, $e9351b49dacdb3de$export$6ec9326aba4fe8d7)($29327506a7da108f$var$uitleenbaarDropDown);
    let gameVakkenDropDownValue = (0, $e9351b49dacdb3de$export$bd4e270cafd52145)($29327506a7da108f$var$vakDropDown, 'undefined', true);
    let gameLeerprofielDropDownValue = (0, $e9351b49dacdb3de$export$841576e3d080987b)($29327506a7da108f$var$leerprofielDropDown);
    let gameExecutieveFunctieDropDownValue = (0, $e9351b49dacdb3de$export$72dec94571b996c5)($29327506a7da108f$var$executieveFunctieDropDown);
    $29327506a7da108f$var$createGameBtn.addEventListener('submit', (e)=>{
        e.preventDefault();
        const errorMessages = [];
        const form = new FormData();
        if (document.getElementById('gameNaam').value != '') form.append('naam', document.getElementById('gameNaam').value);
        else errorMessages.push('Er dient een naam te worden opgegeven.');
        if (locatieDropDownValue.value() === '' || locatieDropDownValue.value() === undefined || locatieDropDownValue.value() === 'undefined') errorMessages.push('Er dient een locatie te worden opgegeven.');
        else form.append('locatie', locatieDropDownValue.value());
        if (gameIsolatieDropDownValue.value() === '' || gameIsolatieDropDownValue.value() === undefined || gameIsolatieDropDownValue.value() === 'undefined') errorMessages.push('Isolatie dient te worden opgegeven.');
        else form.append('isolatie', gameIsolatieDropDownValue.value());
        if (gameExecutieveFunctieDropDownValue.value() === '' || gameExecutieveFunctieDropDownValue.value() === undefined || gameExecutieveFunctieDropDownValue.value() === 'undefined') errorMessages.push('Executieve functie dient te worden opgegeven.');
        else form.append('executieveFunctie', gameExecutieveFunctieDropDownValue.value());
        if (gameKindgesprekDropDownValue.value() == undefined || gameKindgesprekDropDownValue.value().length == 0) form.append('kindgesprek', '');
        else gameKindgesprekDropDownValue.value().forEach((kindgesprek, index)=>{
            form.append('kindgesprek[' + index + ']', kindgesprek);
        });
        if (gameLeerprofielDropDownValue.value() == undefined || gameLeerprofielDropDownValue.value().length == 0) form.append('leerprofiel', '');
        else gameLeerprofielDropDownValue.value().forEach((leerprofiel, index)=>{
            form.append('leerprofiel[' + index + ']', leerprofiel);
        });
        if (gameVakkenDropDownValue.value() == undefined || gameVakkenDropDownValue.value().length == 0) form.append('vak', '');
        else gameVakkenDropDownValue.value().forEach((vak, index)=>{
            form.append('vak[' + index + ']', vak);
        });
        form.append('beschrijving', document.getElementById('gameBeschrijving').value);
        form.append('extraInformatie', document.getElementById('gameExtraInformatie').value);
        if (uitleenbaarDropDownValue.value() != undefined) form.append('uitleenbaar', uitleenbaarDropDownValue.value());
        form.append('minLeeftijd', $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[0]);
        form.append('maxLeeftijd', $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[1]);
        form.append('minSpelers', $29327506a7da108f$var$gameSpelersSlider.noUiSlider.get()[0]);
        form.append('maxSpelers', $29327506a7da108f$var$gameSpelersSlider.noUiSlider.get()[1]);
        if (document.getElementById('gameAfbeelding').files.length == 1) form.append('afbeelding', document.getElementById('gameAfbeelding').files[0]);
        if (errorMessages.length != 0) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', errorMessages.join(' '), 5);
            document.getElementById('createGame').value = 'Voeg toe';
            document.getElementById('createGame').disabled = false;
        } else {
            document.getElementById('createGame').value = 'Updating...';
            document.getElementById('createGame').disabled = true;
            (0, $cd982ef93548d73b$export$9c1a45fa87f90634)(form);
        }
    });
}
if ($29327506a7da108f$var$updateGameBtn) {
    // Initialise the dropdowns and sliders
    const role = document.getElementById('role').value;
    let gameUpdateUitleenbaarDropDown;
    let gameUpdateLocatieDropDownValue;
    let gameUpdateKindgesprekDropDownValue;
    let gameUpdateVakkenDropDownValue;
    let gameUpdateLeerprofielDropDownValue;
    let gameUpdateExecutieveFunctieDropDownValue;
    let gameUpdateIsolatieDropDownValue;
    if (role === 'admin') {
        const gameLocatie = $29327506a7da108f$var$gameUpdateLocatieDropDown.dataset.gameLocatie;
        gameUpdateLocatieDropDownValue = (0, $e9351b49dacdb3de$export$18444686970a42c4)($29327506a7da108f$var$gameUpdateLocatieDropDown, gameLocatie);
        const gameKindgesprek = $29327506a7da108f$var$gameUpdateKindgesprekDropDown.dataset.gameKindgesprek;
        gameUpdateKindgesprekDropDownValue = (0, $e9351b49dacdb3de$export$77214a3ba76484c0)($29327506a7da108f$var$gameUpdateKindgesprekDropDown, gameKindgesprek);
        const gameVak = $29327506a7da108f$var$gameUpdateVakkenDropDown.dataset.gameVak;
        gameUpdateVakkenDropDownValue = (0, $e9351b49dacdb3de$export$bd4e270cafd52145)($29327506a7da108f$var$gameUpdateVakkenDropDown, gameVak, true);
        const gameLeerprofiel = $29327506a7da108f$var$gameUpdateLeerprofielDropDown.dataset.gameLeerprofiel;
        gameUpdateLeerprofielDropDownValue = (0, $e9351b49dacdb3de$export$841576e3d080987b)($29327506a7da108f$var$gameUpdateLeerprofielDropDown, gameLeerprofiel);
        const gameExecutieveFunctie = $29327506a7da108f$var$gameUpdateExecutieveFunctieDropDown.dataset.gameExecutievefunctie;
        gameUpdateExecutieveFunctieDropDownValue = (0, $e9351b49dacdb3de$export$72dec94571b996c5)($29327506a7da108f$var$gameUpdateExecutieveFunctieDropDown, gameExecutieveFunctie);
        const gameIsolatie = $29327506a7da108f$var$gameUpdateIsolatieDropDown.dataset.gameIsolatie;
        gameUpdateIsolatieDropDownValue = (0, $e9351b49dacdb3de$export$c7abf3a563086090)($29327506a7da108f$var$gameUpdateIsolatieDropDown, gameIsolatie);
        const gameUitleenbaar = $29327506a7da108f$var$uitleenbaarDropDown.dataset.gameUitleenbaar;
        gameUpdateUitleenbaarDropDown = (0, $e9351b49dacdb3de$export$6ec9326aba4fe8d7)($29327506a7da108f$var$uitleenbaarDropDown, gameUitleenbaar);
        const minSpelers = $29327506a7da108f$var$gameSpelersSlider.dataset.gameMinspelers;
        const maxSpelers = $29327506a7da108f$var$gameSpelersSlider.dataset.gameMaxspelers;
        $29327506a7da108f$var$gameSpelersSlider.noUiSlider.set([
            minSpelers,
            maxSpelers
        ]);
        const minLeeftijd = $29327506a7da108f$var$leeftijdSlider.dataset.gameMinleeftijd;
        const maxLeeftijd = $29327506a7da108f$var$leeftijdSlider.dataset.gameMaxleeftijd;
        $29327506a7da108f$var$leeftijdSlider.noUiSlider.set([
            minLeeftijd,
            maxLeeftijd
        ]);
    }
    if (role === 'user') {
        const gameUitleenbaar = $29327506a7da108f$var$uitleenbaarDropDown.dataset.gameUitleenbaar;
        gameUpdateUitleenbaarDropDown = (0, $e9351b49dacdb3de$export$6ec9326aba4fe8d7)($29327506a7da108f$var$uitleenbaarDropDown, gameUitleenbaar);
    }
    // Eventhandler for updating
    $29327506a7da108f$var$updateGameBtn.addEventListener('submit', (e)=>{
        e.preventDefault();
        const errorMessages = [];
        const form = new FormData();
        form.append('_id', document.getElementById('id').value);
        form.append('role', role);
        if (role === 'admin') {
            if (document.getElementById('gameNaam').value != '') form.append('naam', document.getElementById('gameNaam').value);
            else errorMessages.push('Er dient een naam te worden opgegeven.');
            if (gameUpdateLocatieDropDownValue.value() != '') form.append('locatie', gameUpdateLocatieDropDownValue.value());
            else errorMessages.push('Er dient een locatie te worden opgegeven.');
            if (gameUpdateIsolatieDropDownValue != '') form.append('isolatie', gameUpdateIsolatieDropDownValue.value());
            else errorMessages.push('Isolatie dient te worden opgegeven.');
            if (gameUpdateKindgesprekDropDownValue.value() == undefined || gameUpdateKindgesprekDropDownValue.value().length == 0) form.append('kindgesprek', '');
            else gameUpdateKindgesprekDropDownValue.value().forEach((kindgesprek, index)=>{
                form.append('kindgesprek[' + index + ']', kindgesprek);
            });
            if (gameUpdateLeerprofielDropDownValue.value() == undefined || gameUpdateLeerprofielDropDownValue.value().length == 0) form.append('leerprofiel', '');
            else gameUpdateLeerprofielDropDownValue.value().forEach((leerprofiel, index)=>{
                form.append('leerprofiel[' + index + ']', leerprofiel);
            });
            if (gameUpdateExecutieveFunctieDropDownValue.value() == undefined || gameUpdateExecutieveFunctieDropDownValue.value().length == 0) form.append('executieveFunctie', '');
            else gameUpdateExecutieveFunctieDropDownValue.value().forEach((executieveFunctie, index)=>{
                form.append('executieveFunctie[' + index + ']', executieveFunctie);
            });
            if (gameUpdateVakkenDropDownValue.value() == undefined || gameUpdateVakkenDropDownValue.value().length == 0) form.append('vak', '');
            else gameUpdateVakkenDropDownValue.value().forEach((vak, index)=>{
                form.append('vak[' + index + ']', vak);
            });
            form.append('beschrijving', document.getElementById('gameBeschrijving').value);
            form.append('uitleenbaar', gameUpdateUitleenbaarDropDown.value());
            form.append('minLeeftijd', $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[0]);
            form.append('maxLeeftijd', $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[1]);
            form.append('minSpelers', $29327506a7da108f$var$gameSpelersSlider.noUiSlider.get()[0]);
            form.append('maxSpelers', $29327506a7da108f$var$gameSpelersSlider.noUiSlider.get()[1]);
            if (document.getElementById('gameAfbeelding').files.length == 1) form.append('afbeelding', document.getElementById('gameAfbeelding').files[0]);
        }
        if (role === 'user') form.append('uitleenbaar', gameUpdateUitleenbaarDropDown.value());
        if (role === 'user' || role === 'admin') form.append('extraInformatie', document.getElementById('gameExtraInformatie').value);
        if (errorMessages.length != 0) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', errorMessages.join(' '), 5);
            document.getElementById('updateGame').value = 'Pas aan';
            document.getElementById('updateGame').disabled = false;
        } else {
            document.getElementById('updateGame').disabled = true;
            document.getElementById('updateGame').value = 'Updating...';
            (0, $cd982ef93548d73b$export$2a7976ab39c03e48)(form);
        }
    });
}
$29327506a7da108f$var$deleteGameBtns.forEach((deleteGameBtn)=>{
    if (deleteGameBtn) deleteGameBtn.addEventListener('click', (e)=>{
        const { gameId: gameId } = e.target.dataset;
        const choice = confirm(e.target.dataset.confirm);
        if (choice) (0, $cd982ef93548d73b$export$e5d662caddcef523)(gameId);
    });
});
// ***** GAMERESERVATIONS BUTTONS *****
if ($29327506a7da108f$var$gameReservationBtn) $29327506a7da108f$var$gameReservationBtn.addEventListener('click', (e)=>{
    const { gameId: gameId, userId: userId } = e.target.dataset;
    (0, $97e72fab7582660d$export$9b8f2347534a9be9)(userId, gameId);
});
$29327506a7da108f$var$deleteGameReservationBtns.forEach((deleteGameReservationBtn)=>{
    if (deleteGameReservationBtn) deleteGameReservationBtn.addEventListener('click', (e)=>{
        const { gamebookingId: gamebookingId, gameId: gameId } = e.currentTarget.dataset;
        (0, $97e72fab7582660d$export$2a4e2b736a1dcc9f)(gamebookingId, gameId);
    });
});
$29327506a7da108f$var$updateGameReservationBtns.forEach((updateGameReservationBtn)=>{
    if (updateGameReservationBtn) updateGameReservationBtn.addEventListener('click', (e)=>{
        const { gamebookingId: gamebookingId } = e.currentTarget.dataset;
        (0, $97e72fab7582660d$export$3029092f488b9534)(gamebookingId);
    });
});
// ***** DIDACTICMATERIAL BUTTONS *****
if ($29327506a7da108f$var$createDidacticMaterialBtn) {
    let locatieDropDownValue = (0, $e9351b49dacdb3de$export$18444686970a42c4)($29327506a7da108f$var$locatieDropDown);
    let vakkenDropDownValue = (0, $e9351b49dacdb3de$export$bd4e270cafd52145)($29327506a7da108f$var$vakDropDown, 'undefined', true);
    let niveauDropDownValue = (0, $e9351b49dacdb3de$export$8d0de60f0f916a94)($29327506a7da108f$var$niveauDropDown, 'undefined', true);
    let uitleenbaarDropDownValue = (0, $e9351b49dacdb3de$export$6ec9326aba4fe8d7)($29327506a7da108f$var$uitleenbaarDropDown);
    $29327506a7da108f$var$createDidacticMaterialBtn.addEventListener('submit', (e)=>{
        e.preventDefault();
        const errorMessages = [];
        const form = new FormData();
        if (document.getElementById('didacticMaterialNaam').value != '') form.append('naam', document.getElementById('didacticMaterialNaam').value);
        else errorMessages.push('Er dient een naam te worden opgegeven.');
        if (locatieDropDownValue.value() === '' || locatieDropDownValue.value() === undefined || locatieDropDownValue.value() === 'undefined') errorMessages.push('Er dient een locatie te worden opgegeven.');
        else form.append('locatie', locatieDropDownValue.value());
        if (vakkenDropDownValue.value() == undefined || vakkenDropDownValue.value().length == 0) form.append('vak', '');
        else vakkenDropDownValue.value().forEach((vak, index)=>{
            form.append('vak[' + index + ']', vak);
        });
        if (niveauDropDownValue.value() == undefined || niveauDropDownValue.value().length == 0) form.append('niveau', '');
        else niveauDropDownValue.value().forEach((niveau, index)=>{
            form.append('niveau[' + index + ']', niveau);
        });
        form.append('beschrijving', document.getElementById('didacticMaterialBeschrijving').value);
        form.append('extraInformatie', document.getElementById('didacticMaterialExtraInformatie').value);
        if (uitleenbaarDropDownValue.value() != undefined) form.append('uitleenbaar', uitleenbaarDropDownValue.value());
        if (document.getElementById('didacticMaterialAfbeelding').files.length == 1) form.append('afbeelding', document.getElementById('didacticMaterialAfbeelding').files[0]);
        if (errorMessages.length != 0) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', errorMessages.join(' '), 5);
            document.getElementById('createDidacticMaterial').value = 'Voeg toe';
            document.getElementById('createDidacticMaterial').disabled = false;
        } else {
            document.getElementById('createDidacticMaterial').value = 'Updating...';
            document.getElementById('createDidacticMaterial').disabled = true;
            (0, $a673f07f331b4e65$export$7856dcda102a774f)(form);
        }
    });
}
if ($29327506a7da108f$var$updateDidacticMaterialBtn) {
    // Initialise the dropdowns and sliders
    const role = document.getElementById('role').value;
    let uitleenbaarDropDownValue;
    let niveauDropDownValue;
    let vakkenDropDownValue;
    let locatieDropDownValue;
    if (role === 'admin') {
        const locatie = $29327506a7da108f$var$locatieDropDown.dataset.didactischmateriaalLocatie;
        locatieDropDownValue = (0, $e9351b49dacdb3de$export$18444686970a42c4)($29327506a7da108f$var$locatieDropDown, locatie);
        const vak = $29327506a7da108f$var$vakDropDown.dataset.didactischmateriaalVak;
        vakkenDropDownValue = (0, $e9351b49dacdb3de$export$bd4e270cafd52145)($29327506a7da108f$var$vakDropDown, vak, true);
        const niveau = $29327506a7da108f$var$niveauDropDown.dataset.didactischmateriaalNiveau;
        niveauDropDownValue = (0, $e9351b49dacdb3de$export$8d0de60f0f916a94)($29327506a7da108f$var$niveauDropDown, niveau, true);
        const uitleenbaar = $29327506a7da108f$var$uitleenbaarDropDown.dataset.didactischmateriaalUitleenbaar;
        uitleenbaarDropDownValue = (0, $e9351b49dacdb3de$export$6ec9326aba4fe8d7)($29327506a7da108f$var$uitleenbaarDropDown, uitleenbaar);
    }
    if (role === 'user') {
        const uitleenbaar = $29327506a7da108f$var$uitleenbaarDropDown.dataset.didactischmateriaalUitleenbaar;
        uitleenbaarDropDownValue = (0, $e9351b49dacdb3de$export$6ec9326aba4fe8d7)($29327506a7da108f$var$uitleenbaarDropDown, uitleenbaar);
    }
    $29327506a7da108f$var$updateDidacticMaterialBtn.addEventListener('submit', (e)=>{
        e.preventDefault();
        const errorMessages = [];
        const form = new FormData();
        form.append('_id', document.getElementById('id').value);
        form.append('role', role);
        if (role === 'admin') {
            if (document.getElementById('didacticMaterialNaam').value != '') form.append('naam', document.getElementById('didacticMaterialNaam').value);
            else errorMessages.push('Er dient een naam te worden opgegeven.');
            if (locatieDropDownValue.value() != '') form.append('locatie', locatieDropDownValue.value());
            else errorMessages.push('Er dient een locatie te worden opgegeven.');
            if (vakkenDropDownValue.value() == undefined || vakkenDropDownValue.value().length == 0) form.append('vak', '');
            else vakkenDropDownValue.value().forEach((vak, index)=>{
                form.append('vak[' + index + ']', vak);
            });
            if (niveauDropDownValue.value() == undefined || niveauDropDownValue.value().length == 0) form.append('niveau', '');
            else niveauDropDownValue.value().forEach((niveau, index)=>{
                form.append('niveau[' + index + ']', niveau);
            });
            form.append('beschrijving', document.getElementById('didacticMaterialBeschrijving').value);
            if (document.getElementById('didacticMaterialAfbeelding').files.length == 1) form.append('afbeelding', document.getElementById('didacticMaterialAfbeelding').files[0]);
            form.append('uitleenbaar', uitleenbaarDropDownValue.value());
        }
        if (role === 'user') form.append('uitleenbaar', uitleenbaarDropDownValue.value());
        if (role === 'user' || role === 'admin') form.append('extraInformatie', document.getElementById('didacticMaterialExtraInformatie').value);
        if (errorMessages.length != 0) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', errorMessages.join(' '), 5);
            document.getElementById('updateDidacticMaterial').value = 'Pas aan';
            document.getElementById('updateDidacticMaterial').disabled = false;
        } else {
            document.getElementById('updateDidacticMaterial').value = 'Updating...';
            document.getElementById('updateDidacticMaterial').disabled = true;
            (0, $a673f07f331b4e65$export$696d5b0683e1dd92)(form);
        }
    });
}
$29327506a7da108f$var$deleteDidacticMaterialBtns.forEach((deleteDidacticMaterialBtn)=>{
    if (deleteDidacticMaterialBtn) deleteDidacticMaterialBtn.addEventListener('click', (e)=>{
        const { didacticmaterialId: didacticmaterialId } = e.target.dataset;
        const choice = confirm(e.target.dataset.confirm);
        if (choice) (0, $a673f07f331b4e65$export$f1876dab6d6878d9)(didacticmaterialId);
    });
});
// ***** DIDACTICMATERIALRESERVATION BUTTONS *****
if ($29327506a7da108f$var$didacticMaterialReservationBtn) $29327506a7da108f$var$didacticMaterialReservationBtn.addEventListener('click', (e)=>{
    const { didacticmaterialId: didacticmaterialId, userId: userId } = e.target.dataset;
    (0, $97e72fab7582660d$export$af5039b866f8025b)(userId, didacticmaterialId);
});
$29327506a7da108f$var$deleteDidacticMaterialReservationBtns.forEach((deleteDidacticMaterialReservationBtn)=>{
    if (deleteDidacticMaterialReservationBtn) deleteDidacticMaterialReservationBtn.addEventListener('click', (e)=>{
        const { didacticmaterialbookingId: didacticmaterialbookingId, didacticmaterialId: didacticmaterialId } = e.currentTarget.dataset;
        (0, $97e72fab7582660d$export$3b954c12d0e6d349)(didacticmaterialbookingId, didacticmaterialId);
    });
});
// ***** LEARNINGBOOK BUTTONS *****
if ($29327506a7da108f$var$createLearningBookBtn) {
    let locatieDropDownValue = (0, $e9351b49dacdb3de$export$18444686970a42c4)($29327506a7da108f$var$locatieDropDown);
    let vakkenDropDownValue = (0, $e9351b49dacdb3de$export$bd4e270cafd52145)($29327506a7da108f$var$vakDropDown, 'undefined', true);
    let niveauDropDownValue = (0, $e9351b49dacdb3de$export$8d0de60f0f916a94)($29327506a7da108f$var$niveauDropDown, 'undefined', true);
    let uitleenbaarDropDownValue = (0, $e9351b49dacdb3de$export$6ec9326aba4fe8d7)($29327506a7da108f$var$uitleenbaarDropDown);
    let handleidingDropDownValue = (0, $e9351b49dacdb3de$export$19eb1dd3ff45e9b)($29327506a7da108f$var$handleidingDropDown);
    $29327506a7da108f$var$createLearningBookBtn.addEventListener('submit', (e)=>{
        e.preventDefault();
        const errorMessages = [];
        const form = new FormData();
        if (document.getElementById('learningBookNaam').value != '') form.append('naam', document.getElementById('learningBookNaam').value);
        else errorMessages.push('Er dient een naam te worden opgegeven.');
        if (locatieDropDownValue.value() === '' || locatieDropDownValue.value() === undefined || locatieDropDownValue.value() === 'undefined') errorMessages.push('Er dient een locatie te worden opgegeven.');
        else form.append('locatie', locatieDropDownValue.value());
        if (vakkenDropDownValue.value() == undefined || vakkenDropDownValue.value().length == 0) form.append('vak', '');
        else vakkenDropDownValue.value().forEach((vak, index)=>{
            form.append('vak[' + index + ']', vak);
        });
        if (niveauDropDownValue.value() == undefined || niveauDropDownValue.value().length == 0) form.append('niveau', '');
        else niveauDropDownValue.value().forEach((niveau, index)=>{
            form.append('niveau[' + index + ']', niveau);
        });
        if (handleidingDropDownValue.value() != undefined) form.append('handleiding', handleidingDropDownValue.value());
        else errorMessages.push('Er dient te worden opgegeven of er een handleiding aanwezig is.');
        form.append('beschrijving', document.getElementById('learningBookBeschrijving').value);
        form.append('extraInformatie', document.getElementById('learningBookExtraInformatie').value);
        form.append('jaarUitgave', document.getElementById('learningBookJaarUitgave').value);
        if (uitleenbaarDropDownValue.value() != undefined) form.append('uitleenbaar', uitleenbaarDropDownValue.value());
        if (document.getElementById('learningBookAfbeelding').files.length == 1) form.append('afbeelding', document.getElementById('learningBookAfbeelding').files[0]);
        if (errorMessages.length != 0) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', errorMessages.join(' '), 5);
            document.getElementById('createLearningBook').value = 'Voeg toe';
            document.getElementById('createLearningBook').disabled = false;
        } else {
            document.getElementById('createLearningBook').value = 'Updating...';
            document.getElementById('createLearningBook').disabled = true;
            (0, $8ffaf538a50e3471$export$7d4f9cbad33e58b3)(form);
        }
    });
}
if ($29327506a7da108f$var$updateLearningBookBtn) {
    // Initialise the dropdowns and sliders
    const role = document.getElementById('role').value;
    let uitleenbaarDropDownValue;
    let niveauDropDownValue;
    let vakkenDropDownValue;
    let locatieDropDownValue;
    let handleidingDropDownValue;
    if (role === 'admin') {
        const locatie = $29327506a7da108f$var$locatieDropDown.dataset.leerboekLocatie;
        locatieDropDownValue = (0, $e9351b49dacdb3de$export$18444686970a42c4)($29327506a7da108f$var$locatieDropDown, locatie);
        const vak = $29327506a7da108f$var$vakDropDown.dataset.leerboekVak;
        vakkenDropDownValue = (0, $e9351b49dacdb3de$export$bd4e270cafd52145)($29327506a7da108f$var$vakDropDown, vak, true);
        const niveau = $29327506a7da108f$var$niveauDropDown.dataset.leerboekNiveau;
        niveauDropDownValue = (0, $e9351b49dacdb3de$export$8d0de60f0f916a94)($29327506a7da108f$var$niveauDropDown, niveau, true);
        const uitleenbaar = $29327506a7da108f$var$uitleenbaarDropDown.dataset.leerboekUitleenbaar;
        uitleenbaarDropDownValue = (0, $e9351b49dacdb3de$export$6ec9326aba4fe8d7)($29327506a7da108f$var$uitleenbaarDropDown, uitleenbaar);
        const handleiding = $29327506a7da108f$var$handleidingDropDown.dataset.leerboekHandleiding;
        handleidingDropDownValue = (0, $e9351b49dacdb3de$export$19eb1dd3ff45e9b)($29327506a7da108f$var$handleidingDropDown, handleiding);
    }
    if (role === 'user') {
        const uitleenbaar = $29327506a7da108f$var$uitleenbaarDropDown.dataset.leerboekUitleenbaar;
        uitleenbaarDropDownValue = (0, $e9351b49dacdb3de$export$6ec9326aba4fe8d7)($29327506a7da108f$var$uitleenbaarDropDown, uitleenbaar);
    }
    $29327506a7da108f$var$updateLearningBookBtn.addEventListener('submit', (e)=>{
        e.preventDefault();
        const errorMessages = [];
        const form = new FormData();
        form.append('_id', document.getElementById('id').value);
        form.append('role', role);
        if (role === 'admin') {
            if (document.getElementById('learningBookNaam').value != '') form.append('naam', document.getElementById('learningBookNaam').value);
            else errorMessages.push('Er dient een naam te worden opgegeven.');
            if (locatieDropDownValue.value() != '') form.append('locatie', locatieDropDownValue.value());
            else errorMessages.push('Er dient een locatie te worden opgegeven.');
            if (vakkenDropDownValue.value() == undefined || vakkenDropDownValue.value().length == 0) form.append('vak', '');
            else vakkenDropDownValue.value().forEach((vak, index)=>{
                form.append('vak[' + index + ']', vak);
            });
            if (niveauDropDownValue.value() == undefined || niveauDropDownValue.value().length == 0) form.append('niveau', '');
            else niveauDropDownValue.value().forEach((niveau, index)=>{
                form.append('niveau[' + index + ']', niveau);
            });
            form.append('beschrijving', document.getElementById('learningBookBeschrijving').value);
            form.append('jaarUitgave', document.getElementById('learningBookJaarUitgave').value);
            if (document.getElementById('learningBookAfbeelding').files.length == 1) form.append('afbeelding', document.getElementById('learningBookAfbeelding').files[0]);
            form.append('uitleenbaar', uitleenbaarDropDownValue.value());
            form.append('handleiding', handleidingDropDownValue.value());
        }
        if (role === 'user') form.append('uitleenbaar', uitleenbaarDropDownValue.value());
        if (role === 'user' || role === 'admin') form.append('extraInformatie', document.getElementById('learningBookExtraInformatie').value);
        if (errorMessages.length != 0) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', errorMessages.join(' '), 5);
            document.getElementById('updateLearningBook').value = 'Pas aan';
            document.getElementById('updateLearningBook').disabled = false;
        } else {
            document.getElementById('updateLearningBook').value = 'Updating...';
            document.getElementById('updateLearningBook').disabled = true;
            (0, $8ffaf538a50e3471$export$8f85d7239543baff)(form);
        }
    });
}
$29327506a7da108f$var$deleteLearningBookBtns.forEach((deleteLearningBookBtn)=>{
    if (deleteLearningBookBtn) deleteLearningBookBtn.addEventListener('click', (e)=>{
        const { learningbookId: learningbookId } = e.target.dataset;
        const choice = confirm(e.target.dataset.confirm);
        if (choice) (0, $8ffaf538a50e3471$export$50ce213ed62b9ab0)(learningbookId);
    });
});
// ***** LEARNINGBOOKRESERVATION BUTTONS *****
if ($29327506a7da108f$var$learningBookReservationBtn) $29327506a7da108f$var$learningBookReservationBtn.addEventListener('click', (e)=>{
    const { learningbookId: learningbookId, userId: userId } = e.target.dataset;
    (0, $97e72fab7582660d$export$8a88153ac8ec8461)(userId, learningbookId);
});
$29327506a7da108f$var$deleteLearningBookReservationBtns.forEach((deleteLearningBookReservationBtn)=>{
    if (deleteLearningBookReservationBtn) deleteLearningBookReservationBtn.addEventListener('click', (e)=>{
        const { learningbookbookingId: learningbookbookingId, learningbookId: learningbookId } = e.currentTarget.dataset;
        (0, $97e72fab7582660d$export$f82dec1db363b56c)(learningbookbookingId, learningbookId);
    });
});
// ***** READINGANDPICTUREBOOK BUTTONS *****
if ($29327506a7da108f$var$createReadingAndPictureBookBtn) {
    let isolatieDropDownValue = (0, $e9351b49dacdb3de$export$c7abf3a563086090)($29327506a7da108f$var$isolatieDropDown);
    let locatieDropDownValue = (0, $e9351b49dacdb3de$export$18444686970a42c4)($29327506a7da108f$var$locatieDropDown);
    let uitleenbaarDropDownValue = (0, $e9351b49dacdb3de$export$6ec9326aba4fe8d7)($29327506a7da108f$var$uitleenbaarDropDown);
    $29327506a7da108f$var$createReadingAndPictureBookBtn.addEventListener('submit', (e)=>{
        e.preventDefault();
        const errorMessages = [];
        const form = new FormData();
        if (document.getElementById('readingAndPictureBookNaam').value != '') form.append('naam', document.getElementById('readingAndPictureBookNaam').value);
        else errorMessages.push('Er dient een naam te worden opgegeven.');
        if (locatieDropDownValue.value() === '' || locatieDropDownValue.value() === undefined || locatieDropDownValue.value() === 'undefined') errorMessages.push('Er dient een locatie te worden opgegeven.');
        else form.append('locatie', locatieDropDownValue.value());
        if (isolatieDropDownValue.value() === '' || isolatieDropDownValue.value() === undefined || isolatieDropDownValue.value() === 'undefined') errorMessages.push('Isolatie dient te worden opgegeven.');
        else form.append('isolatie', isolatieDropDownValue.value());
        form.append('beschrijving', document.getElementById('readingAndPictureBookBeschrijving').value);
        form.append('extraInformatie', document.getElementById('readingAndPictureBookExtraInformatie').value);
        if (uitleenbaarDropDownValue.value() != undefined) form.append('uitleenbaar', uitleenbaarDropDownValue.value());
        form.append('minLeeftijd', $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[0]);
        form.append('maxLeeftijd', $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[1]);
        if (document.getElementById('readingAndPictureBookAfbeelding').files.length == 1) form.append('afbeelding', document.getElementById('readingAndPictureBookAfbeelding').files[0]);
        if (errorMessages.length != 0) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', errorMessages.join(' '), 5);
            document.getElementById('createReadingAndPictureBook').value = 'Voeg toe';
            document.getElementById('createReadingAndPictureBook').disabled = false;
        } else {
            document.getElementById('createReadingAndPictureBook').value = 'Updating...';
            document.getElementById('createReadingAndPictureBook').disabled = true;
            (0, $c965e34cfa1f2763$export$4c5224da3115d2b9)(form);
        }
    });
}
if ($29327506a7da108f$var$updateReadingAndPictureBookBtn) {
    // Initialise the dropdowns and sliders
    const role = document.getElementById('role').value;
    let uitleenbaarDropDownValue;
    let locatieDropDownValue;
    let isolatieDropDownValue;
    if (role === 'admin') {
        const locatie = $29327506a7da108f$var$locatieDropDown.dataset.leesenprentenboekLocatie;
        locatieDropDownValue = (0, $e9351b49dacdb3de$export$18444686970a42c4)($29327506a7da108f$var$locatieDropDown, locatie);
        const isolatie = $29327506a7da108f$var$isolatieDropDown.dataset.leesenprentenboekIsolatie;
        isolatieDropDownValue = (0, $e9351b49dacdb3de$export$c7abf3a563086090)($29327506a7da108f$var$isolatieDropDown, isolatie);
        const uitleenbaar = $29327506a7da108f$var$uitleenbaarDropDown.dataset.leesenprentenboekUitleenbaar;
        uitleenbaarDropDownValue = (0, $e9351b49dacdb3de$export$6ec9326aba4fe8d7)($29327506a7da108f$var$uitleenbaarDropDown, uitleenbaar);
        const minLeeftijd = $29327506a7da108f$var$leeftijdSlider.dataset.leesenprentenboekMinleeftijd;
        const maxLeeftijd = $29327506a7da108f$var$leeftijdSlider.dataset.leesenprentenboekMaxleeftijd;
        $29327506a7da108f$var$leeftijdSlider.noUiSlider.set([
            minLeeftijd,
            maxLeeftijd
        ]);
    }
    if (role === 'user') {
        const uitleenbaar = $29327506a7da108f$var$uitleenbaarDropDown.dataset.leesenprentenboekUitleenbaar;
        uitleenbaarDropDownValue = (0, $e9351b49dacdb3de$export$6ec9326aba4fe8d7)($29327506a7da108f$var$uitleenbaarDropDown, uitleenbaar);
    }
    // Eventhandler for updating
    $29327506a7da108f$var$updateReadingAndPictureBookBtn.addEventListener('submit', (e)=>{
        e.preventDefault();
        const errorMessages = [];
        const form = new FormData();
        form.append('_id', document.getElementById('id').value);
        form.append('role', role);
        if (role === 'admin') {
            if (document.getElementById('readingAndPictureBookNaam').value != '') form.append('naam', document.getElementById('readingAndPictureBookNaam').value);
            else errorMessages.push('Er dient een naam te worden opgegeven.');
            if (locatieDropDownValue.value() != '') form.append('locatie', locatieDropDownValue.value());
            else errorMessages.push('Er dient een locatie te worden opgegeven.');
            if (isolatieDropDownValue != '') form.append('isolatie', isolatieDropDownValue.value());
            else errorMessages.push('Isolatie dient te worden opgegeven.');
            form.append('beschrijving', document.getElementById('readingAndPictureBookBeschrijving').value);
            form.append('uitleenbaar', uitleenbaarDropDownValue.value());
            form.append('minLeeftijd', $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[0]);
            form.append('maxLeeftijd', $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[1]);
            if (document.getElementById('readingAndPictureBookAfbeelding').files.length == 1) form.append('afbeelding', document.getElementById('readingAndPictureBookAfbeelding').files[0]);
        }
        if (role === 'user') form.append('uitleenbaar', uitleenbaarDropDownValue.value());
        if (role === 'user' || role === 'admin') form.append('extraInformatie', document.getElementById('readingAndPictureBookExtraInformatie').value);
        if (errorMessages.length != 0) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', errorMessages.join(' '), 5);
            document.getElementById('updateReadingAndPictureBook').value = 'Pas aan';
            document.getElementById('updateReadingAndPictureBook').disabled = false;
        } else {
            document.getElementById('updateReadingAndPictureBook').value = 'Updating...';
            document.getElementById('updateReadingAndPictureBook').disabled = true;
            (0, $c965e34cfa1f2763$export$a75aafadbe1c7f5d)(form);
        }
    });
}
$29327506a7da108f$var$deleteReadingAndPictureBookBtns.forEach((deleteReadingAndPictureBookBtn)=>{
    if (deleteReadingAndPictureBookBtn) deleteReadingAndPictureBookBtn.addEventListener('click', (e)=>{
        const { readingandpicturebookId: readingandpicturebookId } = e.target.dataset;
        const choice = confirm(e.target.dataset.confirm);
        if (choice) (0, $c965e34cfa1f2763$export$316e3d2b823f3dd9)(readingandpicturebookId);
    });
});
// ***** READINGANDPICTUREBOOKRESERVATION BUTTONS *****
if ($29327506a7da108f$var$readingAndPictureBookReservationBtn) $29327506a7da108f$var$readingAndPictureBookReservationBtn.addEventListener('click', (e)=>{
    const { readingandpicturebookId: readingandpicturebookId, userId: userId } = e.target.dataset;
    (0, $97e72fab7582660d$export$9b41f7c8fbe19296)(userId, readingandpicturebookId);
});
$29327506a7da108f$var$deleteReadingAndPictureBookReservationBtns.forEach((deleteReadingAndPictureBookReservationBtn)=>{
    if (deleteReadingAndPictureBookReservationBtn) deleteReadingAndPictureBookReservationBtn.addEventListener('click', (e)=>{
        const { readingandpicturebookbookingId: readingandpicturebookbookingId, readingandpicturebookId: readingandpicturebookId } = e.currentTarget.dataset;
        (0, $97e72fab7582660d$export$e0fdf5f754ea8c87)(readingandpicturebookbookingId, readingandpicturebookId);
    });
});
// ***** INFORMATIVEBOOK BUTTONS *****
if ($29327506a7da108f$var$createInformativeBookBtn) {
    let kindgesprekDropDownValue = (0, $e9351b49dacdb3de$export$77214a3ba76484c0)($29327506a7da108f$var$kindgesprekDropDown);
    let locatieDropDownValue = (0, $e9351b49dacdb3de$export$18444686970a42c4)($29327506a7da108f$var$locatieDropDown);
    let uitleenbaarDropDownValue = (0, $e9351b49dacdb3de$export$6ec9326aba4fe8d7)($29327506a7da108f$var$uitleenbaarDropDown);
    let leerprofielDropDownValue = (0, $e9351b49dacdb3de$export$841576e3d080987b)($29327506a7da108f$var$leerprofielDropDown);
    $29327506a7da108f$var$createInformativeBookBtn.addEventListener('submit', (e)=>{
        e.preventDefault();
        const errorMessages = [];
        const form = new FormData();
        if (document.getElementById('informativeBookNaam').value != '') form.append('naam', document.getElementById('informativeBookNaam').value);
        else errorMessages.push('Er dient een naam te worden opgegeven.');
        if (locatieDropDownValue.value() === '' || locatieDropDownValue.value() === undefined || locatieDropDownValue.value() === 'undefined') errorMessages.push('Er dient een locatie te worden opgegeven.');
        else form.append('locatie', locatieDropDownValue.value());
        if (kindgesprekDropDownValue.value() == undefined || kindgesprekDropDownValue.value().length == 0) form.append('kindgesprek', '');
        else kindgesprekDropDownValue.value().forEach((kindgesprek, index)=>{
            form.append('kindgesprek[' + index + ']', kindgesprek);
        });
        if (leerprofielDropDownValue.value() == undefined || leerprofielDropDownValue.value().length == 0) form.append('leerprofiel', '');
        else leerprofielDropDownValue.value().forEach((leerprofiel, index)=>{
            form.append('leerprofiel[' + index + ']', leerprofiel);
        });
        form.append('beschrijving', document.getElementById('informativeBookBeschrijving').value);
        form.append('extraInformatie', document.getElementById('informativeBookExtraInformatie').value);
        form.append('jaarUitgave', document.getElementById('informativeBookJaarUitgave').value);
        if (uitleenbaarDropDownValue.value() != undefined) form.append('uitleenbaar', uitleenbaarDropDownValue.value());
        if (document.getElementById('informativeBookAfbeelding').files.length == 1) form.append('afbeelding', document.getElementById('informativeBookAfbeelding').files[0]);
        if (errorMessages.length != 0) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', errorMessages.join(' '), 5);
            document.getElementById('createInformativeBook').value = 'Voeg toe';
            document.getElementById('createInformativeBook').disabled = false;
        } else {
            document.getElementById('createInformativeBook').value = 'Updating...';
            document.getElementById('createInformativeBook').disabled = true;
            (0, $09919c021e3c55d2$export$d32fbee3742ef204)(form);
        }
    });
}
if ($29327506a7da108f$var$updateInformativeBookBtn) {
    // Initialise the dropdowns and sliders
    const role = document.getElementById('role').value;
    let uitleenbaarDropDownValue;
    let locatieDropDownValue;
    let kindgesprekDropDownValue;
    let leerprofielDropDownValue;
    if (role === 'admin') {
        const locatie = $29327506a7da108f$var$locatieDropDown.dataset.informatiefboekLocatie;
        locatieDropDownValue = (0, $e9351b49dacdb3de$export$18444686970a42c4)($29327506a7da108f$var$locatieDropDown, locatie);
        const uitleenbaar = $29327506a7da108f$var$uitleenbaarDropDown.dataset.informatiefboekUitleenbaar;
        uitleenbaarDropDownValue = (0, $e9351b49dacdb3de$export$6ec9326aba4fe8d7)($29327506a7da108f$var$uitleenbaarDropDown, uitleenbaar);
        const kindgesprek = $29327506a7da108f$var$kindgesprekDropDown.dataset.informatiefboekindgesprek;
        kindgesprekDropDownValue = (0, $e9351b49dacdb3de$export$77214a3ba76484c0)($29327506a7da108f$var$kindgesprekDropDown, kindgesprek);
        const leerprofiel = $29327506a7da108f$var$leerprofielDropDown.dataset.informatiefboekLeerprofiel;
        leerprofielDropDownValue = (0, $e9351b49dacdb3de$export$841576e3d080987b)($29327506a7da108f$var$leerprofielDropDown, leerprofiel);
    }
    if (role === 'user') {
        const uitleenbaar = $29327506a7da108f$var$uitleenbaarDropDown.dataset.informatiefboekUitleenbaar;
        uitleenbaarDropDownValue = (0, $e9351b49dacdb3de$export$6ec9326aba4fe8d7)($29327506a7da108f$var$uitleenbaarDropDown, uitleenbaar);
    }
    $29327506a7da108f$var$updateInformativeBookBtn.addEventListener('submit', (e)=>{
        e.preventDefault();
        const errorMessages = [];
        const form = new FormData();
        form.append('_id', document.getElementById('id').value);
        form.append('role', role);
        if (role === 'admin') {
            if (document.getElementById('informativeBookNaam').value != '') form.append('naam', document.getElementById('informativeBookNaam').value);
            else errorMessages.push('Er dient een naam te worden opgegeven.');
            if (locatieDropDownValue.value() != '') form.append('locatie', locatieDropDownValue.value());
            else errorMessages.push('Er dient een locatie te worden opgegeven.');
            form.append('kindgesprek', kindgesprekDropDownValue.value());
            form.append('leerprofiel', leerprofielDropDownValue.value());
            form.append('beschrijving', document.getElementById('informativeBookBeschrijving').value);
            form.append('jaarUitgave', document.getElementById('informativeBookJaarUitgave').value);
            if (document.getElementById('informativeBookAfbeelding').files.length == 1) form.append('afbeelding', document.getElementById('informativeBookAfbeelding').files[0]);
            form.append('uitleenbaar', uitleenbaarDropDownValue.value());
        }
        if (role === 'user') form.append('uitleenbaar', uitleenbaarDropDownValue.value());
        if (role === 'user' || role === 'admin') form.append('extraInformatie', document.getElementById('informativeBookExtraInformatie').value);
        if (errorMessages.length != 0) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', errorMessages.join(' '), 5);
            document.getElementById('updateInformativeBook').value = 'Pas aan';
            document.getElementById('updateInformativeBook').disabled = false;
        } else {
            document.getElementById('updateInformativeBook').value = 'Updating...';
            document.getElementById('updateInformativeBook').disabled = true;
            (0, $09919c021e3c55d2$export$114d2caabdf67d90)(form);
        }
    });
}
$29327506a7da108f$var$deleteInformativeBookBtns.forEach((deleteInformativeBookBtn)=>{
    if (deleteInformativeBookBtn) deleteInformativeBookBtn.addEventListener('click', (e)=>{
        const { informativebookId: informativebookId } = e.target.dataset;
        const choice = confirm(e.target.dataset.confirm);
        if (choice) (0, $09919c021e3c55d2$export$daee55bd8346dd9d)(informativebookId);
    });
});
// ***** INFORMATIVEBOOKRESERVATION BUTTONS *****
if ($29327506a7da108f$var$informativeBookReservationBtn) $29327506a7da108f$var$informativeBookReservationBtn.addEventListener('click', (e)=>{
    const { informativebookId: informativebookId, userId: userId } = e.target.dataset;
    (0, $97e72fab7582660d$export$1996c4600e8f05a4)(userId, informativebookId);
});
$29327506a7da108f$var$deleteInformativeBookReservationBtns.forEach((deleteInformativeBookReservationBtn)=>{
    if (deleteInformativeBookReservationBtn) deleteInformativeBookReservationBtn.addEventListener('click', (e)=>{
        const { informativebookbookingId: informativebookbookingId, informativebookId: informativebookId } = e.currentTarget.dataset;
        (0, $97e72fab7582660d$export$b1d8e3261b652d5c)(informativebookbookingId, informativebookId);
    });
});
// ***** USER BUTTONS *****
if ($29327506a7da108f$var$createUserBtn) {
    let userDepartmentDropDownValue = (0, $e9351b49dacdb3de$export$4014023b4d854e4b)($29327506a7da108f$var$userDepartmentDropDown);
    $29327506a7da108f$var$createUserBtn.addEventListener('submit', async (e)=>{
        e.preventDefault();
        const errorMessages = [];
        const form = new FormData();
        if (document.getElementById('userNaam').value != '') form.append('name', document.getElementById('userNaam').value);
        else errorMessages.push('Er dient een naam te worden opgegeven.');
        if (document.getElementById('userEmail').value != '') form.append('email', document.getElementById('userEmail').value);
        else errorMessages.push('Er dient een e-mail te worden opgegeven.');
        if (userDepartmentDropDownValue.value() == undefined || userDepartmentDropDownValue.value().length == 0) form.append('department', '');
        else userDepartmentDropDownValue.value().forEach((department)=>{
            form.append('department', department);
        });
        const password = document.getElementById('userPaswoord').value;
        const passwordConfirm = document.getElementById('userPaswoordBevestig').value;
        if (password != passwordConfirm || password == '' || passwordConfirm == '') errorMessages.push('De paswoorden moeten gelijk zijn en minstens uit 8 tekens bestaan.');
        else {
            form.append('password', password);
            form.append('passwordConfirm', passwordConfirm);
        }
        if (errorMessages.length != 0) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', errorMessages.join(' '), 5);
            document.getElementById('createUser').value = 'Voeg toe';
            document.getElementById('createUser').disabled = false;
        } else {
            document.getElementById('createUser').value = 'Updating...';
            document.getElementById('createUser').disabled = true;
            await (0, $f9cbaefb61efebd4$export$3493b8991d49f558)(form);
        }
    });
}
if ($29327506a7da108f$var$updateUserBtn) {
    const userRol = $29327506a7da108f$var$userUpdateRolDropDown.dataset.userRol;
    let userUpdateRolDropDownValue = (0, $e9351b49dacdb3de$export$1eec3e886f01dfe2)($29327506a7da108f$var$userUpdateRolDropDown, userRol);
    const userDepartment = $29327506a7da108f$var$userUpdateDepartmentDropDown.dataset.userDepartment;
    let userUpdateDepartmentDropDownValue = (0, $e9351b49dacdb3de$export$4014023b4d854e4b)($29327506a7da108f$var$userUpdateDepartmentDropDown, userDepartment);
    $29327506a7da108f$var$updateUserBtn.addEventListener('submit', (e)=>{
        e.preventDefault();
        const errorMessages = [];
        const form = new FormData();
        form.append('_id', document.getElementById('id').value);
        if (document.getElementById('userNaam').value != '') form.append('name', document.getElementById('userNaam').value);
        else errorMessages.push('Er dient een naam te worden gegeven.');
        if (userUpdateDepartmentDropDownValue.value() == undefined || userUpdateDepartmentDropDownValue.value().length == 0) form.append('department', '');
        else userUpdateDepartmentDropDownValue.value().forEach((department)=>{
            form.append('department', department);
        });
        form.append('role', userUpdateRolDropDownValue.value());
        if (errorMessages.length != 0) {
            (0, $3a240f7f35a56d48$export$de026b00723010c1)('error', errorMessages.join(' '), 5);
            document.getElementById('updateUser').value = 'Pas aan';
            document.getElementById('updateUser').disabled = false;
        } else {
            document.getElementById('updateUser').value = 'Updating...';
            document.getElementById('updateUser').disabled = true;
            (0, $f9cbaefb61efebd4$export$e3ac7a5d19605772)(form);
        }
    });
}
$29327506a7da108f$var$deleteUserBtns.forEach((deleteUserBtn)=>{
    if (deleteUserBtn) deleteUserBtn.addEventListener('click', (e)=>{
        const { userId: userId } = e.target.dataset;
        const choice = confirm(e.target.dataset.confirm);
        if (choice) (0, $f9cbaefb61efebd4$export$7d0f10f273c0438a)(userId);
    });
});
// ***** FILTERS *****
// TODO: voeg sorteren toe
if ($29327506a7da108f$var$filterVirtualRealityAppsBtn) $29327506a7da108f$var$filterVirtualRealityAppsBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    const beschrijving = document.getElementById('virtualRealityApps-description-search').value;
    const vakken = document.getElementById('virtualRealityApps-courses-search');
    const vakkenIndex = vakken.selectedIndex;
    const vakkenValue = vakken.options[vakkenIndex].value;
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-beschrijving-virtualRealityApp', beschrijving);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-vak-virtualRealityApp', vakkenIndex);
    window.location = `/virtualRealityApps/overview?naam=${beschrijving}&beschrijving=${beschrijving}&vak=${vakkenValue}`;
}, window.addEventListener('load', ()=>{
    const beschrijvingCookie = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-beschrijving-virtualRealityApp', {
        expires: 1 / 24
    });
    if (beschrijvingCookie != null) document.getElementById('virtualRealityApps-description-search').value = beschrijvingCookie;
    document.getElementById('virtualRealityApps-courses-search').selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-vak-virtualRealityApp', {
        expires: 1 / 24
    });
}));
if ($29327506a7da108f$var$resetFilterVirtualRealityAppsBtn) $29327506a7da108f$var$resetFilterVirtualRealityAppsBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    //Set values to default
    document.getElementById('virtualRealityApps-description-search').value = '';
    document.getElementById('virtualRealityApps-courses-search').selectedIndex = 0;
    //Remove cookies
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-beschrijving-virtualRealityApp');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-vak-virtualRealityApp');
    window.location = '/virtualRealityApps/overview';
});
if ($29327506a7da108f$var$filterDidacticMaterialBtn) $29327506a7da108f$var$filterDidacticMaterialBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    const beschrijving = document.getElementById('didacticMaterial-description-search').value;
    const niveau = document.getElementById('didacticMaterial-grade-search');
    const niveauIndex = niveau.selectedIndex;
    const niveauValue = niveau.options[niveauIndex].value;
    const locatie = document.getElementById('didacticMaterial-location-search');
    const locatieIndex = locatie.selectedIndex;
    const locatieValue = locatie.options[locatieIndex].value;
    const vakken = document.getElementById('didacticMaterial-courses-search');
    const vakkenIndex = vakken.selectedIndex;
    const vakkenValue = vakken.options[vakkenIndex].value;
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-beschrijving-didactischMateriaal', beschrijving);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-niveau-didactischMateriaal', niveauIndex);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-locatie-didactischMateriaal', locatieIndex);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-vak-didactischMateriaal', vakkenIndex);
    window.location = `/didacticMaterials/overview?naam=${beschrijving}&beschrijving=${beschrijving}&locatie=${locatieValue}&vak=${vakkenValue}&niveau=${niveauValue}`;
}, window.addEventListener('load', ()=>{
    const beschrijvingCookie = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-beschrijving-didactischMateriaal', {
        expires: 1 / 24
    });
    if (beschrijvingCookie != null) document.getElementById('didacticMaterial-description-search').value = beschrijvingCookie;
    document.getElementById('didacticMaterial-location-search').selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-locatie-didactischMateriaal', {
        expires: 1 / 24
    });
    document.getElementById('didacticMaterial-courses-search').selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-vak-didactischMateriaal', {
        expires: 1 / 24
    });
    document.getElementById('didacticMaterial-grade-search').selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-niveau-didactischMateriaal', {
        expires: 1 / 24
    });
}));
if ($29327506a7da108f$var$resetFilterDidacticMaterialBtn) $29327506a7da108f$var$resetFilterDidacticMaterialBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    //Set values to default
    document.getElementById('didacticMaterial-description-search').value = '';
    document.getElementById('didacticMaterial-grade-search').selectedIndex = 0;
    document.getElementById('didacticMaterial-location-search').selectedIndex = 0;
    document.getElementById('didacticMaterial-courses-search').selectedIndex = 0;
    //Remove cookies
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-beschrijving-didactischMateriaal');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-locatie-didactischMateriaal');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-niveau-didactischMateriaal');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-vak-didactischMateriaal');
    window.location = '/didacticMaterials/overview';
});
if ($29327506a7da108f$var$filterGamesBtn) $29327506a7da108f$var$filterGamesBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    const beschrijving = document.getElementById('games-description-search').value;
    const location = document.getElementById('games-location-search');
    const locationIndex = location.selectedIndex;
    const locationValue = location.options[locationIndex].value;
    const vakken = document.getElementById('games-courses-search');
    const vakkenIndex = vakken.selectedIndex;
    const vakkenValue = vakken.options[vakkenIndex].value;
    const executieveFuncties = document.getElementById('games-executieve-functies-search');
    const executieveFunctiesIndex = executieveFuncties.selectedIndex;
    const executieveFunctiesValue = executieveFuncties.options[executieveFunctiesIndex].value;
    const leerprofiel = document.getElementById('games-leerprofiel-search');
    const leerprofielIndex = leerprofiel.selectedIndex;
    const leerprofielValue = leerprofiel.options[leerprofielIndex].value;
    const minLeeftijd = $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[0];
    const maxLeeftijd = $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[1];
    const minSpelers = $29327506a7da108f$var$gameSpelersSlider.noUiSlider.get()[0];
    const maxSpelers = $29327506a7da108f$var$gameSpelersSlider.noUiSlider.get()[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-beschrijving', beschrijving);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-location', locationIndex);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-vakken', vakkenIndex);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-leerprofiel', leerprofielIndex);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-executieveFuncties', executieveFunctiesIndex);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-leeftijd', JSON.stringify([
        minLeeftijd,
        maxLeeftijd
    ]));
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-spelers', JSON.stringify([
        minSpelers,
        maxSpelers
    ]));
    window.location = `/games/overview?naam=${beschrijving}&beschrijving=${beschrijving}&locatie=${locationValue}&executieveFunctie=${executieveFunctiesValue}&vak=${vakkenValue}&leerprofiel=${leerprofielValue}&minLeeftijd=${minLeeftijd}&maxLeeftijd=${maxLeeftijd}&minSpelers=${minSpelers}&maxSpelers=${maxSpelers}`;
}, window.addEventListener('load', ()=>{
    const beschrijvingCookie = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-beschrijving', {
        expires: 1 / 24
    });
    if (beschrijvingCookie != null) document.getElementById('games-description-search').value = beschrijvingCookie;
    document.getElementById('games-location-search').selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-location', {
        expires: 1 / 24
    });
    document.getElementById('games-courses-search').selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-vakken', {
        expires: 1 / 24
    });
    document.getElementById('games-leerprofiel-search').selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-leerprofiel', {
        expires: 1 / 24
    });
    document.getElementById('games-executieve-functies-search').selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-executieveFuncties', {
        expires: 1 / 24
    });
    const leeftijdCookieValue = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-leeftijd', {
        expires: 1 / 24
    });
    if (leeftijdCookieValue != null) {
        const leeftijdCookie = JSON.parse(leeftijdCookieValue);
        if (parseInt(leeftijdCookie[0], 10) != 1 || parseInt(leeftijdCookie[1], 10) != 99) $29327506a7da108f$var$leeftijdSlider.noUiSlider.set([
            parseInt(leeftijdCookie[0], 10),
            parseInt(leeftijdCookie[1], 10)
        ]);
    }
    const spelersCookieValue = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-spelers', {
        expires: 1 / 24
    });
    if (spelersCookieValue != null) {
        const spelersCookie = JSON.parse(spelersCookieValue);
        if (parseInt(spelersCookie[0], 10) != 1 || parseInt(spelersCookie[1], 10) != 10) $29327506a7da108f$var$gameSpelersSlider.noUiSlider.set([
            parseInt(spelersCookie[0], 10),
            parseInt(spelersCookie[1], 10)
        ]);
    }
}));
if ($29327506a7da108f$var$resetFilterGamesBtn) $29327506a7da108f$var$resetFilterGamesBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    //Set values to default
    document.getElementById('games-description-search').value = '';
    document.getElementById('games-location-search').selectedIndex = 0;
    document.getElementById('games-courses-search').selectedIndex = 0;
    document.getElementById('games-leerprofiel-search').selectedIndex = 0;
    document.getElementById('games-executieve-functies-search').selectedIndex = 0;
    $29327506a7da108f$var$leeftijdSlider.noUiSlider.reset();
    $29327506a7da108f$var$gameSpelersSlider.noUiSlider.reset();
    //Remove cookies
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-beschrijving');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-location');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-vakken');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-leerprofiel');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-leeftijd');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-spelers');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-executieveFuncties');
    window.location = '/games/overview';
});
if ($29327506a7da108f$var$filterLearningBookBtn) $29327506a7da108f$var$filterLearningBookBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    const beschrijving = document.getElementById('learningBook-description-search').value;
    const niveau = document.getElementById('learningBook-grade-search');
    const niveauIndex = niveau.selectedIndex;
    const niveauValue = niveau.options[niveauIndex].value;
    const locatie = document.getElementById('learningBook-location-search');
    const locatieIndex = locatie.selectedIndex;
    const locatieValue = locatie.options[locatieIndex].value;
    const vakken = document.getElementById('learningBook-courses-search');
    const vakkenIndex = vakken.selectedIndex;
    const vakkenValue = vakken.options[vakkenIndex].value;
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-beschrijving-leerBoek', beschrijving);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-niveau-leerBoek', niveauIndex);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-locatie-leerBoek', locatieIndex);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-vak-leerBoek', vakkenIndex);
    window.location = `/learningBooks/overview?naam=${beschrijving}&beschrijving=${beschrijving}&locatie=${locatieValue}&vak=${vakkenValue}&niveau=${niveauValue}`;
}, window.addEventListener('load', ()=>{
    const beschrijvingCookie = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-beschrijving-leerBoek', {
        expires: 1 / 24
    });
    if (beschrijvingCookie != null) document.getElementById('learningBook-description-search').value = beschrijvingCookie;
    document.getElementById('learningBook-location-search').selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-locatie-leerBoek', {
        expires: 1 / 24
    });
    document.getElementById('learningBook-courses-search').selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-vak-leerBoek', {
        expires: 1 / 24
    });
    document.getElementById('learningBook-grade-search').selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-niveau-leerBoek', {
        expires: 1 / 24
    });
}));
if ($29327506a7da108f$var$resetFilterLearningBookBtn) $29327506a7da108f$var$resetFilterLearningBookBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    //Set values to default
    document.getElementById('learningBook-description-search').value = '';
    document.getElementById('learningBook-location-search').selectedIndex = 0;
    document.getElementById('learningBook-courses-search').selectedIndex = 0;
    document.getElementById('learningBook-grade-search').selectedIndex = 0;
    //Remove cookies
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-beschrijving-leerBoek');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-locatie-leerBoek');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-vak-leerBoek');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-niveau-leerBoek');
    window.location = '/learningBooks/overview';
});
if ($29327506a7da108f$var$filterInformativeBookBtn) $29327506a7da108f$var$filterInformativeBookBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    const beschrijving = document.getElementById('informativeBook-description-search').value;
    const locatie = document.getElementById('informativeBook-location-search');
    const locatieIndex = locatie.selectedIndex;
    const locatieValue = locatie.options[locatieIndex].value;
    const leerprofiel = document.getElementById('informativeBook-leerprofiel-search');
    const leerprofielIndex = leerprofiel.selectedIndex;
    const leerprofielValue = leerprofiel.options[leerprofielIndex].value;
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-beschrijving-informatiefBoek', beschrijving);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-locatie-informatiefBoek', locatieIndex);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-leerprofiel-informatiefBoek', leerprofielIndex);
    window.location = `/informativeBooks/overview?naam=${beschrijving}&beschrijving=${beschrijving}&locatie=${locatieValue}&leerprofiel=${leerprofielValue}`;
}, window.addEventListener('load', ()=>{
    const beschrijvingCookie = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-beschrijving-informatiefBoek', {
        expires: 1 / 24
    });
    if (beschrijvingCookie != null) document.getElementById('informativeBook-description-search').value = beschrijvingCookie;
    document.getElementById('informativeBook-location-search').selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-locatie-informatiefBoek', {
        expires: 1 / 24
    });
    document.getElementById('informativeBook-leerprofiel-search').selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-leerprofiel-informatiefBoek', {
        expires: 1 / 24
    });
}));
if ($29327506a7da108f$var$resetFilterInformativeBookBtn) $29327506a7da108f$var$resetFilterInformativeBookBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    //Set values to default
    document.getElementById('informativeBook-description-search').value = '';
    document.getElementById('informativeBook-location-search').selectedIndex = 0;
    document.getElementById('informativeBook-leerprofiel-search').selectedIndex = 0;
    //Remove cookies
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-beschrijving-informatiefBoek');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-locatie-informatiefBoek');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-leerprofiel-informatiefBoek');
    window.location = '/informativeBooks/overview';
});
if ($29327506a7da108f$var$filterReadingAndPictureBookBtn) $29327506a7da108f$var$filterReadingAndPictureBookBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    const beschrijving = document.getElementById('readingAndPictureBook-description-search').value;
    const locatie = document.getElementById('readingAndPictureBook-location-search');
    const locatieIndex = locatie.selectedIndex;
    const locatieValue = locatie.options[locatieIndex].value;
    const minLeeftijd = $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[0];
    const maxLeeftijd = $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-beschrijving-readingAndPictureBook', beschrijving);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-locatie-readingAndPictureBook', locatieIndex);
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set('filter-leeftijd-readingAndPictureBook', JSON.stringify([
        minLeeftijd,
        maxLeeftijd
    ]));
    window.location = `/readingAndPictureBooks/overview?naam=${beschrijving}&beschrijving=${beschrijving}&locatie=${locatieValue}&minLeeftijd=${minLeeftijd}&maxLeeftijd=${maxLeeftijd}`;
}, window.addEventListener('load', ()=>{
    const beschrijvingCookie = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-beschrijving-readingAndPictureBook', {
        expires: 1 / 24
    });
    if (beschrijvingCookie != null) document.getElementById('readingAndPictureBook-description-search').value = beschrijvingCookie;
    document.getElementById('readingAndPictureBook-location-search').selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-locatie-readingAndPictureBook', {
        expires: 1 / 24
    });
    const leeftijdCookieValue = (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get('filter-leeftijd-readingAndPictureBook', {
        expires: 1 / 24
    });
    if (leeftijdCookieValue != null) {
        const leeftijdCookie = JSON.parse(leeftijdCookieValue);
        if (parseInt(leeftijdCookie[0], 10) != 1 || parseInt(leeftijdCookie[1], 10) != 99) $29327506a7da108f$var$leeftijdSlider.noUiSlider.set([
            parseInt(leeftijdCookie[0], 10),
            parseInt(leeftijdCookie[1], 10)
        ]);
    }
}));
if ($29327506a7da108f$var$resetFilterReadingAndPictureBookBtn) $29327506a7da108f$var$resetFilterReadingAndPictureBookBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    //Set values to default
    document.getElementById('readingAndPictureBook-description-search').value = '';
    document.getElementById('readingAndPictureBook-location-search').selectedIndex = 0;
    $29327506a7da108f$var$leeftijdSlider.noUiSlider.reset();
    //Remove cookies
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-beschrijving-readingAndPictureBook');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-locatie-readingAndPictureBook');
    (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).remove('filter-leeftijd-readingAndPictureBook');
    window.location = '/readingAndPictureBooks/overview';
});
// **** COOKIES **** //
const $29327506a7da108f$var$consentPropertyName = 'zhssg_c_c';
const $29327506a7da108f$var$shouldShowPopup = ()=>!(0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get($29327506a7da108f$var$consentPropertyName);
const $29327506a7da108f$var$acceptCookieStorage = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set($29327506a7da108f$var$consentPropertyName, true, {
        expires: 365
    });
const $29327506a7da108f$var$declineCookieStorage = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).set($29327506a7da108f$var$consentPropertyName, false, {
        expires: 365
    });
window.onload = ()=>{
    const consentPopup = document.getElementById('consent-popup');
    const acceptBtn = document.getElementById('accept');
    const declineBtn = document.getElementById('decline');
    const acceptFn = (event)=>{
        $29327506a7da108f$var$acceptCookieStorage();
        //location.reload();
        consentPopup.classList.add('hidden');
    };
    const declineFn = (event)=>{
        $29327506a7da108f$var$declineCookieStorage();
        consentPopup.classList.add('hidden');
    };
    acceptBtn.addEventListener('click', acceptFn);
    declineBtn.addEventListener('click', declineFn);
    if ($29327506a7da108f$var$shouldShowPopup()) setTimeout(()=>{
        consentPopup.classList.remove('hidden');
    }, 5000);
    // When first loaded or consent is false, no Cookies are allowed
    if ((0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get($29327506a7da108f$var$consentPropertyName) === 'false' || (0, (/*@__PURE__*/$parcel$interopDefault($d5028c8da4192c16$exports))).get($29327506a7da108f$var$consentPropertyName) === null) // This window property must be set before any calls to the ga() command queue are made, and it must be set on each page for which you want to disable Google Analytics measurement. If the property is not set or set to false then measurement will work as usual.
    window['ga-disable-UA-98627475-6'] = true;
};
// **** PAGINATION **** //
const $29327506a7da108f$var$nextBtn = document.getElementById('page-next');
const $29327506a7da108f$var$backBtn = document.getElementById('page-back');
const $29327506a7da108f$var$pagination = document.querySelector('.pagination');
if ($29327506a7da108f$var$nextBtn) $29327506a7da108f$var$nextBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    const url = window.location.href;
    let page = new Number(new URLSearchParams(window.location.search).get('page'));
    if (page != 0) page += 1;
    else page = 2;
    $29327506a7da108f$var$paginationSearchQuery(url, page);
});
if ($29327506a7da108f$var$backBtn) $29327506a7da108f$var$backBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    const url = window.location.href;
    let page = new Number(new URLSearchParams(window.location.search).get('page'));
    if (page != 0) page -= 1;
    $29327506a7da108f$var$paginationSearchQuery(url, page);
});
function $29327506a7da108f$var$paginationSearchQuery(url, page) {
    const readingAndPictureBooks = url.indexOf('readingAndPictureBooks/overview');
    const learningBooks = url.indexOf('learningBooks/overview');
    const informativeBooks = url.indexOf('informativeBooks/overview');
    const games = url.indexOf('games/overview');
    const didacticMaterials = url.indexOf('didacticMaterials/overview');
    const virtualRealityApps = url.indexOf('virtualRealityApps/overview');
    if (readingAndPictureBooks > -1) {
        const beschrijving = document.getElementById('readingAndPictureBook-description-search').value;
        const locatie = document.getElementById('readingAndPictureBook-location-search');
        const locatieIndex = locatie.selectedIndex;
        const locatieValue = locatie.options[locatieIndex].value;
        const minLeeftijd = $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[0];
        const maxLeeftijd = $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[1];
        window.location = `/readingAndPictureBooks/overview?naam=${beschrijving}&beschrijving=${beschrijving}&locatie=${locatieValue}&minLeeftijd=${minLeeftijd}&maxLeeftijd=${maxLeeftijd}&page=${page}`;
    }
    if (learningBooks > -1) {
        const beschrijving = document.getElementById('learningBook-description-search').value;
        const niveau = document.getElementById('learningBook-grade-search');
        const niveauIndex = niveau.selectedIndex;
        const niveauValue = niveau.options[niveauIndex].value;
        const locatie = document.getElementById('learningBook-location-search');
        const locatieIndex = locatie.selectedIndex;
        const locatieValue = locatie.options[locatieIndex].value;
        const vakken = document.getElementById('learningBook-courses-search');
        const vakkenIndex = vakken.selectedIndex;
        const vakkenValue = vakken.options[vakkenIndex].value;
        window.location = `/learningBooks/overview?naam=${beschrijving}&beschrijving=${beschrijving}&locatie=${locatieValue}&vak=${vakkenValue}&niveau=${niveauValue}&page=${page}`;
    }
    if (informativeBooks > -1) {
        const beschrijving = document.getElementById('informativeBook-description-search').value;
        const locatie = document.getElementById('informativeBook-location-search');
        const locatieIndex = locatie.selectedIndex;
        const locatieValue = locatie.options[locatieIndex].value;
        const leerprofiel = document.getElementById('informativeBook-leerprofiel-search');
        const leerprofielIndex = leerprofiel.selectedIndex;
        const leerprofielValue = leerprofiel.options[leerprofielIndex].value;
        window.location = `/informativeBooks/overview?naam=${beschrijving}&beschrijving=${beschrijving}&locatie=${locatieValue}&leerprofiel=${leerprofielValue}&page=${page}`;
    }
    if (games > -1) {
        const beschrijving = document.getElementById('games-description-search').value;
        const location = document.getElementById('games-location-search');
        const locationIndex = location.selectedIndex;
        const locationValue = location.options[locationIndex].value;
        const vakken = document.getElementById('games-courses-search');
        const vakkenIndex = vakken.selectedIndex;
        const vakkenValue = vakken.options[vakkenIndex].value;
        const leerprofiel = document.getElementById('games-leerprofiel-search');
        const leerprofielIndex = leerprofiel.selectedIndex;
        const leerprofielValue = leerprofiel.options[leerprofielIndex].value;
        const minLeeftijd = $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[0];
        const maxLeeftijd = $29327506a7da108f$var$leeftijdSlider.noUiSlider.get()[1];
        const minSpelers = $29327506a7da108f$var$gameSpelersSlider.noUiSlider.get()[0];
        const maxSpelers = $29327506a7da108f$var$gameSpelersSlider.noUiSlider.get()[1];
        const executieveFuncties = document.getElementById('games-executieve-functies-search');
        const executieveFunctiesIndex = executieveFuncties.selectedIndex;
        const executieveFunctiesValue = executieveFuncties.options[executieveFunctiesIndex].value;
        window.location = `/games/overview?naam=${beschrijving}&beschrijving=${beschrijving}&locatie=${locationValue}&executieveFuncties=${executieveFunctiesValue}&vak=${vakkenValue}&leerprofiel=${leerprofielValue}&minLeeftijd=${minLeeftijd}&maxLeeftijd=${maxLeeftijd}&minSpelers=${minSpelers}&maxSpelers=${maxSpelers}&page=${page}`;
    }
    if (didacticMaterials > -1) {
        const beschrijving = document.getElementById('didacticMaterial-description-search').value;
        const niveau = document.getElementById('didacticMaterial-grade-search');
        const niveauIndex = niveau.selectedIndex;
        const niveauValue = niveau.options[niveauIndex].value;
        const locatie = document.getElementById('didacticMaterial-location-search');
        const locatieIndex = locatie.selectedIndex;
        const locatieValue = locatie.options[locatieIndex].value;
        const vakken = document.getElementById('didacticMaterial-courses-search');
        const vakkenIndex = vakken.selectedIndex;
        const vakkenValue = vakken.options[vakkenIndex].value;
        window.location = `/didacticMaterials/overview?naam=${beschrijving}&beschrijving=${beschrijving}&locatie=${locatieValue}&vak=${vakkenValue}&niveau=${niveauValue}&page=${page}`;
    }
    if (virtualRealityApps > -1) {
        const beschrijving = document.getElementById('virtualRealityApps-description-search').value;
        const vakken = document.getElementById('didacticMaterial-courses-search');
        const vakkenIndex = vakken.selectedIndex;
        const vakkenValue = vakken.options[vakkenIndex].value;
        window.location = `/didacticMaterials/overview?naam=${beschrijving}&beschrijving=${beschrijving}&vak=${vakkenValue}&page=${page}`;
    }
}
if ($29327506a7da108f$var$pagination) window.addEventListener('load', ()=>{
    const page = new URLSearchParams(window.location.search).get('page');
    const pages = document.querySelector('.pagination').dataset.pages;
    if (page) document.getElementById('insert-page-number').textContent = page;
    if (page == 1 || page == null) $29327506a7da108f$var$backBtn.remove();
    if (page == pages || pages == 1) $29327506a7da108f$var$nextBtn.remove();
    if (pages == 0) {
        $29327506a7da108f$var$nextBtn.remove();
        document.querySelector('.pagination').remove();
    }
});

})();
//# sourceMappingURL=index.js.map
